// Gerado automaticamente por app/scripts/generateWhatsAppEmojiKeywords.js.
// Fonte: Unicode CLDR annotations PT/EN. Nao edite manualmente.

const whatsAppEmojiKeywords = {
  "😀": [
    "1f600",
    "cheerful",
    "cheery",
    "engracado",
    "face",
    "feliz",
    "grin",
    "grinning",
    "grinning face",
    "happy",
    "laugh",
    "lol",
    "nice",
    "rindo",
    "risada",
    "riso",
    "rosto",
    "rosto risonho",
    "smile",
    "smileys",
    "smiling",
    "sorridente",
    "teeth"
  ],
  "😃": [
    "1f603",
    "aberto",
    "awesome",
    "big",
    "boca",
    "eyes",
    "face",
    "feliz",
    "grin",
    "grinning",
    "grinning face with big eyes",
    "happy",
    "mouth",
    "olhos arregalados",
    "open",
    "risada",
    "risonho",
    "rosto",
    "rosto risonho com olhos bem abertos",
    "rosto sorrindo com boca aberta",
    "smile",
    "smileys",
    "smiling",
    "sorridente",
    "sorrindo",
    "sorriso",
    "teeth",
    "yay"
  ],
  "😄": [
    "1f604",
    "aberta",
    "boca",
    "engracado",
    "eye",
    "eyes",
    "face",
    "feliz",
    "grin",
    "grinning",
    "grinning face with smiling eyes",
    "haha",
    "happy",
    "laugh",
    "lol",
    "mouth",
    "open",
    "risada",
    "riso",
    "risonho",
    "rosto risonho com olhos sorridentes",
    "smile",
    "smileys",
    "smiling",
    "sorridente",
    "sorriso"
  ],
  "😁": [
    "1f601",
    "beaming",
    "beaming face with smiling eyes",
    "eye",
    "eyes",
    "face",
    "feliz",
    "grin",
    "grinning",
    "happy",
    "nice",
    "olho",
    "olhos sorrindo",
    "rindo",
    "rosto",
    "rosto contente com olhos sorridentes",
    "rosto rindo com olhos sorridentes",
    "smile",
    "smileys",
    "smiling",
    "sorridente",
    "sorrindo",
    "sorriso",
    "sorriso aberto",
    "teeth"
  ],
  "😆": [
    "1f606",
    "closed",
    "eyes",
    "face",
    "gargalhada",
    "gargalhando",
    "grinning",
    "grinning squinting face",
    "haha",
    "hahaha",
    "happy",
    "kkk",
    "laugh",
    "lol",
    "mouth",
    "olhos fechados",
    "open",
    "rir",
    "rofl",
    "rosto",
    "rosto risonho com olhos semicerrados",
    "smile",
    "smileys",
    "smiling",
    "sorriso com olhos fechados",
    "sorriso estilo xd",
    "squinting"
  ],
  "🥹": [
    "1f979",
    "admiracao",
    "admiration",
    "alegria",
    "aww",
    "back",
    "chorar",
    "com raiva",
    "cry",
    "embarrassed",
    "emocao",
    "face",
    "face holding back tears",
    "feelings",
    "grateful",
    "gratidao",
    "gratitude",
    "holding",
    "iti malia",
    "joy",
    "lagrimas",
    "orgulho",
    "please",
    "por favor",
    "proud",
    "resist",
    "resistir",
    "rosto segurando as lagrimas",
    "sad",
    "smileys",
    "tears",
    "tristeza"
  ],
  "😅": [
    "1f605",
    "cold",
    "dejected",
    "estressada",
    "estressado",
    "excited",
    "face",
    "grinning",
    "grinning face with sweat",
    "mouth",
    "nervoso",
    "nervous",
    "open",
    "rindo",
    "rosto",
    "rosto risonho com gota de suor",
    "smile",
    "smileys",
    "smiling",
    "sorriso com suor frio",
    "sorriso mas com suor frio",
    "stress",
    "stressed",
    "suando frio",
    "suor frio",
    "sweat"
  ],
  "😂": [
    "1f602",
    "alegria",
    "chorando de rir",
    "crying",
    "engracada",
    "engracado",
    "face",
    "face with tears of joy",
    "feels",
    "funny",
    "gargalhada",
    "haha",
    "hahaha",
    "happy",
    "hehe",
    "hilarious",
    "joy",
    "kkk",
    "lagrimas",
    "lagrimas de alegria",
    "laugh",
    "lmao",
    "lol",
    "rofl",
    "roflmao",
    "rosto",
    "rosto chorando de rir",
    "rosto com lagrimas de alegria",
    "smileys",
    "tear"
  ],
  "🤣": [
    "1f923",
    "chao",
    "choro",
    "crying",
    "engracada",
    "face",
    "feliz",
    "floor",
    "funny",
    "gargalhada",
    "haha",
    "happy",
    "hehe",
    "hilarious",
    "joy",
    "kkk",
    "lagrimas",
    "laugh",
    "lmao",
    "lol",
    "rindo",
    "rir",
    "risada",
    "rofl",
    "roflmao",
    "rolando",
    "rolando no chao de rir",
    "rolling",
    "rolling on the floor laughing",
    "smileys",
    "tear"
  ],
  "🥲": [
    "1f972",
    "aliviada",
    "chorar",
    "contente",
    "emocionado",
    "face",
    "felicidade",
    "feliz",
    "glad",
    "grata",
    "grateful",
    "gratidao",
    "happy",
    "joy",
    "lagrima",
    "orgulhosa",
    "pain",
    "proud",
    "relieved",
    "rir",
    "rosto sorridente com lagrima",
    "smile",
    "smiley",
    "smileys",
    "smiling",
    "smiling face with tear",
    "sorrir",
    "tear",
    "touched"
  ],
  "☺️": [
    "263a",
    "corada",
    "corado",
    "face",
    "happy",
    "outlined",
    "relaxado",
    "relaxed",
    "rosto",
    "rosto sorridente",
    "rosto sorrindo",
    "rosto sorrindo nao preenchido",
    "smile",
    "smileys",
    "smiling",
    "smiling face",
    "sorridente",
    "sorriso"
  ],
  "😊": [
    "1f60a",
    "alegre",
    "blush",
    "encabulada",
    "envergonhada",
    "eye",
    "eyes",
    "face",
    "feliz",
    "fofo",
    "glad",
    "rosto sorridente com olhos sorridentes",
    "ruborizar",
    "satisfeita",
    "satisfied",
    "sim",
    "smile",
    "smileys",
    "smiling",
    "smiling face with smiling eyes",
    "sorriso",
    "vergonha"
  ],
  "😇": [
    "1f607",
    "angel",
    "angelic",
    "angels",
    "anjinho",
    "anjo",
    "aureola",
    "blessed",
    "face",
    "fairy",
    "fairytale",
    "fantasy",
    "halo",
    "happy",
    "innocent",
    "inocente",
    "peaceful",
    "rosto",
    "rosto sorridente com aureola",
    "smile",
    "smileys",
    "smiling",
    "smiling face with halo",
    "sorriso",
    "sorriso com aureola",
    "spirit",
    "tale"
  ],
  "🙂": [
    "1f642",
    "face",
    "feliz",
    "happy",
    "rosto",
    "rosto levemente sorridente",
    "rosto sorrindo",
    "slightly",
    "slightly smiling face",
    "smile",
    "smileys",
    "smiling",
    "sorriso",
    "sorriso leve"
  ],
  "🙃": [
    "1f643",
    "de cabeca para baixo",
    "face",
    "hehe",
    "rosto de cabeca para baixo",
    "rosto invertido",
    "smile",
    "smileys",
    "upside-down",
    "upside-down face"
  ],
  "😉": [
    "1f609",
    "face",
    "flerte",
    "flirt",
    "heartbreaker",
    "piscada",
    "rosto",
    "rosto com olho piscando",
    "rosto piscando",
    "sexy",
    "slide",
    "smileys",
    "tease",
    "wink",
    "winking",
    "winking face",
    "winks"
  ],
  "😌": [
    "1f60c",
    "alivio",
    "calm",
    "em paz",
    "face",
    "peace",
    "relief",
    "relieved",
    "relieved face",
    "rosto",
    "rosto aliviado",
    "smileys",
    "zen"
  ],
  "😍": [
    "143",
    "1f60d",
    "amor",
    "apaixonado",
    "bae",
    "coracao",
    "eye",
    "face",
    "feels",
    "heart-eyes",
    "hearts",
    "ily",
    "kisses",
    "love",
    "olhar apaixonado",
    "olhos",
    "olhos de coracao",
    "paixao",
    "romance",
    "romantic",
    "rosto",
    "rosto sorridente com olhos de coracao",
    "smile",
    "smileys",
    "smiling face with heart-eyes",
    "xoxo"
  ],
  "🥰": [
    "1f970",
    "3",
    "adore",
    "amando",
    "amei",
    "amo",
    "apaixonada",
    "coracao",
    "crush",
    "face",
    "heart",
    "hearts",
    "ily",
    "love",
    "paixao",
    "romance",
    "rosto",
    "rosto sorridente com 3 coracoes",
    "smile",
    "smileys",
    "smiling",
    "smiling face with hearts",
    "sorridente",
    "te amo",
    "you"
  ],
  "😘": [
    "1f618",
    "adorbs",
    "bae",
    "beijo",
    "blowing",
    "face",
    "face blowing a kiss",
    "flerte",
    "flirt",
    "heart",
    "ily",
    "jogando beijos",
    "kiss",
    "love",
    "lover",
    "mandando beijo",
    "miss",
    "muah",
    "romantic",
    "rosto",
    "rosto jogando beijos",
    "rosto mandando um beijo",
    "smileys",
    "smooch",
    "xoxo",
    "you"
  ],
  "😗": [
    "143",
    "1f617",
    "beijo",
    "date",
    "dating",
    "face",
    "flirt",
    "ily",
    "kiss",
    "kissing face",
    "love",
    "rosto",
    "rosto beijando",
    "rosto com beijo",
    "smileys",
    "smooch",
    "smooches",
    "xoxo",
    "you"
  ],
  "😙": [
    "143",
    "1f619",
    "beijar e sorrir",
    "beijinho",
    "beijos",
    "closed",
    "date",
    "dating",
    "eye",
    "eyes",
    "face",
    "flerte",
    "flirt",
    "ily",
    "kiss",
    "kisses",
    "kissing",
    "kissing face with smiling eyes",
    "love",
    "mandando beijo",
    "night",
    "olhos sorrindo",
    "rosto",
    "rosto beijando com olhos sorridentes",
    "rosto beijando com um sorriso",
    "smile",
    "smileys",
    "smiling",
    "sorriso"
  ],
  "😚": [
    "143",
    "1f61a",
    "bae",
    "beijando",
    "beijando com os olhos fechados",
    "beijinho",
    "blush",
    "closed",
    "date",
    "dating",
    "eye",
    "eyes",
    "face",
    "flirt",
    "ily",
    "kisses",
    "kissing",
    "kissing face with closed eyes",
    "mandando beijo",
    "olhos fechados",
    "rosto",
    "rosto beijando com olhos fechados",
    "smileys",
    "smooches",
    "xoxo"
  ],
  "😋": [
    "1f60b",
    "apetitoso",
    "comida gostosa",
    "delicioso",
    "delicious",
    "eat",
    "face",
    "face savoring food",
    "food",
    "full",
    "gostoso",
    "hungry",
    "nham",
    "rosto",
    "rosto com sorriso",
    "rosto saboreando",
    "rosto saboreando comida",
    "saboroso",
    "savor",
    "smile",
    "smileys",
    "smiling",
    "sorriso",
    "tasty",
    "um",
    "yum",
    "yummy"
  ],
  "😛": [
    "1f61b",
    "awesome",
    "cool",
    "face",
    "face with tongue",
    "lingua para fora",
    "nice",
    "party",
    "rosto",
    "rosto com lingua para fora",
    "rosto mostrando a lingua",
    "smileys",
    "stuck-out",
    "sweet",
    "tongue"
  ],
  "😝": [
    "1f61d",
    "closed",
    "eca",
    "eye",
    "eyes",
    "face",
    "gross",
    "horrible",
    "horrivel",
    "lingua para fora",
    "lingua para fora com os olhos fechados",
    "olhos fechados",
    "omg",
    "rosto",
    "rosto com olhos semicerrados e lingua para fora",
    "smileys",
    "squinting",
    "squinting face with tongue",
    "stuck-out",
    "taste",
    "tongue",
    "whatever",
    "yolo"
  ],
  "😜": [
    "1f61c",
    "brincadeira",
    "crazy",
    "epic",
    "eye",
    "face",
    "funny",
    "joke",
    "lingua para fora com piscadela",
    "loopy",
    "nutty",
    "party",
    "piscadela",
    "piscando e mostrando a lingua",
    "provocacao",
    "rosto",
    "rosto piscando e com lingua para fora",
    "smileys",
    "stuck-out",
    "tongue",
    "wacky",
    "weirdo",
    "wink",
    "winking",
    "winking face with tongue",
    "yolo"
  ],
  "🤪": [
    "1f92a",
    "cara de maluco",
    "crazy",
    "doida",
    "doido",
    "excentrico",
    "eye",
    "eyes",
    "face",
    "goofy",
    "grande",
    "large",
    "louca",
    "louco",
    "olhar de maluco",
    "olho",
    "pequeno",
    "rosto bizarro",
    "small",
    "smileys",
    "zany",
    "zany face"
  ],
  "🤨": [
    "1f928",
    "cetica",
    "ceticismo",
    "cetico",
    "confusa",
    "confuso",
    "desconfiada",
    "desconfiado",
    "desconfianca",
    "disapproval",
    "disbelief",
    "distrust",
    "emoji",
    "eyebrow",
    "face",
    "face with raised eyebrow",
    "hmm",
    "mild",
    "raised",
    "rosto com sobrancelha levantada",
    "skeptic",
    "skeptical",
    "skepticism",
    "smileys",
    "surprise",
    "what"
  ],
  "🧐": [
    "1f9d0",
    "classy",
    "conservador",
    "face",
    "face with monocle",
    "fancy",
    "monocle",
    "rich",
    "rosto com monoculo",
    "smileys",
    "stuffy",
    "wealthy"
  ],
  "🤓": [
    "1f913",
    "brainy",
    "cdf",
    "clever",
    "esperto",
    "estudioso",
    "expert",
    "face",
    "geek",
    "gifted",
    "glasses",
    "inteligencia",
    "inteligente",
    "intelligent",
    "nerd",
    "nerd face",
    "oculos",
    "oculos de grau",
    "rosto de nerd",
    "sabe tudo",
    "sabe-tudo",
    "smart",
    "smileys"
  ],
  "😎": [
    "1f60e",
    "awesome",
    "beach",
    "bright",
    "bro",
    "chilling",
    "cool",
    "face",
    "muito sol",
    "na boa",
    "oculos escuros",
    "rad",
    "relaxed",
    "rosto",
    "rosto sorridente com oculos escuros",
    "shades",
    "slay",
    "smile",
    "smileys",
    "smiling face with sunglasses",
    "sol",
    "sorrindo",
    "sorrindo de oculos escuros",
    "sorriso de oculos",
    "style",
    "sunglasses",
    "swag",
    "to legal",
    "win"
  ],
  "🥸": [
    "1f978",
    "bigode",
    "disfarce",
    "disguise",
    "disguised face",
    "espiao",
    "eyebrow",
    "face",
    "glasses",
    "incognito",
    "moustache",
    "mustache",
    "nariz",
    "nose",
    "oculos",
    "person",
    "pessoa",
    "rosto",
    "rosto disfarcado",
    "smileys",
    "sobrancelha",
    "spy",
    "tache",
    "tash"
  ],
  "🤩": [
    "1f929",
    "estrela",
    "excited",
    "eyes",
    "face",
    "gargalhando",
    "grinning",
    "olhos",
    "rosto",
    "rosto com olhar maravilhado",
    "smile",
    "smileys",
    "star",
    "star-struck",
    "starry-eyed",
    "super animada",
    "super animado",
    "super feliz",
    "superanimada",
    "superanimado",
    "superfeliz",
    "wow"
  ],
  "🥳": [
    "1f973",
    "animacao",
    "aniversario",
    "apito",
    "bday",
    "birthday",
    "celebrate",
    "celebration",
    "chapeu",
    "comemoracao",
    "comemorar",
    "excited",
    "face",
    "feliz aniversario",
    "festa",
    "happy",
    "hat",
    "hooray",
    "horn",
    "lingua de sogra",
    "parabens",
    "party",
    "partying",
    "partying face",
    "rosto",
    "rosto festivo",
    "smileys",
    "viva"
  ],
  "🙂‍↕️": [
    "1f642-200d-2195",
    "cabeca balancando na vertical",
    "confirmacao",
    "head",
    "head shaking vertically",
    "nod",
    "shaking",
    "sim",
    "smileys",
    "vertically",
    "yes"
  ],
  "😏": [
    "1f60f",
    "boss",
    "dapper",
    "face",
    "flerte",
    "flirt",
    "homie",
    "kidding",
    "leer",
    "rosto",
    "rosto com sorriso maroto",
    "shade",
    "slick",
    "sly",
    "smileys",
    "smirk",
    "smirking face",
    "smug",
    "snicker",
    "sorriso maldoso",
    "sorriso malicioso",
    "sorriso maroto",
    "suave",
    "suspeito",
    "suspicious",
    "swag"
  ],
  "😒": [
    "...",
    "1f612",
    "aff",
    "blase",
    "bored",
    "face",
    "fine",
    "jealous",
    "jel",
    "jelly",
    "nada engracado",
    "nao achou graca",
    "nao esta feliz",
    "pissed",
    "rosto",
    "rosto aborrecido",
    "rosto de que nao achou graca",
    "rosto de quem nao achou graca",
    "smh",
    "smileys",
    "ugh",
    "uhh",
    "unamused",
    "unamused face",
    "unhappy",
    "weird",
    "whatever"
  ],
  "🙂‍↔️": [
    "1f642-200d-2194",
    "balancar",
    "cabeca balancando na horizontal",
    "cabeca virando de um lado para o outro",
    "head",
    "head shaking horizontally",
    "horizontally",
    "nao",
    "negar",
    "no",
    "shake",
    "shaking",
    "smileys"
  ],
  "😞": [
    "1f61e",
    "awful",
    "blame",
    "decepcao",
    "dejected",
    "desapontado",
    "desapontamento",
    "disappointed",
    "disappointed face",
    "face",
    "fail",
    "losing",
    "rosto",
    "rosto decepcionado",
    "rosto desapontado",
    "sad",
    "smileys",
    "triste",
    "unhappy"
  ],
  "😔": [
    "1f614",
    "abatido",
    "awful",
    "bored",
    "chateado",
    "dejected",
    "deprimido",
    "desanimado",
    "died",
    "disappointed",
    "face",
    "losing",
    "lost",
    "pensativo",
    "pensive",
    "pensive face",
    "pra baixo",
    "rosto",
    "rosto deprimido",
    "sad",
    "smileys",
    "sucks"
  ],
  "😟": [
    "1f61f",
    "anxious",
    "butterflies",
    "decepcionado",
    "face",
    "nerves",
    "nervous",
    "preocupado",
    "rosto",
    "rosto preocupado",
    "sad",
    "smileys",
    "stress",
    "stressed",
    "surprised",
    "worried",
    "worried face",
    "worry"
  ],
  "😕": [
    "1f615",
    "befuddled",
    "confused",
    "confused face",
    "confusing",
    "confuso",
    "dunno",
    "face",
    "frown",
    "hm",
    "indeciso",
    "meh",
    "nao entendi",
    "nao tenho certeza",
    "not",
    "rosto",
    "rosto confuso",
    "sad",
    "smileys",
    "sorry",
    "sure"
  ],
  "🙁": [
    "1f641",
    "face",
    "frown",
    "frowning",
    "rosto",
    "rosto meio triste",
    "sad",
    "slightly",
    "slightly frowning face",
    "smileys",
    "triste",
    "tristeza",
    "tristinho"
  ],
  "☹️": [
    "2639",
    "decepcao",
    "decepcionado",
    "descontente",
    "face",
    "frown",
    "frowning",
    "frowning face",
    "insatisfeito",
    "rosto",
    "rosto de desaprovacao",
    "rosto descontente",
    "sad",
    "smileys",
    "triste"
  ],
  "😣": [
    "1f623",
    "concentracao",
    "concentrado",
    "concentrate",
    "concentration",
    "dor de cabeca",
    "face",
    "foco",
    "focus",
    "headache",
    "perseveranca",
    "perseverante",
    "persevere",
    "persevering",
    "persevering face",
    "rosto",
    "rosto perseverante",
    "smileys"
  ],
  "😖": [
    "1f616",
    "annoyed",
    "bravo",
    "confounded",
    "confounded face",
    "confused",
    "cringe",
    "distraught",
    "face",
    "feels",
    "frustrado",
    "frustrated",
    "indignado",
    "mad",
    "perplexo",
    "rosto",
    "rosto perplexo",
    "sad",
    "smileys"
  ],
  "😫": [
    "1f62b",
    "cansado",
    "cost",
    "desesperado",
    "exausto",
    "face",
    "feels",
    "nap",
    "rosto",
    "rosto cansado",
    "sad",
    "smileys",
    "sneeze",
    "tired",
    "tired face"
  ],
  "😩": [
    "1f629",
    "aborrecido",
    "cansado",
    "cansei",
    "crying",
    "decepcionado",
    "desolado",
    "exausto",
    "face",
    "fail",
    "feels",
    "hungry",
    "infeliz",
    "mad",
    "nooo",
    "perdi",
    "rosto",
    "rosto desolado",
    "sad",
    "sleepy",
    "smileys",
    "tired",
    "unhappy",
    "weary",
    "weary face"
  ],
  "🥺": [
    "1f97a",
    "begging",
    "big",
    "eyes",
    "face",
    "implorando",
    "mercy",
    "not",
    "olhar de cachorrinho",
    "olhos grandes",
    "perdao",
    "pleading",
    "pleading face",
    "please",
    "por favor",
    "por que nao",
    "pq nao",
    "pretty",
    "puppy",
    "rosto",
    "rosto implorando",
    "sad",
    "smileys",
    "triste",
    "why"
  ],
  "😢": [
    "1f622",
    "awful",
    "chorando",
    "choro",
    "cry",
    "crying",
    "crying face",
    "face",
    "feels",
    "lagrimas",
    "miss",
    "rosto",
    "rosto chorando",
    "sad",
    "smileys",
    "tear",
    "triste",
    "unhappy"
  ],
  "😭": [
    "1f62d",
    "bawling",
    "chorando",
    "chorando alto",
    "chorar",
    "cry",
    "crying",
    "face",
    "infeliz",
    "lagrimas",
    "loudly",
    "loudly crying face",
    "rosto",
    "rosto chorando aos berros",
    "sad",
    "smileys",
    "sob",
    "tear",
    "tears",
    "triste",
    "unhappy"
  ],
  "😤": [
    "1f624",
    "anger",
    "angry",
    "brava",
    "bravo",
    "face",
    "face with steam from nose",
    "feels",
    "fume",
    "fuming",
    "furiosa",
    "furioso",
    "furious",
    "fury",
    "irritada",
    "irritado",
    "mad",
    "nose",
    "rosto",
    "rosto soltando vapor pelo nariz",
    "smileys",
    "soltando fumaca",
    "steam",
    "triumph",
    "triunfo",
    "unhappy",
    "vitoria",
    "won"
  ],
  "😠": [
    "1f620",
    "anger",
    "angry",
    "angry face",
    "blame",
    "face",
    "feels",
    "frustrated",
    "irado",
    "mad",
    "maddening",
    "rage",
    "rosto",
    "rosto zangado",
    "shade",
    "smileys",
    "unhappy",
    "upset",
    "zangado"
  ],
  "😡": [
    "1f621",
    "anger",
    "angry",
    "bravo",
    "enraged",
    "enraged face",
    "face",
    "feels",
    "furioso",
    "irado",
    "mad",
    "maddening",
    "pouting",
    "rage",
    "red",
    "rosto",
    "rosto furioso",
    "shade",
    "smileys",
    "unhappy",
    "upset",
    "vermelho",
    "zangado"
  ],
  "🤬": [
    "1f92c",
    "boca",
    "censor",
    "censurado",
    "cursing",
    "cussing",
    "face",
    "face with symbols on mouth",
    "fala",
    "mad",
    "mal",
    "mouth",
    "pissed",
    "rosto",
    "rosto com simbolos na boca",
    "rude",
    "simbolos",
    "smileys",
    "swearing",
    "symbols",
    "xingando"
  ],
  "🤯": [
    "1f92f",
    "blown",
    "cabeca",
    "cabeca explodindo",
    "chocada",
    "chocado",
    "chocante",
    "choque",
    "explode",
    "explodindo",
    "exploding",
    "exploding head",
    "head",
    "incrivel",
    "mind",
    "mindblown",
    "no",
    "perplexo",
    "shocked",
    "smileys",
    "surpreendente",
    "surpresa",
    "surpreso",
    "way"
  ],
  "😳": [
    "1f633",
    "amazed",
    "atordoado",
    "awkward",
    "crazy",
    "dazed",
    "dead",
    "deslumbrado",
    "disbelief",
    "embarrassed",
    "face",
    "flushed",
    "flushed face",
    "geez",
    "heat",
    "horrorizado",
    "hot",
    "impressed",
    "impressionado",
    "jeez",
    "rosto",
    "rosto ruborizado",
    "ruborizado",
    "smileys",
    "vergonha",
    "what",
    "wow"
  ],
  "🥵": [
    "1f975",
    "calor",
    "dying",
    "face",
    "febre",
    "febril",
    "feverish",
    "heat",
    "hot",
    "hot face",
    "insolacao",
    "lingua de fora",
    "ofegante",
    "panting",
    "quente",
    "red-faced",
    "rosto",
    "rosto fervendo de calor",
    "rosto vermelho",
    "smileys",
    "stroke",
    "suando",
    "suor",
    "sweating",
    "tongue"
  ],
  "🥶": [
    "1f976",
    "abaixo de zero",
    "azul",
    "blue",
    "blue-faced",
    "cold",
    "cold face",
    "congelando",
    "congelei",
    "face",
    "freezing",
    "frio",
    "frostbite",
    "gelado",
    "gelido",
    "glacial",
    "icicles",
    "rosto",
    "rosto gelado",
    "smileys",
    "subzero",
    "teeth"
  ],
  "😶‍🌫️": [
    "1f636-200d-1f32b",
    "absentminded",
    "cabeca nas nuvens",
    "clouds",
    "distraido",
    "face",
    "face in clouds",
    "fog",
    "head",
    "rosto nas nuvens",
    "rosto no nevoeiro",
    "smileys"
  ],
  "😱": [
    "1f631",
    "assustada",
    "assustado",
    "epic",
    "face",
    "face screaming in fear",
    "fear",
    "fearful",
    "gritando",
    "grito",
    "medo",
    "munch",
    "rosto",
    "rosto gritando de medo",
    "scared",
    "scream",
    "screamer",
    "screaming",
    "shocked",
    "smileys",
    "surprised",
    "susto",
    "temeroso",
    "woah"
  ],
  "😨": [
    "1f628",
    "afraid",
    "ansiedade",
    "anxious",
    "assustado",
    "blame",
    "com medo",
    "face",
    "fear",
    "fearful",
    "fearful face",
    "medo",
    "preocupado",
    "rosto",
    "rosto amedrontado",
    "scared",
    "smileys",
    "worried"
  ],
  "😰": [
    "1f630",
    "anxious",
    "anxious face with sweat",
    "blue",
    "boca aberta",
    "cold",
    "eek",
    "face",
    "mouth",
    "nervoso",
    "nervous",
    "open",
    "rosto",
    "rosto ansioso com gota de suor",
    "rosto azul com suor frio",
    "rushed",
    "scared",
    "smileys",
    "suando frio",
    "suor frio",
    "sweat",
    "yikes"
  ],
  "😥": [
    "1f625",
    "aliviado",
    "anxious",
    "call",
    "close",
    "complicated",
    "decepcionado",
    "disappointed",
    "face",
    "nao",
    "not",
    "relieved",
    "rosto",
    "rosto triste, mas aliviado",
    "sad",
    "sad but relieved face",
    "smileys",
    "sweat",
    "time",
    "triste",
    "ufa",
    "whew"
  ],
  "😓": [
    "1f613",
    "close",
    "cold",
    "downcast",
    "downcast face with sweat",
    "face",
    "feels",
    "headache",
    "nervous",
    "rosto",
    "rosto cabisbaixo com gota de suor",
    "rosto com suor frio",
    "sad",
    "scared",
    "smileys",
    "suando frio",
    "suor frio",
    "sweat",
    "yikes"
  ],
  "🤗": [
    "1f917",
    "abraco",
    "carinho",
    "face",
    "feliz",
    "hands",
    "hug",
    "hugging",
    "maos abracando",
    "open",
    "rosto",
    "rosto abracando",
    "rosto sorrindo",
    "smileys",
    "smiling",
    "smiling face with open hands"
  ],
  "🤔": [
    "1f914",
    "chin",
    "consider",
    "curiosa",
    "curioso",
    "duvida",
    "face",
    "hmm",
    "ideia",
    "ideias",
    "mao no queixo",
    "pensando",
    "pensativa",
    "pensativo",
    "ponder",
    "pondering",
    "rosto",
    "rosto pensativo",
    "smileys",
    "thinking",
    "thinking face",
    "wondering"
  ],
  "🫣": [
    "1fae3",
    "captivated",
    "cativada",
    "cativado",
    "embarrass",
    "envergonhada",
    "envergonhado",
    "esconder",
    "espiadinha",
    "espiando",
    "espiar",
    "eye",
    "face",
    "face with peeking eye",
    "hide",
    "hiding",
    "olhar fixamente",
    "peek",
    "peeking",
    "peep",
    "rosto com olho espiando",
    "scared",
    "shy",
    "smiley",
    "smileys",
    "stare",
    "timida",
    "timido",
    "vergonha"
  ],
  "🤭": [
    "1f92d",
    "face",
    "face with hand over mouth",
    "giggle",
    "giggling",
    "hand",
    "hehe",
    "mouth",
    "oops",
    "ops",
    "realization",
    "risadinha",
    "risonho",
    "rosto com a mao sobre a boca",
    "secret",
    "shock",
    "smileys",
    "sorriso envergonhado",
    "sudden",
    "surprise",
    "vergonha",
    "whoops"
  ],
  "🫢": [
    "1fae2",
    "amazement",
    "assustada",
    "awe",
    "chocada",
    "descrenca",
    "disbelief",
    "em choque",
    "embarrass",
    "espanto",
    "eyes",
    "face",
    "face with open eyes and hand over mouth",
    "gasp",
    "hand",
    "mouth",
    "nossa",
    "omg",
    "open",
    "over",
    "passada",
    "quiet",
    "quieta",
    "rosto com olhos abertos e mao sobre a boca",
    "scared",
    "shock",
    "smileys",
    "surpresa",
    "surprise",
    "temor"
  ],
  "🫡": [
    "1fae1",
    "boa sorte",
    "exercito",
    "face",
    "good",
    "luck",
    "ma’am",
    "ok",
    "respect",
    "respeito",
    "rosto saudando",
    "salute",
    "saluting",
    "saluting face",
    "saudacao",
    "senhor",
    "sim",
    "sir",
    "smileys",
    "troops",
    "tropa",
    "yes"
  ],
  "🤫": [
    "1f92b",
    "faca silencio",
    "face",
    "fica quieta",
    "quiet",
    "quieta",
    "quieto",
    "rosto fazendo sinal de silencio",
    "shh",
    "shush",
    "shushing",
    "shushing face",
    "silencio",
    "smileys"
  ],
  "🫠": [
    "1fae0",
    "calor",
    "derretendo",
    "derreter",
    "desaparecer",
    "disappear",
    "dissolve",
    "dissolver",
    "embarrassed",
    "envergonhada",
    "face",
    "haha",
    "heat",
    "hot",
    "liquid",
    "lol",
    "melt",
    "melting",
    "melting face",
    "quente",
    "rosto derretendo",
    "sarcasm",
    "sarcasmo",
    "sarcastic",
    "sarcastica",
    "smileys",
    "vergonha"
  ],
  "🤥": [
    "1f925",
    "face",
    "liar",
    "lie",
    "lying",
    "lying face",
    "mentindo",
    "mentira",
    "mentiroso",
    "nariz crescendo",
    "pinocchio",
    "pinoquio",
    "rosto de mentiroso",
    "smileys"
  ],
  "😶": [
    "1f636",
    "awkward",
    "blank",
    "calada",
    "calado",
    "expressionless",
    "face",
    "face without mouth",
    "mouth",
    "mouthless",
    "mute",
    "quiet",
    "quieto",
    "rosto",
    "rosto sem boca",
    "secret",
    "sem boca",
    "sem comentarios",
    "sem palavras",
    "silence",
    "silent",
    "smileys",
    "speechless"
  ],
  "🫥": [
    "1fae5",
    "depressed",
    "deprimida",
    "desaparecer",
    "disappear",
    "dotted",
    "dotted line face",
    "esconder",
    "escondido",
    "face",
    "hidden",
    "hide",
    "indiferenca",
    "introvert",
    "introvertido",
    "invisible",
    "invisivel",
    "line",
    "meh",
    "rosto com linha pontilhada",
    "smileys",
    "tanto faz",
    "whatever",
    "wtv"
  ],
  "😐": [
    "1f610",
    "awkward",
    "blank",
    "deadpan",
    "expressionless",
    "face",
    "fine",
    "jealous",
    "meh",
    "neutral",
    "neutral face",
    "neutro",
    "oh",
    "putz",
    "rosto",
    "rosto neutro",
    "rosto sem emocao",
    "sem comentarios",
    "sem emocao",
    "sem reacao",
    "shade",
    "smileys",
    "straight",
    "unamused",
    "unhappy",
    "unimpressed",
    "whatever"
  ],
  "🫤": [
    "1fae4",
    "cetico",
    "confusao",
    "confused",
    "confusion",
    "decepcao",
    "desapontado",
    "diagonal",
    "disappointed",
    "doubt",
    "doubtful",
    "duvida",
    "face",
    "face with diagonal mouth",
    "frustracao",
    "frustrated",
    "frustration",
    "indiferenca",
    "inseguro",
    "meh",
    "mouth",
    "rosto com boca diagonal",
    "skeptical",
    "smileys",
    "tanto faz",
    "unsure",
    "whatever",
    "wtv"
  ],
  "😑": [
    "1f611",
    "aff",
    "awkward",
    "dead",
    "expressionless",
    "expressionless face",
    "face",
    "fine",
    "inespressiva",
    "inespressivo",
    "inexpressive",
    "jealous",
    "meh",
    "nada a dizer",
    "not",
    "oh",
    "omg",
    "rosto",
    "rosto inexpressivo",
    "sem comentarios",
    "sem expressao",
    "smileys",
    "straight",
    "tanto faz",
    "uh",
    "unhappy",
    "unimpressed",
    "whatever"
  ],
  "🫨": [
    "1fae8",
    "choque",
    "crazy",
    "daze",
    "earthquake",
    "face",
    "louco",
    "loucura",
    "meu deus",
    "omg",
    "panic",
    "panico",
    "rosto",
    "rosto tremendo",
    "shaking",
    "shaking face",
    "shock",
    "smileys",
    "surpresa",
    "surprise",
    "susto",
    "terremoto",
    "tremendo",
    "vibracao",
    "vibrar",
    "vibrate",
    "whoa",
    "wow"
  ],
  "😬": [
    "1f62c",
    "awk",
    "awkward",
    "careta",
    "dentist",
    "face",
    "fazendo careta",
    "grimace",
    "grimacing",
    "grimacing face",
    "grinning",
    "rosto",
    "rosto expressando desagrado",
    "rosto fazendo careta",
    "sem graca",
    "smile",
    "smileys",
    "smiling"
  ],
  "🙄": [
    "1f644",
    "eyeroll",
    "eyes",
    "face",
    "face with rolling eyes",
    "olhando para cima",
    "olhos",
    "revirando os olhos",
    "rolando os olhos",
    "rolling",
    "rosto",
    "rosto com olhos revirados",
    "shade",
    "smileys",
    "tanto faz",
    "ugh",
    "virando os olhos",
    "whatever"
  ],
  "😯": [
    "1f62f",
    "epic",
    "espantado",
    "face",
    "hushed",
    "hushed face",
    "omg",
    "rosto",
    "rosto surpreso",
    "smileys",
    "stunned",
    "surpreso",
    "surprised",
    "uau",
    "whoa",
    "woah"
  ],
  "😦": [
    "1f626",
    "aberta",
    "assustado",
    "boca",
    "caught",
    "decepcionado",
    "face",
    "frown",
    "frowning",
    "frowning face with open mouth",
    "guard",
    "inesperado",
    "mouth",
    "open",
    "rosto assustado",
    "rosto franzido com boca aberta",
    "scared",
    "scary",
    "smileys",
    "surprise",
    "uau",
    "what",
    "wow"
  ],
  "😧": [
    "1f627",
    "anguished",
    "anguished face",
    "angustiado",
    "face",
    "forgot",
    "rosto",
    "rosto angustiado",
    "scared",
    "scary",
    "smileys",
    "sofrendo",
    "stressed",
    "surprise",
    "unhappy",
    "what",
    "wow"
  ],
  "😮": [
    "1f62e",
    "believe",
    "boca",
    "boca aberta",
    "boquiaberto",
    "empatia",
    "face",
    "face with open mouth",
    "forgot",
    "mouth",
    "omg",
    "open",
    "pasmo",
    "rosto",
    "rosto com boca aberta",
    "shocked",
    "smileys",
    "surprised",
    "sympathy",
    "unbelievable",
    "unreal",
    "whoa",
    "wow",
    "you"
  ],
  "😲": [
    "1f632",
    "astonished",
    "astonished face",
    "chocado",
    "cost",
    "estupefato",
    "face",
    "no",
    "omg",
    "rosto",
    "rosto espantado",
    "shocked",
    "smileys",
    "totally",
    "totalmente chocado",
    "way"
  ],
  "🥱": [
    "1f971",
    "bedtime",
    "bocejo",
    "bored",
    "cansada",
    "cansado",
    "com sono",
    "entediada",
    "entediado",
    "face",
    "goodnight",
    "nap",
    "night",
    "rosto bocejando",
    "sleep",
    "sleepy",
    "smileys",
    "sono",
    "tired",
    "whatever",
    "yawn",
    "yawning",
    "yawning face",
    "zzz"
  ],
  "🫩": [
    "1fae9",
    "bags",
    "bored",
    "cansaco",
    "cansada",
    "cansado",
    "dorminhoco",
    "exausta",
    "exausto",
    "exhausted",
    "eyes",
    "face",
    "face with bags under eyes",
    "fatigued",
    "late",
    "olheiras",
    "rosto com bolsas embaixo dos olhos",
    "rosto com olheiras",
    "sleepy",
    "smileys",
    "tired",
    "weary"
  ],
  "😴": [
    "1f634",
    "bed",
    "bedtime",
    "boa noite",
    "cama",
    "cansada",
    "cansado",
    "cochilo",
    "dormindo",
    "dormir",
    "face",
    "good",
    "goodnight",
    "nap",
    "night",
    "rosto",
    "rosto dormindo",
    "sleep",
    "sleeping",
    "sleeping face",
    "smileys",
    "soneca",
    "sono",
    "tired",
    "whatever",
    "yawn",
    "zzz"
  ],
  "🤤": [
    "1f924",
    "babando",
    "babar",
    "drooling",
    "drooling face",
    "face",
    "rosto",
    "rosto babando",
    "salivando",
    "smileys"
  ],
  "😪": [
    "1f62a",
    "cara de sono",
    "crying",
    "face",
    "good",
    "night",
    "rosto",
    "rosto com sono",
    "rosto sonolento",
    "sad",
    "sleep",
    "sleeping",
    "sleepy",
    "sleepy face",
    "smileys",
    "tired"
  ],
  "😮‍💨": [
    "1f62e-200d-1f4a8",
    "alivio",
    "assobio",
    "assopro",
    "blow",
    "blowing",
    "cansaco",
    "cansada",
    "choque",
    "exalar",
    "exausta",
    "exhale",
    "exhaling",
    "exhausted",
    "face",
    "face exhaling",
    "fumaca",
    "gasp",
    "groan",
    "relief",
    "rosto exalando",
    "sigh",
    "smiley",
    "smileys",
    "smoke",
    "suspiro",
    "triste",
    "whisper",
    "whistle"
  ],
  "😵": [
    "1f635",
    "acabado",
    "atordoado",
    "crossed-out",
    "dead",
    "dizzy",
    "doente",
    "eyes",
    "face",
    "face with crossed-out eyes",
    "feels",
    "knocked",
    "morto",
    "out",
    "rosto",
    "rosto atordoado",
    "sick",
    "smileys",
    "tired",
    "tontura"
  ],
  "😵‍💫": [
    "1f635-200d-1f4ab",
    "caramba",
    "confused",
    "confuso",
    "desnorteado",
    "dizzy",
    "eita",
    "espirais",
    "eyes",
    "face",
    "face with spiral eyes",
    "hipnotizado",
    "hypnotized",
    "omg",
    "problema",
    "putz",
    "rosto com olhos em espiral",
    "smiley",
    "smileys",
    "spiral",
    "tonto",
    "tontura",
    "trouble",
    "uau",
    "whoa",
    "woah",
    "woozy"
  ],
  "🤐": [
    "1f910",
    "boca fechada",
    "calada",
    "calado",
    "face",
    "keep",
    "mouth",
    "quiet",
    "quieta",
    "quieto",
    "rosto",
    "rosto com boca de ziper",
    "secret",
    "segredo",
    "shut",
    "smileys",
    "zip",
    "ziper",
    "zipper",
    "zipper-mouth",
    "zipper-mouth face"
  ],
  "🥴": [
    "1f974",
    "alcoolizado",
    "bebada",
    "bebado",
    "boca ondulada",
    "dizzy",
    "drunk",
    "embriagada",
    "embriagado",
    "eyes",
    "face",
    "intoxicado",
    "intoxicated",
    "mouth",
    "olhos tortos",
    "rosto",
    "rosto embriagado",
    "smileys",
    "tipsy",
    "tonta",
    "tonto",
    "uneven",
    "wavy",
    "woozy",
    "woozy face"
  ],
  "🤢": [
    "1f922",
    "doente",
    "enjoado",
    "enjoo",
    "face",
    "gross",
    "nasty",
    "nausea",
    "nauseated",
    "nauseated face",
    "rosto nauseado",
    "sick",
    "smileys",
    "vomit",
    "vomito"
  ],
  "🤮": [
    "1f92e",
    "barf",
    "doente",
    "ew",
    "face",
    "face vomiting",
    "gross",
    "nojenta",
    "nojento",
    "nojo",
    "puke",
    "rosto vomitando",
    "sick",
    "smileys",
    "spew",
    "throw",
    "up",
    "vomit",
    "vomitando",
    "vomiting",
    "vomito"
  ],
  "🤧": [
    "1f927",
    "de cama",
    "doente",
    "espirrando",
    "espirro",
    "face",
    "fever",
    "flu",
    "gesundheit",
    "gripado",
    "resfriado",
    "rosto espirrando",
    "sick",
    "smileys",
    "sneeze",
    "sneezing",
    "sneezing face"
  ],
  "😷": [
    "1f637",
    "cold",
    "dentist",
    "dermatologist",
    "doctor",
    "doente",
    "dr",
    "face",
    "face with medical mask",
    "germs",
    "gripado",
    "mascara",
    "mascara medica",
    "mask",
    "medical",
    "medicine",
    "resfriado",
    "rosto",
    "rosto com mascara",
    "rosto com mascara medica",
    "sick",
    "smileys"
  ],
  "🤒": [
    "1f912",
    "de cama",
    "doente",
    "face",
    "face with thermometer",
    "febre",
    "febril",
    "ill",
    "rosto",
    "rosto com termometro",
    "sick",
    "smileys",
    "termometro",
    "thermometer"
  ],
  "🤕": [
    "1f915",
    "acidentado",
    "bandage",
    "doente",
    "face",
    "face with head-bandage",
    "ferimento",
    "head-bandage",
    "hurt",
    "injury",
    "machucado",
    "ouch",
    "rosto",
    "rosto com atadura na cabeca",
    "rosto com curativos",
    "smileys"
  ],
  "🤑": [
    "1f911",
    "avarenta",
    "caro",
    "cifrao",
    "dinheiro",
    "face",
    "ganancia",
    "grana",
    "money",
    "money-mouth",
    "money-mouth face",
    "mouth",
    "paid",
    "rica",
    "riqueza",
    "rosto com cifroes",
    "smileys"
  ],
  "🤠": [
    "1f920",
    "cara",
    "cara de cauboi",
    "cauboi",
    "cowboy",
    "cowboy hat face",
    "cowgirl",
    "face",
    "hat",
    "rosto",
    "rosto com chapeu de cauboi",
    "sertanejo",
    "smileys",
    "vaqueiro"
  ],
  "😈": [
    "1f608",
    "cara",
    "chifres",
    "demon",
    "devil",
    "diabinho",
    "diabo",
    "evil",
    "face",
    "fairy",
    "fairytale",
    "fantasy",
    "horns",
    "malicia",
    "purple",
    "rosto",
    "rosto sorridente com chifres",
    "roxa",
    "shade",
    "smile",
    "smileys",
    "smiling",
    "smiling face with horns",
    "sorridente",
    "sorriso",
    "tale"
  ],
  "👿": [
    "1f47f",
    "angry",
    "angry face with horns",
    "bravo",
    "chifres",
    "demon",
    "demonio",
    "devil",
    "diabinho",
    "diabo",
    "evil",
    "face",
    "fairy",
    "fairytale",
    "fantasy",
    "horns",
    "imp",
    "mischievous",
    "purple",
    "rosto",
    "rosto zangado com chifres",
    "shade",
    "smileys",
    "tale",
    "zangado"
  ],
  "👹": [
    "1f479",
    "assustador",
    "conto de fadas",
    "creature",
    "demoniaco",
    "devil",
    "face",
    "fairy",
    "fairytale",
    "fantasy",
    "japones",
    "malvado",
    "mascara",
    "mask",
    "monster",
    "monstro",
    "ogre",
    "ogro",
    "oni",
    "rosto",
    "scary",
    "smileys",
    "tale"
  ],
  "👺": [
    "1f47a",
    "angry",
    "bravo",
    "conto",
    "creature",
    "duende",
    "duende japones",
    "face",
    "fadas",
    "fairy",
    "fairytale",
    "fantasy",
    "goblin",
    "japones",
    "mascara",
    "mask",
    "mean",
    "monster",
    "monstro",
    "raiva",
    "rosto",
    "smileys",
    "tale",
    "tengu",
    "zangado"
  ],
  "🤡": [
    "1f921",
    "cara",
    "circo",
    "clown",
    "clown face",
    "engracado",
    "face",
    "palhaco",
    "piada",
    "rosto",
    "rosto de palhaco",
    "smileys"
  ],
  "💩": [
    "1f4a9",
    "bs",
    "coco",
    "comic",
    "doo",
    "dung",
    "estrume",
    "excremento",
    "face",
    "fezes",
    "fml",
    "monster",
    "pile",
    "pile of poo",
    "pilha",
    "poo",
    "poop",
    "smelly",
    "smh",
    "smileys",
    "stink",
    "stinks",
    "stinky",
    "turd"
  ],
  "👻": [
    "1f47b",
    "assombracao",
    "assombrado",
    "boo",
    "buu",
    "conto",
    "creature",
    "excited",
    "face",
    "fadas",
    "fairy",
    "fairytale",
    "fantasma",
    "fantasy",
    "ghost",
    "halloween",
    "haunting",
    "monster",
    "rosto",
    "scary",
    "silly",
    "smileys",
    "tale"
  ],
  "💀": [
    "1f480",
    "body",
    "caveira",
    "conto",
    "corpo",
    "dead",
    "death",
    "face",
    "fadas",
    "fairy",
    "fairytale",
    "i’m",
    "lmao",
    "monster",
    "morte",
    "rosto",
    "skull",
    "smileys",
    "tale",
    "yolo"
  ],
  "☠️": [
    "2620",
    "bone",
    "caveira",
    "caveira e ossos cruzados",
    "crossbones",
    "dead",
    "death",
    "face",
    "monster",
    "morte",
    "ossos",
    "ossos cruzados",
    "pirata",
    "skull",
    "skull and crossbones",
    "smileys"
  ],
  "👽": [
    "1f47d",
    "alien",
    "alienigena",
    "creature",
    "extraterrestre",
    "extraterrestrial",
    "face",
    "fairy",
    "fairytale",
    "fantasy",
    "monster",
    "ovni",
    "rosto",
    "smileys",
    "space",
    "tale",
    "ufo"
  ],
  "👾": [
    "1f47e",
    "alien",
    "alien monster",
    "creature",
    "e.t.",
    "extraterrestre",
    "extraterrestrial",
    "face",
    "fairy",
    "fairytale",
    "fantasy",
    "game",
    "gamer",
    "games",
    "invasores",
    "monster",
    "monstro",
    "monstro alienigena",
    "ovni",
    "pixelado",
    "pixelated",
    "smileys",
    "space",
    "tale",
    "ufo"
  ],
  "🤖": [
    "1f916",
    "face",
    "monster",
    "monstro",
    "robo",
    "robot",
    "robotizado",
    "rosto",
    "rosto de robo",
    "smileys"
  ],
  "🎃": [
    "1f383",
    "abobora",
    "abobora de halloween",
    "celebration",
    "comemoracao",
    "dia das bruxas",
    "halloween",
    "jack",
    "jack-o-lantern",
    "lantern",
    "lanterna",
    "pumpkin",
    "smileys"
  ],
  "😺": [
    "1f63a",
    "aberta",
    "animal",
    "boca",
    "cat",
    "face",
    "feliz",
    "gato",
    "grinning",
    "grinning cat",
    "mouth",
    "open",
    "rosto",
    "rosto de gato sorrindo",
    "smile",
    "smileys",
    "smiling",
    "sorrindo",
    "sorriso"
  ],
  "😸": [
    "1f638",
    "animal",
    "cat",
    "eye",
    "eyes",
    "face",
    "gato",
    "grin",
    "grinning",
    "grinning cat with smiling eyes",
    "rindo",
    "riso",
    "rosto",
    "rosto de gato sorrindo com olhos sorridentes",
    "smile",
    "smileys",
    "smiling",
    "sorrindo",
    "sorriso"
  ],
  "😹": [
    "1f639",
    "alegria",
    "animal",
    "cat",
    "cat with tears of joy",
    "chorando",
    "choro",
    "engracado",
    "face",
    "felicidade",
    "feliz",
    "gato",
    "joy",
    "lagrimas",
    "laugh",
    "laughing",
    "lol",
    "rir",
    "risos",
    "rosto",
    "rosto de gato com lagrimas de alegria",
    "smileys",
    "tear",
    "tears"
  ],
  "😻": [
    "1f63b",
    "adorei",
    "amor",
    "animal",
    "apaixonado",
    "cat",
    "coracao",
    "eye",
    "face",
    "gato",
    "heart",
    "heart-eyes",
    "love",
    "paixao",
    "rosto",
    "rosto de gato sorridente com olhos de coracao",
    "smile",
    "smileys",
    "smiling",
    "smiling cat with heart-eyes",
    "sorriso"
  ],
  "😼": [
    "1f63c",
    "animal",
    "cat",
    "cat with wry smile",
    "face",
    "gato",
    "ironic",
    "ironico",
    "rosto",
    "rosto de gato com sorriso ironico",
    "smile",
    "smileys",
    "sorriso",
    "wry"
  ],
  "😽": [
    "1f63d",
    "animal",
    "beijando",
    "beijo",
    "cat",
    "closed",
    "eye",
    "eyes",
    "face",
    "fechado",
    "gato",
    "kiss",
    "kissing",
    "kissing cat",
    "olho",
    "rosto",
    "rosto de gato mandando um beijo",
    "smileys"
  ],
  "🙀": [
    "1f640",
    "animal",
    "cat",
    "choque",
    "desolado",
    "face",
    "gato",
    "meu deus",
    "oh",
    "oh!",
    "rosto",
    "rosto de gato desolado",
    "smileys",
    "surpresa",
    "surpreso",
    "surprised",
    "weary",
    "weary cat"
  ],
  "😿": [
    "1f63f",
    "animal",
    "cat",
    "chorando",
    "choro",
    "cry",
    "crying",
    "crying cat",
    "face",
    "gato",
    "lagrima",
    "rosto",
    "rosto de gato chorando",
    "sad",
    "smileys",
    "tear",
    "triste"
  ],
  "😾": [
    "1f63e",
    "animal",
    "bico",
    "bravo",
    "cat",
    "face",
    "gato",
    "mal-humorado",
    "pouting",
    "pouting cat",
    "rosto",
    "rosto de gato mal-humorado",
    "smileys"
  ],
  "🫶": [
    "1faf6",
    "<3",
    "amei",
    "amo voce",
    "amor",
    "coracao",
    "hands",
    "heart",
    "heart hands",
    "love",
    "mao",
    "maos",
    "maos de coracao",
    "smileys",
    "te amo",
    "you"
  ],
  "🤲": [
    "1f932",
    "cima",
    "cupped",
    "devocao",
    "dua",
    "hands",
    "juntas",
    "oracao",
    "palmas",
    "palmas unidas para cima",
    "palms",
    "palms up together",
    "pray",
    "prayer",
    "smileys",
    "together",
    "unidas",
    "up",
    "wish"
  ],
  "👐": [
    "1f450",
    "abertas",
    "hand",
    "hands",
    "hug",
    "jazz",
    "mao",
    "maos abertas",
    "open",
    "open hands",
    "sinal",
    "sinal de maos abertas",
    "smileys",
    "swerve"
  ],
  "🙌": [
    "1f64c",
    "ambas as maos",
    "celebration",
    "comemoracao",
    "gesture",
    "hand",
    "hands",
    "hooray",
    "levantando ambas as maos para comemorar",
    "maos para cima",
    "praise",
    "raised",
    "raising",
    "raising hands",
    "smileys",
    "viva"
  ],
  "👏": [
    "1f44f",
    "aplauso",
    "applause",
    "approval",
    "awesome",
    "bom trabalho",
    "clap",
    "clapping hands",
    "congrats",
    "congratulations",
    "excited",
    "good",
    "great",
    "hand",
    "homie",
    "job",
    "maos",
    "maos aplaudindo",
    "nice",
    "palmas",
    "parabens",
    "prayed",
    "sinal",
    "smileys",
    "well",
    "yay"
  ],
  "🤝": [
    "1f91d",
    "agreement",
    "aperto",
    "aperto de maos",
    "combinado",
    "cumprimento",
    "deal",
    "hand",
    "handshake",
    "maos",
    "meeting",
    "shake",
    "smileys"
  ],
  "👍": [
    "+1",
    "1f44d",
    "beleza",
    "cima",
    "concordo",
    "dedao",
    "good",
    "hand",
    "joia",
    "like",
    "mao",
    "ok",
    "polegar",
    "polegar para cima",
    "sim",
    "sinal",
    "smileys",
    "thumb",
    "thumbs up",
    "up",
    "valeu",
    "yes"
  ],
  "👎": [
    "-1",
    "1f44e",
    "bad",
    "dedao",
    "dedao para baixo",
    "desaprovacao",
    "desaprovado",
    "dislike",
    "down",
    "good",
    "hand",
    "mao",
    "nao",
    "nao gostei",
    "no",
    "nope",
    "para baixo",
    "polegar para baixo",
    "ruim",
    "sinal",
    "smileys",
    "thumb",
    "thumbs",
    "thumbs down"
  ],
  "👊": [
    "1f44a",
    "absolutely",
    "agree",
    "beleza",
    "boom",
    "bro",
    "bruh",
    "bump",
    "clenched",
    "correct",
    "fechado",
    "fist",
    "forca",
    "hand",
    "knuckle",
    "mao",
    "oncoming",
    "oncoming fist",
    "pound",
    "punch",
    "punho",
    "rock",
    "smileys",
    "soco",
    "ta ligado",
    "ttyl"
  ],
  "✊": [
    "270a",
    "clenched",
    "fist",
    "hand",
    "pedra",
    "punch",
    "punho",
    "punho erguido",
    "punho levantado",
    "raised",
    "raised fist",
    "smileys",
    "solidariedade",
    "solidarity"
  ],
  "🤛": [
    "1f91b",
    "esquerdo",
    "fechada",
    "fist",
    "left-facing",
    "left-facing fist",
    "leftwards",
    "mao",
    "punho",
    "punho esquerdo",
    "smileys",
    "soco"
  ],
  "🤜": [
    "1f91c",
    "direito",
    "fist",
    "punho",
    "punho direito",
    "right-facing",
    "right-facing fist",
    "rightwards",
    "smileys",
    "soco"
  ],
  "🫷": [
    "1faf7",
    "bate aqui",
    "block",
    "bloquear",
    "empurrar",
    "esperar",
    "esquerda",
    "five",
    "halt",
    "hand",
    "high",
    "high five",
    "hold",
    "leftward",
    "leftwards",
    "leftwards pushing hand",
    "mao",
    "mao empurrando para a esquerda",
    "parar",
    "pausar",
    "pause",
    "push",
    "pushing",
    "recusar",
    "refuse",
    "slap",
    "smileys",
    "stop",
    "toca aqui",
    "wait"
  ],
  "🫸": [
    "1faf8",
    "bate aqui",
    "block",
    "bloquear",
    "direita",
    "empurrar",
    "esperar",
    "five",
    "halt",
    "hand",
    "high",
    "high five",
    "hold",
    "mao",
    "mao empurrando para a direita",
    "parar",
    "pausar",
    "pause",
    "push",
    "pushing",
    "recusar",
    "refuse",
    "rightward",
    "rightwards",
    "rightwards pushing hand",
    "slap",
    "smileys",
    "stop",
    "toca aqui",
    "wait"
  ],
  "🤞": [
    "1f91e",
    "boa sorte",
    "cross",
    "crossed",
    "crossed fingers",
    "cruzados",
    "dedos",
    "dedos cruzados",
    "finger",
    "fingers",
    "hand",
    "luck",
    "mao",
    "smileys",
    "sorte",
    "torcendo"
  ],
  "✌️": [
    "270c",
    "beleza",
    "hand",
    "mao",
    "mao em v de vitoria",
    "paz",
    "peace",
    "sim",
    "smileys",
    "v",
    "v de vitoria",
    "victory",
    "victory hand",
    "vitoria"
  ],
  "🫰": [
    "1faf0",
    "<3",
    "amor",
    "army",
    "caro",
    "coracao",
    "crossed",
    "dinheiro",
    "estalar",
    "expensive",
    "finger",
    "hand",
    "hand with index finger and thumb crossed",
    "heart",
    "index",
    "k-pop",
    "kpop",
    "love",
    "mao",
    "mao com dedo indicador e polegar cruzados",
    "money",
    "smileys",
    "snap",
    "thumb"
  ],
  "🤟": [
    "1f91f",
    "amor",
    "fingers",
    "gesto",
    "gesto de \"te amo\"",
    "gesture",
    "hand",
    "ily",
    "love",
    "love-you",
    "love-you gesture",
    "mao",
    "smileys",
    "te amo",
    "three",
    "you"
  ],
  "🤘": [
    "1f918",
    "chifres",
    "dedos",
    "finger",
    "hand",
    "horns",
    "mao",
    "metal",
    "rock",
    "rock-on",
    "saudacao do rock",
    "sign",
    "sign of the horns",
    "smileys"
  ],
  "👌": [
    "1f44c",
    "awesome",
    "beliscar",
    "bet",
    "certo",
    "concordo",
    "dope",
    "fleek",
    "fosho",
    "got",
    "gotcha",
    "hand",
    "legit",
    "mao",
    "ok",
    "ok hand",
    "okay",
    "otimo",
    "pinch",
    "rad",
    "rude",
    "sinal",
    "sinal de ok",
    "sinalizando",
    "smileys",
    "sure",
    "sweet",
    "three"
  ],
  "🤌": [
    "1f90c",
    "beliscado",
    "coxinha",
    "dedos",
    "dedos comprimidos",
    "fingers",
    "gesto de mao",
    "gesture",
    "ha",
    "hand",
    "hold",
    "huh",
    "interrogacao",
    "interrogation",
    "italia",
    "italiana",
    "mao",
    "maravilha",
    "o que",
    "patience",
    "pinched",
    "pinched fingers",
    "relax",
    "sarcastic",
    "sarcastico",
    "smileys",
    "ugh",
    "what",
    "zip"
  ],
  "🤏": [
    "1f90f",
    "amount",
    "beliscar",
    "bit",
    "fingers",
    "hand",
    "little",
    "mao",
    "mao beliscando",
    "pequena quantidade",
    "pequeno",
    "pinching",
    "pinching hand",
    "pouco",
    "pouquinho",
    "small",
    "smileys",
    "sort"
  ],
  "🫳": [
    "1faf3",
    "cair",
    "derrubar",
    "descartar",
    "dismiss",
    "down",
    "drop",
    "dropped",
    "hand",
    "mao",
    "mao com a palma para baixo",
    "palm",
    "palm down hand",
    "pegar",
    "pick",
    "segurar",
    "shoo",
    "smileys",
    "soltar",
    "up",
    "xo"
  ],
  "🫴": [
    "1faf4",
    "acenar",
    "beckon",
    "catch",
    "come",
    "hand",
    "hold",
    "know",
    "levantar",
    "lift",
    "mao",
    "mao com a palma para cima",
    "me",
    "oferecer",
    "offer",
    "palm",
    "palm up hand",
    "pegar",
    "segurar",
    "smileys",
    "tell",
    "venha"
  ],
  "👈": [
    "1f448",
    "backhand",
    "backhand index pointing left",
    "costas",
    "dedo",
    "dorso",
    "dorso da mao com indicador apontando para a esquerda",
    "esquerda",
    "finger",
    "hand",
    "index",
    "indicador",
    "left",
    "mao",
    "point",
    "pointing",
    "smileys"
  ],
  "👉": [
    "1f449",
    "apontar",
    "backhand",
    "backhand index pointing right",
    "costas",
    "dedo",
    "direita",
    "dorso",
    "dorso da mao com indicador apontando para a direita",
    "finger",
    "hand",
    "index",
    "indicador",
    "mao",
    "point",
    "pointing",
    "right",
    "smileys"
  ],
  "👆": [
    "1f446",
    "backhand",
    "backhand index pointing up",
    "cima",
    "costas",
    "dedo",
    "dedo para cima",
    "dorso",
    "dorso da mao com indicador apontando para cima",
    "finger",
    "hand",
    "index",
    "indicador",
    "mao",
    "point",
    "pointing",
    "smileys",
    "up"
  ],
  "👇": [
    "1f447",
    "abaixo",
    "backhand",
    "backhand index pointing down",
    "costas da mao",
    "dedo",
    "dedo apontado para baixo",
    "dedo indicador",
    "dedo para baixo",
    "dorso da mao com dedo indicador apontando para baixo",
    "dorso da mao com indicador apontando para baixo",
    "down",
    "embaixo",
    "finger",
    "hand",
    "index",
    "point",
    "pointing",
    "smileys"
  ],
  "☝️": [
    "261d",
    "dedo",
    "dedo apontando para cima",
    "eu",
    "finger",
    "hand",
    "index",
    "index pointing up",
    "indicador",
    "indicador apontando para cima",
    "mao",
    "point",
    "pointing",
    "smileys",
    "this",
    "up"
  ],
  "✋": [
    "270b",
    "5",
    "cinco",
    "erguida",
    "five",
    "hand",
    "high",
    "high five",
    "levantada",
    "mao",
    "mao levantada",
    "papel",
    "pare",
    "raised",
    "raised hand",
    "smileys",
    "stop",
    "toca aqui"
  ],
  "🤚": [
    "1f91a",
    "back",
    "backhand",
    "dorso",
    "dorso da mao levantado",
    "hand",
    "levantada",
    "levantado",
    "mao",
    "para tudo",
    "pare",
    "raised",
    "raised back of hand",
    "smileys"
  ],
  "🖐️": [
    "1f590",
    "5",
    "aberta",
    "cinco",
    "dedos",
    "finger",
    "fingers",
    "hand",
    "hand with fingers splayed",
    "mao",
    "mao aberta com os dedos separados",
    "palma",
    "pare",
    "raised",
    "separados",
    "smileys",
    "splayed",
    "stop"
  ],
  "🖖": [
    "1f596",
    "dedos",
    "finger",
    "hand",
    "hands",
    "jornada nas estrelas",
    "mao",
    "salute",
    "saudacao",
    "saudacao star trek",
    "saudacao vulcana",
    "smileys",
    "spock",
    "star trek",
    "startrek",
    "vulcan",
    "vulcan salute"
  ],
  "👋": [
    "1f44b",
    "acenando",
    "aceno",
    "ate mais",
    "bye",
    "cya",
    "esta ai?",
    "flw",
    "g2g",
    "greetings",
    "gtg",
    "hand",
    "hello",
    "hey",
    "hi",
    "later",
    "mao",
    "mao acenando",
    "oi",
    "ola",
    "outtie",
    "smileys",
    "tai?",
    "tchau",
    "ttfn",
    "ttyl",
    "wave",
    "waving hand",
    "yo",
    "you"
  ],
  "🤙": [
    "1f919",
    "call",
    "call me hand",
    "hand",
    "hang",
    "legal",
    "ligar",
    "loose",
    "mao",
    "me",
    "me liga",
    "shaka",
    "sinal \"me liga\"",
    "smileys"
  ],
  "🫲": [
    "1faf2",
    "apertar",
    "esquerda",
    "hand",
    "handshake",
    "hold",
    "left",
    "leftward",
    "leftwards",
    "leftwards hand",
    "mao",
    "mao para a esquerda",
    "pegar",
    "reach",
    "segurar",
    "shake",
    "smileys"
  ],
  "🫱": [
    "1faf1",
    "apertar",
    "aperto",
    "direita",
    "hand",
    "handshake",
    "hold",
    "mao",
    "mao para a direita",
    "pegar",
    "reach",
    "right",
    "rightward",
    "rightwards",
    "rightwards hand",
    "segurar",
    "shake",
    "smileys"
  ],
  "💪": [
    "1f4aa",
    "academia",
    "arm",
    "beast",
    "bench",
    "biceps",
    "bodybuilder",
    "bro",
    "contraido",
    "curls",
    "engracado",
    "flex",
    "flexed biceps",
    "forte",
    "gains",
    "gym",
    "jacked",
    "muscle",
    "musculacao",
    "musculo",
    "press",
    "ripped",
    "smileys",
    "strong",
    "weightlift"
  ],
  "🦾": [
    "1f9be",
    "accessibility",
    "acessibilidade",
    "arm",
    "braco mecanico",
    "mechanical",
    "mechanical arm",
    "prosthetic",
    "protese",
    "smileys"
  ],
  "🖕": [
    "1f595",
    "dedo",
    "dedo do meio",
    "finger",
    "gesto ofensivo",
    "hand",
    "mao",
    "middle",
    "middle finger",
    "smileys"
  ],
  "✍️": [
    "270d",
    "caneta",
    "escrevendo",
    "escrevendo a mao",
    "hand",
    "mao",
    "smileys",
    "write",
    "writing",
    "writing hand"
  ],
  "🙏": [
    "1f64f",
    "appreciate",
    "ask",
    "beg",
    "blessed",
    "bow",
    "cmon",
    "five",
    "folded",
    "folded hands",
    "gesto",
    "gesture",
    "hand",
    "high",
    "mao",
    "maos juntas",
    "please",
    "pray",
    "reza",
    "rezando",
    "rezar",
    "smileys",
    "thanks",
    "thx"
  ],
  "🫵": [
    "1faf5",
    "ai",
    "apontar",
    "at",
    "cutucar",
    "dedo",
    "finger",
    "hand",
    "index",
    "index pointing at the viewer",
    "indicador",
    "indicador apontando para o visualizador",
    "mao",
    "pointing",
    "poke",
    "smileys",
    "tu",
    "viewer",
    "voce",
    "you"
  ],
  "🦶": [
    "1f9b6",
    "ankle",
    "calcanhar",
    "chutar",
    "chute",
    "feet",
    "foot",
    "kick",
    "pe",
    "pisao",
    "pisar",
    "smileys",
    "stomp",
    "tornozelo"
  ],
  "🦵": [
    "1f9b5",
    "bent",
    "chute",
    "foot",
    "joelho",
    "kick",
    "knee",
    "leg",
    "limb",
    "membro",
    "pe",
    "perna",
    "perna dobrada",
    "smileys"
  ],
  "🦿": [
    "1f9bf",
    "accessibility",
    "acessibilidade",
    "leg",
    "mechanical",
    "mechanical leg",
    "perna mecanica",
    "prosthetic",
    "protese",
    "smileys"
  ],
  "💄": [
    "1f484",
    "batom",
    "cosmeticos",
    "cosmetics",
    "date",
    "lipstick",
    "makeup",
    "maquiagem",
    "smileys",
    "vermelho"
  ],
  "💋": [
    "1f48b",
    "beijo",
    "dating",
    "emotion",
    "heart",
    "kiss",
    "kiss mark",
    "kissing",
    "labios",
    "lips",
    "marca de beijo",
    "mark",
    "romance",
    "sexy",
    "smileys"
  ],
  "👄": [
    "1f444",
    "batom",
    "beauty",
    "beijo",
    "boca",
    "body",
    "corpo",
    "kiss",
    "kissing",
    "labios",
    "lips",
    "lipstick",
    "mouth",
    "rosto",
    "smileys"
  ],
  "🫦": [
    "1fae6",
    "ansioso",
    "anxious",
    "batom",
    "beijo",
    "bite",
    "biting",
    "biting lip",
    "fear",
    "flertar",
    "flirt",
    "flirting",
    "kiss",
    "labios",
    "lip",
    "lipstick",
    "medo",
    "mordendo o labio",
    "mordida",
    "nervoso",
    "nervous",
    "preocupacao",
    "seducao",
    "sexy",
    "smileys",
    "uncomfortable",
    "vontade",
    "worried",
    "worry"
  ],
  "🦷": [
    "1f9b7",
    "branco",
    "dente",
    "dentist",
    "dentista",
    "pearly",
    "smileys",
    "teeth",
    "tooth",
    "white"
  ],
  "👅": [
    "1f445",
    "body",
    "corpo",
    "lick",
    "lingua",
    "rosto",
    "slurp",
    "smileys",
    "tongue"
  ],
  "👂": [
    "1f442",
    "body",
    "corpo",
    "ear",
    "ears",
    "escutar",
    "hear",
    "hearing",
    "listen",
    "listening",
    "orelha",
    "ouvido",
    "smileys",
    "sound"
  ],
  "🦻": [
    "1f9bb",
    "accessibility",
    "acessibilidade",
    "aid",
    "aparelho auditivo",
    "deficiencia auditiva",
    "ear",
    "ear with hearing aid",
    "hard",
    "hearing",
    "ouvido com aparelho auditivo",
    "smileys",
    "surda",
    "surdo"
  ],
  "👃": [
    "1f443",
    "body",
    "cheirar",
    "cheiro",
    "corpo",
    "nariz",
    "nose",
    "noses",
    "nosey",
    "odor",
    "rosto",
    "smell",
    "smells",
    "smileys"
  ],
  "🫆": [
    "1fac6",
    "clue",
    "crime",
    "detective",
    "fingerprint",
    "forensics",
    "identidade",
    "identity",
    "impressao digital",
    "investigacao forense",
    "mystery",
    "print",
    "safety",
    "seguranca",
    "smileys",
    "trace"
  ],
  "👣": [
    "1f463",
    "barefoot",
    "clothing",
    "corpo",
    "footprint",
    "footprints",
    "gravura",
    "omw",
    "pe",
    "pegadas",
    "pes descalcos",
    "print",
    "rastro",
    "smileys",
    "walk"
  ],
  "👁️": [
    "1",
    "1f441",
    "body",
    "eye",
    "olho",
    "one",
    "parte do corpo",
    "rosto",
    "smileys"
  ],
  "👀": [
    "1f440",
    "body",
    "eye",
    "eyes",
    "face",
    "googly",
    "look",
    "looking",
    "olhando",
    "olho",
    "olhos",
    "omg",
    "peep",
    "rosto",
    "see",
    "seeing",
    "smileys",
    "to de olho"
  ],
  "🫀": [
    "1fac0",
    "anatomia",
    "anatomical",
    "anatomical heart",
    "batimento",
    "batimento cardiaco",
    "beat",
    "cardiologia",
    "cardiology",
    "centro",
    "coracao",
    "coracao humano",
    "coracao vermelho",
    "heart",
    "heartbeat",
    "organ",
    "orgao",
    "pulsacao",
    "pulse",
    "pulso",
    "real",
    "red",
    "s2",
    "smileys"
  ],
  "🫁": [
    "1fac1",
    "anatomia",
    "breath",
    "breathe",
    "espiracao",
    "exalacao",
    "exhalation",
    "inalacao",
    "inhalation",
    "lung",
    "lungs",
    "organ",
    "orgao",
    "pulmao",
    "pulmoes",
    "respiracao",
    "respiration",
    "smileys"
  ],
  "🧠": [
    "1f9e0",
    "brain",
    "cerebro",
    "inteligencia",
    "inteligente",
    "intelligent",
    "smart",
    "smileys"
  ],
  "🗣️": [
    "1f5e3",
    "berro",
    "cabeca",
    "face",
    "falando",
    "grito",
    "head",
    "silhouette",
    "silhueta",
    "silhueta falando",
    "smileys",
    "speak",
    "speaking",
    "speaking head",
    "voz"
  ],
  "👤": [
    "1f464",
    "bust",
    "bust in silhouette",
    "busto",
    "misterio",
    "mysterious",
    "pessoas",
    "shadow",
    "silhouette",
    "silhueta",
    "silhueta de busto",
    "smileys",
    "sombra"
  ],
  "👥": [
    "1f465",
    "amigos",
    "bff",
    "bust",
    "busto",
    "busts",
    "busts in silhouette",
    "dupla",
    "everyone",
    "friend",
    "friends",
    "people",
    "pessoas",
    "silhouette",
    "silhueta",
    "silhueta de bustos",
    "smileys"
  ],
  "🫂": [
    "1fac2",
    "abracando",
    "abraco",
    "adeus",
    "amizade",
    "amor",
    "carinho",
    "comfort",
    "conforto",
    "embrace",
    "farewell",
    "friendship",
    "goodbye",
    "hello",
    "hug",
    "hugging",
    "love",
    "obrigado",
    "ola",
    "people",
    "people hugging",
    "pessoas se abracando",
    "smileys",
    "thanks"
  ],
  "👶": [
    "1f476",
    "babies",
    "baby",
    "bebe",
    "bebezinho",
    "children",
    "goo",
    "gravida",
    "infant",
    "nenem",
    "newborn",
    "pessoas",
    "pregnant",
    "recem-nascido",
    "smileys",
    "young"
  ],
  "👧": [
    "1f467",
    "bright-eyed",
    "child",
    "daughter",
    "filha",
    "garota",
    "girl",
    "granddaughter",
    "kid",
    "menina",
    "menininha",
    "neta",
    "pessoas",
    "smileys",
    "virgo",
    "young",
    "younger",
    "zodiac"
  ],
  "🧒": [
    "1f9d2",
    "bright-eyed",
    "child",
    "crianca",
    "filho",
    "grandchild",
    "jovem",
    "kid",
    "neto",
    "pequeno",
    "smileys",
    "young",
    "younger"
  ],
  "👦": [
    "1f466",
    "boy",
    "bright-eyed",
    "child",
    "garoto",
    "grandson",
    "guri",
    "jovem",
    "kid",
    "loiro",
    "menino",
    "pessoas",
    "pia",
    "smileys",
    "son",
    "young",
    "younger"
  ],
  "👩": [
    "1f469",
    "adult",
    "adulta",
    "garota",
    "guria",
    "lady",
    "loira",
    "menina",
    "mina",
    "mulher",
    "smileys",
    "woman"
  ],
  "🧑": [
    "1f9d1",
    "adult",
    "adulta",
    "adulto",
    "person",
    "pessoa",
    "smileys"
  ],
  "👨": [
    "1f468",
    "adult",
    "adulto",
    "amigo",
    "bro",
    "homem",
    "irmao",
    "man",
    "marido",
    "namorado",
    "smileys"
  ],
  "👩‍🦱": [
    "1f469-200d-1f9b1",
    "adult",
    "adulta",
    "cabelo cacheado",
    "curly hair",
    "garota",
    "guria",
    "lady",
    "loira",
    "menina",
    "mina",
    "mulher",
    "mulher: cabelo cacheado",
    "smileys",
    "woman",
    "woman: curly hair"
  ],
  "🧑‍🦱": [
    "1f9d1-200d-1f9b1",
    "adult",
    "adulta",
    "adulto",
    "cabelo cacheado",
    "curly hair",
    "person",
    "person: curly hair",
    "pessoa",
    "pessoa: cabelo cacheado",
    "smileys"
  ],
  "👨‍🦱": [
    "1f468-200d-1f9b1",
    "adult",
    "adulto",
    "amigo",
    "bro",
    "cabelo cacheado",
    "curly hair",
    "homem",
    "homem: cabelo cacheado",
    "irmao",
    "man",
    "man: curly hair",
    "marido",
    "namorado",
    "smileys"
  ],
  "👩‍🦰": [
    "1f469-200d-1f9b0",
    "adult",
    "adulta",
    "cabelo vermelho",
    "garota",
    "guria",
    "lady",
    "loira",
    "menina",
    "mina",
    "mulher",
    "mulher: cabelo vermelho",
    "red hair",
    "smileys",
    "woman",
    "woman: red hair"
  ],
  "🧑‍🦰": [
    "1f9d1-200d-1f9b0",
    "adult",
    "adulta",
    "adulto",
    "cabelo vermelho",
    "person",
    "person: red hair",
    "pessoa",
    "pessoa: cabelo vermelho",
    "red hair",
    "smileys"
  ],
  "👨‍🦰": [
    "1f468-200d-1f9b0",
    "adult",
    "adulto",
    "amigo",
    "bro",
    "cabelo vermelho",
    "homem",
    "homem: cabelo vermelho",
    "irmao",
    "man",
    "man: red hair",
    "marido",
    "namorado",
    "red hair",
    "smileys"
  ],
  "👱‍♀️": [
    "1f471-200d-2640",
    "blond",
    "blond-haired",
    "blonde",
    "garota",
    "guria",
    "hair",
    "loira",
    "loura",
    "menina",
    "mulher",
    "mulher: cabelo loiro",
    "smileys",
    "woman",
    "woman: blond hair"
  ],
  "👱": [
    "1f471",
    "blond",
    "blond-haired",
    "cabelo",
    "human",
    "loiro",
    "louro",
    "person",
    "person: blond hair",
    "pessoa",
    "pessoa loira",
    "pessoa loura",
    "pessoa: cabelo louro",
    "rosto",
    "smileys"
  ],
  "👱‍♂️": [
    "1f471-200d-2642",
    "blond",
    "blond-haired",
    "cabelo",
    "hair",
    "homem",
    "homem: cabelo loiro",
    "loiro",
    "louro",
    "man",
    "man: blond hair",
    "smileys"
  ],
  "👩‍🦳": [
    "1f469-200d-1f9b3",
    "adult",
    "adulta",
    "cabelo branco",
    "garota",
    "guria",
    "lady",
    "loira",
    "menina",
    "mina",
    "mulher",
    "mulher: cabelo branco",
    "smileys",
    "white hair",
    "woman",
    "woman: white hair"
  ],
  "🧑‍🦳": [
    "1f9d1-200d-1f9b3",
    "adult",
    "adulta",
    "adulto",
    "cabelo branco",
    "person",
    "person: white hair",
    "pessoa",
    "pessoa: cabelo branco",
    "smileys",
    "white hair"
  ],
  "👨‍🦳": [
    "1f468-200d-1f9b3",
    "adult",
    "adulto",
    "amigo",
    "bro",
    "cabelo branco",
    "homem",
    "homem: cabelo branco",
    "irmao",
    "man",
    "man: white hair",
    "marido",
    "namorado",
    "smileys",
    "white hair"
  ],
  "👩‍🦲": [
    "1f469-200d-1f9b2",
    "adult",
    "adulta",
    "bald",
    "careca",
    "garota",
    "guria",
    "lady",
    "loira",
    "menina",
    "mina",
    "mulher",
    "mulher: careca",
    "smileys",
    "woman",
    "woman: bald"
  ],
  "🧑‍🦲": [
    "1f9d1-200d-1f9b2",
    "adult",
    "adulta",
    "adulto",
    "bald",
    "careca",
    "person",
    "person: bald",
    "pessoa",
    "pessoa: careca",
    "smileys"
  ],
  "👨‍🦲": [
    "1f468-200d-1f9b2",
    "adult",
    "adulto",
    "amigo",
    "bald",
    "bro",
    "careca",
    "homem",
    "homem: careca",
    "irmao",
    "man",
    "man: bald",
    "marido",
    "namorado",
    "smileys"
  ],
  "🧔‍♀️": [
    "1f9d4-200d-2640",
    "barba",
    "beard",
    "bearded",
    "mulher",
    "mulher: barba",
    "smileys",
    "whiskers",
    "woman",
    "woman: beard"
  ],
  "🧔": [
    "1f9d4",
    "barba",
    "barbudo",
    "beard",
    "bearded",
    "homem",
    "homem: barba",
    "person",
    "person: beard",
    "pessoa",
    "smileys",
    "whiskers"
  ],
  "🧔‍♂️": [
    "1f9d4-200d-2642",
    "barba",
    "beard",
    "bearded",
    "homem",
    "homem: barba",
    "homem: barbudo",
    "man",
    "man: beard",
    "smileys",
    "whiskers"
  ],
  "👵": [
    "1f475",
    "adult",
    "adulta",
    "elderly",
    "grandma",
    "grandmother",
    "granny",
    "idosa",
    "lady",
    "mulher",
    "old",
    "old woman",
    "pessoas",
    "smileys",
    "velhinha",
    "vovo",
    "vovozinha",
    "wise",
    "woman"
  ],
  "🧓": [
    "1f9d3",
    "adult",
    "adulto",
    "avo",
    "elderly",
    "grandparent",
    "idoso",
    "old",
    "older person",
    "person",
    "sabio",
    "smileys",
    "velho",
    "vovo",
    "wise"
  ],
  "👴": [
    "1f474",
    "adult",
    "adulto",
    "avo",
    "bald",
    "careca",
    "elderly",
    "gramps",
    "grandfather",
    "grandpa",
    "homem",
    "homem idoso",
    "idoso",
    "man",
    "old",
    "old man",
    "pessoas",
    "smileys",
    "vovo",
    "wise"
  ],
  "👲": [
    "1f472",
    "cap",
    "chapeu chines",
    "chinese",
    "gua",
    "gua pi mao",
    "guapi",
    "guapimao",
    "hat",
    "homem com gua pi mao",
    "homem de bone",
    "mao",
    "person",
    "person with skullcap",
    "pessoas",
    "pi",
    "skullcap",
    "smileys"
  ],
  "👳‍♀️": [
    "1f473-200d-2640",
    "mulher",
    "mulher com turbante",
    "smileys",
    "turban",
    "turbante",
    "wearing",
    "woman",
    "woman wearing turban"
  ],
  "👳": [
    "1f473",
    "person",
    "person wearing turban",
    "pessoa",
    "pessoa com turbante",
    "smileys",
    "turban",
    "turbante",
    "wearing"
  ],
  "👳‍♂️": [
    "1f473-200d-2642",
    "homem",
    "homem com turbante",
    "man",
    "man wearing turban",
    "smileys",
    "turban",
    "turbante",
    "wearing"
  ],
  "🧕": [
    "1f9d5",
    "bandana",
    "cabeca",
    "head",
    "headscarf",
    "hijab",
    "kerchief",
    "lenco",
    "mantilla",
    "mulher",
    "mulher com veu",
    "smileys",
    "tichel",
    "woman",
    "woman with headscarf"
  ],
  "👮‍♀️": [
    "1f46e-200d-2640",
    "apprehend",
    "arrest",
    "autoridade",
    "citation",
    "cop",
    "law",
    "mulher",
    "multar",
    "officer",
    "over",
    "police",
    "policia",
    "policial",
    "policial mulher",
    "prender",
    "pulled",
    "smileys",
    "tira",
    "undercover",
    "woman",
    "woman police officer"
  ],
  "👮": [
    "1f46e",
    "apprehend",
    "arrest",
    "autoridade",
    "citation",
    "cop",
    "law",
    "multar",
    "officer",
    "over",
    "pessoa",
    "police",
    "police officer",
    "policia",
    "policial",
    "prender",
    "pulled",
    "smileys",
    "undercover"
  ],
  "👮‍♂️": [
    "1f46e-200d-2642",
    "apprehend",
    "arrest",
    "citation",
    "cop",
    "homem",
    "law",
    "man",
    "man police officer",
    "officer",
    "over",
    "police",
    "policia",
    "policial",
    "policial homem",
    "pulled",
    "smileys",
    "tira",
    "undercover"
  ],
  "👷‍♀️": [
    "1f477-200d-2640",
    "build",
    "capacete",
    "construcao",
    "construction",
    "contrucao",
    "fix",
    "hardhat",
    "hat",
    "man",
    "mulher",
    "operaria",
    "operario",
    "pedreira",
    "pedreiro",
    "rebuild",
    "remodel",
    "repair",
    "smileys",
    "woman",
    "woman construction worker",
    "work",
    "worker"
  ],
  "👷": [
    "1f477",
    "build",
    "capacete",
    "chapeu",
    "construcao",
    "construcao civil",
    "construction",
    "construction worker",
    "construir",
    "fix",
    "hardhat",
    "hat",
    "man",
    "person",
    "pessoa",
    "rebuild",
    "remodel",
    "repair",
    "smileys",
    "trabalhador",
    "trabalhador de construcao civil",
    "work",
    "worker"
  ],
  "👷‍♂️": [
    "1f477-200d-2642",
    "build",
    "construcao",
    "construction",
    "fix",
    "hardhat",
    "hat",
    "homem",
    "man",
    "man construction worker",
    "operario",
    "pedreiro",
    "rebuild",
    "remodel",
    "repair",
    "smileys",
    "work",
    "worker"
  ],
  "💂‍♀️": [
    "1f482-200d-2640",
    "buckingham",
    "guard",
    "guarda",
    "guarda mulher",
    "helmet",
    "london",
    "londres",
    "mulher",
    "palace",
    "palacio",
    "realeza",
    "seguranca",
    "smileys",
    "woman",
    "woman guard"
  ],
  "💂": [
    "1f482",
    "buckingham",
    "guard",
    "guarda",
    "helmet",
    "london",
    "londres",
    "palace",
    "palacio",
    "pessoas",
    "seguranca",
    "smileys"
  ],
  "💂‍♂️": [
    "1f482-200d-2642",
    "buckingham",
    "guard",
    "guarda",
    "guarda homem",
    "helmet",
    "homem",
    "london",
    "man",
    "man guard",
    "palace",
    "seguranca",
    "smileys"
  ],
  "🕵️‍♀️": [
    "1f575-200d-2640",
    "detective",
    "detetive",
    "detetive mulher",
    "espia",
    "espionar",
    "investigadora",
    "investigar",
    "mulher",
    "sleuth",
    "smileys",
    "spy",
    "woman",
    "woman detective"
  ],
  "🕵️": [
    "1f575",
    "detective",
    "detetive",
    "espiao",
    "investigador",
    "rosto",
    "rosto com lupa",
    "sleuth",
    "smileys",
    "spy"
  ],
  "🕵️‍♂️": [
    "1f575-200d-2642",
    "detective",
    "detetive homem",
    "espiao",
    "homem",
    "investigador",
    "man",
    "man detective",
    "sleuth",
    "smileys",
    "spy"
  ],
  "👩‍⚕️": [
    "1f469-200d-2695",
    "doctor",
    "doutora",
    "enfermeira",
    "garota",
    "guria",
    "health",
    "healthcare",
    "medica",
    "menina",
    "mulher",
    "mulher profissional da saude",
    "nurse",
    "saude",
    "smileys",
    "terapeuta",
    "therapist",
    "woman",
    "woman health worker",
    "worker"
  ],
  "🧑‍⚕️": [
    "1f9d1-200d-2695",
    "cuidados de saude",
    "doctor",
    "enfermeira",
    "health",
    "health worker",
    "healthcare",
    "medico",
    "nurse",
    "profissional de saude",
    "smileys",
    "terapeuta",
    "therapist",
    "worker"
  ],
  "👨‍⚕️": [
    "1f468-200d-2695",
    "doctor",
    "doutor",
    "enfermeiro",
    "health",
    "healthcare",
    "homem",
    "homem profissional da saude",
    "man",
    "man health worker",
    "medico",
    "nurse",
    "saude",
    "smileys",
    "terapeuta",
    "therapist",
    "worker"
  ],
  "👩‍🌾": [
    "1f469-200d-1f33e",
    "agricultora",
    "farmer",
    "fazendeira",
    "gardener",
    "jardineira",
    "mulher",
    "rancher",
    "smileys",
    "woman",
    "woman farmer"
  ],
  "🧑‍🌾": [
    "1f9d1-200d-1f33e",
    "agricultor",
    "farmer",
    "gardener",
    "jardineiro",
    "rancheiro",
    "rancher",
    "smileys"
  ],
  "👨‍🌾": [
    "1f468-200d-1f33e",
    "agricultor",
    "farmer",
    "fazendeiro",
    "gardener",
    "homem",
    "jardineiro",
    "man",
    "man farmer",
    "rancher",
    "smileys"
  ],
  "👩‍🍳": [
    "1f469-200d-1f373",
    "chef",
    "cook",
    "cozinheira",
    "mulher",
    "smileys",
    "woman",
    "woman cook"
  ],
  "🧑‍🍳": [
    "1f9d1-200d-1f373",
    "chef",
    "chef de cozinha",
    "cook",
    "cozinheiro",
    "smileys"
  ],
  "👨‍🍳": [
    "1f468-200d-1f373",
    "chef",
    "cook",
    "cozinheiro",
    "homem",
    "man",
    "man cook",
    "restaurante",
    "smileys"
  ],
  "👩‍🎓": [
    "1f469-200d-1f393",
    "aluna",
    "estudante",
    "formanda",
    "graduate",
    "mulher",
    "smileys",
    "student",
    "woman",
    "woman student"
  ],
  "🧑‍🎓": [
    "1f9d1-200d-1f393",
    "aluno",
    "estudante",
    "graduando",
    "graduate",
    "smileys",
    "student"
  ],
  "👨‍🎓": [
    "1f468-200d-1f393",
    "aluno",
    "colando grau",
    "estudante",
    "formando",
    "graduacao",
    "graduate",
    "homem",
    "man",
    "man student",
    "smileys",
    "student"
  ],
  "👩‍🎤": [
    "1f469-200d-1f3a4",
    "actor",
    "artista",
    "atriz",
    "cantora",
    "entertainer",
    "mulher",
    "pop",
    "rock",
    "rockstar",
    "singer",
    "smileys",
    "star",
    "woman",
    "woman singer"
  ],
  "🧑‍🎤": [
    "1f9d1-200d-1f3a4",
    "actor",
    "ator",
    "cantor",
    "entertainer",
    "entretenimento",
    "estrela",
    "rock",
    "rockstar",
    "singer",
    "smileys",
    "star"
  ],
  "👨‍🎤": [
    "1f468-200d-1f3a4",
    "actor",
    "artista",
    "ator",
    "cantor",
    "cantor homem",
    "entertainer",
    "homem",
    "man",
    "man singer",
    "pop",
    "rock",
    "rockstar",
    "singer",
    "smileys",
    "star"
  ],
  "👩‍🏫": [
    "1f469-200d-1f3eb",
    "instructor",
    "instrutora",
    "lecturer",
    "mestra",
    "mulher",
    "professor",
    "professora",
    "smileys",
    "teacher",
    "woman",
    "woman teacher"
  ],
  "🧑‍🏫": [
    "1f9d1-200d-1f3eb",
    "instructor",
    "instrutora",
    "lecturer",
    "professor",
    "professora",
    "professora na escola",
    "smileys",
    "teacher"
  ],
  "👨‍🏫": [
    "1f468-200d-1f3eb",
    "educador",
    "homem",
    "instructor",
    "instrutor",
    "lecturer",
    "man",
    "man teacher",
    "mestre",
    "professor",
    "smileys",
    "teacher"
  ],
  "👩‍🏭": [
    "1f469-200d-1f3ed",
    "assembly",
    "fabrica",
    "factory",
    "industria",
    "industrial",
    "mulher",
    "operaria",
    "smileys",
    "trabalhadora",
    "woman",
    "woman factory worker",
    "worker"
  ],
  "🧑‍🏭": [
    "1f9d1-200d-1f3ed",
    "assembly",
    "fabrica",
    "factory",
    "factory worker",
    "funcionario de fabrica",
    "industrial",
    "montagem",
    "smileys",
    "trabalhador",
    "worker"
  ],
  "👨‍🏭": [
    "1f468-200d-1f3ed",
    "assembly",
    "fabrica",
    "factory",
    "homem",
    "industria",
    "industrial",
    "man",
    "man factory worker",
    "metalurgico",
    "operario",
    "smileys",
    "trabalhador",
    "worker"
  ],
  "👩‍💻": [
    "1f469-200d-1f4bb",
    "coder",
    "codificadora",
    "computador",
    "computer",
    "criadora",
    "desenvolvedora",
    "developer",
    "inventor",
    "inventora",
    "mulher",
    "programadora",
    "smileys",
    "software",
    "technologist",
    "tecnologa",
    "woman",
    "woman technologist"
  ],
  "🧑‍💻": [
    "1f9d1-200d-1f4bb",
    "coder",
    "computer",
    "desenvolvedor",
    "developer",
    "inventor",
    "programador",
    "smileys",
    "software",
    "technologist",
    "tecnologo"
  ],
  "👨‍💻": [
    "1f468-200d-1f4bb",
    "coder",
    "codificador",
    "computador",
    "computer",
    "criador",
    "desenvolvedor",
    "developer",
    "homem",
    "inventor",
    "man",
    "man technologist",
    "programador",
    "smileys",
    "software",
    "technologist",
    "tecnologo"
  ],
  "👩‍💼": [
    "1f469-200d-1f4bc",
    "architect",
    "arquiteta",
    "branco",
    "business",
    "colarinho",
    "empresaria",
    "escritorio",
    "funcionaria",
    "funcionaria de escritorio",
    "gerente",
    "manager",
    "mulher",
    "office",
    "smileys",
    "white-collar",
    "woman",
    "woman office worker",
    "worker"
  ],
  "🧑‍💼": [
    "1f9d1-200d-1f4bc",
    "architect",
    "arquiteto",
    "business",
    "colarinho branco",
    "gerente",
    "manager",
    "negocios",
    "office",
    "office worker",
    "smileys",
    "trabalhador de escritorio",
    "white-collar",
    "worker"
  ],
  "👨‍💼": [
    "1f468-200d-1f4bc",
    "architect",
    "arquiteto",
    "business",
    "colarinho branco",
    "empresario",
    "escritorio",
    "funcionario de escritorio",
    "gerente",
    "homem",
    "man",
    "man office worker",
    "manager",
    "office",
    "smileys",
    "white-collar",
    "worker"
  ],
  "👩‍🔧": [
    "1f469-200d-1f527",
    "electrician",
    "eletricista",
    "encanadora",
    "mecanica",
    "mechanic",
    "mulher",
    "plumber",
    "prestadora de servicos",
    "smileys",
    "tradesperson",
    "woman",
    "woman mechanic"
  ],
  "🧑‍🔧": [
    "1f9d1-200d-1f527",
    "electrician",
    "eletricista",
    "encanador",
    "mecanico",
    "mecanico trabalhando",
    "mechanic",
    "plumber",
    "prestador de servico",
    "smileys",
    "tradesperson"
  ],
  "👨‍🔧": [
    "1f468-200d-1f527",
    "electrician",
    "eletricista",
    "encanador",
    "homem",
    "man",
    "man mechanic",
    "mecanico",
    "mechanic",
    "plumber",
    "prestador de servicos",
    "smileys",
    "tradesperson"
  ],
  "👩‍🔬": [
    "1f469-200d-1f52c",
    "biologa",
    "biologist",
    "chemist",
    "cientista",
    "cientista mulher",
    "engineer",
    "fisica",
    "mathematician",
    "mulher",
    "physicist",
    "professora",
    "quimica",
    "scientist",
    "smileys",
    "woman",
    "woman scientist"
  ],
  "🧑‍🔬": [
    "1f9d1-200d-1f52c",
    "biologist",
    "biologo",
    "chemist",
    "cientista",
    "engenheiro",
    "engineer",
    "fisico",
    "mathematician",
    "physicist",
    "quimico",
    "scientist",
    "smileys"
  ],
  "👨‍🔬": [
    "1f468-200d-1f52c",
    "biologist",
    "biologo",
    "chemist",
    "cientista homem",
    "engineer",
    "fisico",
    "homem",
    "man",
    "man scientist",
    "mathematician",
    "physicist",
    "professor",
    "quimico",
    "scientist",
    "smileys"
  ],
  "👩‍🎨": [
    "1f469-200d-1f3a8",
    "artist",
    "artista",
    "artista plastica",
    "mulher",
    "palette",
    "pintura",
    "smileys",
    "woman",
    "woman artist"
  ],
  "🧑‍🎨": [
    "1f9d1-200d-1f3a8",
    "artist",
    "artista",
    "paleta",
    "palette",
    "smileys"
  ],
  "👨‍🎨": [
    "1f468-200d-1f3a8",
    "artist",
    "artista",
    "artista plastico",
    "homem",
    "man",
    "man artist",
    "palette",
    "pintor",
    "pintura",
    "plastico",
    "quadros",
    "smileys"
  ],
  "👩‍🚒": [
    "1f469-200d-1f692",
    "bombeira",
    "caminhao",
    "corpo de bombeiros",
    "fire",
    "firefighter",
    "firetruck",
    "fogo",
    "incendio",
    "mulher",
    "smileys",
    "woman",
    "woman firefighter"
  ],
  "🧑‍🚒": [
    "1f9d1-200d-1f692",
    "bombeiro",
    "caminhao de bombeiros",
    "fire",
    "firefighter",
    "firetruck",
    "smileys"
  ],
  "👨‍🚒": [
    "1f468-200d-1f692",
    "bombeiro",
    "bombeiro homem",
    "caminhao",
    "corpo de bombeiros",
    "fire",
    "firefighter",
    "firetruck",
    "fogo",
    "homem",
    "incendio",
    "man",
    "man firefighter",
    "smileys"
  ],
  "👩‍✈️": [
    "1f469-200d-2708",
    "aviao",
    "garota",
    "guria",
    "mulher",
    "pilot",
    "piloto",
    "piloto de aviao mulher",
    "plane",
    "smileys",
    "voando",
    "woman",
    "woman pilot"
  ],
  "🧑‍✈️": [
    "1f9d1-200d-2708",
    "aviao",
    "pilot",
    "piloto",
    "plane",
    "smileys"
  ],
  "👨‍✈️": [
    "1f468-200d-2708",
    "aviao",
    "homem",
    "man",
    "man pilot",
    "pilot",
    "piloto",
    "piloto de aviao homem",
    "plane",
    "smileys"
  ],
  "👩‍🚀": [
    "1f469-200d-1f680",
    "astronaut",
    "astronauta",
    "astronauta mulher",
    "espaco",
    "foguete",
    "mulher",
    "rocket",
    "smileys",
    "space",
    "woman",
    "woman astronaut"
  ],
  "🧑‍🚀": [
    "1f9d1-200d-1f680",
    "astronaut",
    "astronauta",
    "foguete",
    "rocket",
    "smileys",
    "space"
  ],
  "👨‍🚀": [
    "1f468-200d-1f680",
    "astronaut",
    "astronauta homem",
    "espaco",
    "foguete",
    "homem",
    "man",
    "man astronaut",
    "rocket",
    "smileys",
    "space"
  ],
  "👩‍⚖️": [
    "1f469-200d-2696",
    "balanca",
    "judge",
    "juiza",
    "justica",
    "justice",
    "law",
    "mulher",
    "scales",
    "smileys",
    "woman",
    "woman judge"
  ],
  "🧑‍⚖️": [
    "1f9d1-200d-2696",
    "balanca",
    "judge",
    "juiz",
    "juiz no tribunal",
    "justice",
    "law",
    "scales",
    "smileys"
  ],
  "👨‍⚖️": [
    "1f468-200d-2696",
    "balanca",
    "homem",
    "judge",
    "juiz",
    "justica",
    "justice",
    "law",
    "man",
    "man judge",
    "scales",
    "smileys"
  ],
  "👰‍♀️": [
    "1f470-200d-2640",
    "bride",
    "noiva",
    "noiva com veu",
    "smileys",
    "veil",
    "veu",
    "wedding",
    "woman",
    "woman with veil"
  ],
  "👰": [
    "1f470",
    "casamento",
    "noiva",
    "noiva com veu",
    "person",
    "person with veil",
    "pessoa com veu",
    "pessoas",
    "smileys",
    "veil",
    "veu",
    "veu de noiva",
    "wedding"
  ],
  "👰‍♂️": [
    "1f470-200d-2642",
    "man",
    "man with veil",
    "noivo",
    "noivo com veu",
    "smileys",
    "veil",
    "veu",
    "wedding"
  ],
  "🤵‍♀️": [
    "1f935-200d-2640",
    "formal",
    "mulher",
    "mulher de smoking",
    "smileys",
    "smoking",
    "tuxedo",
    "wedding",
    "woman",
    "woman in tuxedo"
  ],
  "🤵": [
    "1f935",
    "festa",
    "formal",
    "gala",
    "homem",
    "homem de smoking",
    "noivo",
    "person",
    "person in tuxedo",
    "pessoa de smoking",
    "smileys",
    "smoking",
    "tuxedo",
    "wedding"
  ],
  "🤵‍♂️": [
    "1f935-200d-2642",
    "formal",
    "groom",
    "homem",
    "homem de smoking",
    "man",
    "man in tuxedo",
    "smileys",
    "smoking",
    "tuxedo",
    "wedding"
  ],
  "👸": [
    "1f478",
    "conto",
    "coroa",
    "crown",
    "fadas",
    "fairy",
    "fairytale",
    "fantasia",
    "fantasy",
    "loira",
    "menina",
    "mulher",
    "pessoas",
    "princesa",
    "princess",
    "queen",
    "rainha",
    "royal",
    "royalty",
    "smileys",
    "tale"
  ],
  "🫅": [
    "1fac5",
    "coroa",
    "crown",
    "monarca",
    "monarch",
    "noble",
    "nobre",
    "person",
    "person with crown",
    "pessoa",
    "pessoa com coroa",
    "princesa",
    "principe",
    "rainha",
    "real",
    "realeza",
    "regal",
    "rei",
    "reino",
    "royal",
    "royalty",
    "smileys"
  ],
  "🤴": [
    "1f934",
    "crown",
    "fairy",
    "fairytale",
    "fantasy",
    "king",
    "prince",
    "principe",
    "realeza",
    "rei",
    "royal",
    "royalty",
    "smileys",
    "tale"
  ],
  "🥷": [
    "1f977",
    "assassin",
    "assassino",
    "fight",
    "fighter",
    "furtividade",
    "guerra",
    "habilidades",
    "hidden",
    "luta",
    "lutador",
    "ninja",
    "oculto",
    "person",
    "pessoa",
    "secret",
    "skills",
    "sly",
    "smileys",
    "soldado",
    "soldier",
    "stealth",
    "war"
  ],
  "🦸‍♀️": [
    "1f9b8-200d-2640",
    "boa",
    "good",
    "hero",
    "heroi",
    "heroina",
    "heroine",
    "mulher",
    "smileys",
    "super-heroina",
    "superhero",
    "superpoder",
    "superpower",
    "woman",
    "woman superhero"
  ],
  "🦸": [
    "1f9b8",
    "bem",
    "boa",
    "bom",
    "good",
    "hero",
    "heroi",
    "heroina",
    "smileys",
    "super-heroi",
    "super-homem",
    "superhero",
    "superman",
    "superpoder",
    "superpower"
  ],
  "🦸‍♂️": [
    "1f9b8-200d-2642",
    "bom",
    "good",
    "hero",
    "heroi",
    "homem",
    "homem super-heroi",
    "man",
    "man superhero",
    "smileys",
    "superhero",
    "superpoder",
    "superpower"
  ],
  "🦹‍♀️": [
    "1f9b9-200d-2640",
    "bad",
    "criminal",
    "criminosa",
    "evil",
    "ma",
    "mulher",
    "smileys",
    "superpoder",
    "superpower",
    "supervila",
    "supervillain",
    "vila",
    "villain",
    "woman",
    "woman supervillain"
  ],
  "🦹": [
    "1f9b9",
    "bad",
    "bandido",
    "criminal",
    "criminoso",
    "evil",
    "mal",
    "malvado",
    "mau",
    "smileys",
    "superpoder",
    "superpower",
    "supervilao",
    "supervillain",
    "vilao",
    "villain"
  ],
  "🦹‍♂️": [
    "1f9b9-200d-2642",
    "bad",
    "criminal",
    "criminoso",
    "evil",
    "homem",
    "homem supervilao",
    "mal",
    "man",
    "man supervillain",
    "smileys",
    "superpoder",
    "superpower",
    "supervillain",
    "vilao",
    "villain"
  ],
  "🤶": [
    "1f936",
    "celebration",
    "christmas",
    "claus",
    "comemoracao",
    "fairy",
    "fantasy",
    "holiday",
    "mamae",
    "mamae noel",
    "merry",
    "mother",
    "mrs",
    "mrs. claus",
    "natal",
    "noel",
    "santa",
    "smileys",
    "tale",
    "vovo",
    "xmas"
  ],
  "🧑‍🎄": [
    "1f9d1-200d-1f384",
    "celebration",
    "chapeu",
    "christmas",
    "claus",
    "fairy",
    "fantasy",
    "feliz",
    "festas",
    "gorro",
    "holiday",
    "mamae",
    "merry",
    "mx",
    "mx claus",
    "natal",
    "noel",
    "pessoa",
    "santa",
    "smileys",
    "tale",
    "xmas"
  ],
  "🎅": [
    "1f385",
    "celebration",
    "christmas",
    "claus",
    "comemoracao",
    "fairy",
    "fantasy",
    "father",
    "festas",
    "holiday",
    "merry",
    "natal",
    "noel",
    "papai",
    "papai noel",
    "santa",
    "santa claus",
    "smileys",
    "tale",
    "xmas"
  ],
  "🧙‍♀️": [
    "1f9d9-200d-2640",
    "bruxa",
    "fantasy",
    "feiticeira",
    "maga",
    "mage",
    "magic",
    "play",
    "smileys",
    "sorcerer",
    "sorceress",
    "sorcery",
    "spell",
    "summon",
    "witch",
    "wizard",
    "woman",
    "woman mage"
  ],
  "🧙": [
    "1f9d9",
    "bruxa",
    "fantasia",
    "fantasy",
    "feiticeira",
    "feiticeiro",
    "feitico",
    "maga",
    "mage",
    "magia",
    "magic",
    "mago",
    "play",
    "rpg",
    "smileys",
    "sorcerer",
    "sorceress",
    "sorcery",
    "spell",
    "summon",
    "witch",
    "wizard"
  ],
  "🧙‍♂️": [
    "1f9d9-200d-2642",
    "fantasy",
    "feiticeiro",
    "homem mago",
    "mage",
    "magic",
    "mago",
    "man",
    "man mage",
    "play",
    "smileys",
    "sorcerer",
    "sorceress",
    "sorcery",
    "spell",
    "summon",
    "witch",
    "wizard"
  ],
  "🧝‍♀️": [
    "1f9dd-200d-2640",
    "duende mulher",
    "elf",
    "elfa",
    "elves",
    "enchantment",
    "fantasy",
    "folklore",
    "magic",
    "magical",
    "myth",
    "smileys",
    "woman",
    "woman elf"
  ],
  "🧝": [
    "1f9dd",
    "duende",
    "elf",
    "elfo",
    "elves",
    "enchantment",
    "fantasia",
    "fantasy",
    "folklore",
    "legolas",
    "magia",
    "magic",
    "magical",
    "magico",
    "mistico",
    "myth",
    "rpg",
    "ser encantado",
    "smileys"
  ],
  "🧝‍♂️": [
    "1f9dd-200d-2642",
    "duende homem",
    "elf",
    "elfo",
    "elfo homem",
    "elves",
    "enchantment",
    "fantasy",
    "folklore",
    "magic",
    "magical",
    "man",
    "man elf",
    "myth",
    "smileys"
  ],
  "🧌": [
    "1f9cc",
    "conto",
    "fadas",
    "fairy",
    "fantasia",
    "fantasy",
    "gigante",
    "monster",
    "monstro",
    "ogro",
    "smileys",
    "tale",
    "troll",
    "trolling"
  ],
  "🧛‍♀️": [
    "1f9db-200d-2640",
    "blood",
    "fangs",
    "halloween",
    "mulher vampira",
    "scary",
    "smileys",
    "supernatural",
    "teeth",
    "undead",
    "vampira",
    "vampire",
    "woman",
    "woman vampire"
  ],
  "🧛": [
    "1f9db",
    "assustador",
    "blood",
    "bruxas",
    "dia",
    "dracula",
    "fangs",
    "fantasia",
    "halloween",
    "monstro",
    "sangue",
    "scary",
    "smileys",
    "supernatural",
    "teeth",
    "terror",
    "undead",
    "vampire",
    "vampiro"
  ],
  "🧛‍♂️": [
    "1f9db-200d-2642",
    "blood",
    "dracula",
    "fangs",
    "halloween",
    "homem vampiro",
    "man",
    "man vampire",
    "scary",
    "smileys",
    "supernatural",
    "teeth",
    "undead",
    "vampire",
    "vampiro"
  ],
  "🧟‍♀️": [
    "1f9df-200d-2640",
    "apocalypse",
    "cazumbi",
    "dead",
    "halloween",
    "horror",
    "mulher zumbi",
    "scary",
    "smileys",
    "undead",
    "walking",
    "woman",
    "woman zombie",
    "zombie"
  ],
  "🧟": [
    "1f9df",
    "apocalipse",
    "apocalypse",
    "assustador",
    "bruxas",
    "dead",
    "dia",
    "halloween",
    "horror",
    "morto-vivo",
    "scary",
    "smileys",
    "terror",
    "undead",
    "walking",
    "zombie",
    "zumbi"
  ],
  "🧟‍♂️": [
    "1f9df-200d-2642",
    "apocalypse",
    "cazumbi",
    "dead",
    "halloween",
    "homem zumbi",
    "horror",
    "man",
    "man zombie",
    "scary",
    "smileys",
    "undead",
    "walking",
    "zombie"
  ],
  "🧞‍♀️": [
    "1f9de-200d-2640",
    "djinn",
    "fantasy",
    "genie",
    "jinn",
    "lamp",
    "mulher genio",
    "myth",
    "rub",
    "smileys",
    "wishes",
    "woman",
    "woman genie"
  ],
  "🧞": [
    "1f9de",
    "desejos",
    "djinn",
    "fantasia",
    "fantasy",
    "genie",
    "genio",
    "jinn",
    "lamp",
    "lampada",
    "magica",
    "mistico",
    "myth",
    "rub",
    "smileys",
    "wishes"
  ],
  "🧞‍♂️": [
    "1f9de-200d-2642",
    "djinn",
    "fantasy",
    "genie",
    "homem genio",
    "jinn",
    "lamp",
    "man",
    "man genie",
    "myth",
    "rub",
    "smileys",
    "wishes"
  ],
  "🧜‍♀️": [
    "1f9dc-200d-2640",
    "creature",
    "fairytale",
    "folklore",
    "mermaid",
    "merwoman",
    "ocean",
    "sea",
    "sereia",
    "siren",
    "smileys",
    "trident"
  ],
  "🧜": [
    "1f9dc",
    "canto",
    "cauda",
    "contos",
    "creature",
    "criatura",
    "fada",
    "fairytale",
    "folklore",
    "fundo",
    "mar",
    "merperson",
    "ocean",
    "oceano",
    "pessoa sereia",
    "sea",
    "ser encantado",
    "sereia",
    "siren",
    "sirene",
    "smileys",
    "trident",
    "tridente"
  ],
  "🧜‍♂️": [
    "1f9dc-200d-2642",
    "creature",
    "fairytale",
    "folklore",
    "merman",
    "neptune",
    "ocean",
    "poseidon",
    "sea",
    "sereio",
    "siren",
    "smileys",
    "trident",
    "tritao",
    "triton"
  ],
  "🧚‍♀️": [
    "1f9da-200d-2640",
    "fada",
    "fairy",
    "fairytale",
    "fantasy",
    "mulher fada",
    "myth",
    "person",
    "pixie",
    "smileys",
    "tale",
    "titania",
    "wings",
    "woman",
    "woman fairy"
  ],
  "🧚": [
    "1f9da",
    "asas",
    "conto",
    "encantado",
    "fada",
    "fairy",
    "fairytale",
    "fantasia",
    "fantasy",
    "myth",
    "person",
    "pixie",
    "ser",
    "smileys",
    "tale",
    "wings"
  ],
  "🧚‍♂️": [
    "1f9da-200d-2642",
    "fada",
    "fairy",
    "fairytale",
    "fantasy",
    "homem fada",
    "man",
    "man fairy",
    "myth",
    "oberon",
    "person",
    "pixie",
    "puck",
    "smileys",
    "tale",
    "wings"
  ],
  "👼": [
    "1f47c",
    "angel",
    "anjo",
    "baby",
    "baby angel",
    "bebe",
    "bebe anjo",
    "church",
    "conto",
    "face",
    "fadas",
    "fairy",
    "fairytale",
    "fantasy",
    "rosto",
    "smileys",
    "tale"
  ],
  "🤰": [
    "1f930",
    "estou gravida",
    "gravida",
    "gravidez",
    "mulher",
    "pregnant",
    "pregnant woman",
    "smileys",
    "woman"
  ],
  "🫄": [
    "1fac4",
    "barriga",
    "belly",
    "bloated",
    "cheia",
    "cheio",
    "comi demais",
    "excesso",
    "excesso de peso",
    "full",
    "gravida",
    "gravidez",
    "inchada",
    "overeat",
    "person",
    "pessoa",
    "pessoa gravida",
    "pregnant",
    "pregnant person",
    "smileys",
    "stuffed"
  ],
  "🫃": [
    "1fac3",
    "barriga",
    "belly",
    "bloated",
    "cheia",
    "cheio",
    "comi demais",
    "excesso de peso",
    "full",
    "gravidez",
    "gravido",
    "homem",
    "homem gravido",
    "inchado",
    "man",
    "overeat",
    "pessoa",
    "pregnant",
    "pregnant man",
    "smileys"
  ],
  "🤱": [
    "1f931",
    "amamentacao",
    "amamentando",
    "baby",
    "bebe",
    "breast",
    "breast-feeding",
    "feeding",
    "leite",
    "mae",
    "materno",
    "mom",
    "mother",
    "nenem",
    "nursing",
    "smileys",
    "woman"
  ],
  "👩‍🍼": [
    "1f469-200d-1f37c",
    "alimentando",
    "amamentacao",
    "amamentando",
    "amor",
    "baby",
    "bebe",
    "feed",
    "feeding",
    "mae",
    "mamae",
    "mom",
    "mother",
    "mulher",
    "mulher alimentando bebe",
    "nanny",
    "nascido",
    "nenem",
    "newborn",
    "nursing",
    "pessoa",
    "recem",
    "recem-nascido",
    "smileys",
    "woman",
    "woman feeding baby"
  ],
  "🧑‍🍼": [
    "1f9d1-200d-1f37c",
    "alimentando",
    "amamentacao",
    "amamentar",
    "baby",
    "bebe",
    "feed",
    "feeding",
    "homem",
    "mae",
    "mulher",
    "nanny",
    "nenem",
    "newborn",
    "nursing",
    "pai",
    "parent",
    "person feeding baby",
    "pessoa",
    "pessoa alimentando bebe",
    "recem-nascido",
    "smileys"
  ],
  "👨‍🍼": [
    "1f468-200d-1f37c",
    "alimentando",
    "amamentacao",
    "amamentando",
    "amor",
    "baby",
    "bebe",
    "dad",
    "father",
    "feed",
    "feeding",
    "homem",
    "homem alimentando bebe",
    "man",
    "man feeding baby",
    "nanny",
    "nenem",
    "newborn",
    "nursing",
    "pai",
    "papai",
    "pessoa",
    "recem nascido",
    "recem-nascido",
    "smileys"
  ],
  "🙇‍♀️": [
    "1f647-200d-2640",
    "apology",
    "ask",
    "beg",
    "bow",
    "bowing",
    "desculpas",
    "desculpe",
    "favor",
    "forgive",
    "gesto",
    "gesture",
    "meditacao",
    "meditar",
    "meditate",
    "meditation",
    "mulher",
    "mulher fazendo reverencia",
    "mulher pedindo desculpas",
    "pity",
    "regret",
    "respeito",
    "reverencia",
    "smileys",
    "sorry",
    "woman",
    "woman bowing"
  ],
  "🙇": [
    "1f647",
    "apology",
    "arrependimento",
    "ask",
    "beg",
    "bow",
    "bowing",
    "desculpa",
    "desculpe",
    "favor",
    "forgive",
    "gesto",
    "gesture",
    "meditacao",
    "meditate",
    "meditation",
    "perdao",
    "person",
    "person bowing",
    "pessoa",
    "pessoa fazendo reverencia",
    "pity",
    "regret",
    "reverencia",
    "reverencia respeitosa",
    "smileys",
    "sorry"
  ],
  "🙇‍♂️": [
    "1f647-200d-2642",
    "apology",
    "ask",
    "beg",
    "bow",
    "bowing",
    "desculpas",
    "favor",
    "forgive",
    "gesto",
    "gesture",
    "homem",
    "homem fazendo reverencia",
    "homem pedindo desculpas",
    "man",
    "man bowing",
    "meditate",
    "meditation",
    "pity",
    "regret",
    "respeito",
    "reverencia",
    "smileys",
    "sorry"
  ],
  "💁‍♀️": [
    "1f481-200d-2640",
    "fetch",
    "flick",
    "flip",
    "gossip",
    "hand",
    "mulher",
    "mulher com a palma virada para cima",
    "sarcasm",
    "sarcastic",
    "sassy",
    "seriously",
    "smileys",
    "tipping",
    "whatever",
    "woman",
    "woman tipping hand"
  ],
  "💁": [
    "1f481",
    "ajuda",
    "diva",
    "divo",
    "fala serio",
    "fetch",
    "flick",
    "flip",
    "fofoca",
    "gossip",
    "hand",
    "informacoes",
    "jogada de cabelo",
    "mao",
    "person",
    "person tipping hand",
    "pessoa",
    "pessoa com a mao virada para cima",
    "pessoa com a palma virada para cima",
    "sarcasm",
    "sarcasmo",
    "sarcastic",
    "sassy",
    "seriously",
    "smileys",
    "tipping",
    "whatever"
  ],
  "💁‍♂️": [
    "1f481-200d-2642",
    "ajuda",
    "fetch",
    "flick",
    "flip",
    "fofoca",
    "garoto",
    "gorjeta",
    "gossip",
    "guri",
    "hand",
    "homem",
    "homem com a palma virada para cima",
    "man",
    "man tipping hand",
    "menino",
    "sarcasm",
    "sarcasmo",
    "sarcastic",
    "sarcastico",
    "sassy",
    "seriously",
    "smileys",
    "tipping",
    "whatever"
  ],
  "🙅‍♀️": [
    "1f645-200d-2640",
    "forbidden",
    "gesto",
    "gesture",
    "hand",
    "mao",
    "mulher",
    "mulher fazendo gesto de “nao”",
    "no",
    "not",
    "prohibit",
    "proibido",
    "smileys",
    "woman",
    "woman gesturing no"
  ],
  "🙅": [
    "1f645",
    "de jeito nenhum",
    "forbidden",
    "gesto",
    "gesture",
    "hand",
    "mao",
    "nao",
    "no",
    "not",
    "person",
    "person gesturing no",
    "pessoa fazendo gesto de “nao”",
    "prohibit",
    "proibido",
    "sem chance",
    "smileys"
  ],
  "🙅‍♂️": [
    "1f645-200d-2642",
    "forbidden",
    "gesto",
    "gesture",
    "hand",
    "homem",
    "homem fazendo gesto de “nao”",
    "man",
    "man gesturing no",
    "mao",
    "menino",
    "nao",
    "no",
    "not",
    "prohibit",
    "proibido",
    "proibir",
    "smileys"
  ],
  "🙆‍♀️": [
    "1f646-200d-2640",
    "exercise",
    "gesto",
    "gesture",
    "gesturing",
    "hand",
    "mao",
    "mulher",
    "mulher fazendo gesto de “ok”",
    "ok",
    "omg",
    "smileys",
    "woman",
    "woman gesturing ok"
  ],
  "🙆": [
    "1f646",
    "exercicio",
    "exercise",
    "gesto",
    "gesto para ok",
    "gesture",
    "gesturing",
    "hand",
    "mao",
    "maos para cima",
    "ok",
    "omg",
    "person",
    "person gesturing ok",
    "pessoa",
    "pessoa fazendo gesto de “ok”",
    "smileys"
  ],
  "🙆‍♂️": [
    "1f646-200d-2642",
    "cabeca",
    "exercicio",
    "exercise",
    "gesto",
    "gesture",
    "gesturing",
    "hand",
    "homem",
    "homem fazendo gesto de “ok”",
    "man",
    "man gesturing ok",
    "mao",
    "menino",
    "nossa",
    "ok",
    "omg",
    "smileys"
  ],
  "🙋‍♀️": [
    "1f64b-200d-2640",
    "gesto",
    "gesture",
    "hand",
    "here",
    "know",
    "mao",
    "me",
    "mulher",
    "mulher levantando a mao",
    "pedir a palavra",
    "pick",
    "question",
    "raise",
    "raising",
    "smileys",
    "woman",
    "woman raising hand"
  ],
  "🙋": [
    "1f64b",
    "duvida",
    "eu",
    "eu sei",
    "feliz",
    "gesto",
    "gesture",
    "hand",
    "here",
    "know",
    "levantando a mao",
    "levantar a mao",
    "mao",
    "me",
    "person",
    "person raising hand",
    "pessoa",
    "pessoa levantando a mao",
    "pick",
    "question",
    "raise",
    "raising",
    "smileys"
  ],
  "🙋‍♂️": [
    "1f64b-200d-2642",
    "eu",
    "eu sei",
    "gesto",
    "gesture",
    "hand",
    "here",
    "homem",
    "homem levantando a mao",
    "know",
    "levantando a mao",
    "man",
    "man raising hand",
    "mao",
    "me",
    "menino",
    "pedir a palavra",
    "pergunta",
    "pick",
    "question",
    "raise",
    "raising",
    "smileys",
    "voluntario"
  ],
  "🧏‍♀️": [
    "1f9cf-200d-2640",
    "accessibility",
    "deaf",
    "deaf woman",
    "ear",
    "gesture",
    "hear",
    "mulher",
    "mulher surda",
    "smileys",
    "surda",
    "woman"
  ],
  "🧏": [
    "1f9cf",
    "accessibility",
    "acessibilidade",
    "audicao",
    "deaf",
    "deaf person",
    "ear",
    "gesture",
    "hear",
    "orelha",
    "person",
    "pessoa surda",
    "smileys",
    "surda",
    "surdo",
    "surdos"
  ],
  "🧏‍♂️": [
    "1f9cf-200d-2642",
    "accessibility",
    "deaf",
    "deaf man",
    "ear",
    "gesture",
    "hear",
    "homem",
    "homem surdo",
    "man",
    "smileys",
    "surdo"
  ],
  "🤦‍♀️": [
    "1f926-200d-2640",
    "again",
    "bewilder",
    "como assim",
    "decepcao",
    "decepcionada",
    "desapontamento",
    "disbelief",
    "exasperation",
    "facepalm",
    "inacreditavel",
    "meu deus",
    "mulher",
    "mulher decepcionada",
    "nao acredito",
    "nao e possivel",
    "no",
    "not",
    "oh",
    "omg",
    "shock",
    "smh",
    "smileys",
    "woman",
    "woman facepalming"
  ],
  "🤦": [
    "1f926",
    "again",
    "bewilder",
    "como assim",
    "decepcao",
    "decepcionada",
    "decepcionado",
    "desapontamento",
    "descrenca",
    "disbelief",
    "exasperation",
    "facepalm",
    "inacreditavel",
    "meu deus",
    "nao acredito",
    "nao e possivel",
    "no",
    "not",
    "oh",
    "omg",
    "person",
    "person facepalming",
    "pessoa",
    "pessoa dececionada",
    "pessoa decepcionada",
    "shock",
    "smh",
    "smileys"
  ],
  "🤦‍♂️": [
    "1f926-200d-2642",
    "again",
    "bewilder",
    "como assim",
    "decepcao",
    "decepcionado",
    "desapontamento",
    "disbelief",
    "exasperation",
    "facepalm",
    "homem",
    "homem decepcionado",
    "inacreditavel",
    "man",
    "man facepalming",
    "meu deus",
    "nao acredito",
    "nao e possivel",
    "no",
    "not",
    "oh",
    "omg",
    "shock",
    "smh",
    "smileys"
  ],
  "🤷‍♀️": [
    "1f937-200d-2640",
    "dar de ombros",
    "doubt",
    "dunno",
    "duvida",
    "garota",
    "guess",
    "idk",
    "ignorance",
    "indiferenca",
    "indifference",
    "knows",
    "maybe",
    "menina",
    "mulher",
    "mulher dando de ombros",
    "nao sei",
    "quem sabe",
    "sei la",
    "shrug",
    "shrugging",
    "smileys",
    "tanto faz",
    "whatever",
    "who",
    "woman",
    "woman shrugging"
  ],
  "🤷": [
    "1f937",
    "dar de ombros",
    "doubt",
    "dunno",
    "duvida",
    "guess",
    "idk",
    "ignorance",
    "ignorancia",
    "indiferenca",
    "indifference",
    "knows",
    "maybe",
    "nao sei",
    "ombros",
    "person",
    "person shrugging",
    "pessoa",
    "pessoa dando de ombros",
    "quem sabe",
    "sei la",
    "shrug",
    "shrugging",
    "smileys",
    "tanto faz",
    "whatever",
    "who"
  ],
  "🤷‍♂️": [
    "1f937-200d-2642",
    "dar de ombros",
    "doubt",
    "dunno",
    "duvida",
    "guess",
    "homem",
    "homem dando de ombros",
    "idk",
    "ignorance",
    "indiferenca",
    "indifference",
    "knows",
    "man",
    "man shrugging",
    "maybe",
    "menino",
    "nao sei",
    "quem sabe",
    "sei la",
    "shrug",
    "shrugging",
    "smileys",
    "tanto faz",
    "whatever",
    "who"
  ],
  "🙎‍♀️": [
    "1f64e-200d-2640",
    "bico",
    "cara feia",
    "disappointed",
    "downtrodden",
    "frown",
    "grimace",
    "mulher",
    "mulher fazendo bico",
    "pouting",
    "scowl",
    "smileys",
    "sulk",
    "upset",
    "whine",
    "woman",
    "woman pouting"
  ],
  "🙎": [
    "1f64e",
    "beicinho",
    "beico",
    "careta",
    "chateada",
    "chateado",
    "disappointed",
    "downtrodden",
    "emburrada",
    "emburrado",
    "fazendo bico",
    "frown",
    "gesto",
    "grimace",
    "person",
    "person pouting",
    "pessoa",
    "pessoa fazendo bico",
    "pouting",
    "scowl",
    "smileys",
    "sulk",
    "upset",
    "whine"
  ],
  "🙎‍♂️": [
    "1f64e-200d-2642",
    "apontando",
    "bico",
    "cara feia",
    "disappointed",
    "downtrodden",
    "frown",
    "gesto",
    "grimace",
    "homem",
    "homem fazendo bico",
    "homen apontando",
    "man",
    "man pouting",
    "pouting",
    "scowl",
    "smileys",
    "sulk",
    "upset",
    "whine"
  ],
  "🙍‍♀️": [
    "1f64d-200d-2640",
    "annoyed",
    "carrancuda",
    "desconfiada",
    "disappointed",
    "disgruntled",
    "disturbed",
    "frown",
    "frowning",
    "frustrated",
    "gesture",
    "irritated",
    "mulher",
    "mulher franzindo a sobrancelha",
    "smileys",
    "upset",
    "woman",
    "woman frowning"
  ],
  "🙍": [
    "1f64d",
    "annoyed",
    "brava",
    "bravo",
    "chateada",
    "chateado",
    "disappointed",
    "disgruntled",
    "disturbed",
    "franzindo a sobrancelha",
    "franzindo a testa",
    "frown",
    "frowning",
    "frustrated",
    "gesto",
    "gesture",
    "irritated",
    "person",
    "person frowning",
    "pessoa",
    "pessoa franzindo a sobrancelha",
    "smileys",
    "triste",
    "upset"
  ],
  "🙍‍♂️": [
    "1f64d-200d-2642",
    "annoyed",
    "carrancudo",
    "chateado",
    "desconfiado",
    "disappointed",
    "disgruntled",
    "disturbed",
    "frown",
    "frowning",
    "frustrated",
    "gesto",
    "gesture",
    "homem",
    "homem franzindo a sobrancelha",
    "irritated",
    "magoado",
    "man",
    "man frowning",
    "menino",
    "smileys",
    "upset"
  ],
  "💇‍♀️": [
    "1f487-200d-2640",
    "barber",
    "beauty",
    "chop",
    "corte de cabelo",
    "cosmetology",
    "cut",
    "groom",
    "hair",
    "haircut",
    "mulher",
    "mulher cortando o cabelo",
    "parlor",
    "person",
    "salao de beleza",
    "shears",
    "smileys",
    "style",
    "woman",
    "woman getting haircut"
  ],
  "💇": [
    "1f487",
    "barber",
    "beauty",
    "beleza",
    "chop",
    "cortando o cabelo",
    "corte de cabelo",
    "cosmetology",
    "cut",
    "groom",
    "hair",
    "haircut",
    "parlor",
    "person",
    "person getting haircut",
    "pessoa",
    "pessoa cortando o cabelo",
    "salao",
    "salao de beleza",
    "shears",
    "smileys",
    "style"
  ],
  "💇‍♂️": [
    "1f487-200d-2642",
    "barbeiro",
    "barber",
    "beauty",
    "beleza",
    "cabelo",
    "chop",
    "corte",
    "cosmetology",
    "cut",
    "groom",
    "hair",
    "haircut",
    "homem",
    "homem cortando o cabelo",
    "man",
    "man getting haircut",
    "menino",
    "parlor",
    "person",
    "salao",
    "shears",
    "smileys",
    "style"
  ],
  "💆‍♀️": [
    "1f486-200d-2640",
    "face",
    "getting",
    "headache",
    "massage",
    "massagem",
    "mulher",
    "mulher recebendo massagem facial",
    "relax",
    "relaxamento",
    "relaxing",
    "salon",
    "smileys",
    "soothe",
    "spa",
    "tension",
    "therapy",
    "treatment",
    "woman",
    "woman getting massage"
  ],
  "💆": [
    "1f486",
    "dor de cabeca",
    "face",
    "getting",
    "headache",
    "massage",
    "massagem",
    "massagem facial",
    "pele",
    "person",
    "person getting massage",
    "pessoa recebendo massagem facial",
    "relax",
    "relaxar",
    "relaxing",
    "rosto",
    "salon",
    "smileys",
    "soothe",
    "spa",
    "tensao",
    "tension",
    "therapy",
    "treatment"
  ],
  "💆‍♂️": [
    "1f486-200d-2642",
    "acalmar",
    "dor de cabeca",
    "face",
    "getting",
    "headache",
    "homem",
    "homem recebendo massagem facial",
    "man",
    "man getting massage",
    "massage",
    "massagem",
    "menino",
    "relax",
    "relaxamento",
    "relaxar",
    "relaxing",
    "rosto",
    "salao",
    "salon",
    "smileys",
    "soothe",
    "spa",
    "tensao",
    "tension",
    "tenso",
    "therapy",
    "treatment"
  ],
  "🧖‍♀️": [
    "1f9d6-200d-2640",
    "day",
    "luxurious",
    "mulher na sauna",
    "pamper",
    "relax",
    "room",
    "sauna",
    "smileys",
    "spa",
    "steam",
    "steambath",
    "unwind",
    "woman",
    "woman in steamy room"
  ],
  "🧖": [
    "1f9d6",
    "banho",
    "day",
    "homem",
    "luxurious",
    "mulher",
    "pamper",
    "person",
    "person in steamy room",
    "pessoa",
    "pessoa na sauna",
    "relax",
    "relaxar",
    "room",
    "sauna",
    "smileys",
    "spa",
    "steam",
    "steambath",
    "unwind"
  ],
  "🧖‍♂️": [
    "1f9d6-200d-2642",
    "day",
    "homem na sauna",
    "luxurious",
    "man",
    "man in steamy room",
    "pamper",
    "relax",
    "room",
    "sauna",
    "smileys",
    "spa",
    "steam",
    "steambath",
    "unwind"
  ],
  "💅": [
    "1f485",
    "bored",
    "care",
    "cosmeticos",
    "cosmetics",
    "done",
    "esmalte",
    "esmalte de unha",
    "makeup",
    "manicure",
    "mao",
    "nail",
    "nail polish",
    "polish",
    "smileys",
    "unhas",
    "whatever"
  ],
  "🤳": [
    "1f933",
    "camera",
    "celular",
    "foto",
    "phone",
    "selfie",
    "smartphone",
    "smileys"
  ],
  "💃": [
    "1f483",
    "bailarina",
    "danca",
    "dancando",
    "dance",
    "dancer",
    "dancing",
    "elegant",
    "festive",
    "flair",
    "flamenco",
    "groove",
    "let’s",
    "mulher",
    "mulher dancando",
    "pessoas",
    "salsa",
    "smileys",
    "tango",
    "vamos dancar",
    "woman",
    "woman dancing"
  ],
  "🕺": [
    "1f57a",
    "dancando",
    "dance",
    "dancer",
    "dancing",
    "elegant",
    "festive",
    "flair",
    "flamenco",
    "groove",
    "homem",
    "homem dancando",
    "let’s",
    "man",
    "man dancing",
    "salsa",
    "smileys",
    "tango"
  ],
  "👯‍♀️": [
    "1f46f-200d-2640",
    "bestie",
    "bff",
    "bunny",
    "counterpart",
    "dancarinas",
    "dancer",
    "double",
    "ear",
    "festa",
    "identical",
    "mulheres",
    "mulheres com orelhas de coelho",
    "orelha de coelho",
    "pair",
    "party",
    "partying",
    "people",
    "smileys",
    "soulmate",
    "twin",
    "twinsies",
    "women",
    "women with bunny ears"
  ],
  "👯": [
    "1f46f",
    "amigas",
    "bestie",
    "bff",
    "bunny",
    "coelho",
    "counterpart",
    "dancar",
    "dancarinas",
    "dancer",
    "double",
    "ear",
    "festa",
    "gemeas",
    "identical",
    "melhores",
    "orelhas",
    "pair",
    "party",
    "partying",
    "people",
    "people with bunny ears",
    "pessoas com orelhas de coelho",
    "smileys",
    "soulmate",
    "twin",
    "twinsies"
  ],
  "👯‍♂️": [
    "1f46f-200d-2642",
    "bestie",
    "bff",
    "bunny",
    "coelho",
    "counterpart",
    "dancarino",
    "dancer",
    "double",
    "ear",
    "festa",
    "homem",
    "homens com orelhas de coelho",
    "identical",
    "men",
    "men with bunny ears",
    "meninos",
    "orelhas",
    "pair",
    "party",
    "partying",
    "people",
    "smileys",
    "soulmate",
    "twin",
    "twinsies"
  ],
  "🕴️": [
    "1f574",
    "business",
    "homem",
    "homem de terno",
    "homem de terno levitando",
    "levitating",
    "person",
    "person in suit levitating",
    "smileys",
    "suit",
    "terno"
  ],
  "👩‍🦽": [
    "1f469-200d-1f9bd",
    "accessibility",
    "acessibilidade",
    "cadeira de rodas",
    "manual",
    "mulher",
    "mulher em cadeira de rodas manual",
    "smileys",
    "wheelchair",
    "woman",
    "woman in manual wheelchair"
  ],
  "🧑‍🦽": [
    "1f9d1-200d-1f9bd",
    "accessibility",
    "acessibilidade",
    "cadeira de rodas",
    "manual",
    "person",
    "person in manual wheelchair",
    "pessoa em cadeira de rodas manual",
    "smileys",
    "wheelchair"
  ],
  "👨‍🦽": [
    "1f468-200d-1f9bd",
    "accessibility",
    "acessibilidade",
    "cadeira de rodas",
    "homem",
    "homem em cadeira de rodas manual",
    "man",
    "man in manual wheelchair",
    "manual",
    "smileys",
    "wheelchair"
  ],
  "👩‍🦽‍➡️": [
    "1f469-200d-1f9bd-200d-27a1",
    "a",
    "accessibility",
    "acessibilidade",
    "cadeira de rodas",
    "de",
    "direita",
    "facing",
    "frente",
    "manual",
    "mulher",
    "mulher em cadeira de rodas manual",
    "mulher em cadeira de rodas manual: de frente para a direita",
    "para",
    "right",
    "smileys",
    "wheelchair",
    "woman",
    "woman in manual wheelchair: facing right"
  ],
  "🧑‍🦽‍➡️": [
    "1f9d1-200d-1f9bd-200d-27a1",
    "a",
    "accessibility",
    "acessibilidade",
    "cadeira de rodas",
    "de",
    "direita",
    "facing",
    "frente",
    "manual",
    "para",
    "person",
    "person in manual wheelchair: facing right",
    "pessoa em cadeira de rodas manual",
    "pessoa em cadeira de rodas manual: de frente para a direita",
    "right",
    "smileys",
    "wheelchair"
  ],
  "👨‍🦽‍➡️": [
    "1f468-200d-1f9bd-200d-27a1",
    "a",
    "accessibility",
    "acessibilidade",
    "cadeira de rodas",
    "de",
    "direita",
    "facing",
    "frente",
    "homem",
    "homem em cadeira de rodas manual",
    "homem em cadeira de rodas manual: de frente para a direita",
    "man",
    "man in manual wheelchair: facing right",
    "manual",
    "para",
    "right",
    "smileys",
    "wheelchair"
  ],
  "👩‍🦼": [
    "1f469-200d-1f9bc",
    "accessibility",
    "acessibilidade",
    "cadeira de rodas",
    "motorized",
    "mulher",
    "mulher em cadeira de rodas motorizada",
    "smileys",
    "wheelchair",
    "woman",
    "woman in motorized wheelchair"
  ],
  "🧑‍🦼": [
    "1f9d1-200d-1f9bc",
    "accessibility",
    "acessibilidade",
    "cadeira de rodas",
    "motorized",
    "person",
    "person in motorized wheelchair",
    "pessoa em cadeira de rodas motorizada",
    "smileys",
    "wheelchair"
  ],
  "👨‍🦼": [
    "1f468-200d-1f9bc",
    "accessibility",
    "acessibilidade",
    "cadeira de rodas",
    "homem",
    "homem em cadeira de rodas motorizada",
    "man",
    "man in motorized wheelchair",
    "motorized",
    "smileys",
    "wheelchair"
  ],
  "👩‍🦼‍➡️": [
    "1f469-200d-1f9bc-200d-27a1",
    "a",
    "accessibility",
    "acessibilidade",
    "cadeira de rodas",
    "de",
    "direita",
    "facing",
    "frente",
    "motorized",
    "mulher",
    "mulher em cadeira de rodas motorizada",
    "mulher em cadeira de rodas motorizada: de frente para a direita",
    "para",
    "right",
    "smileys",
    "wheelchair",
    "woman",
    "woman in motorized wheelchair: facing right"
  ],
  "🧑‍🦼‍➡️": [
    "1f9d1-200d-1f9bc-200d-27a1",
    "a",
    "accessibility",
    "acessibilidade",
    "cadeira de rodas",
    "de",
    "direita",
    "facing",
    "frente",
    "motorized",
    "para",
    "person",
    "person in motorized wheelchair: facing right",
    "pessoa em cadeira de rodas motorizada",
    "pessoa em cadeira de rodas motorizada: de frente para a direita",
    "right",
    "smileys",
    "wheelchair"
  ],
  "👨‍🦼‍➡️": [
    "1f468-200d-1f9bc-200d-27a1",
    "a",
    "accessibility",
    "acessibilidade",
    "cadeira de rodas",
    "de",
    "direita",
    "facing",
    "frente",
    "homem",
    "homem em cadeira de rodas motorizada",
    "homem em cadeira de rodas motorizada: de frente para a direita",
    "man",
    "man in motorized wheelchair: facing right",
    "motorized",
    "para",
    "right",
    "smileys",
    "wheelchair"
  ],
  "🚶‍♀️": [
    "1f6b6-200d-2640",
    "amble",
    "andando",
    "andar",
    "caminhada",
    "caminhando",
    "caminhar",
    "gait",
    "hike",
    "man",
    "mulher",
    "mulher andando",
    "pace",
    "passeio",
    "pedestre",
    "pedestrian",
    "perambulando",
    "smileys",
    "stride",
    "stroll",
    "walk",
    "walking",
    "woman",
    "woman walking"
  ],
  "🚶": [
    "1f6b6",
    "amble",
    "andar",
    "caminhada",
    "caminhar",
    "gait",
    "hike",
    "man",
    "pace",
    "passo",
    "pedestre",
    "pedestrian",
    "perambulando",
    "person",
    "person walking",
    "pessoa",
    "pessoa andando",
    "smileys",
    "stride",
    "stroll",
    "walk",
    "walking"
  ],
  "🚶‍♂️": [
    "1f6b6-200d-2642",
    "amble",
    "andar",
    "caminhar",
    "gait",
    "hike",
    "homem andando",
    "homem caminhando",
    "man",
    "man walking",
    "pace",
    "pedestrian",
    "smileys",
    "stride",
    "stroll",
    "walk",
    "walking"
  ],
  "🚶‍♀️‍➡️": [
    "1f6b6-200d-2640-200d-27a1",
    "a",
    "amble",
    "andando",
    "andar",
    "caminhada",
    "caminhando",
    "caminhar",
    "de",
    "direita",
    "facing",
    "frente",
    "gait",
    "hike",
    "man",
    "mulher",
    "mulher andando: de frente para a direita",
    "pace",
    "para",
    "passeio",
    "pedestre",
    "pedestrian",
    "perambulando",
    "right",
    "smileys",
    "stride",
    "stroll",
    "walk",
    "walking",
    "woman",
    "woman walking: facing right"
  ],
  "🚶‍➡️": [
    "1f6b6-200d-27a1",
    "a",
    "amble",
    "andar",
    "caminhada",
    "caminhar",
    "de",
    "direita",
    "facing",
    "frente",
    "gait",
    "hike",
    "man",
    "pace",
    "para",
    "passo",
    "pedestre",
    "pedestrian",
    "perambulando",
    "person",
    "person walking: facing right",
    "pessoa",
    "pessoa andando: de frente para a direita",
    "right",
    "smileys",
    "stride",
    "stroll",
    "walk",
    "walking"
  ],
  "🚶‍♂️‍➡️": [
    "1f6b6-200d-2642-200d-27a1",
    "a",
    "amble",
    "andar",
    "caminhar",
    "de",
    "direita",
    "facing",
    "frente",
    "gait",
    "hike",
    "homem andando",
    "homem andando: de frente para a direita",
    "homem caminhando",
    "man",
    "man walking: facing right",
    "pace",
    "para",
    "pedestrian",
    "right",
    "smileys",
    "stride",
    "stroll",
    "walk",
    "walking"
  ],
  "👩‍🦯": [
    "1f469-200d-1f9af",
    "accessibilidade",
    "accessibility",
    "blind",
    "cane",
    "cega",
    "deficiencia visual",
    "mulher",
    "mulher com bengala para cego",
    "probing",
    "smileys",
    "white",
    "woman",
    "woman with white cane"
  ],
  "🧑‍🦯": [
    "1f9d1-200d-1f9af",
    "accessibility",
    "acessibilidade",
    "blind",
    "cane",
    "cego",
    "person",
    "person with white cane",
    "pessoa com bengala para cego",
    "probing",
    "smileys",
    "white"
  ],
  "👨‍🦯": [
    "1f468-200d-1f9af",
    "accessibilidade",
    "accessibility",
    "blind",
    "cane",
    "cego",
    "homem",
    "homem com bengala para cego",
    "man",
    "man with white cane",
    "probing",
    "smileys",
    "white"
  ],
  "👩‍🦯‍➡️": [
    "1f469-200d-1f9af-200d-27a1",
    "a",
    "accessibilidade",
    "accessibility",
    "blind",
    "cane",
    "cega",
    "de",
    "deficiencia visual",
    "direita",
    "facing",
    "frente",
    "mulher",
    "mulher com bengala para cego",
    "mulher com bengala para cego: de frente para a direita",
    "para",
    "probing",
    "right",
    "smileys",
    "white",
    "woman",
    "woman with white cane: facing right"
  ],
  "🧑‍🦯‍➡️": [
    "1f9d1-200d-1f9af-200d-27a1",
    "a",
    "accessibility",
    "acessibilidade",
    "blind",
    "cane",
    "cego",
    "de",
    "direita",
    "facing",
    "frente",
    "para",
    "person",
    "person with white cane: facing right",
    "pessoa com bengala para cego",
    "pessoa com bengala para cego: de frente para a direita",
    "probing",
    "right",
    "smileys",
    "white"
  ],
  "👨‍🦯‍➡️": [
    "1f468-200d-1f9af-200d-27a1",
    "a",
    "accessibilidade",
    "accessibility",
    "blind",
    "cane",
    "cego",
    "de",
    "direita",
    "facing",
    "frente",
    "homem",
    "homem com bengala para cego",
    "homem com bengala para cego: de frente para a direita",
    "man",
    "man with white cane: facing right",
    "para",
    "probing",
    "right",
    "smileys",
    "white"
  ],
  "🧎‍♀️": [
    "1f9ce-200d-2640",
    "ajoelhada",
    "kneel",
    "kneeling",
    "knees",
    "mulher",
    "mulher ajoelhando",
    "smileys",
    "woman",
    "woman kneeling"
  ],
  "🧎": [
    "1f9ce",
    "ajoelhado",
    "ajoelhar",
    "joelhos",
    "kneel",
    "kneeling",
    "knees",
    "pedir",
    "person",
    "person kneeling",
    "pessoa",
    "pessoa ajoelhando",
    "por favor",
    "smileys"
  ],
  "🧎‍♂️": [
    "1f9ce-200d-2642",
    "ajoelhado",
    "homem",
    "homem ajoelhando",
    "kneel",
    "kneeling",
    "knees",
    "man",
    "man kneeling",
    "smileys"
  ],
  "🏃‍♀️": [
    "1f3c3-200d-2640",
    "corredora",
    "correndo",
    "corrida",
    "esporte",
    "fast",
    "garota",
    "guria",
    "hurry",
    "marathon",
    "maratona",
    "menina",
    "move",
    "mulher",
    "mulher correndo",
    "pressa",
    "quick",
    "race",
    "racing",
    "rapida",
    "rapido",
    "run",
    "rush",
    "smileys",
    "speed",
    "woman",
    "woman running"
  ],
  "🏃": [
    "1f3c3",
    "correndo",
    "correr",
    "corrida",
    "esporte",
    "fast",
    "hurry",
    "marathon",
    "maratona",
    "maratonista",
    "move",
    "person",
    "person running",
    "pessoa",
    "pessoa correndo",
    "pressa",
    "quick",
    "race",
    "racing",
    "run",
    "rush",
    "smileys",
    "speed"
  ],
  "🏃‍♂️": [
    "1f3c3-200d-2642",
    "corrida",
    "esporte",
    "fast",
    "homem",
    "homem correndo",
    "hurry",
    "man",
    "man running",
    "marathon",
    "maratona",
    "move",
    "quick",
    "race",
    "racing",
    "run",
    "rush",
    "smileys",
    "speed"
  ],
  "🏃‍♀️‍➡️": [
    "1f3c3-200d-2640-200d-27a1",
    "a",
    "corredora",
    "correndo",
    "corrida",
    "de",
    "direita",
    "esporte",
    "facing",
    "fast",
    "frente",
    "garota",
    "guria",
    "hurry",
    "marathon",
    "maratona",
    "menina",
    "move",
    "mulher",
    "mulher correndo: de frente para a direita",
    "para",
    "pressa",
    "quick",
    "race",
    "racing",
    "rapida",
    "rapido",
    "right",
    "run",
    "rush",
    "smileys",
    "speed",
    "woman",
    "woman running: facing right"
  ],
  "🏃‍➡️": [
    "1f3c3-200d-27a1",
    "a",
    "correndo",
    "correr",
    "corrida",
    "de",
    "direita",
    "esporte",
    "facing",
    "fast",
    "frente",
    "hurry",
    "marathon",
    "maratona",
    "maratonista",
    "move",
    "para",
    "person",
    "person running: facing right",
    "pessoa",
    "pessoa correndo: de frente para a direita",
    "pressa",
    "quick",
    "race",
    "racing",
    "right",
    "run",
    "rush",
    "smileys",
    "speed"
  ],
  "🏃‍♂️‍➡️": [
    "1f3c3-200d-2642-200d-27a1",
    "a",
    "corrida",
    "de",
    "direita",
    "esporte",
    "facing",
    "fast",
    "frente",
    "homem",
    "homem correndo",
    "homem correndo: de frente para a direita",
    "hurry",
    "man",
    "man running: facing right",
    "marathon",
    "maratona",
    "move",
    "para",
    "quick",
    "race",
    "racing",
    "right",
    "run",
    "rush",
    "smileys",
    "speed"
  ],
  "🧎‍♀️‍➡️": [
    "1f9ce-200d-2640-200d-27a1",
    "a",
    "ajoelhada",
    "de",
    "direita",
    "facing",
    "frente",
    "kneel",
    "kneeling",
    "knees",
    "mulher",
    "mulher ajoelhando",
    "mulher ajoelhando: de frente para a direita",
    "para",
    "right",
    "smileys",
    "woman",
    "woman kneeling: facing right"
  ],
  "🧎‍➡️": [
    "1f9ce-200d-27a1",
    "a",
    "ajoelhado",
    "ajoelhar",
    "de",
    "direita",
    "facing",
    "frente",
    "joelhos",
    "kneel",
    "kneeling",
    "knees",
    "para",
    "pedir",
    "person",
    "person kneeling: facing right",
    "pessoa",
    "pessoa ajoelhando: de frente para a direita",
    "por favor",
    "right",
    "smileys"
  ],
  "🧎‍♂️‍➡️": [
    "1f9ce-200d-2642-200d-27a1",
    "a",
    "ajoelhado",
    "de",
    "direita",
    "facing",
    "frente",
    "homem",
    "homem ajoelhando",
    "homem ajoelhando: de frente para a direita",
    "kneel",
    "kneeling",
    "knees",
    "man",
    "man kneeling: facing right",
    "para",
    "right",
    "smileys"
  ],
  "🧍‍♀️": [
    "1f9cd-200d-2640",
    "em pe",
    "mulher",
    "mulher em pe",
    "smileys",
    "stand",
    "standing",
    "woman",
    "woman standing"
  ],
  "🧍": [
    "1f9cd",
    "de pe",
    "person",
    "person standing",
    "pessoa em pe",
    "smileys",
    "stand",
    "standing"
  ],
  "🧍‍♂️": [
    "1f9cd-200d-2642",
    "em pe",
    "homem",
    "homem em pe",
    "man",
    "man standing",
    "smileys",
    "stand",
    "standing"
  ],
  "👫": [
    "1f46b",
    "amigos",
    "bae",
    "bestie",
    "bff",
    "casal",
    "couple",
    "dating",
    "flirt",
    "friends",
    "hand",
    "hold",
    "homem",
    "homem e mulher de maos dadas",
    "man",
    "maos dadas",
    "mulher",
    "pessoas",
    "smileys",
    "twins",
    "woman",
    "woman and man holding hands"
  ],
  "👭": [
    "1f46d",
    "amigas",
    "bae",
    "bestie",
    "bff",
    "casal",
    "couple",
    "dadas",
    "dating",
    "duas mulheres de maos dadas",
    "flirt",
    "friends",
    "gemeas",
    "girls",
    "hand",
    "hold",
    "maos",
    "parceiras",
    "parceria",
    "pessoa",
    "sisters",
    "smileys",
    "twins",
    "women",
    "women holding hands"
  ],
  "👬": [
    "1f46c",
    "amigos",
    "bae",
    "bestie",
    "bff",
    "boys",
    "brothers",
    "casal",
    "couple",
    "dating",
    "dois homens",
    "dois homens de maos dadas",
    "flirt",
    "friends",
    "gemeos",
    "hand",
    "hold",
    "homem",
    "irmaos",
    "maos dadas",
    "men",
    "men holding hands",
    "namorados",
    "pessoas",
    "smileys",
    "twins"
  ],
  "👩‍❤️‍👨": [
    "1f469-200d-2764-200d-1f468",
    "anniversary",
    "babe",
    "bae",
    "casal",
    "casal apaixonado",
    "casal apaixonado: mulher e homem",
    "casal com um coracao",
    "coracao",
    "couple",
    "couple with heart: woman, man",
    "dating",
    "heart",
    "homem",
    "kiss",
    "love",
    "man",
    "mulher",
    "person",
    "pessoas",
    "relationship",
    "romance",
    "smileys",
    "together",
    "woman",
    "you"
  ],
  "👩‍❤️‍👩": [
    "1f469-200d-2764-200d-1f469",
    "anniversary",
    "babe",
    "bae",
    "casal",
    "casal apaixonado",
    "casal apaixonado: mulher e mulher",
    "casal com um coracao",
    "coracao",
    "couple",
    "couple with heart: woman, woman",
    "dating",
    "heart",
    "kiss",
    "love",
    "mulher",
    "person",
    "pessoas",
    "relationship",
    "romance",
    "smileys",
    "together",
    "woman",
    "you"
  ],
  "💑": [
    "1f491",
    "anniversary",
    "babe",
    "bae",
    "casal",
    "casal apaixonado",
    "casal com um coracao",
    "coracao",
    "couple",
    "couple with heart",
    "dating",
    "heart",
    "kiss",
    "love",
    "person",
    "pessoas",
    "relationship",
    "romance",
    "smileys",
    "together",
    "you"
  ],
  "👨‍❤️‍👨": [
    "1f468-200d-2764-200d-1f468",
    "anniversary",
    "babe",
    "bae",
    "casal",
    "casal apaixonado",
    "casal apaixonado: homem e homem",
    "casal com um coracao",
    "coracao",
    "couple",
    "couple with heart: man, man",
    "dating",
    "heart",
    "homem",
    "kiss",
    "love",
    "man",
    "person",
    "pessoas",
    "relationship",
    "romance",
    "smileys",
    "together",
    "you"
  ],
  "👩‍❤️‍💋‍👨": [
    "1f469-200d-2764-200d-1f48b-200d-1f468",
    "amor",
    "anniversary",
    "babe",
    "bae",
    "beijar",
    "beijo",
    "beijo: mulher e homem",
    "casal",
    "coracao",
    "couple",
    "date",
    "dating",
    "heart",
    "homem",
    "kiss",
    "kiss: woman, man",
    "love",
    "man",
    "mulher",
    "mwah",
    "person",
    "pessoas",
    "romance",
    "smileys",
    "together",
    "woman",
    "xoxo"
  ],
  "👩‍❤️‍💋‍👩": [
    "1f469-200d-2764-200d-1f48b-200d-1f469",
    "amor",
    "anniversary",
    "babe",
    "bae",
    "beijar",
    "beijo",
    "beijo: mulher e mulher",
    "casal",
    "coracao",
    "couple",
    "date",
    "dating",
    "heart",
    "kiss",
    "kiss: woman, woman",
    "love",
    "mulher",
    "mwah",
    "person",
    "pessoas",
    "romance",
    "smileys",
    "together",
    "woman",
    "xoxo"
  ],
  "💏": [
    "1f48f",
    "amor",
    "anniversary",
    "babe",
    "bae",
    "beijar",
    "beijo",
    "casal",
    "coracao",
    "couple",
    "date",
    "dating",
    "heart",
    "kiss",
    "love",
    "mwah",
    "person",
    "pessoas",
    "romance",
    "smileys",
    "together",
    "xoxo"
  ],
  "👨‍❤️‍💋‍👨": [
    "1f468-200d-2764-200d-1f48b-200d-1f468",
    "amor",
    "anniversary",
    "babe",
    "bae",
    "beijar",
    "beijo",
    "beijo: homem e homem",
    "casal",
    "coracao",
    "couple",
    "date",
    "dating",
    "heart",
    "homem",
    "kiss",
    "kiss: man, man",
    "love",
    "man",
    "mwah",
    "person",
    "pessoas",
    "romance",
    "smileys",
    "together",
    "xoxo"
  ],
  "🪢": [
    "1faa2",
    "amarrar",
    "cord",
    "corda",
    "cordel",
    "emaranhado",
    "fio",
    "knot",
    "laco",
    "marinheiro",
    "no",
    "rope",
    "smileys",
    "tangled",
    "tie",
    "twine",
    "twist"
  ],
  "🧶": [
    "1f9f6",
    "ball",
    "bola",
    "croche",
    "crochet",
    "knit",
    "la",
    "novelo",
    "smileys",
    "trico",
    "tricotar",
    "yarn"
  ],
  "🧵": [
    "1f9f5",
    "agulha",
    "barbante",
    "carretel",
    "costura",
    "linha",
    "needle",
    "sewing",
    "smileys",
    "spool",
    "string",
    "thread"
  ],
  "🪡": [
    "1faa1",
    "agulha",
    "agulha de costura",
    "alfaiataria",
    "bordados",
    "costura",
    "embroidery",
    "linha",
    "needle",
    "pontos",
    "sew",
    "sewing",
    "sewing needle",
    "smileys",
    "stitches",
    "suturas",
    "sutures",
    "tailoring",
    "thread",
    "vagonite"
  ],
  "🧥": [
    "1f9e5",
    "agasalho",
    "blusa",
    "brr",
    "bundle",
    "casaco",
    "coat",
    "cold",
    "frio",
    "jacket",
    "jaqueta",
    "smileys",
    "up"
  ],
  "🥼": [
    "1f97c",
    "cientista",
    "clothes",
    "coat",
    "doctor",
    "dr",
    "dr.",
    "experiencia",
    "experiment",
    "experimento",
    "jacket",
    "jaleco",
    "lab",
    "lab coat",
    "medico",
    "roupa",
    "scientist",
    "smileys",
    "white"
  ],
  "🦺": [
    "1f9ba",
    "colete",
    "colete salva-vidas",
    "emergencia",
    "emergency",
    "refletivo",
    "safety",
    "safety vest",
    "salva-vidas",
    "seguranca",
    "smileys",
    "vest"
  ],
  "👚": [
    "1f45a",
    "azul",
    "blouse",
    "blusa",
    "camiseta",
    "clothes",
    "clothing",
    "collar",
    "dress",
    "dressed",
    "feminina",
    "lady",
    "roupa",
    "roupas femininas",
    "shirt",
    "shopping",
    "smileys",
    "woman",
    "woman’s",
    "woman’s clothes"
  ],
  "👕": [
    "1f455",
    "blue",
    "camisa",
    "camiseta",
    "casual",
    "clothes",
    "clothing",
    "collar",
    "dressed",
    "roupa",
    "shirt",
    "shopping",
    "smileys",
    "t-shirt",
    "tshirt",
    "weekend"
  ],
  "👖": [
    "1f456",
    "blue",
    "calca",
    "casual",
    "clothes",
    "clothing",
    "denim",
    "dressed",
    "jeans",
    "pants",
    "roupa",
    "shopping",
    "smileys",
    "trousers",
    "weekend"
  ],
  "🩲": [
    "1fa72",
    "banho",
    "bathing",
    "briefs",
    "cueca",
    "intima",
    "nadar",
    "one-piece",
    "praia",
    "roupa",
    "smileys",
    "suit",
    "sunga",
    "swimsuit",
    "underwear"
  ],
  "🩳": [
    "1fa73",
    "banho",
    "bathing",
    "bermuda",
    "nadar",
    "pants",
    "praia",
    "roupa",
    "shorts",
    "smileys",
    "suit",
    "swimsuit",
    "underwear"
  ],
  "👔": [
    "1f454",
    "acessorio",
    "clothing",
    "employed",
    "gravata",
    "necktie",
    "roupa",
    "serious",
    "shirt",
    "smileys",
    "tie"
  ],
  "👗": [
    "1f457",
    "clothes",
    "clothing",
    "dress",
    "dressed",
    "fancy",
    "peca unica",
    "roupa",
    "shopping",
    "smileys",
    "vestido"
  ],
  "👙": [
    "1f459",
    "banho",
    "bathing",
    "beach",
    "bikini",
    "biquini",
    "clothing",
    "piscina",
    "pool",
    "praia",
    "roupa",
    "smileys",
    "suit",
    "swim"
  ],
  "🩱": [
    "1fa71",
    "banho",
    "bathing",
    "maio",
    "nadar",
    "one-piece",
    "one-piece swimsuit",
    "praia",
    "roupa",
    "smileys",
    "suit",
    "swimsuit"
  ],
  "👘": [
    "1f458",
    "clothing",
    "comfortable",
    "kimono",
    "quimono",
    "roupa",
    "smileys",
    "vestir"
  ],
  "🥻": [
    "1f97b",
    "clothing",
    "dress",
    "india",
    "indiana",
    "roupa",
    "sari",
    "smileys",
    "vestido"
  ],
  "🩴": [
    "1fa74",
    "alpargatas",
    "beach",
    "chinelo",
    "flip",
    "flop",
    "piscina",
    "praia",
    "rasteirinha",
    "sandal",
    "sandalia",
    "sandals",
    "shoe",
    "smileys",
    "thong",
    "thong sandal",
    "thongs",
    "zori"
  ],
  "🥿": [
    "1f97f",
    "ballet",
    "comfy",
    "confortavel",
    "flat",
    "flat shoe",
    "flats",
    "sapatilha",
    "sapatilha de bale",
    "sapato",
    "sem fivela",
    "shoe",
    "slip-on",
    "slipper",
    "smileys"
  ],
  "👠": [
    "1f460",
    "acessorio",
    "alto",
    "chique",
    "clothes",
    "clothing",
    "dress",
    "fashion",
    "heel",
    "heels",
    "high-heeled",
    "high-heeled shoe",
    "moda",
    "mulher",
    "salto",
    "sapato",
    "sapato de salto alto",
    "scarpin",
    "shoe",
    "shoes",
    "shopping",
    "smileys",
    "stiletto",
    "woman"
  ],
  "👡": [
    "1f461",
    "acessorio",
    "clothing",
    "feminino",
    "medio",
    "salto",
    "sandal",
    "sandalia",
    "sandalia feminina",
    "shoe",
    "smileys",
    "woman",
    "woman’s",
    "woman’s sandal"
  ],
  "👢": [
    "1f462",
    "acessorio",
    "boot",
    "bota",
    "bota feminina",
    "calcado",
    "clothes",
    "clothing",
    "dress",
    "feminina",
    "medio",
    "salto",
    "shoe",
    "shoes",
    "shopping",
    "smileys",
    "woman",
    "woman’s",
    "woman’s boot"
  ],
  "👞": [
    "1f45e",
    "acessorio",
    "brown",
    "clothes",
    "clothing",
    "feet",
    "foot",
    "kick",
    "man",
    "man’s",
    "man’s shoe",
    "sapato masculino",
    "sapatos",
    "shoe",
    "shoes",
    "shopping",
    "smileys"
  ],
  "👟": [
    "1f45f",
    "acessorio",
    "athletic",
    "clothes",
    "clothing",
    "correr",
    "corrida",
    "esportivo",
    "fast",
    "kick",
    "running",
    "running shoe",
    "sapato",
    "shoe",
    "shoes",
    "shopping",
    "smileys",
    "sneaker",
    "tenis",
    "tenis de corrida",
    "tennis"
  ],
  "🥾": [
    "1f97e",
    "acampamento",
    "acampar",
    "backpacking",
    "boot",
    "bota",
    "bota de trekking",
    "brown",
    "caminhada",
    "camping",
    "hiking",
    "hiking boot",
    "marrom",
    "mochilao",
    "natureza",
    "outdoors",
    "sapato",
    "shoe",
    "smileys",
    "trilha"
  ],
  "🧦": [
    "1f9e6",
    "meia",
    "meiao",
    "meias",
    "smileys",
    "socks",
    "stocking"
  ],
  "🧤": [
    "1f9e4",
    "gloves",
    "hand",
    "inverno",
    "luva",
    "luvas",
    "mao",
    "smileys"
  ],
  "🧣": [
    "1f9e3",
    "bundle",
    "cachecol",
    "cold",
    "frio",
    "inverno",
    "neck",
    "pescoco",
    "scarf",
    "smileys",
    "up"
  ],
  "🎩": [
    "1f3a9",
    "cartola",
    "chapeu",
    "chique",
    "clothes",
    "clothing",
    "entretenimento",
    "fancy",
    "formal",
    "hat",
    "magic",
    "roupa",
    "smileys",
    "top",
    "top hat",
    "tophat"
  ],
  "🧢": [
    "1f9e2",
    "baseball",
    "bent",
    "billed",
    "billed cap",
    "bone",
    "bone de beisebol",
    "cap",
    "chapeu",
    "dad",
    "hat",
    "smileys"
  ],
  "👒": [
    "1f452",
    "acessorio",
    "chapeu",
    "chapeu feminino",
    "clothes",
    "clothing",
    "fashion",
    "feminino",
    "garden",
    "hat",
    "hats",
    "party",
    "smileys",
    "woman",
    "woman’s",
    "woman’s hat"
  ],
  "🎓": [
    "1f393",
    "cap",
    "capelo",
    "celebration",
    "chapeu",
    "chapeu de formatura",
    "clothing",
    "comemoracao",
    "education",
    "formatura",
    "graduation",
    "graduation cap",
    "hat",
    "scholar",
    "smileys"
  ],
  "⛑️": [
    "26d1",
    "aid",
    "ajuda",
    "branca",
    "capacacete de socorrista",
    "capacete",
    "cross",
    "cruz",
    "face",
    "hat",
    "helmet",
    "primeiros",
    "rescue",
    "rescue worker’s helmet",
    "resgate",
    "rosto",
    "salvamento",
    "smileys",
    "socorrista",
    "socorros",
    "vermelho",
    "worker’s"
  ],
  "🪖": [
    "1fa96",
    "army",
    "capacete",
    "capacete militar",
    "exercito",
    "guerra",
    "guerreiro",
    "helmet",
    "militar",
    "military",
    "military helmet",
    "smileys",
    "soldado",
    "soldier",
    "war",
    "warrior"
  ],
  "👑": [
    "1f451",
    "acessorio",
    "clothing",
    "coroa",
    "crown",
    "familia real",
    "family",
    "game of thrones",
    "king",
    "medieval",
    "queen",
    "rainha",
    "realeza",
    "rei",
    "reinado",
    "royal",
    "royalty",
    "smileys",
    "win"
  ],
  "💍": [
    "1f48d",
    "anel",
    "diamante",
    "diamond",
    "engaged",
    "engagement",
    "married",
    "ring",
    "romance",
    "shiny",
    "smileys",
    "sparkling",
    "wedding"
  ],
  "👝": [
    "1f45d",
    "acessorio",
    "bag",
    "bolsa",
    "bolsa pequena",
    "carteira",
    "clothes",
    "clothing",
    "clutch",
    "clutch bag",
    "dress",
    "fashion",
    "handbag",
    "pequena",
    "pouch",
    "purse",
    "smileys"
  ],
  "👛": [
    "1f45b",
    "acessorio",
    "bolsa",
    "bolsinha",
    "clothes",
    "clothing",
    "coin",
    "dress",
    "fancy",
    "handbag",
    "moeda",
    "niqueleira",
    "porta",
    "purse",
    "rosa",
    "shopping",
    "smileys"
  ],
  "👜": [
    "1f45c",
    "acessorio",
    "bag",
    "bolsa",
    "bolsa de mao",
    "clothes",
    "clothing",
    "dress",
    "fashion",
    "handbag",
    "lady",
    "mala",
    "mao",
    "purse",
    "shopping",
    "smileys"
  ],
  "💼": [
    "1f4bc",
    "briefcase",
    "mala",
    "maleta",
    "office",
    "pasta",
    "smileys"
  ],
  "🎒": [
    "1f392",
    "backpack",
    "backpacking",
    "bag",
    "bolsa",
    "bookbag",
    "education",
    "escola",
    "mochila",
    "rucksack",
    "satchel",
    "school",
    "smileys",
    "viagem",
    "viajar"
  ],
  "🧳": [
    "1f9f3",
    "bag",
    "bagagem",
    "luggage",
    "mala",
    "packing",
    "rodinhas",
    "roller",
    "smileys",
    "suitcase",
    "travel",
    "viagem"
  ],
  "👓": [
    "1f453",
    "acessorio",
    "clothing",
    "eye",
    "eyeglasses",
    "eyewear",
    "glasses",
    "oculos",
    "smileys"
  ],
  "🕶️": [
    "1f576",
    "dark",
    "eye",
    "eyewear",
    "glasses",
    "oculos",
    "oculos de sol",
    "oculos escuros",
    "smileys",
    "sunglasses"
  ],
  "🥽": [
    "1f97d",
    "dive",
    "eye",
    "goggles",
    "mergulho",
    "natacao",
    "oculos",
    "oculos de protecao",
    "olhos",
    "protecao",
    "protection",
    "scuba",
    "ski",
    "smileys",
    "solda",
    "soldagem",
    "swimming",
    "welding"
  ],
  "🌂": [
    "1f302",
    "chuva",
    "chuvoso",
    "closed",
    "closed umbrella",
    "clothing",
    "guarda-chuva",
    "guarda-chuva fechado",
    "rain",
    "smileys",
    "umbrella"
  ],
  "🐶": [
    "1f436",
    "adorbs",
    "animal",
    "cachorro",
    "dog",
    "dog face",
    "face",
    "natureza",
    "pet",
    "puppies",
    "puppy",
    "rosto",
    "rosto de cachorro"
  ],
  "🐱": [
    "1f431",
    "animal",
    "cat",
    "cat face",
    "face",
    "felino",
    "gatinho",
    "gato",
    "kitten",
    "kitty",
    "natureza",
    "pet",
    "rosto",
    "rosto de gato"
  ],
  "🐭": [
    "1f42d",
    "animal",
    "camundongo",
    "face",
    "mouse",
    "mouse face",
    "natureza",
    "ratinho",
    "rato",
    "rosto",
    "rosto de camundongo"
  ],
  "🐹": [
    "1f439",
    "animal",
    "face",
    "hamster",
    "natureza",
    "pet",
    "rosto",
    "rosto de hamster"
  ],
  "🐰": [
    "1f430",
    "animal",
    "bunny",
    "coelho",
    "face",
    "natureza",
    "pet",
    "rabbit",
    "rabbit face",
    "rosto",
    "rosto de coelho"
  ],
  "🦊": [
    "1f98a",
    "animal",
    "bicho",
    "face",
    "fox",
    "natureza",
    "raposa",
    "rosto",
    "rosto de raposa"
  ],
  "🐻": [
    "1f43b",
    "animal",
    "bear",
    "face",
    "grizzly",
    "growl",
    "honey",
    "natureza",
    "rosto",
    "rosto de urso",
    "urso"
  ],
  "🐼": [
    "1f43c",
    "animal",
    "bamboo",
    "face",
    "natureza",
    "panda",
    "rosto",
    "rosto de panda"
  ],
  "🐻‍❄️": [
    "1f43b-200d-2744",
    "animal",
    "arctic",
    "artico",
    "bear",
    "branco",
    "natureza",
    "polar",
    "polar bear",
    "urso",
    "urso polar",
    "white"
  ],
  "🐨": [
    "1f428",
    "animal",
    "australia",
    "bear",
    "coala",
    "down",
    "face",
    "koala",
    "marsupial",
    "natureza",
    "under"
  ],
  "🐯": [
    "1f42f",
    "animal",
    "big",
    "cat",
    "face",
    "natureza",
    "predator",
    "rosto de tigre",
    "tiger",
    "tiger face",
    "tigre"
  ],
  "🦁": [
    "1f981",
    "alpha",
    "animal",
    "face",
    "leao",
    "leo",
    "lion",
    "mane",
    "natureza",
    "order",
    "rawr",
    "roar",
    "rosto",
    "rosto de leao",
    "safari",
    "strong",
    "zodiac",
    "zodiaco"
  ],
  "🐮": [
    "1f42e",
    "animal",
    "cow",
    "cow face",
    "face",
    "farm",
    "fazenda",
    "leite",
    "milk",
    "moo",
    "muuu",
    "natureza",
    "rosto",
    "rosto de vaca",
    "vaca",
    "vaquinha"
  ],
  "🐷": [
    "1f437",
    "animal",
    "bacon",
    "face",
    "farm",
    "natureza",
    "pig",
    "pig face",
    "porco",
    "pork",
    "rosto",
    "rosto de porco"
  ],
  "🐽": [
    "1f43d",
    "animal",
    "face",
    "farm",
    "nariz",
    "nariz de porco",
    "natureza",
    "nose",
    "pig",
    "pig nose",
    "porco",
    "rosto",
    "smell",
    "snout"
  ],
  "🐸": [
    "1f438",
    "animal",
    "face",
    "frog",
    "natureza",
    "rosto",
    "rosto de sapo",
    "sapo"
  ],
  "🐵": [
    "1f435",
    "animal",
    "banana",
    "face",
    "macaco",
    "monkey",
    "monkey face",
    "natureza",
    "rosto",
    "rosto de macaco"
  ],
  "🙈": [
    "1f648",
    "embarrassed",
    "envergonhado",
    "evil",
    "face",
    "forbidden",
    "forgot",
    "gesture",
    "hide",
    "macaco",
    "macaco que nao ve nada",
    "monkey",
    "nao veja o mal",
    "nao vi nada",
    "natureza",
    "no",
    "olhos",
    "omg",
    "prohibited",
    "scared",
    "secret",
    "see-no-evil monkey",
    "smh",
    "tapados",
    "vergonha",
    "watch"
  ],
  "🙉": [
    "1f649",
    "animal",
    "ears",
    "evil",
    "face",
    "forbidden",
    "gesture",
    "hear",
    "hear-no-evil monkey",
    "listen",
    "macaco",
    "macaco que nao ouve nada",
    "monkey",
    "nao ouca o mal",
    "nao ouco",
    "nao ouve nada",
    "nao quero ouvir",
    "natureza",
    "no",
    "not",
    "ouvidos",
    "prohibited",
    "secret",
    "shh",
    "tapados",
    "tmi"
  ],
  "🙊": [
    "1f64a",
    "animal",
    "boca tapada",
    "evil",
    "face",
    "forbidden",
    "gesture",
    "macaco",
    "macaco que nao fala nada",
    "monkey",
    "nao",
    "nao fale nada",
    "nao posso contar",
    "nao posso falar",
    "natureza",
    "no",
    "not",
    "oops",
    "prohibited",
    "quiet",
    "secret",
    "segredo",
    "silencio",
    "speak",
    "speak-no-evil monkey",
    "stealth",
    "ups"
  ],
  "🐒": [
    "1f412",
    "animal",
    "banana",
    "macaco",
    "monkey",
    "natureza"
  ],
  "🐔": [
    "1f414",
    "animal",
    "ave",
    "bird",
    "chicken",
    "galinha",
    "natureza",
    "ornithology"
  ],
  "🐧": [
    "1f427",
    "animal",
    "antarctica",
    "antartica",
    "bird",
    "frio",
    "natureza",
    "ornithology",
    "penguin",
    "pinguim"
  ],
  "🐦": [
    "1f426",
    "animal",
    "bird",
    "natureza",
    "ornithology",
    "passaro"
  ],
  "🐤": [
    "1f424",
    "animal",
    "ave",
    "baby",
    "baby chick",
    "bebe",
    "bird",
    "chick",
    "filhote",
    "galinha",
    "natureza",
    "ornithology",
    "pintinho",
    "pintinho de perfil",
    "pinto",
    "rosto de pintinho"
  ],
  "🐣": [
    "1f423",
    "animal",
    "ave",
    "baby",
    "bebe",
    "bird",
    "chick",
    "chocando",
    "egg",
    "filhote",
    "galinha",
    "hatching",
    "hatching chick",
    "natureza",
    "pintinho",
    "pintinho chocando",
    "pinto"
  ],
  "🐥": [
    "1f425",
    "animal",
    "ave",
    "baby",
    "bebe",
    "bird",
    "chick",
    "fihote",
    "front-facing",
    "front-facing baby chick",
    "galinha",
    "natureza",
    "newborn",
    "ornithology",
    "pintinho",
    "pintinho de frente",
    "pintinho olhando para frente",
    "pinto"
  ],
  "🪿": [
    "1fabf",
    "animal",
    "ave",
    "bird",
    "bobo",
    "duck",
    "flock",
    "fowl",
    "gaggle",
    "gander",
    "ganso",
    "gansos",
    "geese",
    "goose",
    "grasno",
    "honk",
    "marreco",
    "natureza",
    "ornithology",
    "passaro",
    "pato",
    "silly"
  ],
  "🦆": [
    "1f986",
    "animal",
    "bird",
    "duck",
    "natureza",
    "ornithology",
    "passaro",
    "pato"
  ],
  "🐦‍⬛": [
    "1f426-200d-2b1b",
    "animal",
    "ave",
    "beak",
    "bico",
    "bird",
    "black",
    "black bird",
    "caw",
    "corvid",
    "corvo",
    "crow",
    "gralha",
    "natureza",
    "ornithology",
    "passarinho",
    "passaro",
    "passaro preto",
    "preto",
    "raven",
    "rook"
  ],
  "🦅": [
    "1f985",
    "aguia",
    "animal",
    "bird",
    "eagle",
    "natureza",
    "ornithology",
    "passaro"
  ],
  "🦉": [
    "1f989",
    "animal",
    "bird",
    "coruja",
    "natureza",
    "ornithology",
    "owl",
    "passaro",
    "sabedoria",
    "wise"
  ],
  "🦇": [
    "1f987",
    "animal",
    "bat",
    "morcego",
    "natureza",
    "vampire",
    "vampiro"
  ],
  "🐺": [
    "1f43a",
    "animal",
    "face",
    "lobo",
    "natureza",
    "rosto",
    "rosto de lobo",
    "wolf"
  ],
  "🐗": [
    "1f417",
    "animal",
    "boar",
    "javali",
    "natureza",
    "pig"
  ],
  "🐴": [
    "1f434",
    "animal",
    "cavalo",
    "dressage",
    "equine",
    "equino",
    "face",
    "farm",
    "horse",
    "horse face",
    "horses",
    "natureza",
    "rosto",
    "rosto de cavalo"
  ],
  "🦄": [
    "1f984",
    "animal",
    "face",
    "natureza",
    "rosto",
    "rosto de unicornio",
    "unicorn",
    "unicornio"
  ],
  "🫎": [
    "1face",
    "alce",
    "alces",
    "animal",
    "antlers",
    "cervo",
    "chifres",
    "elk",
    "galhada",
    "mamifero",
    "mammal",
    "moose",
    "natureza",
    "rena"
  ],
  "🐝": [
    "1f41d",
    "abelha",
    "animal",
    "bee",
    "bumblebee",
    "honey",
    "honeybee",
    "insect",
    "inseto",
    "nature",
    "natureza",
    "spring"
  ],
  "🪱": [
    "1fab1",
    "anelideo",
    "animal",
    "annelid",
    "earthworm",
    "minhoca",
    "natureza",
    "parasita",
    "parasite",
    "verme",
    "worm"
  ],
  "🐛": [
    "1f41b",
    "animal",
    "bug",
    "centopeia",
    "garden",
    "insect",
    "inseto",
    "lagarta",
    "natureza"
  ],
  "🦋": [
    "1f98b",
    "beleza",
    "borboleta",
    "butterfly",
    "insect",
    "inseto",
    "natureza",
    "pretty"
  ],
  "🐌": [
    "1f40c",
    "animal",
    "caracol",
    "escargot",
    "garden",
    "nature",
    "natureza",
    "slug",
    "snail"
  ],
  "🐞": [
    "1f41e",
    "animal",
    "beetle",
    "besouro",
    "garden",
    "insect",
    "inseto",
    "joaninha",
    "lady",
    "lady beetle",
    "ladybird",
    "ladybug",
    "nature",
    "natureza",
    "tipo de besouro"
  ],
  "🐜": [
    "1f41c",
    "animal",
    "ant",
    "formiga",
    "garden",
    "insect",
    "inseto",
    "natureza"
  ],
  "🪰": [
    "1fab0",
    "animal",
    "apodrecendo",
    "disease",
    "doenca",
    "fly",
    "insect",
    "inseto",
    "larva",
    "maggot",
    "mosca",
    "mosca-varejeira",
    "natureza",
    "pest",
    "praga",
    "rotting",
    "varejeira"
  ],
  "🪲": [
    "1fab2",
    "animal",
    "beetle",
    "besouro",
    "bicho",
    "bug",
    "insect",
    "inseto",
    "natureza"
  ],
  "🪳": [
    "1fab3",
    "animal",
    "barata",
    "baratas",
    "cockroach",
    "insect",
    "inseto",
    "natureza",
    "nojento",
    "nojo",
    "pest",
    "praga",
    "roach"
  ],
  "🦟": [
    "1f99f",
    "aedes",
    "aegypti",
    "amarela",
    "animal",
    "bite",
    "chicungunha",
    "dengue",
    "disease",
    "doenca",
    "febre",
    "fever",
    "insect",
    "inseto",
    "malaria",
    "mosquito",
    "natureza",
    "pernilongo",
    "pest",
    "virus",
    "zica"
  ],
  "🦗": [
    "1f997",
    "animal",
    "bug",
    "cricket",
    "gafanhoto",
    "grasshopper",
    "grilo",
    "insect",
    "inseto",
    "natureza",
    "orthoptera"
  ],
  "🕷️": [
    "1f577",
    "animal",
    "aranha",
    "dias das bruxas",
    "halloween",
    "insect",
    "inseto",
    "natureza",
    "spider"
  ],
  "🕸️": [
    "1f578",
    "aranha",
    "halloween",
    "inseto",
    "natureza",
    "spider",
    "spider web",
    "teia",
    "teia de aranha",
    "web"
  ],
  "🦂": [
    "1f982",
    "animal",
    "deserto",
    "escorpiao",
    "inseto",
    "natureza",
    "scorpio",
    "scorpion",
    "scorpius",
    "zodiac",
    "zodiaco"
  ],
  "🐢": [
    "1f422",
    "animal",
    "natureza",
    "tartaruga",
    "terrapin",
    "tortoise",
    "turtle"
  ],
  "🐍": [
    "1f40d",
    "animal",
    "bearer",
    "cobra",
    "natureza",
    "ophiuchus",
    "reptil",
    "serpent",
    "serpente",
    "snake",
    "zodiac"
  ],
  "🦎": [
    "1f98e",
    "animal",
    "lagartixa",
    "lagarto",
    "lizard",
    "natureza",
    "reptil",
    "reptile"
  ],
  "🦖": [
    "1f996",
    "dinosaur",
    "dinossauro",
    "natureza",
    "rex",
    "t",
    "t-rex",
    "tiranossauro rex",
    "tyrannosaurus"
  ],
  "🦕": [
    "1f995",
    "brachiosaurus",
    "braquiosaurus",
    "braquiossauro",
    "brontosaurus",
    "brontossauro",
    "brontossuro",
    "dinosaur",
    "dinossauro",
    "diplodoco",
    "diplodocus",
    "natureza",
    "sauropod",
    "sauropode"
  ],
  "🐙": [
    "1f419",
    "animal",
    "creature",
    "natureza",
    "ocean",
    "oceano",
    "octopus",
    "polvo"
  ],
  "🦑": [
    "1f991",
    "animal",
    "comida",
    "food",
    "lula",
    "mollusk",
    "molusco",
    "natureza",
    "squid"
  ],
  "🪼": [
    "1fabc",
    "agua-viva",
    "ai",
    "animal",
    "aquario",
    "aquarium",
    "burn",
    "ferrao",
    "invertebrado",
    "invertebrate",
    "jelly",
    "jellyfish",
    "life",
    "mar",
    "marine",
    "marinha",
    "medusa",
    "natureza",
    "ocean",
    "oceano",
    "ouch",
    "plankton",
    "queimadura",
    "sea",
    "sting",
    "stinger",
    "tentacles",
    "tentaculos"
  ],
  "🦐": [
    "1f990",
    "animal",
    "camarao",
    "comida",
    "crustaceo",
    "food",
    "natureza",
    "shellfish",
    "shrimp",
    "small"
  ],
  "🦞": [
    "1f99e",
    "animal",
    "bisque",
    "caldo",
    "claws",
    "fruto do mar",
    "garras",
    "lagosta",
    "lobster",
    "natureza",
    "seafood"
  ],
  "🦀": [
    "1f980",
    "animal",
    "animal marinho",
    "cancer",
    "caranguejo",
    "crab",
    "natureza",
    "signo de cancer",
    "zodiac",
    "zodiaco"
  ],
  "🐡": [
    "1f421",
    "animal",
    "baiacu",
    "blowfish",
    "fish",
    "natureza",
    "peixe"
  ],
  "🐠": [
    "1f420",
    "animal",
    "fish",
    "fishes",
    "natureza",
    "peixe",
    "peixe tropical",
    "tropical",
    "tropical fish"
  ],
  "🐟": [
    "1f41f",
    "animal",
    "dinner",
    "fish",
    "fishes",
    "fishing",
    "natureza",
    "peixe",
    "peixes",
    "pesca",
    "pescar",
    "pisces",
    "signo de peixes",
    "zodiac",
    "zodiaco"
  ],
  "🐬": [
    "1f42c",
    "animal",
    "beach",
    "dolphin",
    "flipper",
    "golfinho",
    "natureza",
    "ocean",
    "oceano"
  ],
  "🐳": [
    "1f433",
    "animal",
    "baleia",
    "baleia esguichando agua",
    "beach",
    "esguicho",
    "face",
    "natureza",
    "ocean",
    "spouting",
    "spouting whale",
    "whale"
  ],
  "🐋": [
    "1f40b",
    "animal",
    "baleia",
    "beach",
    "mar",
    "natureza",
    "ocean",
    "oceano",
    "whale"
  ],
  "🦈": [
    "1f988",
    "animal",
    "fish",
    "natureza",
    "peixe",
    "shark",
    "tubarao"
  ],
  "🦭": [
    "1f9ad",
    "animal",
    "animal marinho",
    "foca",
    "leao marinho",
    "leao-marinho",
    "lion",
    "natureza",
    "ocean",
    "oceano",
    "sea",
    "seal"
  ],
  "🐊": [
    "1f40a",
    "animal",
    "crocodile",
    "crocodilo",
    "jacare",
    "natureza",
    "zoo"
  ],
  "🐅": [
    "1f405",
    "animal",
    "big",
    "cat",
    "natureza",
    "predator",
    "tiger",
    "tigre",
    "zoo"
  ],
  "🐆": [
    "1f406",
    "animal",
    "big",
    "cat",
    "leopard",
    "leopardo",
    "natureza",
    "onca",
    "predator",
    "zoo"
  ],
  "🦓": [
    "1f993",
    "animal",
    "listra",
    "listras",
    "natureza",
    "stripe",
    "zebra"
  ],
  "🦍": [
    "1f98d",
    "animal",
    "gorila",
    "gorilla",
    "macaco",
    "natureza"
  ],
  "🦧": [
    "1f9a7",
    "animal",
    "ape",
    "macaco",
    "monkey",
    "natureza",
    "orangotango",
    "orangutan",
    "primata"
  ],
  "🦣": [
    "1f9a3",
    "animal",
    "extinction",
    "extinto",
    "grande",
    "lanoso",
    "large",
    "mammoth",
    "mamute",
    "natureza",
    "pre-historico",
    "presa",
    "tusk",
    "wooly"
  ],
  "🐘": [
    "1f418",
    "animal",
    "elefante",
    "elephant",
    "natureza"
  ],
  "🦛": [
    "1f99b",
    "animal",
    "hipopotamo",
    "hippo",
    "hippopotamus",
    "natureza"
  ],
  "🦏": [
    "1f98f",
    "animal",
    "natureza",
    "rhinoceros",
    "rinoceronte"
  ],
  "🐪": [
    "1f42a",
    "animal",
    "camel",
    "camelo",
    "camelo de uma so corcova",
    "corcova",
    "desert",
    "deserto",
    "dromedario",
    "dromedary",
    "hump",
    "natureza",
    "one"
  ],
  "🐫": [
    "1f42b",
    "animal",
    "bactrian",
    "camel",
    "camelo",
    "camelo asiatico com duas corcovas",
    "camelo com duas corcovas",
    "corcova",
    "desert",
    "deserto",
    "hump",
    "natureza",
    "two",
    "two-hump",
    "two-hump camel"
  ],
  "🦒": [
    "1f992",
    "animal",
    "girafa",
    "giraffe",
    "natureza",
    "spots"
  ],
  "🦘": [
    "1f998",
    "animal",
    "australia",
    "canguru",
    "filhote",
    "joey",
    "jump",
    "kangaroo",
    "marsupial",
    "natureza",
    "pula",
    "pulo",
    "salto"
  ],
  "🦬": [
    "1f9ac",
    "animal",
    "bisao",
    "bison",
    "bisonte",
    "bufalo",
    "buffalo",
    "herd",
    "natureza",
    "rebanho",
    "wisent"
  ],
  "🐃": [
    "1f403",
    "agua",
    "animal",
    "bufalo",
    "bufalo-asiatico",
    "buffalo",
    "natureza",
    "water",
    "water buffalo",
    "zoo"
  ],
  "🐂": [
    "1f402",
    "animal",
    "animals",
    "boi",
    "bull",
    "farm",
    "natureza",
    "ox",
    "taurus",
    "touro",
    "zodiac",
    "zodiaco"
  ],
  "🐄": [
    "1f404",
    "animal",
    "animals",
    "cow",
    "farm",
    "fazenda",
    "milk",
    "moo",
    "natureza",
    "vaca"
  ],
  "🫏": [
    "1facf",
    "animais",
    "animal",
    "asno",
    "ass",
    "burro",
    "donkey",
    "hinny",
    "jegue",
    "mamifero",
    "mammal",
    "mula",
    "mule",
    "natureza",
    "relinchar",
    "relincho",
    "stubborn",
    "teimosa",
    "teimoso"
  ],
  "🐎": [
    "1f40e",
    "animal",
    "cavalo",
    "corrida",
    "equestre",
    "equestrian",
    "farm",
    "horse",
    "natureza",
    "racehorse",
    "racing"
  ],
  "🐖": [
    "1f416",
    "animal",
    "bacon",
    "farm",
    "natureza",
    "pig",
    "porco",
    "pork",
    "sow"
  ],
  "🐏": [
    "1f40f",
    "animal",
    "aries",
    "carneiro",
    "chifre",
    "horns",
    "male",
    "natureza",
    "ram",
    "sheep",
    "zodiac",
    "zodiaco",
    "zoo"
  ],
  "🐑": [
    "1f411",
    "animal",
    "baa",
    "ewe",
    "farm",
    "fazenda",
    "female",
    "fluffy",
    "la",
    "lamb",
    "natureza",
    "ovelha",
    "sheep",
    "wool"
  ],
  "🦙": [
    "1f999",
    "alpaca",
    "animal",
    "guanaco",
    "la",
    "lhama",
    "llama",
    "natureza",
    "vicuna",
    "vicunha",
    "wool"
  ],
  "🐐": [
    "1f410",
    "animal",
    "bode",
    "cabra",
    "capricorn",
    "capricornio",
    "farm",
    "goat",
    "milk",
    "natureza",
    "zodiac",
    "zodiaco"
  ],
  "🦌": [
    "1f98c",
    "animal",
    "cervo",
    "deer",
    "natureza",
    "veado"
  ],
  "🐕": [
    "1f415",
    "animal",
    "animals",
    "cachorro",
    "cao",
    "dog",
    "dogs",
    "natureza",
    "pet"
  ],
  "🐩": [
    "1f429",
    "animal",
    "cachorro",
    "dog",
    "fluffy",
    "natureza",
    "poodle"
  ],
  "🦮": [
    "1f9ae",
    "accessibility",
    "acessibilidade",
    "animal",
    "blind",
    "cachorro",
    "cadela",
    "cao",
    "cao-guia",
    "cega",
    "cego",
    "cegueira",
    "deficiencia visual",
    "dog",
    "guia",
    "guide",
    "guide dog",
    "labrador",
    "natureza"
  ],
  "🐕‍🦺": [
    "1f415-200d-1f9ba",
    "accessibilidade",
    "accessibility",
    "animal",
    "assistance",
    "assistencia",
    "cachorro",
    "cadela",
    "cao",
    "cao de servico",
    "cao-guia",
    "dog",
    "natureza",
    "pastor alemao",
    "service",
    "service dog",
    "servico"
  ],
  "🐈": [
    "1f408",
    "animal",
    "animals",
    "cat",
    "cats",
    "felino",
    "gato",
    "kitten",
    "natureza",
    "pet"
  ],
  "🐈‍⬛": [
    "1f408-200d-2b1b",
    "animal",
    "azar",
    "black",
    "black cat",
    "cat",
    "dia das bruxas",
    "feline",
    "felino",
    "gata",
    "gato",
    "gato preto",
    "halloween",
    "meow",
    "miado",
    "miau",
    "natureza",
    "preto",
    "unlucky"
  ],
  "🪶": [
    "1fab6",
    "bird",
    "feather",
    "flight",
    "leve",
    "light",
    "natureza",
    "passaro",
    "pena",
    "plumage",
    "plumagem",
    "voo"
  ],
  "🪽": [
    "1fabd",
    "angelic",
    "angelical",
    "anjo",
    "asa",
    "ascend",
    "ascender",
    "aviacao",
    "aviation",
    "bird",
    "celestial",
    "fly",
    "flying",
    "heavenly",
    "mitologia",
    "mythology",
    "natureza",
    "passaro",
    "soar",
    "voando",
    "voar",
    "voar alto",
    "wing"
  ],
  "🐓": [
    "1f413",
    "animal",
    "ave",
    "bird",
    "galo",
    "natureza",
    "ornithology",
    "rooster"
  ],
  "🦃": [
    "1f983",
    "animal",
    "ave",
    "bird",
    "gobble",
    "natureza",
    "peru",
    "peru de natal",
    "thanksgiving",
    "turkey"
  ],
  "🦤": [
    "1f9a4",
    "animal",
    "ave",
    "bird",
    "dodo",
    "extinction",
    "extinto",
    "grande",
    "large",
    "mauricio",
    "natureza",
    "ornithology",
    "passaro"
  ],
  "🦚": [
    "1f99a",
    "animal",
    "ave",
    "bird",
    "colorful",
    "colorido",
    "natureza",
    "orgulhoso",
    "ornithology",
    "ostentatious",
    "pavao",
    "pavoa",
    "peacock",
    "peahen",
    "pomposo",
    "pretty",
    "proud"
  ],
  "🦜": [
    "1f99c",
    "animal",
    "ave",
    "bird",
    "fala",
    "natureza",
    "ornithology",
    "papagaio",
    "parrot",
    "passaro",
    "pirata",
    "pirate",
    "repete",
    "talk"
  ],
  "🦢": [
    "1f9a2",
    "animal",
    "ave",
    "bird",
    "cisne",
    "cygnet",
    "duckling",
    "natureza",
    "ornithology",
    "passaro",
    "patinho feio",
    "swan",
    "ugly"
  ],
  "🦩": [
    "1f9a9",
    "animal",
    "ave",
    "bird",
    "extravagante",
    "flamboyant",
    "flamingo",
    "natureza",
    "ornithology",
    "tropical"
  ],
  "🕊️": [
    "1f54a",
    "animal",
    "ave branca",
    "bird",
    "dove",
    "fly",
    "natureza",
    "ornithology",
    "passaro",
    "paz",
    "peace",
    "pomba",
    "pomba branca"
  ],
  "🐇": [
    "1f407",
    "animal",
    "bunny",
    "coelhinho",
    "coelhinho da pascoa",
    "coelho",
    "natureza",
    "pet",
    "rabbit"
  ],
  "🦝": [
    "1f99d",
    "animal",
    "astuto",
    "curioso",
    "curious",
    "guaxinim",
    "natureza",
    "raccoon",
    "sly",
    "travesso"
  ],
  "🦨": [
    "1f9a8",
    "animal",
    "fedida",
    "fedido",
    "fedor",
    "gamba",
    "natureza",
    "skunk",
    "stink"
  ],
  "🦡": [
    "1f9a1",
    "animal",
    "badger",
    "honey",
    "incomodar",
    "natureza",
    "pester",
    "ratel",
    "texugo",
    "texugo de mel"
  ],
  "🦫": [
    "1f9ab",
    "animal",
    "beaver",
    "castor",
    "dam",
    "dentuco",
    "natureza",
    "represa",
    "teeth"
  ],
  "🦦": [
    "1f9a6",
    "animal",
    "brincalhona",
    "fishing",
    "lontra",
    "natureza",
    "otter",
    "pesca",
    "playful"
  ],
  "🦥": [
    "1f9a5",
    "bicho-preguica",
    "devagar",
    "lazy",
    "lenta",
    "lentidao",
    "natureza",
    "preguica",
    "preguicosa",
    "preguicoso",
    "sloth",
    "slow"
  ],
  "🐁": [
    "1f401",
    "animal",
    "animals",
    "camundongo",
    "mouse",
    "natureza",
    "ratinho"
  ],
  "🐀": [
    "1f400",
    "animal",
    "natureza",
    "rat",
    "ratazana",
    "rato"
  ],
  "🐿️": [
    "1f43f",
    "animal",
    "chipmunk",
    "esquilo",
    "natureza",
    "squirrel"
  ],
  "🦔": [
    "1f994",
    "animal",
    "espinhoso",
    "hedgehog",
    "natureza",
    "ourico",
    "porco-espinho",
    "spiny"
  ],
  "🐾": [
    "1f43e",
    "animal",
    "feet",
    "natureza",
    "pata",
    "patas",
    "patinhas de cachorro",
    "paw",
    "paw prints",
    "paws",
    "pegada",
    "pegada de pata",
    "print",
    "prints"
  ],
  "🐉": [
    "1f409",
    "animal",
    "dragao",
    "dragon",
    "fairy",
    "fairytale",
    "game of thrones",
    "knights",
    "natureza",
    "tale"
  ],
  "🐲": [
    "1f432",
    "animal",
    "dragao",
    "dragon",
    "dragon face",
    "face",
    "fairy",
    "fairytale",
    "natureza",
    "rosto",
    "rosto de dragao",
    "tale"
  ],
  "🐦‍🔥": [
    "1f426-200d-1f525",
    "ascend",
    "ascension",
    "emerge",
    "fantasia",
    "fantasy",
    "fenix",
    "firebird",
    "glory",
    "immortal",
    "imortal",
    "natureza",
    "passaro de fogo",
    "phoenix",
    "rebirth",
    "reemergir",
    "reencarnacao",
    "reencarnar",
    "reincarnacao",
    "reincarnation",
    "reinvent",
    "renascer",
    "renascimento",
    "renewal",
    "revival",
    "revive",
    "reviver",
    "rise",
    "transform",
    "transformacao"
  ],
  "🌵": [
    "1f335",
    "cacto",
    "cactus",
    "desert",
    "deserto",
    "drought",
    "nature",
    "natureza",
    "plant",
    "planta",
    "seca"
  ],
  "🎄": [
    "1f384",
    "arvore",
    "arvore de natal",
    "celebration",
    "christmas",
    "christmas tree",
    "comemoracao",
    "natal",
    "natureza",
    "pinheirinho",
    "tree"
  ],
  "🌲": [
    "1f332",
    "arvore",
    "arvore de pinheiro",
    "christmas",
    "conifera",
    "evergreen",
    "evergreen tree",
    "floresta",
    "forest",
    "natal",
    "natureza",
    "pine",
    "pinheirinho",
    "pinheiro",
    "tree"
  ],
  "🌳": [
    "1f333",
    "arvore",
    "arvore caidica",
    "arvore cheia",
    "caidica",
    "deciduous",
    "deciduous tree",
    "desfolha",
    "forest",
    "green",
    "habitat",
    "natureza",
    "shedding",
    "tree"
  ],
  "🌴": [
    "1f334",
    "arvore",
    "arvore de palmeira",
    "beach",
    "coqueiro",
    "natureza",
    "palm",
    "palm tree",
    "palmeira",
    "plant",
    "tree",
    "tropical"
  ],
  "🪾": [
    "1fabe",
    "arvore seca",
    "arvore sem folhas",
    "bare",
    "barren",
    "branches",
    "dead",
    "drought",
    "inverno",
    "leafless",
    "leafless tree",
    "natureza",
    "seca",
    "tree",
    "trunk",
    "winter",
    "wood"
  ],
  "🪵": [
    "1fab5",
    "lenha",
    "log",
    "lumber",
    "madeira",
    "madeira serrada",
    "natureza",
    "timber",
    "tora",
    "tronco",
    "wood"
  ],
  "🌱": [
    "1f331",
    "brotar",
    "broto",
    "jovem",
    "muda",
    "muda de planta",
    "natureza",
    "plant",
    "planta jovem",
    "plantinha",
    "sapling",
    "seedling",
    "sprout",
    "young"
  ],
  "🌿": [
    "1f33f",
    "erva",
    "folha",
    "herb",
    "leaf",
    "natureza",
    "plant",
    "planta"
  ],
  "☘️": [
    "2618",
    "irish",
    "irlanda",
    "irlandes",
    "natureza",
    "plant",
    "planta",
    "shamrock",
    "trevo",
    "trevo de tres folhas"
  ],
  "🍀": [
    "1f340",
    "4",
    "clover",
    "folhas",
    "four",
    "four leaf clover",
    "four-leaf",
    "irish",
    "irlandes",
    "leaf",
    "lucky",
    "natureza",
    "plant",
    "planta",
    "quatro",
    "sorte",
    "sortudo",
    "trevo",
    "trevo de quatro folhas"
  ],
  "🎍": [
    "1f38d",
    "bamboo",
    "bambu",
    "celebration",
    "comemoracao",
    "decoracao de pinhas",
    "decoracao de pinhos",
    "decoration",
    "japanese",
    "japones",
    "natureza",
    "pine",
    "pine decoration",
    "pinha",
    "plant"
  ],
  "🪴": [
    "1fab4",
    "casa",
    "chato",
    "decor",
    "decoracao",
    "grow",
    "house",
    "natureza",
    "nurturing",
    "nutrir",
    "plant",
    "planta",
    "plantar",
    "pot",
    "potted",
    "potted plant",
    "samambaia",
    "sem utilidade",
    "vaso",
    "vaso com planta"
  ],
  "🎋": [
    "1f38b",
    "arvore",
    "arvore de tanabata",
    "banner",
    "celebration",
    "comemoracao",
    "estrelas",
    "festival",
    "japanese",
    "japonesa",
    "natureza",
    "papel",
    "tanabata",
    "tanabata tree",
    "tiras",
    "tree"
  ],
  "🍃": [
    "1f343",
    "blow",
    "flutter",
    "fluttering",
    "folha",
    "folha ao vento",
    "leaf",
    "leaf fluttering in wind",
    "natureza",
    "soprando",
    "vento",
    "wind"
  ],
  "🍂": [
    "1f342",
    "autumn",
    "caidas",
    "cair",
    "fall",
    "fallen",
    "fallen leaf",
    "falling",
    "folha",
    "folhas",
    "folhas caidas",
    "leaf",
    "natureza",
    "outono"
  ],
  "🍁": [
    "1f341",
    "falling",
    "folha",
    "folha caida",
    "folha de bordo",
    "folha vermelha",
    "leaf",
    "maple",
    "maple leaf",
    "natureza",
    "outono"
  ],
  "🪺": [
    "1faba",
    "aninhando",
    "bird",
    "branch",
    "egg",
    "eggs",
    "galhos",
    "lar",
    "natureza",
    "nest",
    "nest with eggs",
    "nesting",
    "ninho",
    "ninho com ovos",
    "ovo",
    "ovos",
    "passarinho",
    "passaro"
  ],
  "🪹": [
    "1fab9",
    "aninhando",
    "branch",
    "empty",
    "empty nest",
    "galhos",
    "home",
    "lar",
    "natureza",
    "nest",
    "nesting",
    "ninho",
    "ninho vazio",
    "passarinho",
    "passaro"
  ],
  "🍄": [
    "1f344",
    "champignon",
    "cogumelo",
    "fungo",
    "fungus",
    "mario",
    "mushroom",
    "natureza",
    "planta",
    "toadstool"
  ],
  "🍄‍🟫": [
    "1f344-200d-1f7eb",
    "brown mushroom",
    "champignon",
    "cogumelo",
    "cogumelo marrom",
    "comida",
    "food",
    "fungi",
    "fungo",
    "fungos",
    "fungus",
    "mushroom",
    "nature",
    "natureza",
    "pizza",
    "portobello",
    "shiitake",
    "shroom",
    "spore",
    "sprout",
    "toppings",
    "trufa",
    "truffle",
    "vegetable",
    "vegetal",
    "vegetarian",
    "vegetariano",
    "veggie"
  ],
  "🐚": [
    "1f41a",
    "animal",
    "beach",
    "caramujo",
    "conch",
    "concha",
    "concha do mar",
    "concha em espiral",
    "natureza",
    "sea",
    "shell",
    "spiral",
    "spiral shell"
  ],
  "🪸": [
    "1fab8",
    "change",
    "climate",
    "coral",
    "mar",
    "mudanca climatica",
    "natureza",
    "ocean",
    "oceano",
    "recife",
    "reef",
    "sea"
  ],
  "🪨": [
    "1faa8",
    "boulder",
    "heavy",
    "natureza",
    "pedra",
    "pedregulho",
    "pesado",
    "rocha",
    "rock",
    "seixo",
    "solid",
    "solido",
    "stone",
    "tough"
  ],
  "🌾": [
    "1f33e",
    "arroz",
    "comida",
    "ear",
    "espiga",
    "espiga de arroz",
    "fazenda",
    "grain",
    "grains",
    "graos",
    "natureza",
    "plant",
    "planta",
    "planta de arroz",
    "planta do arroz",
    "rice",
    "sheaf",
    "sheaf of rice"
  ],
  "💐": [
    "1f490",
    "aniversario",
    "anniversary",
    "birthday",
    "bouquet",
    "buque",
    "date",
    "flor",
    "flower",
    "love",
    "natureza",
    "plant",
    "planta",
    "romance"
  ],
  "🌷": [
    "1f337",
    "blossom",
    "flor",
    "flower",
    "growth",
    "natureza",
    "plant",
    "tulip",
    "tulipa"
  ],
  "🌹": [
    "1f339",
    "beauty",
    "elegant",
    "flor",
    "flower",
    "love",
    "natureza",
    "plant",
    "red",
    "rosa",
    "rose",
    "valentine"
  ],
  "🥀": [
    "1f940",
    "dying",
    "flor",
    "flor murcha",
    "flower",
    "morrendo",
    "murcha",
    "murchando",
    "natureza",
    "wilted",
    "wilted flower"
  ],
  "🪻": [
    "1fabb",
    "arbusto",
    "bloom",
    "bluebonnet",
    "flor",
    "flor-cranio-do-dragao",
    "flower",
    "hyacinth",
    "indigo",
    "jacinto",
    "lavanda",
    "lavender",
    "lilac",
    "lilas",
    "lupine",
    "lupinus",
    "natureza",
    "plant",
    "planta",
    "primavera",
    "purple",
    "roxo",
    "shrub",
    "snapdragon",
    "spring",
    "violet",
    "violeta"
  ],
  "🪷": [
    "1fab7",
    "beauty",
    "beleza",
    "buddhism",
    "budismo",
    "calm",
    "calma",
    "flor",
    "flor de lotus",
    "flower",
    "hinduism",
    "hinduismo",
    "india",
    "lotus",
    "natureza",
    "paz",
    "peace",
    "pureza",
    "purity",
    "serenidade",
    "serenity",
    "vietna"
  ],
  "🌺": [
    "1f33a",
    "flor",
    "flower",
    "hibisco",
    "hibiscus",
    "natureza",
    "plant",
    "planta",
    "primavera"
  ],
  "🌸": [
    "1f338",
    "blossom",
    "cereja",
    "cerejeira",
    "cherry",
    "cherry blossom",
    "flor",
    "flor de cerejeira",
    "flower",
    "natureza",
    "plant",
    "planta",
    "primavera",
    "spring",
    "springtime"
  ],
  "🌼": [
    "1f33c",
    "blossom",
    "buttercup",
    "dandelion",
    "flor",
    "florescer",
    "flower",
    "natureza",
    "plant",
    "planta"
  ],
  "🌻": [
    "1f33b",
    "flor",
    "flower",
    "girassol",
    "natureza",
    "outdoors",
    "plant",
    "planta",
    "sun",
    "sunflower"
  ],
  "🌞": [
    "1f31e",
    "beach",
    "bright",
    "day",
    "face",
    "heat",
    "natureza",
    "praia",
    "rosto",
    "rosto do sol",
    "shine",
    "sol",
    "sun",
    "sun with face",
    "sunny",
    "sunshine",
    "weather"
  ],
  "🌝": [
    "1f31d",
    "bright",
    "cheia",
    "face",
    "full",
    "full moon face",
    "lua",
    "lua cheia com rosto",
    "lua com rosto",
    "moon",
    "natureza",
    "rosto",
    "rosto da lua cheia"
  ],
  "🌛": [
    "1f31b",
    "crescente",
    "face",
    "first",
    "first quarter moon face",
    "lua",
    "moon",
    "natureza",
    "noite",
    "quarter",
    "quarto",
    "rosto",
    "rosto da lua de quarto crescente",
    "space"
  ],
  "🌜": [
    "1f31c",
    "dreams",
    "face",
    "last",
    "last quarter moon face",
    "lua",
    "lua com rosto",
    "lua de quarto minguante",
    "moon",
    "natureza",
    "quarter",
    "quarto minguante",
    "quarto minguante com rosto",
    "rosto",
    "rosto da lua de quarto minguante"
  ],
  "🌚": [
    "1f31a",
    "face",
    "lua",
    "lua nova",
    "lua nova com rosto",
    "moon",
    "natureza",
    "new",
    "new moon face",
    "rosto",
    "rosto da lua nova",
    "space"
  ],
  "🌕": [
    "1f315",
    "cheia",
    "full",
    "full moon",
    "lua",
    "lua cheia",
    "luar",
    "moon",
    "natureza",
    "space"
  ],
  "🌖": [
    "1f316",
    "convexa",
    "gibbous",
    "lua",
    "lua minguante convexa",
    "minguante",
    "moon",
    "natureza",
    "space",
    "waning",
    "waning gibbous moon"
  ],
  "🌗": [
    "1f317",
    "last",
    "last quarter moon",
    "lua",
    "lua de quarto minguante",
    "moon",
    "natureza",
    "quarter",
    "quarto",
    "quarto minguante",
    "space"
  ],
  "🌘": [
    "1f318",
    "concava",
    "crescent",
    "lua",
    "lua minguante concava",
    "minguante",
    "moon",
    "natureza",
    "space",
    "waning",
    "waning crescent moon"
  ],
  "🌑": [
    "1f311",
    "dark",
    "escuro",
    "lua",
    "lua negra",
    "lua nova",
    "moon",
    "natureza",
    "new",
    "new moon",
    "noite",
    "nova",
    "space"
  ],
  "🌒": [
    "1f312",
    "concava",
    "crescent",
    "crescente",
    "dreams",
    "lua",
    "lua crescente concava",
    "moon",
    "natureza",
    "noite",
    "space",
    "waxing",
    "waxing crescent moon"
  ],
  "🌓": [
    "1f313",
    "first",
    "first quarter moon",
    "lua",
    "lua de quarto crescente",
    "moon",
    "natureza",
    "quarter",
    "quarto",
    "quarto crescente",
    "space"
  ],
  "🌔": [
    "1f314",
    "convexa",
    "crescente",
    "gibbous",
    "lua",
    "lua crescente convexa",
    "moon",
    "natureza",
    "space",
    "waxing",
    "waxing gibbous moon"
  ],
  "🌙": [
    "1f319",
    "crescent",
    "crescent moon",
    "crescente",
    "lua",
    "lua crescente",
    "moon",
    "natureza",
    "ramadan",
    "space"
  ],
  "🌎": [
    "1f30e",
    "america",
    "americas",
    "as americas",
    "earth",
    "globe",
    "globe showing americas",
    "globo mostrando as americas",
    "natureza",
    "showing",
    "terra",
    "world"
  ],
  "🌍": [
    "1f30d",
    "africa",
    "earth",
    "europa",
    "europe",
    "europe-africa",
    "globe",
    "globe showing europe-africa",
    "globo mostrando europa e africa",
    "natureza",
    "showing",
    "terra",
    "world"
  ],
  "🌏": [
    "1f30f",
    "asia",
    "asia-australia",
    "australia",
    "earth",
    "globe",
    "globe showing asia-australia",
    "globo mostrando asia e oceania",
    "natureza",
    "oceania",
    "planeta terra",
    "showing",
    "terra",
    "world"
  ],
  "🪐": [
    "1fa90",
    "aneis",
    "natureza",
    "planet",
    "planeta",
    "planeta com aneis",
    "ringed",
    "ringed planet",
    "saturn",
    "saturnine",
    "saturnino",
    "saturno"
  ],
  "💫": [
    "1f4ab",
    "brilhante",
    "comic",
    "dizzy",
    "emocao",
    "engracado",
    "estrelas",
    "natureza",
    "olhando para as estrelas",
    "shining",
    "shooting",
    "star",
    "stars",
    "zonzo"
  ],
  "⭐️": [
    "2b50",
    "amarela",
    "astronomia",
    "astronomy",
    "estrela",
    "estrela branca media",
    "medium",
    "natureza",
    "star",
    "stars",
    "white"
  ],
  "🌟": [
    "1f31f",
    "brilhante",
    "brilho",
    "cintilante",
    "estrela",
    "estrela brilhante",
    "glittery",
    "glow",
    "glowing",
    "glowing star",
    "luminosa",
    "natureza",
    "night",
    "reluzente",
    "shining",
    "sparkle",
    "star",
    "win"
  ],
  "✨": [
    "*",
    "2728",
    "brilhantes",
    "brilhos",
    "estrelas",
    "faiscas",
    "magic",
    "magica",
    "natureza",
    "sparkle",
    "sparkles",
    "star"
  ],
  "⚡️": [
    "26a1",
    "alta",
    "alta tensao",
    "danger",
    "electric",
    "electricity",
    "eletricidade",
    "high",
    "high voltage",
    "lightning",
    "nature",
    "natureza",
    "perigo",
    "relampago",
    "sinal",
    "tensao",
    "thunder",
    "thunderbolt",
    "voltage",
    "zap"
  ],
  "☄️": [
    "2604",
    "comet",
    "cometa",
    "espaco",
    "estrela cadente",
    "meteoro",
    "natureza",
    "satelite",
    "space"
  ],
  "💥": [
    "1f4a5",
    "bomb",
    "boom",
    "colisao",
    "collide",
    "collision",
    "comic",
    "emocao",
    "engracado",
    "explode",
    "explosao",
    "natureza",
    "simbolo de colisao"
  ],
  "🔥": [
    "1f525",
    "af",
    "burn",
    "chama",
    "fire",
    "flame",
    "fogo",
    "hot",
    "lit",
    "litaf",
    "natureza",
    "tool"
  ],
  "🌪️": [
    "1f32a",
    "clima",
    "cloud",
    "furacao",
    "natureza",
    "nuvem",
    "tornado",
    "weather",
    "whirlwind"
  ],
  "🌈": [
    "1f308",
    "arco-iris",
    "chuva",
    "clima",
    "gay",
    "genderqueer",
    "glbt",
    "glbtq",
    "lesbian",
    "lesbica",
    "lgbt",
    "lgbtq",
    "lgbtqia",
    "lgbtqia+",
    "nature",
    "natureza",
    "orgulho",
    "pride",
    "queer",
    "rain",
    "rainbow",
    "trans",
    "transgender",
    "transgenero",
    "weather"
  ],
  "☀️": [
    "2600",
    "bright",
    "clima",
    "dia claro",
    "natureza",
    "raios",
    "rays",
    "sol",
    "solar",
    "space",
    "sun",
    "sunny",
    "tempo",
    "weather"
  ],
  "🌤️": [
    "1f324",
    "behind",
    "clima",
    "cloud",
    "ensolarado",
    "natureza",
    "nublado",
    "nuvem",
    "sol",
    "sol com nuvens",
    "sun",
    "sun behind small cloud",
    "weather"
  ],
  "⛅️": [
    "26c5",
    "behind",
    "clima",
    "cloud",
    "cloudy",
    "natureza",
    "nublado",
    "nuvem",
    "sol",
    "sol por tras das nuvens",
    "sun",
    "sun behind cloud",
    "weather"
  ],
  "🌥️": [
    "1f325",
    "behind",
    "clima",
    "cloud",
    "natureza",
    "nublado",
    "nuvem",
    "sol",
    "sun",
    "sun behind large cloud",
    "weather"
  ],
  "☁️": [
    "2601",
    "clima",
    "cloud",
    "natureza",
    "nuvem",
    "weather"
  ],
  "🌦️": [
    "1f326",
    "behind",
    "chuva",
    "clima",
    "cloud",
    "natureza",
    "nuvem",
    "rain",
    "sol",
    "sol com chuva",
    "sun",
    "sun behind rain cloud",
    "weather"
  ],
  "🌧️": [
    "1f327",
    "chovendo",
    "chuva",
    "clima",
    "cloud",
    "cloud with rain",
    "natureza",
    "nuvem",
    "nuvem com chuva",
    "rain",
    "weather"
  ],
  "⛈️": [
    "26c8",
    "chuva",
    "chuva com trovao",
    "clima",
    "cloud",
    "cloud with lightning and rain",
    "lightning",
    "natureza",
    "nuvem",
    "rain",
    "relampago",
    "temporal",
    "thunder",
    "thunderstorm",
    "trovao"
  ],
  "🌩️": [
    "1f329",
    "clima",
    "cloud",
    "cloud with lightning",
    "lightning",
    "natureza",
    "nuvem",
    "nuvem com trovao",
    "relampago",
    "weather"
  ],
  "🌨️": [
    "1f328",
    "clima",
    "cloud",
    "cloud with snow",
    "cold",
    "frio",
    "natureza",
    "neve",
    "nuvem",
    "nuvem com neve",
    "snow",
    "weather"
  ],
  "❄️": [
    "2744",
    "clima",
    "cold",
    "floco",
    "floco de neve",
    "frio",
    "natureza",
    "neve",
    "snow",
    "snowflake",
    "weather"
  ],
  "☃️": [
    "2603",
    "boneco",
    "boneco de neve",
    "clima",
    "cold",
    "frio",
    "inverno",
    "man",
    "natureza",
    "neve",
    "snow",
    "snowman"
  ],
  "⛄️": [
    "26c4",
    "boneco",
    "boneco de neve sem neve",
    "cold",
    "frio",
    "inverno",
    "man",
    "natureza",
    "neve",
    "snow",
    "snowman",
    "snowman without snow"
  ],
  "🌬️": [
    "1f32c",
    "blow",
    "clima",
    "cloud",
    "face",
    "natureza",
    "nuvem",
    "rosto",
    "rosto de vento",
    "soprar",
    "sopro",
    "vento",
    "wind",
    "wind face"
  ],
  "💨": [
    "1f4a8",
    "away",
    "cloud",
    "comic",
    "correr",
    "corrida",
    "dash",
    "dashing",
    "dashing away",
    "emocao",
    "engracado",
    "fart",
    "fast",
    "fugir",
    "go",
    "gone",
    "gotta",
    "natureza",
    "rapidez",
    "running",
    "smoke"
  ],
  "💧": [
    "1f4a7",
    "cold",
    "com suor",
    "comic",
    "drop",
    "droplet",
    "engracado",
    "gota",
    "gota de suor",
    "nature",
    "natureza",
    "sad",
    "suor",
    "sweat",
    "tear",
    "water",
    "weather"
  ],
  "💦": [
    "1f4a6",
    "borrifo",
    "com suor",
    "comic",
    "drip",
    "droplet",
    "droplets",
    "drops",
    "emocao",
    "engracado",
    "natureza",
    "pingos de suor",
    "splash",
    "splashing",
    "squirt",
    "suor",
    "sweat",
    "sweat droplets",
    "water",
    "wet",
    "work",
    "workout"
  ],
  "🫧": [
    "1fae7",
    "agua",
    "aquatica",
    "aquatico",
    "arroto",
    "bolha",
    "bolhas",
    "bubble",
    "bubbles",
    "burp",
    "clean",
    "embaixo d’agua",
    "floating",
    "flutuar",
    "limpo",
    "natureza",
    "pearl",
    "perolas",
    "sabao",
    "soap",
    "underwater"
  ],
  "☔️": [
    "2614",
    "acessorio",
    "chuva",
    "clima",
    "clothing",
    "drop",
    "drops",
    "gotas",
    "guarda-chuva",
    "natureza",
    "rain",
    "sombrinha",
    "sombrinha na chuva",
    "umbrella",
    "umbrella with rain drops",
    "weather"
  ],
  "☂️": [
    "2602",
    "acessorio",
    "chuva",
    "clima",
    "clothing",
    "guarda-chuva",
    "natureza",
    "rain",
    "sombrinha aberta",
    "umbrella"
  ],
  "🌊": [
    "1f30a",
    "agua",
    "mar",
    "nature",
    "natureza",
    "ocean",
    "oceano",
    "onda",
    "praia",
    "surf",
    "surfe",
    "surfer",
    "surfing",
    "tsunami",
    "water",
    "water wave",
    "wave"
  ],
  "🌫️": [
    "1f32b",
    "clima",
    "cloud",
    "fog",
    "furacao",
    "natureza",
    "neblina",
    "nevoeiro",
    "nuvem",
    "weather"
  ],
  "🍏": [
    "1f34f",
    "apple",
    "comida",
    "comidas",
    "fome",
    "fruit",
    "fruta",
    "green",
    "green apple",
    "maca",
    "maca verde",
    "verde"
  ],
  "🍎": [
    "1f34e",
    "apple",
    "comidas",
    "diet",
    "food",
    "fruit",
    "fruta",
    "health",
    "maca",
    "maca vermelha",
    "red",
    "red apple",
    "ripe",
    "vermelha"
  ],
  "🍐": [
    "1f350",
    "comida",
    "comidas",
    "fome",
    "fruit",
    "fruta",
    "pear",
    "pera"
  ],
  "🍊": [
    "1f34a",
    "c",
    "citrica",
    "citrus",
    "comidas",
    "fruit",
    "fruta",
    "laranja",
    "nectarine",
    "orange",
    "tangerina",
    "tangerine",
    "vitamin"
  ],
  "🍋": [
    "1f34b",
    "azedo",
    "citrico",
    "citrus",
    "comidas",
    "fruit",
    "fruta",
    "lemon",
    "lima",
    "limao",
    "limao siciliano",
    "sour"
  ],
  "🍋‍🟩": [
    "1f34b-200d-1f7e9",
    "acidez",
    "acidity",
    "caipirinha",
    "citrica",
    "citrico",
    "citrus",
    "cocktail",
    "comidas",
    "drink",
    "fruit",
    "fruta",
    "garnish",
    "key",
    "lima",
    "limao",
    "lime",
    "limonada",
    "margarita",
    "mojito",
    "refreshing",
    "salsa",
    "sour",
    "tangy",
    "tequila",
    "tropical",
    "verde",
    "zest"
  ],
  "🍌": [
    "1f34c",
    "banana",
    "comidas",
    "fruit",
    "fruta",
    "potassium"
  ],
  "🍉": [
    "1f349",
    "comidas",
    "fruit",
    "fruta",
    "melancia",
    "watermelon"
  ],
  "🍇": [
    "1f347",
    "comidas",
    "dionysus",
    "fruit",
    "fruta",
    "grape",
    "grapes",
    "uva",
    "uvas"
  ],
  "🍓": [
    "1f353",
    "berry",
    "comida",
    "comidas",
    "fome",
    "fruit",
    "fruta",
    "frutas vermelhas",
    "morango",
    "strawberry"
  ],
  "🫐": [
    "1fad0",
    "alimento",
    "azul",
    "baga",
    "berries",
    "berry",
    "bilberry",
    "blue",
    "blueberries",
    "blueberry",
    "comida",
    "comidas",
    "food",
    "fruit",
    "fruta",
    "mirtilo",
    "mirtilos",
    "silvestre"
  ],
  "🍈": [
    "1f348",
    "cantaloupe",
    "comidas",
    "fruit",
    "fruta",
    "melao",
    "melon"
  ],
  "🍒": [
    "1f352",
    "berries",
    "cereja",
    "cherries",
    "cherry",
    "comida",
    "comidas",
    "fome",
    "fruit",
    "fruta",
    "frutas vermelhas",
    "red"
  ],
  "🍑": [
    "1f351",
    "comidas",
    "fruit",
    "fruta",
    "peach",
    "pessego"
  ],
  "🥭": [
    "1f96d",
    "comida",
    "comidas",
    "food",
    "fruit",
    "fruta",
    "manga",
    "mango",
    "tropical"
  ],
  "🍍": [
    "1f34d",
    "abacaxi",
    "colada",
    "comida",
    "comidas",
    "fome",
    "fruit",
    "fruta",
    "pina",
    "pineapple",
    "tropical"
  ],
  "🥥": [
    "1f965",
    "coco",
    "coconut",
    "colada",
    "comidas",
    "fruta",
    "palm",
    "palmeira",
    "pina",
    "pina colada"
  ],
  "🥝": [
    "1f95d",
    "comida",
    "comidas",
    "food",
    "fruit",
    "fruta",
    "kiwi",
    "kiwi fruit"
  ],
  "🍅": [
    "1f345",
    "comidas",
    "food",
    "fruit",
    "fruta",
    "fruto",
    "legume",
    "tomate",
    "tomato",
    "vegetable",
    "vegetal"
  ],
  "🍆": [
    "1f346",
    "aubergine",
    "beringela",
    "berinjela",
    "comida",
    "comidas",
    "eggplant",
    "legume",
    "vegetable",
    "vegetal"
  ],
  "🥑": [
    "1f951",
    "abacate",
    "avocado",
    "comida",
    "comidas",
    "food",
    "fruit",
    "fruta"
  ],
  "🫛": [
    "1fadb",
    "beans",
    "beanstalk",
    "comida",
    "comidas",
    "edamame",
    "ervilha",
    "feijao",
    "grao",
    "legume",
    "leguminosa",
    "pe de feijao",
    "pea",
    "pea pod",
    "pod",
    "soybean",
    "vagem",
    "vegetable",
    "vegetal",
    "veggie"
  ],
  "🥦": [
    "1f966",
    "broccoli",
    "brocoli",
    "brocolis",
    "cabbage",
    "comidas",
    "wild"
  ],
  "🥬": [
    "1f96c",
    "alface",
    "bok",
    "bok choy",
    "burgers",
    "cabbage",
    "choy",
    "comida",
    "comidas",
    "couve",
    "green",
    "hamburguer",
    "kale",
    "leafy",
    "leafy green",
    "lettuce",
    "repolho",
    "repolho chines",
    "salad",
    "salada",
    "verdura"
  ],
  "🥒": [
    "1f952",
    "comida",
    "comidas",
    "cucumber",
    "fome",
    "food",
    "legume",
    "pepino",
    "pickle",
    "picles",
    "salada",
    "vegetable",
    "vegetal"
  ],
  "🌶️": [
    "1f336",
    "apimentada",
    "apimentado",
    "comidas",
    "hot",
    "hot pepper",
    "pepper",
    "pimenta",
    "tempero"
  ],
  "🫑": [
    "1fad1",
    "alimento",
    "bell",
    "bell pepper",
    "capsicum",
    "comida",
    "comidas",
    "food",
    "pepper",
    "pimenta",
    "pimentao",
    "pimentao verde",
    "vegetable",
    "vegetal"
  ],
  "🌽": [
    "1f33d",
    "comida",
    "comidas",
    "corn",
    "crops",
    "ear",
    "ear of corn",
    "espiga",
    "espiga de milho",
    "farm",
    "fome",
    "maize",
    "maze",
    "milho"
  ],
  "🥕": [
    "1f955",
    "carrot",
    "cenoura",
    "comida",
    "comidas",
    "fome",
    "food",
    "legume",
    "salada",
    "vegetable",
    "vegetal"
  ],
  "🫒": [
    "1fad2",
    "alimento",
    "azeitona",
    "comida",
    "comidas",
    "food",
    "olive",
    "oliveira"
  ],
  "🧄": [
    "1f9c4",
    "alho",
    "comidas",
    "flavoring",
    "garlic",
    "tempero"
  ],
  "🧅": [
    "1f9c5",
    "cebola",
    "comidas",
    "flavoring",
    "onion",
    "tempero"
  ],
  "🥔": [
    "1f954",
    "batata",
    "comida",
    "comidas",
    "fome",
    "food",
    "legume",
    "potato",
    "vegetable",
    "vegetal"
  ],
  "🫜": [
    "1fadc",
    "beet",
    "beterraba",
    "comidas",
    "food",
    "garden",
    "legume",
    "nabo",
    "radish",
    "raiz",
    "root",
    "root vegetable",
    "salad",
    "tuberculo",
    "turnip",
    "vegetable",
    "vegetal",
    "vegetarian"
  ],
  "🍠": [
    "1f360",
    "assada",
    "batata",
    "batata assada",
    "batata-doce",
    "comidas",
    "doce",
    "food",
    "potato",
    "restaurante",
    "roasted",
    "roasted sweet potato",
    "sweet"
  ],
  "🫚": [
    "1fada",
    "beer",
    "cerveja",
    "comida",
    "comidas",
    "erva",
    "especiaria",
    "gengibre",
    "ginger",
    "ginger root",
    "health",
    "herb",
    "natural",
    "raiz",
    "root",
    "saude",
    "spice",
    "tempero"
  ],
  "🥐": [
    "1f950",
    "bread",
    "breakfast",
    "cafe da manha",
    "comida",
    "comidas",
    "crescent",
    "croissant",
    "fome",
    "food",
    "french",
    "pao",
    "roll"
  ],
  "🥯": [
    "1f96f",
    "bagel",
    "bakery",
    "bread",
    "breakfast",
    "cafe da manha",
    "chimia",
    "comida",
    "comidas",
    "confeitaria",
    "pao",
    "rosca",
    "rosquinha",
    "schmear"
  ],
  "🍞": [
    "1f35e",
    "bread",
    "carbs",
    "comidas",
    "food",
    "grain",
    "loaf",
    "pao",
    "pao de forma",
    "pao para fatiar",
    "restaurant",
    "restaurante",
    "toast",
    "torrada",
    "tostex",
    "wheat"
  ],
  "🥖": [
    "1f956",
    "baguete",
    "baguette",
    "baguette bread",
    "bisnaga",
    "bread",
    "comida",
    "comidas",
    "food",
    "french",
    "pao",
    "pao frances"
  ],
  "🥨": [
    "1f968",
    "comidas",
    "convoluted",
    "pao torcido",
    "pretzel",
    "twisted"
  ],
  "🧀": [
    "1f9c0",
    "cheese",
    "cheese wedge",
    "comida",
    "comidas",
    "fome",
    "queijo",
    "queijo suico",
    "wedge"
  ],
  "🥚": [
    "1f95a",
    "breakfast",
    "comida",
    "comidas",
    "egg",
    "fome",
    "food",
    "ovo"
  ],
  "🍳": [
    "1f373",
    "breakfast",
    "comida",
    "comidas",
    "cooking",
    "culinaria",
    "easy",
    "egg",
    "frigideira",
    "fry",
    "frying",
    "over",
    "ovo",
    "ovo estrelado",
    "ovo frito",
    "pan",
    "restaurant",
    "restaurante",
    "side",
    "sunny",
    "up"
  ],
  "🧈": [
    "1f9c8",
    "butter",
    "comidas",
    "dairy",
    "laticinio",
    "manteiga",
    "margarina"
  ],
  "🥞": [
    "1f95e",
    "breakfast",
    "cafe da manha",
    "comida",
    "comidas",
    "crepe",
    "crepes",
    "fome",
    "food",
    "hotcake",
    "pancake",
    "pancakes",
    "panquecas"
  ],
  "🧇": [
    "1f9c7",
    "breakfast",
    "comidas",
    "doce",
    "gofre",
    "indecisive",
    "iron",
    "wafel",
    "waffle",
    "wafle"
  ],
  "🥓": [
    "1f953",
    "bacon",
    "breakfast",
    "comida",
    "comidas",
    "fome",
    "food",
    "meat",
    "toucinho"
  ],
  "🥩": [
    "1f969",
    "bife",
    "carne",
    "carne vermelha",
    "chop",
    "comidas",
    "corte de carne",
    "costela de cordeiro",
    "costeleta",
    "costeleta de porco",
    "cut",
    "cut of meat",
    "lambchop",
    "meat",
    "porco",
    "porkchop",
    "red",
    "steak"
  ],
  "🍗": [
    "1f357",
    "aves",
    "bone",
    "chicken",
    "comida",
    "comidas",
    "coxa",
    "coxa de frango",
    "coxinha",
    "drumstick",
    "fome",
    "hungry",
    "leg",
    "osso",
    "peru",
    "poultry",
    "poultry leg",
    "restaurante",
    "turkey"
  ],
  "🍖": [
    "1f356",
    "bone",
    "carne",
    "carne com osso",
    "carne no osso",
    "churras",
    "churrasco",
    "comidas",
    "meat",
    "meat on bone",
    "osso",
    "restaurante"
  ],
  "🦴": [
    "1f9b4",
    "bone",
    "bones",
    "cachorro",
    "comidas",
    "dog",
    "esqueleto",
    "osso",
    "skeleton",
    "wishbone"
  ],
  "🌭": [
    "1f32d",
    "cachorro quente",
    "cachorro-quente",
    "comidas",
    "dog",
    "frankfurter",
    "hot",
    "hot dog",
    "hotdog",
    "pao com salsicha",
    "pao com vina",
    "sausage",
    "vina"
  ],
  "🍔": [
    "1f354",
    "burger",
    "burguer",
    "cheese burguer",
    "comidas",
    "eat",
    "fast",
    "food",
    "hamburger",
    "hamburguer",
    "hungry",
    "restaurante"
  ],
  "🍟": [
    "1f35f",
    "batata frita",
    "comida",
    "comidas",
    "fast",
    "fast food",
    "fome",
    "food",
    "french",
    "french fries",
    "fries",
    "fritas",
    "lanchonete",
    "restaurante"
  ],
  "🍕": [
    "1f355",
    "cheese",
    "comidas",
    "fatia",
    "food",
    "hungry",
    "pepperoni",
    "pizza",
    "restaurante",
    "slice"
  ],
  "🫓": [
    "1fad3",
    "alimento",
    "arepa",
    "bread",
    "comida",
    "comidas",
    "flatbread",
    "food",
    "gordita",
    "lavash",
    "naan",
    "pao",
    "pao folha",
    "pao sirio",
    "pita"
  ],
  "🥪": [
    "1f96a",
    "bread",
    "comidas",
    "pao",
    "pao de forma",
    "sanduiche",
    "sandwich"
  ],
  "🥙": [
    "1f959",
    "comida",
    "comidas",
    "falafel",
    "flatbread",
    "food",
    "gyro",
    "kebab",
    "pao",
    "pao recheado",
    "recheio",
    "stuffed",
    "stuffed flatbread",
    "wrap"
  ],
  "🧆": [
    "1f9c6",
    "almondega",
    "chickpea",
    "comidas",
    "falafel",
    "grao de bico",
    "meatball"
  ],
  "🌮": [
    "1f32e",
    "comida mexicana",
    "comidas",
    "mexican",
    "mexicano",
    "taco",
    "tacos"
  ],
  "🌯": [
    "1f32f",
    "burrito",
    "comida mexicana",
    "comidas",
    "mexican",
    "mexicano",
    "wrap"
  ],
  "🫔": [
    "1fad4",
    "alimento",
    "comida",
    "comidas",
    "enrolado",
    "food",
    "mexican",
    "mexicano",
    "milho",
    "pamonha",
    "tamale",
    "wrapped"
  ],
  "🥗": [
    "1f957",
    "comida",
    "comidas",
    "fome",
    "food",
    "green",
    "green salad",
    "restaurante",
    "salad",
    "salada",
    "salada verde",
    "verde"
  ],
  "🥘": [
    "1f958",
    "cacarola",
    "cacarola com comida",
    "casserole",
    "comida",
    "comidas",
    "fome",
    "food",
    "paella",
    "pan",
    "panela",
    "rasa",
    "shallow",
    "shallow pan of food"
  ],
  "🫕": [
    "1fad5",
    "alimento",
    "cheese",
    "chocolate",
    "comida",
    "comidas",
    "derretido",
    "fondue",
    "food",
    "melted",
    "panela",
    "pot",
    "queijo",
    "ski",
    "suico"
  ],
  "🥫": [
    "1f96b",
    "can",
    "canned",
    "canned food",
    "comida enlatada",
    "comidas",
    "food",
    "lata"
  ],
  "🫙": [
    "1fad9",
    "armazenar",
    "comidas",
    "condiment",
    "condimento",
    "conserva",
    "container",
    "empty",
    "jar",
    "jarra",
    "jarro",
    "molho",
    "nada",
    "nothing",
    "pote",
    "recipiente",
    "sauce",
    "store",
    "vazio",
    "vidro"
  ],
  "🍝": [
    "1f35d",
    "comida",
    "comidas",
    "espaguete",
    "fome",
    "food",
    "italiano",
    "macarrao",
    "macarronada",
    "meatballs",
    "pasta",
    "restaurant",
    "restaurante",
    "spaghetti"
  ],
  "🍜": [
    "1f35c",
    "bowl",
    "chopsticks",
    "comida",
    "comidas",
    "fome",
    "food",
    "lamen",
    "macarrao",
    "miojo",
    "noodle",
    "pho",
    "quentinha",
    "ramen",
    "restaurante",
    "sopa",
    "soup",
    "steaming",
    "steaming bowl",
    "tigela",
    "tigela de macarrao"
  ],
  "🍲": [
    "1f372",
    "comidas",
    "ensopado",
    "food",
    "panela",
    "pot",
    "pot of food",
    "restaurante",
    "soup",
    "stew",
    "tigela de comida"
  ],
  "🍛": [
    "1f35b",
    "arroz",
    "arroz com curry",
    "comidas",
    "curry",
    "curry e arroz",
    "curry rice",
    "food",
    "restaurante",
    "rice"
  ],
  "🍣": [
    "1f363",
    "comida japonesa",
    "comidas",
    "food",
    "restaurante",
    "restaurante japones",
    "sashimi",
    "sushi"
  ],
  "🍱": [
    "1f371",
    "almoco japones",
    "bento",
    "bento box",
    "box",
    "caixa",
    "caixa de bento",
    "comidas",
    "food",
    "restaurante"
  ],
  "🥟": [
    "1f95f",
    "asiatico",
    "bolinho",
    "bolinho asiatico",
    "chines",
    "comidas",
    "dumpling",
    "empanada",
    "gyoza",
    "jiaozi",
    "massa",
    "pierogi",
    "potsticker"
  ],
  "🦪": [
    "1f9aa",
    "comidas",
    "diving",
    "frutos do mar",
    "mar",
    "mergulho",
    "ostra",
    "oyster",
    "pearl",
    "perola"
  ],
  "🍤": [
    "1f364",
    "camarao",
    "camarao empanado",
    "camarao frito",
    "comidas",
    "fried",
    "fried shrimp",
    "prawn",
    "restaurante",
    "shrimp",
    "tempura"
  ],
  "🍙": [
    "1f359",
    "arroz",
    "arroz japones",
    "ball",
    "bolinho de arroz",
    "comida",
    "comidas",
    "fome",
    "food",
    "japanese",
    "japones",
    "onigiri",
    "restaurante",
    "rice",
    "rice ball"
  ],
  "🍚": [
    "1f35a",
    "arroz",
    "arroz cozido",
    "comida",
    "comidas",
    "cooked",
    "cooked rice",
    "fome",
    "food",
    "restaurante",
    "rice"
  ],
  "🍘": [
    "1f358",
    "arroz",
    "biscoito de arroz",
    "bolacha de arroz",
    "comidas",
    "cracker",
    "food",
    "rice",
    "rice cracker"
  ],
  "🍥": [
    "1f365",
    "bolinho de peixe",
    "cake",
    "comidas",
    "croquete",
    "fish",
    "fish cake with swirl",
    "food",
    "pastry",
    "peixe",
    "redemoinho",
    "restaurant",
    "restaurante",
    "swirl"
  ],
  "🥠": [
    "1f960",
    "biscoito chines",
    "biscoito da fortuna",
    "biscoito da sorte",
    "comidas",
    "cookie",
    "fortune",
    "fortune cookie",
    "profecia",
    "prophecy",
    "sorte"
  ],
  "🥮": [
    "1f96e",
    "autumn",
    "bolo da lua",
    "bolo lunar",
    "cake",
    "comida",
    "comidas",
    "confeitaria",
    "festival",
    "festival chines",
    "moon",
    "moon cake",
    "outono",
    "yuebing"
  ],
  "🍢": [
    "1f362",
    "comidas",
    "espetinho",
    "food",
    "frutos do mar",
    "frutos do mar no espetinho",
    "kebab",
    "oden",
    "restaurant",
    "restaurante",
    "seafood",
    "skewer",
    "stick"
  ],
  "🍡": [
    "1f361",
    "bolinho de mochi",
    "bolinho de mochi no espetinho",
    "bolinho japones",
    "comida",
    "comidas",
    "dango",
    "dessert",
    "doce",
    "fome",
    "japanese",
    "japones",
    "mochi",
    "mochiko",
    "skewer",
    "sobremesa",
    "stick",
    "sweet"
  ],
  "🍧": [
    "1f367",
    "comidas",
    "dessert",
    "gelo",
    "ice",
    "raspadinha",
    "raspadinha de gelo",
    "restaurant",
    "restaurante",
    "shaved",
    "shaved ice",
    "sobremesa",
    "sweet"
  ],
  "🍨": [
    "1f368",
    "comidas",
    "cream",
    "creme",
    "dessert",
    "food",
    "gelo",
    "ice",
    "ice cream",
    "restaurant",
    "restaurante",
    "sobremesa",
    "sorvete",
    "sweet"
  ],
  "🍦": [
    "1f366",
    "comidas",
    "cream",
    "dessert",
    "doce",
    "fome",
    "food",
    "ice",
    "icecream",
    "restaurant",
    "serve",
    "sobremesa",
    "soft",
    "soft ice cream",
    "sorvete",
    "sorvete de casquinha",
    "sorvete de massa",
    "sorvete italiano",
    "sorvete na casquinha",
    "sweet"
  ],
  "🥧": [
    "1f967",
    "abobora",
    "apple",
    "carne",
    "comidas",
    "doce",
    "fatia",
    "fatia de torta",
    "filling",
    "fruit",
    "fruta",
    "maca",
    "meat",
    "padaria",
    "pastry",
    "pie",
    "pumpkin",
    "recheio",
    "salgado",
    "slice",
    "torta"
  ],
  "🧁": [
    "1f9c1",
    "acucar",
    "bakery",
    "bolinho",
    "bolo",
    "comida",
    "comidas",
    "confeitaria",
    "confeito",
    "cupcake",
    "dessert",
    "doce",
    "sobremesa",
    "sprinkles",
    "sugar",
    "sweet",
    "torta",
    "treat"
  ],
  "🍰": [
    "1f370",
    "bolo",
    "bolo recheado",
    "cake",
    "comidas",
    "dessert",
    "doce",
    "fatia",
    "fatia de bolo",
    "pao de lo",
    "pao de lo de morango",
    "pastry",
    "restaurante",
    "shortcake",
    "slice",
    "sobremesa",
    "sweet"
  ],
  "🎂": [
    "1f382",
    "aniversario",
    "bday",
    "birthday",
    "birthday cake",
    "bolo",
    "bolo de aniversario",
    "cake",
    "celebration",
    "comemoracao",
    "comidas",
    "dessert",
    "doce",
    "feliz aniversario",
    "festa",
    "happy",
    "niver",
    "pastry",
    "sweet"
  ],
  "🍮": [
    "1f36e",
    "comidas",
    "custard",
    "dessert",
    "pudding",
    "pudim",
    "pudim de leite",
    "pudim de ovos",
    "restaurante",
    "sweet"
  ],
  "🍭": [
    "1f36d",
    "bala",
    "candy",
    "comidas",
    "dessert",
    "doce",
    "food",
    "lollipop",
    "pirulito",
    "restaurant",
    "sweet"
  ],
  "🍬": [
    "1f36c",
    "bala",
    "balinha",
    "candy",
    "cavities",
    "comidas",
    "dessert",
    "doce",
    "halloween",
    "restaurant",
    "sweet",
    "tooth",
    "wrapper"
  ],
  "🍫": [
    "1f36b",
    "bar",
    "barra",
    "barra de chocolate",
    "candy",
    "chocolate",
    "chocolate bar",
    "comidas",
    "dessert",
    "doce",
    "fome",
    "halloween",
    "sweet",
    "tooth"
  ],
  "🍿": [
    "1f37f",
    "balde",
    "cinema",
    "comidas",
    "corn",
    "movie",
    "pipoca",
    "pop",
    "popcorn"
  ],
  "🍩": [
    "1f369",
    "breakfast",
    "comida",
    "comidas",
    "dessert",
    "donut",
    "doughnut",
    "fome",
    "food",
    "restaurante",
    "rosquinha",
    "sonho doce",
    "sweet"
  ],
  "🍪": [
    "1f36a",
    "biscoito",
    "bolacha",
    "chip",
    "chocolate",
    "comida",
    "comidas",
    "cookie",
    "dessert",
    "doce",
    "fome",
    "sobremesa",
    "sweet"
  ],
  "🌰": [
    "1f330",
    "almond",
    "castanha",
    "chestnut",
    "comidas",
    "plant",
    "planta"
  ],
  "🥜": [
    "1f95c",
    "amendoim",
    "comida",
    "comidas",
    "food",
    "nut",
    "peanut",
    "peanuts",
    "vegetable"
  ],
  "🫘": [
    "1fad8",
    "alimento",
    "beans",
    "comida",
    "comidas",
    "feijao",
    "feijoes",
    "food",
    "grao",
    "kidney",
    "legume",
    "small"
  ],
  "🍯": [
    "1f36f",
    "barrel",
    "bear",
    "comidas",
    "food",
    "honey",
    "honey pot",
    "honeypot",
    "jar",
    "mel",
    "pot",
    "pote",
    "pote de mel",
    "restaurante",
    "sweet"
  ],
  "🥛": [
    "1f95b",
    "comidas",
    "copo",
    "copo de leite",
    "drink",
    "glass",
    "glass of milk",
    "leite",
    "milk"
  ],
  "🫗": [
    "1fad7",
    "acabou",
    "accident",
    "acidente",
    "agua",
    "bebida",
    "comidas",
    "copo",
    "derramando liquido",
    "derramar",
    "derrubar",
    "drink",
    "empty",
    "fim",
    "glass",
    "liquid",
    "liquido",
    "oops",
    "ops",
    "pingar",
    "pour",
    "pouring",
    "pouring liquid",
    "spill",
    "vazio",
    "water"
  ],
  "🍼": [
    "1f37c",
    "babies",
    "baby",
    "baby bottle",
    "bebe",
    "birth",
    "born",
    "bottle",
    "comidas",
    "drink",
    "infant",
    "leite",
    "leitinho",
    "mamadeira",
    "mamar",
    "milk",
    "nenem",
    "newborn"
  ],
  "🫖": [
    "1fad6",
    "alimento",
    "bebida",
    "brew",
    "bule",
    "cha",
    "chaleira",
    "comida",
    "comidas",
    "drink",
    "food",
    "infusao",
    "pot",
    "tea",
    "teapot"
  ],
  "☕️": [
    "2615",
    "beverage",
    "cafe",
    "cafeina",
    "cafezinho",
    "caffeine",
    "cha",
    "chai",
    "coffee",
    "comidas",
    "drink",
    "hot",
    "hot beverage",
    "inverno",
    "morning",
    "quente",
    "steaming",
    "tea"
  ],
  "🍵": [
    "1f375",
    "bebida",
    "beverage",
    "cha",
    "cha verde",
    "comidas",
    "cup",
    "drink",
    "handle",
    "oolong",
    "tea",
    "teacup",
    "teacup without handle",
    "xicara",
    "xicara de cha",
    "xicara de cha sem alca"
  ],
  "🧃": [
    "1f9c3",
    "beverage",
    "beverage box",
    "box",
    "caixa de suco",
    "caixinha de suco",
    "comidas",
    "juice",
    "straw",
    "suco",
    "suco de caixa",
    "suquinho",
    "sweet"
  ],
  "🥤": [
    "1f964",
    "agua",
    "canudo",
    "comidas",
    "copo",
    "copo com canudo",
    "cup",
    "cup with straw",
    "drink",
    "juice",
    "malt",
    "refrigerante",
    "soda",
    "soft",
    "straw",
    "suco",
    "water"
  ],
  "🧋": [
    "1f9cb",
    "bebida",
    "boba",
    "bolha",
    "bubble",
    "bubble tea",
    "cha",
    "cha perolado",
    "comida",
    "comidas",
    "food",
    "leite",
    "milk",
    "pearl",
    "perola",
    "poba",
    "tea"
  ],
  "🍶": [
    "1f376",
    "bar",
    "bebida",
    "beverage",
    "bottle",
    "comidas",
    "copo",
    "cup",
    "drink",
    "garrafa",
    "garrafa e copo de saque",
    "japones",
    "restaurant",
    "restaurante",
    "sake",
    "saque"
  ],
  "🍺": [
    "1f37a",
    "alcohol",
    "ale",
    "bar",
    "bebida",
    "beer",
    "beer mug",
    "booze",
    "caneca",
    "caneca de cerveja",
    "cerveja",
    "chopp",
    "comidas",
    "drink",
    "drinking",
    "drinks",
    "gelada",
    "happy hour",
    "mug",
    "octoberfest",
    "oktoberfest",
    "pint",
    "restaurante",
    "stein",
    "summer"
  ],
  "🍻": [
    "1f37b",
    "alcohol",
    "bar",
    "beer",
    "booze",
    "bottoms",
    "caneca",
    "canecas de cerveja",
    "cerveja",
    "cheers",
    "chope",
    "chopp",
    "clink",
    "clinking",
    "clinking beer mugs",
    "comidas",
    "drinking",
    "drinks",
    "mugs",
    "restaurante"
  ],
  "🥂": [
    "1f942",
    "brinde",
    "celebrate",
    "champagne",
    "champanhe",
    "clink",
    "clinking",
    "clinking glasses",
    "comemoracao",
    "comidas",
    "drink",
    "glass",
    "glasses",
    "taca",
    "tacas brindando",
    "tim-tim"
  ],
  "🍷": [
    "1f377",
    "alcohol",
    "bar",
    "bebida",
    "beverage",
    "booze",
    "calice de vinho",
    "club",
    "comidas",
    "drink",
    "drinking",
    "drinks",
    "glass",
    "restaurant",
    "restaurante",
    "taca",
    "vinho",
    "wine",
    "wine glass"
  ],
  "🥃": [
    "1f943",
    "bar",
    "bebida",
    "comidas",
    "copo",
    "drink",
    "glass",
    "liquor",
    "scotch",
    "shot",
    "tumbler",
    "tumbler glass",
    "whiskey",
    "whisky"
  ],
  "🍸": [
    "1f378",
    "alcohol",
    "bar",
    "beber",
    "bebida",
    "booze",
    "cachaca",
    "club",
    "cocktail",
    "cocktail glass",
    "comidas",
    "coquetel",
    "drink",
    "drinking",
    "drinks",
    "glass",
    "happy hour",
    "mad",
    "martini",
    "men",
    "restaurante",
    "taca",
    "taca de coquetel"
  ],
  "🍹": [
    "1f379",
    "alcohol",
    "bar",
    "bebida",
    "bebida tropical",
    "booze",
    "club",
    "cocktail",
    "comidas",
    "coquetel",
    "coquetel de frutas",
    "drink",
    "drinking",
    "drinks",
    "drunk",
    "happy hour",
    "mai",
    "party",
    "restaurante",
    "tai",
    "tropical",
    "tropical drink",
    "tropics"
  ],
  "🧉": [
    "1f9c9",
    "bebida",
    "chimarrao",
    "comidas",
    "cuia de chimarrao",
    "drink",
    "mate",
    "terere"
  ],
  "🍾": [
    "1f37e",
    "aniversario",
    "bar",
    "bottle",
    "bottle with popping cork",
    "champagne",
    "champanha",
    "champanhe",
    "cidra",
    "comemorar",
    "comidas",
    "cork",
    "drink",
    "espumante",
    "estourar",
    "festa",
    "garrafa",
    "garrafa de champanhe",
    "parabens",
    "popping"
  ],
  "🧊": [
    "1f9ca",
    "cold",
    "comidas",
    "cube",
    "cubo de gelo",
    "gelado",
    "gelo",
    "ice",
    "iceberg"
  ],
  "🥄": [
    "1f944",
    "colher",
    "comidas",
    "eat",
    "spoon",
    "tableware",
    "talher"
  ],
  "🍴": [
    "1f374",
    "almoco",
    "breakfast",
    "breaky",
    "comer",
    "comida",
    "comidas",
    "cooking",
    "cutlery",
    "delicious",
    "dinner",
    "eat",
    "faca",
    "feed",
    "fome",
    "food",
    "fork",
    "fork and knife",
    "garfo",
    "garfo e faca",
    "hungry",
    "jantar",
    "knife",
    "lunch",
    "restaurant",
    "restaurante",
    "talher",
    "talheres",
    "yum",
    "yummy"
  ],
  "🍽️": [
    "1f37d",
    "almoco",
    "comidas",
    "cooking",
    "dinner",
    "eat",
    "faca",
    "fome",
    "fork",
    "fork and knife with plate",
    "garfo",
    "jantar",
    "knife",
    "plate",
    "prato",
    "prato com talheres",
    "prato com talheres ao lado",
    "restaurante",
    "talheres"
  ],
  "🥣": [
    "1f963",
    "bowl",
    "bowl with spoon",
    "breakfast",
    "cafe da manha",
    "cereal",
    "comidas",
    "congee",
    "oatmeal",
    "porridge",
    "prato de sopa",
    "spoon",
    "tigela com colher"
  ],
  "🥡": [
    "1f961",
    "box",
    "caixa para viagem",
    "caixinha para levar",
    "chopsticks",
    "comidas",
    "delivery",
    "food",
    "marmita",
    "oyster",
    "pail",
    "takeout",
    "takeout box"
  ],
  "🥢": [
    "1f962",
    "chopsticks",
    "comida japonesa",
    "comidas",
    "hashi",
    "jeotgarak",
    "kuaizi",
    "pauzinhos"
  ],
  "🧂": [
    "1f9c2",
    "comida",
    "comidas",
    "condiment",
    "condimento",
    "flavor",
    "mad",
    "sabor",
    "sal",
    "saleiro",
    "salgado",
    "salt",
    "salty",
    "shaker",
    "taste",
    "upset"
  ],
  "⚽️": [
    "26bd",
    "atividades",
    "ball",
    "bola",
    "bola de futebol",
    "football",
    "futbol",
    "futebol",
    "jogar",
    "soccer",
    "soccer ball",
    "sport"
  ],
  "🏀": [
    "1f3c0",
    "atividades",
    "ball",
    "basketball",
    "basquete",
    "bola",
    "bola de basquete",
    "cesta",
    "esporte",
    "hoop",
    "jogo",
    "sport"
  ],
  "🏈": [
    "1f3c8",
    "american",
    "american football",
    "americano",
    "atividades",
    "ball",
    "bola",
    "bola de futebol americano",
    "bowl",
    "esporte",
    "football",
    "futebol",
    "sport",
    "super",
    "super bowl"
  ],
  "⚾️": [
    "26be",
    "atividades",
    "ball",
    "baseball",
    "beisebol",
    "bola",
    "bola de beisebol",
    "esportes",
    "sport"
  ],
  "🥎": [
    "1f94e",
    "atividades",
    "ball",
    "bola",
    "esporte",
    "glove",
    "luva",
    "softball",
    "softbol",
    "sports",
    "underarm"
  ],
  "🎾": [
    "1f3be",
    "atividades",
    "ball",
    "bola",
    "esporte",
    "racquet",
    "raquete",
    "sport",
    "tenis",
    "tennis"
  ],
  "🏐": [
    "1f3d0",
    "atividades",
    "ball",
    "bola",
    "bola de volei",
    "game",
    "jogar",
    "jogo",
    "volei",
    "volleyball"
  ],
  "🏉": [
    "1f3c9",
    "americano",
    "atividades",
    "ball",
    "bola",
    "bola de rugby",
    "esporte",
    "football",
    "futebol",
    "rugby",
    "rugby football",
    "sport"
  ],
  "🥏": [
    "1f94f",
    "atividades",
    "disc",
    "disco",
    "esporte",
    "flying",
    "flying disc",
    "frisbee",
    "ultimate",
    "voador"
  ],
  "🎱": [
    "1f3b1",
    "8",
    "8ball",
    "atividades",
    "ball",
    "bilhar",
    "billiard",
    "bola oito",
    "eight",
    "game",
    "jogo",
    "pool",
    "pool 8 ball"
  ],
  "🪀": [
    "1fa80",
    "atividades",
    "brinquedo",
    "fluctuate",
    "flutua",
    "ioio",
    "toy",
    "yo-yo"
  ],
  "🏓": [
    "1f3d3",
    "atividades",
    "ball",
    "bat",
    "game",
    "mesa",
    "paddle",
    "ping",
    "ping pong",
    "pingpong",
    "pingue-pongue",
    "pong",
    "raquete",
    "table",
    "tenis",
    "tennis"
  ],
  "🏸": [
    "1f3f8",
    "atividades",
    "badminton",
    "birdie",
    "game",
    "jogo",
    "peteca",
    "racquet",
    "raquete",
    "shuttlecock"
  ],
  "🏒": [
    "1f3d2",
    "atividades",
    "disco",
    "game",
    "gelo",
    "hockey",
    "hoquei",
    "hoquei no gelo",
    "ice",
    "ice hockey",
    "jogo",
    "puck",
    "stick",
    "taco"
  ],
  "🏑": [
    "1f3d1",
    "atividades",
    "ball",
    "bola",
    "campo",
    "field",
    "field hockey",
    "game",
    "hockey",
    "hoquei",
    "hoquei de campo",
    "jogo",
    "stick",
    "taco"
  ],
  "🥍": [
    "1f94d",
    "atividades",
    "ball",
    "bastao",
    "bola",
    "esporte",
    "goal",
    "gol",
    "lacrosse",
    "raquete",
    "sports",
    "stick",
    "taco"
  ],
  "🏏": [
    "1f3cf",
    "atividades",
    "ball",
    "bat",
    "betes",
    "bola",
    "cricket",
    "cricket game",
    "criquete",
    "game",
    "jogo",
    "taco"
  ],
  "🪃": [
    "1fa83",
    "aborigene",
    "arma",
    "atividades",
    "australia",
    "boomerang",
    "bumerangue",
    "rebote",
    "rebound",
    "repercussao",
    "repercussion",
    "weapon"
  ],
  "🥅": [
    "1f945",
    "atividades",
    "esporte",
    "futebol",
    "goal",
    "goal net",
    "gol",
    "goleira",
    "goleiro",
    "net",
    "rede"
  ],
  "⛳️": [
    "26f3",
    "atividades",
    "bandeira",
    "bandeira no buraco",
    "buraco",
    "esporte",
    "flag",
    "flag in hole",
    "golf",
    "golfe",
    "hole",
    "sport"
  ],
  "🪁": [
    "1fa81",
    "atividades",
    "fly",
    "kite",
    "papagaio",
    "pipa",
    "planar",
    "soar",
    "voar"
  ],
  "🛝": [
    "1f6dd",
    "amusement",
    "atividades",
    "brincar",
    "brinquedo",
    "escorregador",
    "escorregar",
    "park",
    "parque de diversoes",
    "parquinho",
    "play",
    "playground",
    "playground slide",
    "playing",
    "slide",
    "sliding",
    "theme"
  ],
  "🏹": [
    "1f3f9",
    "archer",
    "archery",
    "arco",
    "arco e flecha",
    "arma",
    "arrow",
    "atividades",
    "bow",
    "bow and arrow",
    "flecha",
    "sagitario",
    "sagittarius",
    "tool",
    "weapon",
    "zodiac",
    "zodiaco"
  ],
  "🎣": [
    "1f3a3",
    "atividades",
    "entertainment",
    "entretenimento",
    "fish",
    "fishing",
    "fishing pole",
    "peixe",
    "pesca",
    "pescador",
    "pescaria",
    "pole",
    "recreacao",
    "sport",
    "vara"
  ],
  "🤿": [
    "1f93f",
    "atividades",
    "diving",
    "diving mask",
    "esnorquel",
    "mascara",
    "mascara de mergulho",
    "mask",
    "mergulhador",
    "mergulho",
    "scuba",
    "snorkel",
    "snorkeling"
  ],
  "🥊": [
    "1f94a",
    "atividades",
    "boxe",
    "boxing",
    "boxing glove",
    "esporte",
    "glove",
    "luta",
    "luva",
    "luva de boxe"
  ],
  "🥋": [
    "1f94b",
    "artes",
    "arts",
    "atividades",
    "esporte",
    "faixa",
    "judo",
    "karate",
    "marciais",
    "martial",
    "martial arts uniform",
    "preta",
    "quimono",
    "quimono de artes marciais",
    "taekwondo",
    "uniform",
    "uniforme"
  ],
  "🎽": [
    "1f3bd",
    "athletics",
    "atividades",
    "camiseta",
    "camiseta de corrida",
    "corrida",
    "esporte",
    "faixa",
    "running",
    "running shirt",
    "sash",
    "shirt"
  ],
  "🛹": [
    "1f6f9",
    "atividades",
    "board",
    "rodinhas",
    "skate",
    "skateboard",
    "skater",
    "skatista",
    "wheels"
  ],
  "🛼": [
    "1f6fc",
    "atividades",
    "blades",
    "esporte",
    "patinacao",
    "patins",
    "patins de rodas",
    "rodas",
    "roller",
    "roller skate",
    "skate",
    "skates",
    "sport"
  ],
  "🛷": [
    "1f6f7",
    "atividades",
    "luge",
    "neve",
    "sled",
    "sledge",
    "sleigh",
    "snow",
    "toboga",
    "toboggan",
    "treno"
  ],
  "⛸️": [
    "26f8",
    "atividades",
    "gelo",
    "ice",
    "ice skate",
    "patinacao",
    "patins",
    "patins de gelo",
    "skate",
    "skating"
  ],
  "🥌": [
    "1f94c",
    "atividades",
    "curling",
    "curling stone",
    "game",
    "jogo",
    "pedra",
    "pedra de curling",
    "rock",
    "stone"
  ],
  "🎿": [
    "1f3bf",
    "atividades",
    "bota",
    "esporte",
    "esqui",
    "esquiar",
    "neve",
    "ski",
    "skis",
    "snow",
    "sport"
  ],
  "⛷️": [
    "26f7",
    "atividades",
    "esporte",
    "esqui",
    "esquiador",
    "frio",
    "neve",
    "ski",
    "skier",
    "snow"
  ],
  "🏂": [
    "1f3c2",
    "atividades",
    "esporte",
    "inverno",
    "neve",
    "praticante de snowboard",
    "ski",
    "snow",
    "snowboard",
    "snowboarder",
    "sport"
  ],
  "🪂": [
    "1fa82",
    "asa-delta",
    "atividades",
    "hang-glide",
    "parachute",
    "paraquedas",
    "paraquedista",
    "parasail",
    "saltar de paraquedas",
    "skydive"
  ],
  "🏋️‍♀️": [
    "1f3cb-200d-2640",
    "atividades",
    "barbell",
    "bodybuilder",
    "deadlift",
    "esporte",
    "forca",
    "garota",
    "guria",
    "levantadora de peso",
    "levantar",
    "lifter",
    "lifting",
    "malhar",
    "menina",
    "mulher",
    "mulher levantando peso",
    "peso",
    "powerlifting",
    "weight",
    "weightlifter",
    "weights",
    "woman",
    "woman lifting weights",
    "workout"
  ],
  "🏋️": [
    "1f3cb",
    "atividades",
    "barbell",
    "bodybuilder",
    "deadlift",
    "esporte",
    "fisiculturista",
    "forca",
    "levantar",
    "lifter",
    "lifting",
    "person",
    "person lifting weights",
    "peso",
    "pessoa levantando peso",
    "powerlifting",
    "weight",
    "weightlifter",
    "weights",
    "workout"
  ],
  "🏋️‍♂️": [
    "1f3cb-200d-2642",
    "atividades",
    "barbell",
    "bodybuilder",
    "deadlift",
    "esporte",
    "forca",
    "homem",
    "homem levantando peso",
    "lifter",
    "lifting",
    "man",
    "man lifting weights",
    "peso",
    "powerlifting",
    "weight",
    "weightlifter",
    "weights",
    "workout"
  ],
  "🤼‍♀️": [
    "1f93c-200d-2640",
    "atividades",
    "combat",
    "combate",
    "duel",
    "esporte",
    "grapple",
    "greco-romana",
    "livre",
    "luta",
    "lutadora",
    "mulher",
    "mulheres lutando",
    "ring",
    "torneio",
    "tournament",
    "women",
    "women wrestling",
    "wrestle",
    "wrestling"
  ],
  "🤼": [
    "1f93c",
    "atividades",
    "combat",
    "combate",
    "duel",
    "esporte",
    "grapple",
    "greco-romana",
    "livre",
    "luta",
    "lutador",
    "people",
    "people wrestling",
    "pessoa",
    "pessoas lutando",
    "ring",
    "torneio",
    "tournament",
    "wrestle",
    "wrestling"
  ],
  "🤼‍♂️": [
    "1f93c-200d-2642",
    "atividades",
    "combat",
    "combate",
    "duel",
    "esporte",
    "grapple",
    "greco-romana",
    "homem",
    "homens lutando",
    "livre",
    "luta",
    "lutador",
    "men",
    "men wrestling",
    "ring",
    "torneio",
    "tournament",
    "wrestle",
    "wrestling"
  ],
  "🤸‍♀️": [
    "1f938-200d-2640",
    "active",
    "animada",
    "atividades",
    "cartwheel",
    "cartwheeling",
    "esporte",
    "estrela",
    "excited",
    "feliz",
    "flip",
    "ginasta",
    "ginastica",
    "gymnastics",
    "happy",
    "menina",
    "mulher",
    "mulher fazendo estrela",
    "somersault",
    "virar",
    "woman",
    "woman cartwheeling"
  ],
  "🤸": [
    "1f938",
    "active",
    "animada",
    "animado",
    "atividades",
    "cartwheel",
    "cartwheeling",
    "esporte",
    "estrela",
    "estrelinha",
    "excited",
    "feliz",
    "flip",
    "ginasta",
    "ginastica",
    "gymnastics",
    "happy",
    "person",
    "person cartwheeling",
    "pessoa",
    "pessoa fazendo estrela",
    "somersault"
  ],
  "🤸‍♂️": [
    "1f938-200d-2642",
    "active",
    "animado",
    "atividades",
    "cartwheel",
    "cartwheeling",
    "esporte",
    "estrela",
    "estrelinha",
    "excited",
    "feliz",
    "flip",
    "ginastica",
    "gymnastics",
    "happy",
    "homem",
    "homem fazendo estrela",
    "man",
    "man cartwheeling",
    "menino",
    "somersault",
    "virar"
  ],
  "⛹️‍♀️": [
    "26f9-200d-2640",
    "athletic",
    "atividades",
    "ball",
    "basketball",
    "basquete",
    "bola",
    "bouncing",
    "championship",
    "dribble",
    "esporte",
    "garota",
    "jogadora",
    "jogo",
    "menina",
    "mulher",
    "mulher jogando basquete",
    "net",
    "player",
    "throw",
    "woman",
    "woman bouncing ball"
  ],
  "⛹️": [
    "26f9",
    "arremesso",
    "athletic",
    "atividades",
    "atleta",
    "ball",
    "basketball",
    "basquete",
    "bater bola",
    "bola",
    "bouncing",
    "cesta",
    "championship",
    "dribble",
    "esporte",
    "jogador",
    "lance livre",
    "net",
    "person",
    "person bouncing ball",
    "pessoa jogando basquete",
    "player",
    "throw"
  ],
  "⛹️‍♂️": [
    "26f9-200d-2642",
    "athletic",
    "atividades",
    "ball",
    "basketball",
    "basquete",
    "bola",
    "bouncing",
    "championship",
    "dribble",
    "esporte",
    "homem",
    "homem jogando basquete",
    "man",
    "man bouncing ball",
    "net",
    "player",
    "throw"
  ],
  "🤺": [
    "1f93a",
    "atividades",
    "esgrima",
    "esgrimista",
    "espada",
    "esporte",
    "fencer",
    "fencing",
    "person",
    "person fencing",
    "pessoa",
    "sword"
  ],
  "🤾‍♀️": [
    "1f93e-200d-2640",
    "athletics",
    "atividades",
    "ball",
    "bola",
    "catch",
    "chuck",
    "esporte",
    "gol",
    "handball",
    "handebol",
    "hurl",
    "jogadora",
    "jogadora de handebol",
    "jogando",
    "lob",
    "menina",
    "mulher",
    "passe",
    "pitch",
    "playing",
    "quadra",
    "sport",
    "throw",
    "toss",
    "woman",
    "woman playing handball"
  ],
  "🤾": [
    "1f93e",
    "athletics",
    "atividades",
    "atleta",
    "ball",
    "bola",
    "catch",
    "chuck",
    "esporte",
    "gol",
    "handball",
    "handebol",
    "hurl",
    "jogador",
    "lob",
    "passe",
    "person",
    "person playing handball",
    "pessoa",
    "pitch",
    "playing",
    "sport",
    "throw",
    "toss"
  ],
  "🤾‍♂️": [
    "1f93e-200d-2642",
    "athletics",
    "atividades",
    "ball",
    "bola",
    "catch",
    "chuck",
    "esporte",
    "handball",
    "handebol",
    "homem",
    "hurl",
    "jogador",
    "jogador de handebol",
    "jogando",
    "lob",
    "man",
    "man playing handball",
    "menino",
    "pitch",
    "playing",
    "quadra",
    "sport",
    "throw",
    "toss"
  ],
  "🏌️‍♀️": [
    "1f3cc-200d-2640",
    "atividades",
    "ball",
    "birdie",
    "bola",
    "caddy",
    "driving",
    "esporte",
    "garota",
    "golf",
    "golfe",
    "golfing",
    "golfista",
    "green",
    "menina",
    "mulher",
    "mulher golfista",
    "pga",
    "putt",
    "range",
    "tee",
    "woman",
    "woman golfing"
  ],
  "🏌️": [
    "1f3cc",
    "atividades",
    "ball",
    "birdie",
    "bola",
    "caddy",
    "driving",
    "esporte",
    "golf",
    "golfe",
    "golfing",
    "golfista",
    "green",
    "jogando",
    "person",
    "person golfing",
    "pga",
    "putt",
    "range",
    "tee"
  ],
  "🏌️‍♂️": [
    "1f3cc-200d-2642",
    "atividades",
    "ball",
    "birdie",
    "caddy",
    "driving",
    "golf",
    "golfe",
    "golfing",
    "green",
    "homem",
    "homem golfista",
    "homem jogando golfe",
    "man",
    "man golfing",
    "pga",
    "putt",
    "range",
    "tee"
  ],
  "🏇": [
    "1f3c7",
    "atividades",
    "cavalo",
    "corrida",
    "corrida de cavalos",
    "esporte",
    "horse",
    "horse racing",
    "jockey",
    "joquei",
    "racehorse",
    "racing",
    "riding",
    "sport"
  ],
  "🧘‍♀️": [
    "1f9d8-200d-2640",
    "atividades",
    "cross",
    "ioga",
    "legged",
    "legs",
    "lotus",
    "meditacao",
    "meditation",
    "mulher na posicao de lotus",
    "peace",
    "position",
    "relax",
    "serenity",
    "woman",
    "woman in lotus position",
    "yoga",
    "yogi",
    "zen"
  ],
  "🧘": [
    "1f9d8",
    "atividades",
    "cross",
    "cruzadas",
    "ioga",
    "legged",
    "legs",
    "lotus",
    "meditacao",
    "meditation",
    "peace",
    "pernas",
    "person",
    "person in lotus position",
    "pessoa na posicao de lotus",
    "posicao",
    "position",
    "postura",
    "relax",
    "relaxar",
    "serenidade",
    "serenity",
    "yoga",
    "yogi",
    "zen"
  ],
  "🧘‍♂️": [
    "1f9d8-200d-2642",
    "atividades",
    "cross",
    "homem na posicao de lotus",
    "ioga",
    "legged",
    "legs",
    "lotus",
    "man",
    "man in lotus position",
    "meditacao",
    "meditation",
    "peace",
    "position",
    "relax",
    "serenity",
    "yoga",
    "yogi",
    "zen"
  ],
  "🏄‍♀️": [
    "1f3c4-200d-2640",
    "atividades",
    "beach",
    "esporte",
    "garota",
    "guria",
    "mar",
    "menina",
    "mulher",
    "mulher surfista",
    "ocean",
    "onda",
    "person",
    "praia",
    "sport",
    "surf",
    "surfando",
    "surfe",
    "surfer",
    "surfing",
    "surfista",
    "swell",
    "waves",
    "woman surfing"
  ],
  "🏄": [
    "1f3c4",
    "atividades",
    "beach",
    "esporte",
    "ocean",
    "onda",
    "ondas",
    "person",
    "person surfing",
    "pessoa",
    "praia",
    "prancha",
    "sport",
    "surf",
    "surfer",
    "surfing",
    "surfista",
    "swell",
    "waves"
  ],
  "🏄‍♂️": [
    "1f3c4-200d-2642",
    "atividades",
    "beach",
    "homem",
    "homem surfista",
    "man",
    "man surfing",
    "ocean",
    "sport",
    "surf",
    "surfando",
    "surfer",
    "surfing",
    "swell",
    "waves"
  ],
  "🏊‍♀️": [
    "1f3ca-200d-2640",
    "atividades",
    "esporte",
    "freestyle",
    "homem",
    "man",
    "mulher nadando",
    "nadadora",
    "nado",
    "natacao",
    "olimpiada",
    "sport",
    "swim",
    "swimmer",
    "swimming",
    "triathlon",
    "triatlo",
    "woman swimming"
  ],
  "🏊": [
    "1f3ca",
    "atividades",
    "esporte",
    "freestyle",
    "nadar",
    "natacao",
    "olimpiada",
    "person",
    "person swimming",
    "pessoa nadando",
    "sport",
    "swim",
    "swimmer",
    "swimming",
    "triathlon",
    "triatlo"
  ],
  "🏊‍♂️": [
    "1f3ca-200d-2642",
    "atividades",
    "freestyle",
    "homem",
    "homem nadando",
    "man",
    "man swimming",
    "nadar",
    "natacao",
    "sport",
    "swim",
    "swimmer",
    "swimming",
    "triathlon"
  ],
  "🤽‍♀️": [
    "1f93d-200d-2640",
    "aquatico",
    "atividades",
    "esporte",
    "jogadora",
    "menina",
    "mulher",
    "mulher jogando polo aquatico",
    "piscina",
    "playing",
    "polo",
    "sport",
    "swimming",
    "water",
    "waterpolo",
    "woman",
    "woman playing water polo"
  ],
  "🤽": [
    "1f93d",
    "aquatico",
    "atividades",
    "competicao",
    "esporte",
    "person",
    "person playing water polo",
    "pessoa",
    "pessoa jogando polo aquatico",
    "piscina",
    "playing",
    "polo",
    "sport",
    "swimming",
    "water",
    "waterpolo"
  ],
  "🤽‍♂️": [
    "1f93d-200d-2642",
    "aquatico",
    "atividades",
    "esporte",
    "homem",
    "homem jogando polo aquatico",
    "jogador",
    "jogando",
    "man",
    "man playing water polo",
    "piscina",
    "playing",
    "polo",
    "sport",
    "swimming",
    "water",
    "waterpolo"
  ],
  "🚣‍♀️": [
    "1f6a3-200d-2640",
    "atividades",
    "barco",
    "boat",
    "caiaque",
    "canoa",
    "canoe",
    "cruise",
    "esporte",
    "fishing",
    "garota",
    "lake",
    "menina",
    "mulher",
    "mulher remando",
    "oar",
    "paddle",
    "pescaria",
    "raft",
    "remadora",
    "remando",
    "remo",
    "rio",
    "river",
    "row",
    "rowboat",
    "rowing",
    "woman",
    "woman rowing boat"
  ],
  "🚣": [
    "1f6a3",
    "atividades",
    "barco",
    "boat",
    "bote",
    "canoa",
    "canoe",
    "cruise",
    "fishing",
    "lake",
    "mar",
    "oar",
    "oceano",
    "paddle",
    "person",
    "person rowing boat",
    "pessoa",
    "pessoa remando",
    "raft",
    "remo",
    "rio",
    "river",
    "row",
    "rowboat",
    "rowing"
  ],
  "🚣‍♂️": [
    "1f6a3-200d-2642",
    "atividades",
    "boat",
    "canoe",
    "cruise",
    "esporte",
    "fishing",
    "homem",
    "homem remando",
    "lake",
    "man",
    "man rowing boat",
    "oar",
    "paddle",
    "raft",
    "remador",
    "remo",
    "river",
    "row",
    "rowboat",
    "rowing"
  ],
  "🧗‍♀️": [
    "1f9d7-200d-2640",
    "atividades",
    "climb",
    "climber",
    "climbing",
    "escalar",
    "mountain",
    "mulher escalando",
    "rock",
    "scale",
    "up",
    "woman",
    "woman climbing"
  ],
  "🧗": [
    "1f9d7",
    "alpinista",
    "atividades",
    "climb",
    "climber",
    "climbing",
    "escalada",
    "escalando",
    "escalar",
    "esporte",
    "montanha",
    "mountain",
    "person",
    "person climbing",
    "pessoa escalando",
    "rock",
    "scale",
    "up"
  ],
  "🧗‍♂️": [
    "1f9d7-200d-2642",
    "atividades",
    "climb",
    "climber",
    "climbing",
    "escalar",
    "homem escalando",
    "man",
    "man climbing",
    "mountain",
    "rock",
    "scale",
    "up"
  ],
  "🚵‍♀️": [
    "1f6b5-200d-2640",
    "atividades",
    "bicicleta",
    "bicycle",
    "bicyclist",
    "bike",
    "biking",
    "ciclista",
    "cycle",
    "cyclist",
    "esporte",
    "garota",
    "guria",
    "menina",
    "montanha",
    "mountain",
    "mulher",
    "mulher fazendo mountain bike",
    "pedalar",
    "riding",
    "sport",
    "woman",
    "woman mountain biking"
  ],
  "🚵": [
    "1f6b5",
    "atividades",
    "bicicleta",
    "bicycle",
    "bicyclist",
    "bike",
    "biking",
    "ciclismo",
    "ciclista",
    "cycle",
    "cyclist",
    "esporte",
    "montanha",
    "mountain",
    "mountain bike",
    "pedalando",
    "person",
    "person mountain biking",
    "pessoa fazendo mountain bike",
    "riding",
    "sport",
    "trilha"
  ],
  "🚵‍♂️": [
    "1f6b5-200d-2642",
    "atividades",
    "bicicleta",
    "bicycle",
    "bicyclist",
    "bike",
    "biking",
    "ciclista",
    "cycle",
    "cyclist",
    "homem fazendo mountain bike",
    "man",
    "man mountain biking",
    "mountain",
    "mountain bike",
    "riding",
    "sport"
  ],
  "🚴‍♀️": [
    "1f6b4-200d-2640",
    "atividades",
    "bicicleta",
    "bicycle",
    "bicyclist",
    "bike",
    "biking",
    "ciclismo",
    "ciclista",
    "cycle",
    "cyclist",
    "esporte",
    "garota",
    "guria",
    "menina",
    "mulher",
    "mulher ciclista",
    "passeio",
    "pedalando",
    "pedalar",
    "riding",
    "sport",
    "woman",
    "woman biking"
  ],
  "🚴": [
    "1f6b4",
    "atividades",
    "bicicleta",
    "bicycle",
    "bicyclist",
    "bike",
    "biking",
    "ciclismo",
    "ciclista",
    "cycle",
    "cyclist",
    "esporte",
    "pedalar",
    "person",
    "person biking",
    "riding",
    "sport"
  ],
  "🚴‍♂️": [
    "1f6b4-200d-2642",
    "atividades",
    "bicicleta",
    "bicycle",
    "bicyclist",
    "bike",
    "biking",
    "cycle",
    "cyclist",
    "esporte",
    "homem",
    "homem ciclista",
    "man",
    "man biking",
    "passeio",
    "riding",
    "sport"
  ],
  "🏆": [
    "1f3c6",
    "atividades",
    "campea",
    "campeao",
    "champion",
    "champs",
    "premio",
    "prize",
    "slay",
    "sport",
    "trofeu",
    "trophy",
    "victory",
    "win",
    "winning"
  ],
  "🥇": [
    "1f947",
    "1o. lugar",
    "1st",
    "1st place medal",
    "1º. lugar",
    "atividades",
    "first",
    "gold",
    "medal",
    "medalha",
    "medalha de ouro",
    "ouro",
    "place",
    "vitoria"
  ],
  "🥈": [
    "1f948",
    "2nd",
    "2nd place medal",
    "2o. lugar",
    "2º. lugar",
    "atividades",
    "medal",
    "medalha",
    "medalha de prata",
    "place",
    "prata",
    "second",
    "segundo",
    "silver"
  ],
  "🥉": [
    "1f949",
    "3o. lugar",
    "3rd",
    "3rd place medal",
    "3º. lugar",
    "atividades",
    "bronze",
    "medal",
    "medalha",
    "medalha de bronze",
    "place",
    "terceiro",
    "third"
  ],
  "🏅": [
    "1f3c5",
    "atividades",
    "award",
    "gold",
    "medal",
    "medalha",
    "medalha esportiva",
    "sports",
    "sports medal",
    "vitoria",
    "winner"
  ],
  "🎖️": [
    "1f396",
    "atividades",
    "award",
    "celebration",
    "condecoracao",
    "medal",
    "medalha",
    "medalha militar",
    "militar",
    "military",
    "military medal",
    "premio"
  ],
  "🏵️": [
    "1f3f5",
    "atividades",
    "flor",
    "flor amarela",
    "plant",
    "planta",
    "primavera",
    "roseta",
    "rosette"
  ],
  "🎗️": [
    "1f397",
    "atividades",
    "celebracao",
    "celebration",
    "comemoracao",
    "fita de lembrete",
    "laco",
    "lembrete",
    "reminder",
    "reminder ribbon",
    "ribbon"
  ],
  "🎫": [
    "1f3ab",
    "admission",
    "atividades",
    "entretenimento",
    "ingresso",
    "stub",
    "ticket"
  ],
  "🎟️": [
    "1f39f",
    "admission",
    "admission tickets",
    "atividades",
    "cinema",
    "entrada",
    "ingresso",
    "ingresso de cinema",
    "ticket",
    "tickets"
  ],
  "🎪": [
    "1f3aa",
    "atividades",
    "circo",
    "circus",
    "circus tent",
    "entretenimento",
    "lona",
    "lona de circo",
    "tenda",
    "tent"
  ],
  "🤹‍♀️": [
    "1f939-200d-2640",
    "act",
    "atividades",
    "balance",
    "balancing",
    "equilibrio",
    "habilidade",
    "handle",
    "juggle",
    "juggling",
    "malabarismo",
    "malabarista",
    "manage",
    "mulher",
    "mulher malabarista",
    "multitarefa",
    "multitask",
    "skill",
    "woman",
    "woman juggling"
  ],
  "🤹": [
    "1f939",
    "act",
    "atividades",
    "balance",
    "balancing",
    "equilibrio",
    "habilidade",
    "handle",
    "juggle",
    "juggling",
    "malabares",
    "malabarismo",
    "malabarista",
    "manage",
    "multitarefa",
    "multitask",
    "person",
    "person juggling",
    "skill"
  ],
  "🤹‍♂️": [
    "1f939-200d-2642",
    "act",
    "atividades",
    "balance",
    "balancing",
    "equilibrio",
    "habilidade",
    "handle",
    "homem",
    "homem malabarista",
    "juggle",
    "juggling",
    "malabares",
    "malabarismo",
    "man",
    "man juggling",
    "manage",
    "multitarefa",
    "multitask",
    "skill"
  ],
  "🎭": [
    "1f3ad",
    "actor",
    "actress",
    "art",
    "arte",
    "arts",
    "atividades",
    "ator",
    "atriz",
    "drama",
    "dramatica",
    "entertainment",
    "entretenimento",
    "espetaculo",
    "mascara",
    "mask",
    "peca",
    "performance",
    "performing",
    "performing arts",
    "teatro",
    "theater",
    "theatre",
    "thespian"
  ],
  "🩰": [
    "1fa70",
    "atividades",
    "bailarina",
    "bale",
    "ballet",
    "ballet shoes",
    "danca",
    "dance",
    "sapatilha",
    "sapatilha de bale",
    "shoes"
  ],
  "🎨": [
    "1f3a8",
    "art",
    "arte",
    "artist",
    "artist palette",
    "artista",
    "artistica",
    "artsy",
    "arty",
    "atividades",
    "colorful",
    "creative",
    "entertainment",
    "museu",
    "museum",
    "painter",
    "painting",
    "paleta",
    "paleta de tintas",
    "palette",
    "pintor",
    "pintura",
    "tinta"
  ],
  "🫟": [
    "1fadf",
    "atividades",
    "drip",
    "holi",
    "ink",
    "liquid",
    "mancha",
    "mess",
    "paint",
    "pingo",
    "respingo",
    "spill",
    "splatter",
    "stain",
    "tinta"
  ],
  "🎬": [
    "1f3ac",
    "action",
    "atividades",
    "board",
    "cena",
    "clapper",
    "clapper board",
    "claquete",
    "entretenimento",
    "filme",
    "movie",
    "tomada"
  ],
  "🎤": [
    "1f3a4",
    "atividades",
    "cantar",
    "entretenimento",
    "karaoke",
    "mic",
    "microfone",
    "microphone",
    "music",
    "musica",
    "sing",
    "sound"
  ],
  "🎧": [
    "1f3a7",
    "atividades",
    "earbud",
    "entretenimento",
    "fone",
    "fones de ouvido",
    "headphone",
    "musica",
    "ouvido",
    "som",
    "sound"
  ],
  "🎼": [
    "1f3bc",
    "atividades",
    "music",
    "musica",
    "musical",
    "musical score",
    "note",
    "partitura",
    "partitura musical",
    "score"
  ],
  "🎹": [
    "1f3b9",
    "atividades",
    "instrument",
    "instrumento",
    "instrumento musical",
    "keyboard",
    "music",
    "musica",
    "musical",
    "musical keyboard",
    "piano",
    "teclado",
    "teclado musical"
  ],
  "🪇": [
    "1fa87",
    "atividades",
    "cha",
    "chacoalhar",
    "chocalho",
    "danca",
    "dance",
    "festa",
    "instrument",
    "instrumento",
    "maraca",
    "maracas",
    "mexer",
    "music",
    "musica",
    "party",
    "percussao",
    "percussion",
    "rattle",
    "shake",
    "shaker"
  ],
  "🥁": [
    "1f941",
    "atividades",
    "baquetas",
    "drum",
    "drumsticks",
    "music",
    "musica",
    "percussao",
    "tambor"
  ],
  "🪘": [
    "1fa98",
    "atabaque",
    "atividades",
    "batida",
    "beat",
    "comprido",
    "conga",
    "drum",
    "instrument",
    "instrumento",
    "long",
    "long drum",
    "percussao",
    "rhythm",
    "ritmo",
    "tambor",
    "tambor comprido"
  ],
  "🎷": [
    "1f3b7",
    "atividades",
    "instrument",
    "instrumento",
    "instrumento musical",
    "music",
    "musica",
    "sax",
    "saxofone",
    "saxophone"
  ],
  "🎺": [
    "1f3ba",
    "atividades",
    "instrument",
    "instrumento",
    "instrumento musical",
    "music",
    "musica",
    "trompete",
    "trumpet"
  ],
  "🪗": [
    "1fa97",
    "accordion",
    "acordeao",
    "atividades",
    "box",
    "concertina",
    "instrument",
    "instrumento",
    "music",
    "musica",
    "sanfona",
    "squeeze",
    "squeezebox"
  ],
  "🎸": [
    "1f3b8",
    "atividades",
    "guitar",
    "guitarra",
    "instrument",
    "instrumento",
    "instrumento musical",
    "music",
    "musica",
    "strat"
  ],
  "🪕": [
    "1fa95",
    "atividades",
    "banjo",
    "cordas",
    "instrumento",
    "music",
    "musica",
    "stringed"
  ],
  "🪉": [
    "1fa89",
    "amor",
    "atividades",
    "cupid",
    "cupido",
    "harp",
    "harpa",
    "instrument",
    "instrumento",
    "love",
    "music",
    "musica",
    "orchestra",
    "orquestra"
  ],
  "🎻": [
    "1f3bb",
    "atividades",
    "instrument",
    "instrumento",
    "instrumento musical",
    "music",
    "musica",
    "violin",
    "violino"
  ],
  "🪈": [
    "1fa88",
    "atividades",
    "band",
    "banda",
    "fife",
    "flauta",
    "flautim",
    "flautist",
    "flute",
    "instrument",
    "instrumento",
    "marching",
    "marcial",
    "music",
    "musica",
    "orchestra",
    "orquestra",
    "piccolo",
    "pifano",
    "pife",
    "pipe",
    "recorder",
    "sopro",
    "tubo",
    "woodwind"
  ],
  "🎲": [
    "1f3b2",
    "atividades",
    "dado",
    "dados",
    "dice",
    "die",
    "entertainment",
    "game",
    "game die",
    "jogo",
    "jogo de dado",
    "sorte"
  ],
  "♟️": [
    "265f",
    "atividades",
    "chess",
    "chess pawn",
    "dupe",
    "expendable",
    "pawn",
    "peao",
    "peao de xadrez",
    "truque",
    "xadrez"
  ],
  "🎯": [
    "1f3af",
    "alvo",
    "atividades",
    "bull",
    "bullseye",
    "certeiro",
    "dardos",
    "dart",
    "direct",
    "entertainment",
    "game",
    "hit",
    "jogo",
    "mira",
    "mosca",
    "no alvo",
    "target",
    "tiro"
  ],
  "🎳": [
    "1f3b3",
    "atividades",
    "ball",
    "bola",
    "boliche",
    "bowling",
    "game",
    "jogo",
    "sport",
    "strike"
  ],
  "🎮": [
    "1f3ae",
    "atividades",
    "controle",
    "controller",
    "entertainment",
    "game",
    "jogo",
    "jogos",
    "playstation",
    "video",
    "video game",
    "videogame",
    "xbox"
  ],
  "🎰": [
    "1f3b0",
    "aposta",
    "atividades",
    "azar",
    "caca-niquel",
    "casino",
    "cassino",
    "gamble",
    "gambling",
    "game",
    "jogo",
    "machine",
    "maquina",
    "slot",
    "slot machine",
    "slots"
  ],
  "🧩": [
    "1f9e9",
    "atividades",
    "clue",
    "dica",
    "encaixe",
    "interlocking",
    "jigsaw",
    "peca",
    "piece",
    "puzzle",
    "puzzle piece",
    "quebra-cabeca"
  ],
  "🚗": [
    "1f697",
    "automobile",
    "automovel",
    "car",
    "carro",
    "driving",
    "vehicle",
    "veiculo",
    "viagens"
  ],
  "🚕": [
    "1f695",
    "cab",
    "cabbie",
    "car",
    "drive",
    "taxi",
    "vehicle",
    "veiculo",
    "viagens",
    "yellow"
  ],
  "🚙": [
    "1f699",
    "car",
    "carro",
    "drive",
    "recreational",
    "sport",
    "sport utility vehicle",
    "sportutility",
    "suv",
    "trailer",
    "utility",
    "vehicle",
    "veiculo",
    "veiculo recreacional",
    "viagens"
  ],
  "🚌": [
    "1f68c",
    "bus",
    "onibus",
    "school",
    "transporte publico",
    "vehicle",
    "veiculo",
    "viagens"
  ],
  "🚎": [
    "1f68e",
    "bonde eletrico",
    "bus",
    "onibus",
    "onibus movido a eletricidade",
    "tram",
    "trolebus",
    "trolley",
    "trolleybus",
    "veiculo",
    "viagens"
  ],
  "🏎️": [
    "1f3ce",
    "automobilismo",
    "car",
    "carro",
    "carro de corrida",
    "corrida",
    "racing",
    "racing car",
    "viagens",
    "zoom"
  ],
  "🚓": [
    "1f693",
    "5–0",
    "car",
    "carro patrulha",
    "cops",
    "patrol",
    "police",
    "police car",
    "policia",
    "veiculo",
    "viagens",
    "viatura policial"
  ],
  "🚑": [
    "1f691",
    "ambulance",
    "ambulancia",
    "emergency",
    "vehicle",
    "veiculo",
    "viagens"
  ],
  "🚒": [
    "1f692",
    "bombeiro",
    "caminhao do corpo de bombeiros",
    "carro",
    "carro do corpo de bombeiros",
    "engine",
    "fire",
    "fire engine",
    "fogo",
    "incendio",
    "truck",
    "veiculo",
    "viagens"
  ],
  "🚐": [
    "1f690",
    "bus",
    "drive",
    "mini onibus",
    "minibus",
    "onibus",
    "van",
    "vehicle",
    "veiculo",
    "veraneio",
    "viagens"
  ],
  "🛻": [
    "1f6fb",
    "automobile",
    "automovel",
    "cacamba",
    "caminhao",
    "caminhonete",
    "car",
    "carro",
    "flatbed",
    "picape",
    "pick-up",
    "pickup",
    "pickup truck",
    "transportation",
    "transporte",
    "truck",
    "veiculo",
    "viagens"
  ],
  "🚚": [
    "1f69a",
    "caminhao",
    "caminhao de entrega",
    "car",
    "delivery",
    "delivery truck",
    "drive",
    "truck",
    "vehicle",
    "veiculo",
    "viagens"
  ],
  "🚛": [
    "1f69b",
    "articulated",
    "articulated lorry",
    "caminhao",
    "caminhao articulado",
    "car",
    "drive",
    "lorry",
    "move",
    "semi",
    "trailer",
    "truck",
    "vehicle",
    "veiculo",
    "viagens"
  ],
  "🚜": [
    "1f69c",
    "obra",
    "tractor",
    "trator",
    "vehicle",
    "veiculo",
    "viagens"
  ],
  "🦯": [
    "1f9af",
    "accessibility",
    "acessibilidade",
    "bengala",
    "bengala para cegos",
    "blind",
    "cane",
    "cega",
    "cego",
    "cegueira",
    "deficiente",
    "probing",
    "viagens",
    "visual",
    "white",
    "white cane"
  ],
  "🦽": [
    "1f9bd",
    "accessibility",
    "acessibilidade",
    "cadeira de rodas",
    "cadeira de rodas manual",
    "manual",
    "manual wheelchair",
    "viagens",
    "wheelchair"
  ],
  "🦼": [
    "1f9bc",
    "accessibility",
    "acessibilidade",
    "cadeira de rodas motorizada",
    "motorized",
    "motorized wheelchair",
    "viagens",
    "wheelchair"
  ],
  "🩼": [
    "1fa7c",
    "aid",
    "ajuda",
    "bastao",
    "bengala",
    "cane",
    "crutch",
    "deficiencia",
    "desculpa",
    "disability",
    "help",
    "hurt",
    "injured",
    "lesao",
    "machucar",
    "mobilidade",
    "mobility",
    "muleta",
    "stick",
    "viagens"
  ],
  "🛴": [
    "1f6f4",
    "brinquedo",
    "kick",
    "kick scooter",
    "patinete",
    "scooter",
    "viagens"
  ],
  "🚲": [
    "1f6b2",
    "bicicleta",
    "bicycle",
    "bike",
    "class",
    "cycle",
    "cycling",
    "cyclist",
    "gang",
    "ride",
    "spin",
    "spinning",
    "veiculo",
    "viagens"
  ],
  "🛵": [
    "1f6f5",
    "monareta",
    "motinho",
    "moto",
    "motoca",
    "motor",
    "motor scooter",
    "scooter",
    "viagens"
  ],
  "🏍️": [
    "1f3cd",
    "corrida",
    "moto",
    "motocicleta",
    "motorcycle",
    "racing",
    "veiculo",
    "viagens"
  ],
  "🛺": [
    "1f6fa",
    "auto",
    "auto rickshaw",
    "automovel riquixa",
    "autorriquixa",
    "rickshaw",
    "tuk",
    "tuk tuk",
    "viagens"
  ],
  "🛞": [
    "1f6de",
    "car",
    "carro",
    "circle",
    "circulo",
    "direcao",
    "girar",
    "pneu",
    "roda",
    "tire",
    "turn",
    "vehicle",
    "veiculo",
    "viagens",
    "volante",
    "wheel"
  ],
  "🚨": [
    "1f6a8",
    "alarm",
    "alert",
    "beacon",
    "car",
    "carro da policia",
    "emergency",
    "farol policial",
    "light",
    "luz de viatura policial",
    "luz giratoria",
    "police",
    "police car light",
    "revolving",
    "siren",
    "sirene",
    "viagens"
  ],
  "🚔": [
    "1f694",
    "car",
    "oncoming",
    "oncoming police car",
    "police",
    "policia",
    "veiculo",
    "viagens",
    "viatura policial",
    "viatura policial se aproximando"
  ],
  "🚍": [
    "1f68d",
    "bus",
    "cars",
    "oncoming",
    "oncoming bus",
    "onibus",
    "onibus se aproximando",
    "se aproximando",
    "veiculo",
    "viagens"
  ],
  "🚘": [
    "1f698",
    "automobile",
    "automovel",
    "car",
    "carona",
    "carro",
    "carro se aproximando",
    "cars",
    "chegada",
    "drove",
    "oncoming",
    "oncoming automobile",
    "se aproximando",
    "vehicle",
    "veiculo",
    "viagens"
  ],
  "🚖": [
    "1f696",
    "cab",
    "cabbie",
    "cars",
    "chegada",
    "drove",
    "hail",
    "oncoming",
    "oncoming taxi",
    "taxi",
    "taxi se aproximando",
    "transporte",
    "veiculo",
    "viagens",
    "yellow"
  ],
  "🚡": [
    "1f6a1",
    "aerea",
    "aerial",
    "aerial tramway",
    "bonde",
    "cable",
    "car",
    "gondola",
    "linha",
    "ropeway",
    "teleferico",
    "tramway",
    "veiculo",
    "viagens"
  ],
  "🚠": [
    "1f6a0",
    "bonde",
    "cable",
    "cableway",
    "cabo",
    "cabo suspenso usado em telefericos nas montanhas",
    "gondola",
    "lift",
    "montanha",
    "mountain",
    "mountain cableway",
    "ski",
    "teleferico",
    "teleferico de montanha",
    "teleferico na montanha",
    "veiculo",
    "viagens"
  ],
  "🚟": [
    "1f69f",
    "estrada de ferro",
    "estrada de ferro suspensa",
    "railway",
    "suspensao",
    "suspension",
    "suspension railway",
    "trem",
    "veiculo",
    "viagens"
  ],
  "🚃": [
    "1f683",
    "bonde",
    "car",
    "electric",
    "eletrico",
    "ferroviario",
    "railway",
    "railway car",
    "train",
    "tram",
    "transporte",
    "travel",
    "trem",
    "trolebus",
    "trolleybus",
    "vagao",
    "vagao de trem",
    "veiculo",
    "viagens"
  ],
  "🚋": [
    "1f68b",
    "bonde",
    "bonde eletrico",
    "bus",
    "car",
    "carro",
    "tram",
    "tram car",
    "trolebus",
    "trolley",
    "trolleybus",
    "veiculo",
    "viagens"
  ],
  "🚞": [
    "1f69e",
    "car",
    "carro",
    "estrada de ferro",
    "estrada de ferro na montanha",
    "montanha",
    "mountain",
    "mountain railway",
    "railway",
    "teleferico",
    "trip",
    "veiculo",
    "viagens"
  ],
  "🚝": [
    "1f69d",
    "monorail",
    "monotrilho",
    "trem",
    "vehicle",
    "veiculo",
    "viagens"
  ],
  "🚄": [
    "1f684",
    "alta",
    "bala",
    "high-speed",
    "high-speed train",
    "japones",
    "railway",
    "shinkansen",
    "speed",
    "train",
    "trem",
    "trem de alta velocidade",
    "trens",
    "veiculo",
    "velocidade",
    "veloz",
    "viagens"
  ],
  "🚅": [
    "1f685",
    "bala",
    "bullet",
    "bullet train",
    "ferrovia",
    "high-speed",
    "japao",
    "nose",
    "railway",
    "shinkansen",
    "speed",
    "train",
    "travel",
    "trem",
    "trem de alta velocidade japones",
    "velocidade",
    "veloz",
    "viagem",
    "viagens"
  ],
  "🚈": [
    "1f688",
    "arrived",
    "chegada",
    "cheguei",
    "leve",
    "light",
    "light rail",
    "monorail",
    "rail",
    "railway",
    "trem",
    "trem urbano",
    "veiculo",
    "viagens"
  ],
  "🚂": [
    "1f682",
    "caboose",
    "engine",
    "locomotiva",
    "locomotive",
    "railway",
    "steam",
    "train",
    "trains",
    "travel",
    "trem",
    "vapor",
    "veiculo",
    "viagens"
  ],
  "🚆": [
    "1f686",
    "arrived",
    "choo",
    "ferrovia",
    "railway",
    "train",
    "trem",
    "veiculo",
    "viagens"
  ],
  "🚇": [
    "1f687",
    "metro",
    "subway",
    "travel",
    "trem",
    "tunel",
    "tunel subterraneo",
    "veiculo",
    "viagens"
  ],
  "🚊": [
    "1f68a",
    "bonde eletrico",
    "tram",
    "trolebus",
    "trolleybus",
    "veiculo",
    "viagens"
  ],
  "🚉": [
    "1f689",
    "estacao",
    "estacao de trem",
    "metro",
    "railway",
    "station",
    "train",
    "trem",
    "viagens"
  ],
  "✈️": [
    "2708",
    "aereo",
    "aeroplane",
    "airplane",
    "aviao",
    "fly",
    "flying",
    "jet",
    "plane",
    "travel",
    "veiculo",
    "viagens",
    "viajar",
    "voar",
    "voo"
  ],
  "🛫": [
    "1f6eb",
    "aeroplane",
    "airplane",
    "airplane departure",
    "aviao",
    "aviao decolando",
    "check-in",
    "decolar",
    "departure",
    "departures",
    "ferias",
    "fui",
    "partindo",
    "partiu",
    "plane",
    "viagem",
    "viagens",
    "viajando"
  ],
  "🛬": [
    "1f6ec",
    "aeroplane",
    "airplane",
    "airplane arrival",
    "arrival",
    "arrivals",
    "arriving",
    "aterrissagem",
    "aterrissando",
    "aviao",
    "aviao aterrissando",
    "chegando",
    "landing",
    "plane",
    "pousando",
    "veiculo",
    "viagens",
    "voltando"
  ],
  "🛩️": [
    "1f6e9",
    "aereo",
    "aeroplane",
    "airplane",
    "aviao",
    "aviao pequeno",
    "jatinho",
    "jato",
    "pequeno",
    "plane",
    "small",
    "small airplane",
    "veiculo",
    "viagens"
  ],
  "💺": [
    "1f4ba",
    "assento",
    "cadeira",
    "chair",
    "poltrona",
    "seat",
    "viagens"
  ],
  "🛰️": [
    "1f6f0",
    "antena",
    "espaco",
    "satelite",
    "satellite",
    "space",
    "viagens"
  ],
  "🚀": [
    "1f680",
    "espaco",
    "foguete",
    "launch",
    "rocket",
    "rockets",
    "space",
    "travel",
    "veiculo",
    "viagens"
  ],
  "🛸": [
    "1f6f8",
    "alienigena",
    "aliens",
    "disco",
    "disco voador",
    "et",
    "extra",
    "flying",
    "flying saucer",
    "ovni",
    "saucer",
    "terrestre",
    "terrestrial",
    "ufo",
    "viagens",
    "voador"
  ],
  "🚁": [
    "1f681",
    "copter",
    "helicopter",
    "helicoptero",
    "roflcopter",
    "travel",
    "vehicle",
    "veiculo",
    "viagem",
    "viagens",
    "viajar",
    "voo"
  ],
  "🛶": [
    "1f6f6",
    "barco",
    "boat",
    "canoa",
    "canoe",
    "viagens"
  ],
  "⛵️": [
    "26f5",
    "barco",
    "barco a vela",
    "boat",
    "iate",
    "navegar",
    "oceano",
    "praia",
    "resort",
    "sailboat",
    "sailing",
    "sea",
    "vela",
    "viagens",
    "yacht"
  ],
  "🚤": [
    "1f6a4",
    "barco",
    "billionaire",
    "boat",
    "ferias",
    "lake",
    "lancha",
    "luxury",
    "millionaire",
    "praia",
    "speedboat",
    "summer",
    "travel",
    "veiculo",
    "verao",
    "viagens"
  ],
  "🛥️": [
    "1f6e5",
    "barco",
    "boat",
    "lancha",
    "motor",
    "motor boat",
    "motorboat",
    "navio",
    "veiculo",
    "viagens"
  ],
  "🛳️": [
    "1f6f3",
    "barco",
    "cruzeiro",
    "embarcacao",
    "navio",
    "passageiros",
    "passenger",
    "passenger ship",
    "ship",
    "veiculo",
    "viagens"
  ],
  "⛴️": [
    "26f4",
    "balsa",
    "barco",
    "boat",
    "ferry",
    "ferry boat",
    "ferry-boat",
    "navegar",
    "passenger",
    "viagens"
  ],
  "🚢": [
    "1f6a2",
    "aquatico",
    "barco",
    "boat",
    "cruzeiro",
    "ferias",
    "navio",
    "passenger",
    "ship",
    "travel",
    "veiculo",
    "viagem",
    "viagens"
  ],
  "🛟": [
    "1f6df",
    "boia",
    "buoy",
    "colete",
    "float",
    "flutuar",
    "guarda-vidas",
    "guardar",
    "life",
    "lifesaver",
    "nadar",
    "preserver",
    "rescue",
    "resgate",
    "ring",
    "ring buoy",
    "safety",
    "salva",
    "salva-vidas",
    "save",
    "saver",
    "seguranca",
    "swim",
    "viagens",
    "vidas"
  ],
  "⚓️": [
    "2693",
    "anchor",
    "ancora",
    "marinha",
    "navegar",
    "ship",
    "sinal",
    "tool",
    "viagens"
  ],
  "🪝": [
    "1fa9d",
    "atracao para venda",
    "bandido",
    "catch",
    "crook",
    "curva",
    "curve",
    "ensnare",
    "gancho",
    "hook",
    "pegar",
    "point",
    "prender",
    "selling",
    "viagens"
  ],
  "⛽️": [
    "26fd",
    "abastecer",
    "alcool",
    "bomba",
    "combustivel",
    "diesel",
    "fuel",
    "fuel pump",
    "fuelpump",
    "gas",
    "gasolina",
    "gasoline",
    "posto",
    "posto de gasolina",
    "pump",
    "station",
    "viagens"
  ],
  "🚧": [
    "1f6a7",
    "barrier",
    "construcao",
    "construction",
    "em construcao",
    "simbolo",
    "simbolo para “em construcao”",
    "viagens"
  ],
  "🚦": [
    "1f6a6",
    "cruzamento",
    "drove",
    "intersection",
    "light",
    "luz",
    "semaforo",
    "semaforo vertical",
    "signal",
    "sinal",
    "sinaleira",
    "stop",
    "stoplight",
    "traffic",
    "transito",
    "vertical",
    "vertical traffic light",
    "viagens"
  ],
  "🚥": [
    "1f6a5",
    "cruzamento",
    "horizontal",
    "horizontal traffic light",
    "intersection",
    "light",
    "luz",
    "semaforo",
    "semaforo horizontal",
    "signal",
    "sinal",
    "sinaleira",
    "stop",
    "stoplight",
    "traffic",
    "transito",
    "viagens"
  ],
  "🚏": [
    "1f68f",
    "bus",
    "bus stop",
    "busao",
    "busstop",
    "onibus",
    "ponto",
    "ponto de onibus",
    "stop",
    "transporte publico",
    "viagens"
  ],
  "🗺️": [
    "1f5fa",
    "geografia",
    "map",
    "mapa",
    "mapa-mundi",
    "mundo",
    "viagens",
    "world",
    "world map"
  ],
  "🗿": [
    "1f5ff",
    "estatua",
    "face",
    "moai",
    "moyai",
    "rosto",
    "statue",
    "stoneface",
    "travel",
    "viagens"
  ],
  "🗽": [
    "1f5fd",
    "estatua",
    "estatua da liberdade",
    "liberdade",
    "liberty",
    "new",
    "ny",
    "nyc",
    "statue",
    "statue of liberty",
    "viagens",
    "york"
  ],
  "🗼": [
    "1f5fc",
    "japao",
    "tokyo",
    "tokyo tower",
    "toquio",
    "torre",
    "torre de toquio",
    "tower",
    "viagens"
  ],
  "🏰": [
    "1f3f0",
    "building",
    "castelo",
    "castelo europeu",
    "castelo medieval",
    "castle",
    "european",
    "predio",
    "viagens"
  ],
  "🏯": [
    "1f3ef",
    "building",
    "castelo",
    "castelo japones",
    "castle",
    "japanese",
    "japanese castle",
    "japones",
    "pagoda",
    "pagode",
    "predio",
    "viagens"
  ],
  "🏟️": [
    "1f3df",
    "arena",
    "estadio",
    "stadium",
    "viagens"
  ],
  "🎡": [
    "1f3a1",
    "amusement",
    "entretenimento",
    "ferris",
    "ferris wheel",
    "gigante",
    "park",
    "parque de diversoes",
    "roda",
    "roda gigante",
    "theme",
    "viagens",
    "wheel"
  ],
  "🎢": [
    "1f3a2",
    "amusement",
    "coaster",
    "entretenimento",
    "montanha",
    "montanha russa",
    "park",
    "parque de diversoes",
    "parque tematico",
    "roller",
    "roller coaster",
    "russa",
    "theme",
    "viagens"
  ],
  "🎠": [
    "1f3a0",
    "carousel",
    "carousel horse",
    "carrossel",
    "cavalo",
    "cavalo de carrossel",
    "entertainment",
    "entretenimento",
    "horse",
    "parque de diversao",
    "viagens"
  ],
  "⛲️": [
    "26f2",
    "agua",
    "chafariz",
    "fonte",
    "fountain",
    "praca",
    "viagens"
  ],
  "⛱️": [
    "26f1",
    "chuva",
    "clima",
    "ground",
    "guarda-sol",
    "praia",
    "rain",
    "sol",
    "sombra",
    "sombrinha",
    "sun",
    "umbrella",
    "umbrella on ground",
    "viagens"
  ],
  "🏖️": [
    "1f3d6",
    "beach",
    "beach with umbrella",
    "guarda-sol",
    "praia",
    "praia e guarda-sol",
    "umbrella",
    "viagens"
  ],
  "🏝️": [
    "1f3dd",
    "desert",
    "desert island",
    "ilha",
    "ilha deserta",
    "island",
    "palmeira",
    "praia",
    "viagens"
  ],
  "🏜️": [
    "1f3dc",
    "clima seco",
    "desert",
    "deserto",
    "viagens"
  ],
  "🌋": [
    "1f30b",
    "erupcao vulcanica",
    "eruption",
    "lava",
    "mountain",
    "nature",
    "natureza",
    "viagens",
    "volcano",
    "vulcao"
  ],
  "⛰️": [
    "26f0",
    "montanha",
    "mountain",
    "natureza",
    "viagens"
  ],
  "🏔️": [
    "1f3d4",
    "alpes",
    "cold",
    "frio",
    "montanha",
    "montanha com neve",
    "mountain",
    "neve",
    "snow",
    "snow-capped",
    "snow-capped mountain",
    "viagens"
  ],
  "🗻": [
    "1f5fb",
    "fuji",
    "montanha",
    "monte fuji",
    "mount",
    "mount fuji",
    "mountain",
    "nature",
    "viagens"
  ],
  "🏕️": [
    "1f3d5",
    "acampamento",
    "barraca",
    "camping",
    "viagens"
  ],
  "⛺️": [
    "26fa",
    "acampamento",
    "acampar",
    "barraca",
    "camping",
    "tent",
    "viagens"
  ],
  "🛖": [
    "1f6d6",
    "abrigo",
    "cabana",
    "casa",
    "home",
    "house",
    "hut",
    "roundhouse",
    "shelter",
    "viagens",
    "yurt"
  ],
  "🏠": [
    "1f3e0",
    "building",
    "casa",
    "construcao",
    "country",
    "domicilio",
    "heart",
    "home",
    "house",
    "lar",
    "ranch",
    "residencia",
    "settle",
    "simple",
    "suburban",
    "suburbia",
    "viagens",
    "where"
  ],
  "🏡": [
    "1f3e1",
    "building",
    "casa",
    "casa com jardim",
    "construcao",
    "country",
    "garden",
    "heart",
    "home",
    "house",
    "house with garden",
    "jardim",
    "lar",
    "ranch",
    "settle",
    "simple",
    "suburban",
    "suburbia",
    "viagens",
    "where"
  ],
  "🏘️": [
    "1f3d8",
    "casas",
    "house",
    "houses",
    "viagens"
  ],
  "🏚️": [
    "1f3da",
    "casa",
    "casa abandonada",
    "derelict",
    "derelict house",
    "home",
    "house",
    "viagens"
  ],
  "🏗️": [
    "1f3d7",
    "building",
    "building construction",
    "construcao",
    "construction",
    "crane",
    "guindaste",
    "obra",
    "viagens"
  ],
  "🏭": [
    "1f3ed",
    "building",
    "fabrica",
    "factory",
    "predio",
    "viagens"
  ],
  "🏢": [
    "1f3e2",
    "building",
    "city",
    "cubical",
    "edificio",
    "edificio comercial",
    "escritorio",
    "job",
    "office",
    "office building",
    "viagens"
  ],
  "🏬": [
    "1f3ec",
    "building",
    "departamentos",
    "department",
    "department store",
    "estabelecimento comercial",
    "loja",
    "loja de departamentos",
    "store",
    "viagens"
  ],
  "🏣": [
    "1f3e3",
    "building",
    "correio",
    "correio japones",
    "japanese",
    "japanese post office",
    "japones",
    "office",
    "oriental",
    "post",
    "predio",
    "viagens"
  ],
  "🏤": [
    "1f3e4",
    "building",
    "correio",
    "european",
    "europeu",
    "office",
    "post",
    "post office",
    "predio",
    "viagens"
  ],
  "🏥": [
    "1f3e5",
    "building",
    "doctor",
    "doente",
    "hospital",
    "internado",
    "medicine",
    "medico",
    "predio",
    "viagens"
  ],
  "🏦": [
    "1f3e6",
    "banco",
    "bank",
    "building",
    "predio",
    "viagens"
  ],
  "🏨": [
    "1f3e8",
    "building",
    "hotel",
    "predio",
    "viagens"
  ],
  "🏪": [
    "1f3ea",
    "24",
    "24 horas",
    "24h",
    "building",
    "convenience",
    "convenience store",
    "conveniencia",
    "hours",
    "loja",
    "loja de conveniencia",
    "predio",
    "store",
    "viagens"
  ],
  "🏫": [
    "1f3eb",
    "building",
    "colegio",
    "escola",
    "predio",
    "predio da escola",
    "school",
    "viagens"
  ],
  "🏩": [
    "1f3e9",
    "amor",
    "building",
    "hotel",
    "love",
    "love hotel",
    "motel",
    "predio",
    "viagens"
  ],
  "💒": [
    "1f492",
    "capela",
    "capela de casamento",
    "casamento",
    "chapel",
    "hitched",
    "nuptials",
    "romance",
    "viagens",
    "wedding"
  ],
  "🏛️": [
    "1f3db",
    "arquitetura",
    "building",
    "classical",
    "classical building",
    "classico",
    "grego",
    "predio grego",
    "viagens"
  ],
  "⛪️": [
    "26ea",
    "bless",
    "capela",
    "chapel",
    "christian",
    "church",
    "crista",
    "cristao",
    "cross",
    "igreja",
    "missa",
    "predio",
    "religiao",
    "religion",
    "viagens"
  ],
  "🕌": [
    "1f54c",
    "isla",
    "islam",
    "masjid",
    "mesquita",
    "mosque",
    "muculmano",
    "muslim",
    "religiao",
    "religion",
    "viagens"
  ],
  "🕍": [
    "1f54d",
    "jew",
    "jewish",
    "judaism",
    "judaismo",
    "judeu",
    "judia",
    "religiao",
    "religion",
    "sinagoga",
    "synagogue",
    "temple",
    "templo",
    "viagens"
  ],
  "🛕": [
    "1f6d5",
    "hindu",
    "hindu temple",
    "temple",
    "templo",
    "templo hindu",
    "viagens"
  ],
  "🕋": [
    "1f54b",
    "caaba isla",
    "hajj",
    "isla",
    "islam",
    "kaaba",
    "muculmano",
    "muslim",
    "religiao",
    "religion",
    "umrah",
    "viagens"
  ],
  "⛩️": [
    "26e9",
    "japones",
    "oriental",
    "religiao",
    "religion",
    "santuario",
    "santuario japones",
    "shinto",
    "shinto shrine",
    "shrine",
    "viagens",
    "xintoismo"
  ],
  "🛤️": [
    "1f6e4",
    "railway",
    "railway track",
    "track",
    "train",
    "trem",
    "trilhos",
    "viagens"
  ],
  "🛣️": [
    "1f6e3",
    "caminho",
    "estrada",
    "highway",
    "motorway",
    "road",
    "viagem",
    "viagens",
    "viajar"
  ],
  "🗾": [
    "1f5fe",
    "japan",
    "japao",
    "map",
    "map of japan",
    "mapa",
    "mapa do japao",
    "viagens"
  ],
  "🎑": [
    "1f391",
    "celebration",
    "ceremony",
    "cerimonia de contemplacao da lua",
    "comemoracao",
    "contemplacao",
    "contemplacao da lua",
    "lua",
    "moon",
    "moon viewing ceremony",
    "viagens",
    "viewing"
  ],
  "🏞️": [
    "1f3de",
    "national",
    "national park",
    "park",
    "parque",
    "parque com rio",
    "parque nacional",
    "reserva florestal",
    "rio",
    "viagens"
  ],
  "🌅": [
    "1f305",
    "amanhecer",
    "aurora",
    "aurora sobre agua",
    "morning",
    "nature",
    "natureza",
    "oceano",
    "rio",
    "sol",
    "sol da manha",
    "sol nascendo",
    "sun",
    "sunrise",
    "viagens"
  ],
  "🌄": [
    "1f304",
    "aurora sobre montanhas",
    "montanha",
    "morning",
    "mountains",
    "nascer do sol sobre as montanhas",
    "over",
    "sol da manha",
    "sun",
    "sunrise",
    "sunrise over mountains",
    "viagens"
  ],
  "🌠": [
    "1f320",
    "cadente",
    "cai",
    "estrela",
    "estrela cadente",
    "falling",
    "night",
    "shooting",
    "shooting star",
    "space",
    "star",
    "viagens"
  ],
  "🎇": [
    "1f387",
    "boom",
    "celebration",
    "comemoracao",
    "fireworks",
    "fogo de artificio",
    "fogo de artificio vela estrela",
    "sparkle",
    "sparkler",
    "vela estrela",
    "viagens"
  ],
  "🎆": [
    "1f386",
    "ano novo",
    "boom",
    "celebration",
    "comemoracao",
    "entertainment",
    "fireworks",
    "fogos",
    "fogos de artificio",
    "viagens",
    "yolo"
  ],
  "🌇": [
    "1f307",
    "anoitecer",
    "building",
    "calor",
    "cidade",
    "dusk",
    "entardecer",
    "por do sol",
    "por do sol sobre predios",
    "predio",
    "sun",
    "sunset",
    "viagens"
  ],
  "🌆": [
    "1f306",
    "anoitecer",
    "at",
    "building",
    "cidade",
    "cidade ao anoitecer",
    "city",
    "cityscape",
    "cityscape at dusk",
    "dusk",
    "evening",
    "landscape",
    "noite",
    "paisagem",
    "por do sol",
    "predio",
    "sun",
    "sunset",
    "viagens"
  ],
  "🏙️": [
    "1f3d9",
    "cidade",
    "city",
    "cityscape",
    "predios",
    "urbano",
    "viagens"
  ],
  "🌃": [
    "1f303",
    "cidade a noite",
    "estrelas",
    "night",
    "night with stars",
    "noite",
    "noite estrelada",
    "predios",
    "star",
    "stars",
    "viagens"
  ],
  "🌌": [
    "1f30c",
    "ceu",
    "espaco",
    "estrelado",
    "milky",
    "milky way",
    "space",
    "via lactea",
    "viagens",
    "way"
  ],
  "🌉": [
    "1f309",
    "at",
    "bridge",
    "bridge at night",
    "night",
    "noite",
    "ponte",
    "ponte a noite",
    "pontilhao",
    "viagens"
  ],
  "🌁": [
    "1f301",
    "bruma",
    "cerracao",
    "enevoado",
    "fog",
    "foggy",
    "neblina",
    "nevoa",
    "nevoeiro",
    "viagens"
  ],
  "⌚️": [
    "231a",
    "clock",
    "hora",
    "objetos",
    "relogio",
    "relogio de pulso",
    "tempo",
    "time",
    "watch"
  ],
  "📱": [
    "1f4f1",
    "cell",
    "celular",
    "communication",
    "mobile",
    "mobile phone",
    "objetos",
    "phone",
    "telefone",
    "telefone celular",
    "telefone movel",
    "telephone"
  ],
  "📲": [
    "1f4f2",
    "arrow",
    "build",
    "call",
    "cell",
    "celular",
    "chamada",
    "communication",
    "fazer",
    "ligar",
    "mobile",
    "mobile phone with arrow",
    "objetos",
    "phone",
    "receber",
    "receive",
    "seta",
    "smartphone",
    "telefone",
    "telefone celular com seta",
    "telephone"
  ],
  "💻": [
    "1f4bb",
    "computador",
    "computer",
    "laptop",
    "notebook",
    "objetos",
    "office",
    "pc",
    "personal",
    "pessoal",
    "trabalho"
  ],
  "⌨️": [
    "2328",
    "acessorio",
    "computador",
    "computer",
    "digitacao",
    "keyboard",
    "objetos",
    "teclado"
  ],
  "🖥️": [
    "1f5a5",
    "computador",
    "computador de mesa",
    "computer",
    "desktop",
    "desktop computer",
    "mesa",
    "monitor",
    "objetos"
  ],
  "🖨️": [
    "1f5a8",
    "acessorio",
    "computador",
    "computer",
    "documento",
    "impressao",
    "impressora",
    "imprimir",
    "objetos",
    "printer"
  ],
  "🖱️": [
    "1f5b1",
    "acessorio",
    "computador",
    "computer",
    "computer mouse",
    "mouse",
    "objetos"
  ],
  "🖲️": [
    "1f5b2",
    "acessorio",
    "bolinha",
    "computador",
    "computer",
    "mouse",
    "objetos",
    "trackball"
  ],
  "🕹️": [
    "1f579",
    "atari",
    "controle",
    "game",
    "jogo",
    "joystick",
    "objetos",
    "video",
    "videogame"
  ],
  "🗜️": [
    "1f5dc",
    "bracadeira",
    "clamp",
    "compress",
    "compressao",
    "ferramenta",
    "morsa",
    "objetos",
    "tool",
    "torno",
    "vice"
  ],
  "💽": [
    "1f4bd",
    "computacao",
    "computer",
    "computer disk",
    "disc",
    "disco",
    "disk",
    "hd",
    "md",
    "mini",
    "minidisc",
    "minidisk",
    "objetos",
    "optical",
    "rigido"
  ],
  "💾": [
    "1f4be",
    "computador",
    "computer",
    "disco",
    "disco flexivel",
    "disk",
    "disquete",
    "floppy",
    "floppy disk",
    "objetos"
  ],
  "💿": [
    "1f4bf",
    "blu-ray",
    "cd",
    "computador",
    "computer",
    "disco",
    "disk",
    "dvd",
    "objetos",
    "optical",
    "optical disk",
    "optico"
  ],
  "📀": [
    "1f4c0",
    "blu-ray",
    "cd",
    "computador",
    "computer",
    "disco",
    "disk",
    "dvd",
    "objetos",
    "optical",
    "optico"
  ],
  "📼": [
    "1f4fc",
    "cassete",
    "fita",
    "objetos",
    "old",
    "school",
    "tape",
    "vcr",
    "vhs",
    "video",
    "videocassete",
    "videocassette"
  ],
  "📷": [
    "1f4f7",
    "camera",
    "foto",
    "objetos",
    "photo",
    "selfie",
    "snap",
    "tbt",
    "trip",
    "video"
  ],
  "📸": [
    "1f4f8",
    "camera",
    "camera com flash",
    "camera with flash",
    "flash",
    "foto",
    "fotografia",
    "objetos",
    "video"
  ],
  "📹": [
    "1f4f9",
    "camcorder",
    "camera",
    "camera de video",
    "filmadora",
    "objetos",
    "tbt",
    "video",
    "video camera"
  ],
  "🎥": [
    "1f3a5",
    "bollywood",
    "camera",
    "camera de cinema",
    "cinema",
    "entretenimento",
    "film",
    "filmar",
    "filme",
    "hollywood",
    "movie",
    "movie camera",
    "objetos",
    "record"
  ],
  "📽️": [
    "1f4fd",
    "cinema",
    "film",
    "film projector",
    "filme",
    "movie",
    "objetos",
    "projector",
    "projetor",
    "projetor de filmes",
    "video"
  ],
  "🎞️": [
    "1f39e",
    "cinema",
    "film",
    "film frames",
    "filme",
    "frames",
    "movie",
    "objetos",
    "rolo de filmes"
  ],
  "📞": [
    "1f4de",
    "aparelho de telefone",
    "communication",
    "comunicacao",
    "objetos",
    "phone",
    "receiver",
    "telefone",
    "telephone",
    "telephone receiver",
    "voip"
  ],
  "☎️": [
    "260e",
    "gancho",
    "objetos",
    "phone",
    "telefone",
    "telefone no gancho",
    "telephone"
  ],
  "📟": [
    "1f4df",
    "communication",
    "comunicacao",
    "objetos",
    "pager"
  ],
  "📠": [
    "1f4e0",
    "communication",
    "comunicacao",
    "fax",
    "fax machine",
    "machine",
    "maquina de fax",
    "objetos"
  ],
  "📺": [
    "1f4fa",
    "canal",
    "objetos",
    "televisao",
    "television",
    "tv",
    "video"
  ],
  "📻": [
    "1f4fb",
    "entertainment",
    "objetos",
    "radio",
    "radiola",
    "som",
    "tbt",
    "video"
  ],
  "🎙️": [
    "1f399",
    "estudio",
    "mic",
    "microfone",
    "microfone de estudio",
    "microphone",
    "music",
    "musica",
    "objetos",
    "studio",
    "studio microphone"
  ],
  "🎚️": [
    "1f39a",
    "controle",
    "controle de volume",
    "level",
    "level slider",
    "music",
    "musica",
    "objetos",
    "slider",
    "volume"
  ],
  "🎛️": [
    "1f39b",
    "botoes",
    "botoes giratorios",
    "control",
    "control knobs",
    "controle",
    "knobs",
    "music",
    "musica",
    "objetos"
  ],
  "🧭": [
    "1f9ed",
    "bussola",
    "bussola magnetica",
    "compass",
    "direcao",
    "direction",
    "ima",
    "magnetic",
    "magnetico",
    "navegacao",
    "navigation",
    "norte",
    "objetos",
    "orientacao",
    "orienteering",
    "pontos cardeais"
  ],
  "⏱️": [
    "23f1",
    "clock",
    "cronometro",
    "objetos",
    "relogio",
    "stopwatch",
    "tempo",
    "time"
  ],
  "⏲️": [
    "23f2",
    "clock",
    "cronometro",
    "objetos",
    "relogio",
    "relogio temporizador",
    "timer",
    "timer clock"
  ],
  "⏰": [
    "23f0",
    "alarm",
    "alarm clock",
    "alarme",
    "atrasada",
    "atrasado",
    "clock",
    "despertador",
    "hora",
    "horario",
    "hours",
    "hrs",
    "late",
    "objetos",
    "relogio",
    "time",
    "waiting"
  ],
  "🕰️": [
    "1f570",
    "clock",
    "mantelpiece",
    "mantelpiece clock",
    "objetos",
    "relogio",
    "relogio antigo",
    "relogio de mesa",
    "time"
  ],
  "⌛️": [
    "231b",
    "ampulheta",
    "areia",
    "done",
    "hourglass",
    "hourglass done",
    "objetos",
    "sand",
    "tempo",
    "time",
    "timer"
  ],
  "⏳": [
    "23f3",
    "ampulheta",
    "ampulheta contando o tempo",
    "areia",
    "cheia",
    "contando",
    "done",
    "em cima",
    "flowing",
    "hora",
    "hourglass",
    "hourglass not done",
    "hours",
    "not",
    "objetos",
    "relogio",
    "sand",
    "tempo",
    "timer",
    "waiting",
    "yolo"
  ],
  "📡": [
    "1f4e1",
    "aliens",
    "antena",
    "antena parabolica",
    "antenna",
    "comunicacao",
    "contact",
    "dish",
    "objetos",
    "parabolica",
    "satelite",
    "satellite",
    "satellite antenna",
    "science"
  ],
  "🔋": [
    "1f50b",
    "bateria",
    "battery",
    "objetos",
    "pilha"
  ],
  "🪫": [
    "1faab",
    "acabando",
    "bateria",
    "battery",
    "cansado",
    "descarregada",
    "drained",
    "electronic",
    "eletronico",
    "energia",
    "energy",
    "fim",
    "fraca",
    "low",
    "low battery",
    "objetos",
    "pilha",
    "pouca",
    "pouca bateria",
    "power",
    "sem"
  ],
  "🔌": [
    "1f50c",
    "cabo",
    "electric",
    "electric plug",
    "electricity",
    "eletrica",
    "eletricidade",
    "energia",
    "objetos",
    "plug",
    "plugue",
    "tomada",
    "tomada eletrica"
  ],
  "💡": [
    "1f4a1",
    "bulb",
    "comic",
    "electric",
    "eletrica",
    "idea",
    "ideia",
    "lampada",
    "light",
    "light bulb",
    "luz",
    "objetos",
    "quadrinhos",
    "tenho uma ideia"
  ],
  "🔦": [
    "1f526",
    "electric",
    "eletrica",
    "ferramenta",
    "flashlight",
    "lanterna",
    "light",
    "luz",
    "objetos",
    "tool",
    "torch"
  ],
  "🕯️": [
    "1f56f",
    "acesa",
    "candle",
    "light",
    "luz",
    "objetos",
    "vela"
  ],
  "🪔": [
    "1fa94",
    "diya",
    "diya lamp",
    "lamp",
    "lampada",
    "lampada de oleo",
    "light",
    "objetos",
    "oil",
    "oleo"
  ],
  "🧯": [
    "1f9ef",
    "apagar",
    "extinguir",
    "extinguish",
    "extinguisher",
    "extintor",
    "extintor de incendio",
    "fire",
    "fire extinguisher",
    "fogo",
    "incendio",
    "objetos",
    "quench"
  ],
  "🛢️": [
    "1f6e2",
    "barril",
    "barril de oleo",
    "drum",
    "lata",
    "latao",
    "objetos",
    "oil",
    "oil drum",
    "oleo"
  ],
  "💸": [
    "1f4b8",
    "asas",
    "banco",
    "bank",
    "banknote",
    "bill",
    "billion",
    "cash",
    "cedula",
    "dinheiro",
    "dinheiro indo embora",
    "dinheiro voando",
    "dollar",
    "fly",
    "million",
    "money",
    "money with wings",
    "nota",
    "note",
    "objetos",
    "pay",
    "voando",
    "wings"
  ],
  "💵": [
    "1f4b5",
    "bank",
    "banknote",
    "bill",
    "currency",
    "dinheiro",
    "dolar",
    "dollar",
    "dollar banknote",
    "moeda",
    "money",
    "nota",
    "nota bancaria",
    "nota de dolar",
    "note",
    "objetos"
  ],
  "💴": [
    "1f4b4",
    "bank",
    "banknote",
    "bill",
    "cedula",
    "currency",
    "dinheiro",
    "grana",
    "iene",
    "moeda",
    "money",
    "nota",
    "nota de iene",
    "note",
    "objetos",
    "yen",
    "yen banknote"
  ],
  "💶": [
    "100",
    "1f4b6",
    "bank",
    "banknote",
    "bill",
    "cedula",
    "currency",
    "dinheiro",
    "euro",
    "euro banknote",
    "grana",
    "moeda",
    "money",
    "nota",
    "nota de euro",
    "note",
    "objetos",
    "rich"
  ],
  "💷": [
    "1f4b7",
    "bank",
    "banknote",
    "bill",
    "billion",
    "cash",
    "cedula",
    "currency",
    "dinheiro",
    "grana",
    "libra",
    "moeda",
    "money",
    "nota",
    "nota de libra",
    "note",
    "objetos",
    "pound",
    "pound banknote",
    "pounds"
  ],
  "🪙": [
    "1fa99",
    "coin",
    "dinheiro",
    "dolar",
    "dollar",
    "euro",
    "gold",
    "metal",
    "moeda",
    "money",
    "objetos",
    "ouro",
    "prata",
    "real",
    "rica",
    "rich",
    "rico",
    "silver",
    "tesouro",
    "treasure"
  ],
  "💰": [
    "1f4b0",
    "bag",
    "bank",
    "bet",
    "billion",
    "cash",
    "cost",
    "dinheiro",
    "dolares",
    "dollar",
    "gold",
    "million",
    "money",
    "money bag",
    "moneybag",
    "objetos",
    "paid",
    "paying",
    "pot",
    "rich",
    "saco",
    "saco de dinheiro",
    "win"
  ],
  "💳": [
    "1f4b3",
    "banco",
    "bank",
    "card",
    "cartao",
    "cartao de credito",
    "cash",
    "charge",
    "credit",
    "credit card",
    "credito",
    "debito",
    "dinheiro",
    "money",
    "objetos",
    "pay"
  ],
  "🪪": [
    "1faaa",
    "card",
    "carta",
    "cartao",
    "cartao de identificacao",
    "carteira",
    "cracha",
    "credenciais",
    "credentials",
    "document",
    "documento",
    "habilitacao",
    "id",
    "identidade",
    "identification",
    "identification card",
    "licenca",
    "license",
    "motorista",
    "objetos",
    "rg",
    "security",
    "seguranca"
  ],
  "💎": [
    "1f48e",
    "diamante",
    "diamond",
    "engagement",
    "gem",
    "gem stone",
    "jewel",
    "joia",
    "money",
    "objetos",
    "pedra preciosa",
    "romance",
    "stone",
    "wedding"
  ],
  "⚖️": [
    "2696",
    "balanca",
    "balance",
    "balance scale",
    "ferramenta",
    "justica",
    "justice",
    "libra",
    "objetos",
    "peso",
    "scale",
    "scales",
    "tool",
    "weight",
    "zodiac",
    "zodiaco"
  ],
  "🪜": [
    "1fa9c",
    "climb",
    "degrau",
    "escada",
    "ladder",
    "mao",
    "objetos",
    "rung",
    "step",
    "subir"
  ],
  "🧰": [
    "1f9f0",
    "box",
    "caixa",
    "caixa de ferramentas",
    "chest",
    "ferramenta",
    "mecanico",
    "mechanic",
    "objetos",
    "red",
    "tool",
    "toolbox",
    "vermelha"
  ],
  "🪛": [
    "1fa9b",
    "chave de fenda",
    "ferramenta",
    "flathead",
    "handy",
    "objetos",
    "screw",
    "screwdriver",
    "tool"
  ],
  "🔧": [
    "1f527",
    "chave",
    "chave inglesa",
    "ferramenta",
    "home",
    "improvement",
    "inglesa",
    "objetos",
    "obra",
    "reforma",
    "spanner",
    "tool",
    "wrench"
  ],
  "🔨": [
    "1f528",
    "construcao",
    "ferramenta",
    "hammer",
    "home",
    "improvement",
    "martelada",
    "martelo",
    "objetos",
    "repairs",
    "reparo",
    "tool"
  ],
  "⚒️": [
    "2692",
    "ferramenta",
    "geologia",
    "hammer",
    "hammer and pick",
    "martelo",
    "martelo e picareta",
    "objetos",
    "picareta",
    "pick",
    "tool"
  ],
  "🛠️": [
    "1f6e0",
    "chave",
    "chave-inglesa",
    "ferramenta",
    "hammer",
    "hammer and wrench",
    "inglesa",
    "martelo",
    "martelo e chave-inglesa",
    "objetos",
    "spanner",
    "tool",
    "wrench"
  ],
  "⛏️": [
    "26cf",
    "ferramenta",
    "hammer",
    "mineracao",
    "mining",
    "objetos",
    "picareta",
    "pick",
    "tool"
  ],
  "🪏": [
    "1fa8f",
    "buraco",
    "bury",
    "cavar",
    "dig",
    "garden",
    "hole",
    "objetos",
    "pa",
    "pazinha",
    "plant",
    "scoop",
    "shovel",
    "snow",
    "spade"
  ],
  "🪚": [
    "1fa9a",
    "carpenter",
    "carpentry",
    "carpentry saw",
    "carpinteiro",
    "cortar",
    "cut",
    "ferramenta",
    "lumber",
    "madeira",
    "objetos",
    "saw",
    "serra",
    "serrar",
    "serrote",
    "tool",
    "trim"
  ],
  "🔩": [
    "1f529",
    "bolt",
    "construcao",
    "ferramenta",
    "home",
    "improvement",
    "nut",
    "nut and bolt",
    "objetos",
    "parafuso",
    "porca",
    "porca e parafuso",
    "tool"
  ],
  "⚙️": [
    "2699",
    "cog",
    "cogwheel",
    "engrenagem",
    "ferramenta",
    "gear",
    "objetos",
    "tool"
  ],
  "🪤": [
    "1faa4",
    "armadilha",
    "atrair",
    "bait",
    "cheese",
    "isca",
    "lure",
    "mouse",
    "mouse trap",
    "mousetrap",
    "objetos",
    "prender",
    "queijo",
    "ratoeira",
    "snare",
    "trap"
  ],
  "🧱": [
    "1f9f1",
    "argamassa",
    "argila",
    "brick",
    "bricks",
    "cimento",
    "clay",
    "mortar",
    "muro",
    "objetos",
    "parede",
    "terra",
    "tijolo",
    "wall"
  ],
  "⛓️": [
    "26d3",
    "chain",
    "chains",
    "corrente",
    "correntes",
    "metal",
    "objetos"
  ],
  "⛓️‍💥": [
    "26d3-200d-1f4a5",
    "algema",
    "break",
    "breaking",
    "broken",
    "broken chain",
    "chain",
    "corrente",
    "corrente quebrada",
    "cuffs",
    "freedom",
    "liberdade",
    "objetos",
    "quebrada",
    "quebrando",
    "quebrar"
  ],
  "🧲": [
    "1f9f2",
    "atracao",
    "attraction",
    "ferradura",
    "horseshoe",
    "ima",
    "magnet",
    "magnetic",
    "magnetico",
    "negative",
    "objetos",
    "positive",
    "positivo-negativo",
    "shape",
    "u"
  ],
  "🔫": [
    "1f52b",
    "agua",
    "arma",
    "ferramenta",
    "gun",
    "handgun",
    "objetos",
    "pistol",
    "pistola",
    "pistola d’agua",
    "revolver",
    "tool",
    "water",
    "water pistol",
    "weapon"
  ],
  "💣": [
    "1f4a3",
    "bomb",
    "bomba",
    "boom",
    "comic",
    "dangerous",
    "emocao",
    "engracado",
    "explosao",
    "explosion",
    "explosivo",
    "hot",
    "objetos",
    "perigo"
  ],
  "🧨": [
    "1f9e8",
    "artificio",
    "bomba",
    "bombinha",
    "chiando",
    "dinamite",
    "dynamite",
    "estourar",
    "explosive",
    "explosivo",
    "faisca",
    "fire",
    "firecracker",
    "fireworks",
    "fogo",
    "light",
    "luz",
    "objetos",
    "pirotecnia",
    "pop",
    "popping",
    "roubada",
    "spark"
  ],
  "🪓": [
    "1fa93",
    "ax",
    "axe",
    "chop",
    "cortar",
    "hatchet",
    "machado",
    "madeira",
    "objetos",
    "partir",
    "split",
    "wood"
  ],
  "🔪": [
    "1f52a",
    "chef",
    "cooking",
    "cozinhar",
    "faca",
    "faca de cozinha",
    "hocho",
    "kitchen",
    "kitchen knife",
    "knife",
    "objetos",
    "tool",
    "weapon"
  ],
  "🗡️": [
    "1f5e1",
    "adaga",
    "arma",
    "dagger",
    "faca",
    "knife",
    "objetos",
    "weapon"
  ],
  "⚔️": [
    "2694",
    "arma",
    "batalha",
    "crossed",
    "crossed swords",
    "cruzadas",
    "espadas",
    "espadas cruzadas",
    "guerra",
    "objetos",
    "swords",
    "weapon"
  ],
  "🛡️": [
    "1f6e1",
    "arma",
    "escudo",
    "objetos",
    "shield",
    "weapon"
  ],
  "🚬": [
    "1f6ac",
    "cigarette",
    "cigarro",
    "e permitido fumar",
    "fumante",
    "fumar",
    "fumo",
    "objetos",
    "simbolo",
    "simbolo para “e permitido fumar”",
    "smoking"
  ],
  "⚰️": [
    "26b0",
    "caixao",
    "caixao funerario",
    "coffin",
    "dead",
    "death",
    "funeral",
    "morte",
    "objetos",
    "vampire",
    "velorio"
  ],
  "🪦": [
    "1faa6",
    "cemetery",
    "cemiterio",
    "dead",
    "descanse em paz",
    "grave",
    "graveyard",
    "headstone",
    "lapide",
    "memorial",
    "morto",
    "objetos",
    "rip",
    "sepultura",
    "tomb",
    "tombstone",
    "tumba",
    "tumulo"
  ],
  "⚱️": [
    "26b1",
    "ashes",
    "cinzas",
    "death",
    "funeral",
    "funeral urn",
    "morte",
    "objetos",
    "urn",
    "urna",
    "urna funeraria"
  ],
  "🏺": [
    "1f3fa",
    "amphora",
    "anfora",
    "aquarius",
    "cooking",
    "drink",
    "jug",
    "objetos",
    "ornamento chines",
    "tool",
    "vaso",
    "vaso chines",
    "weapon",
    "zodiac"
  ],
  "🔮": [
    "1f52e",
    "adivinhacao",
    "ball",
    "bola",
    "bola de cristal",
    "cristal",
    "crystal",
    "crystal ball",
    "destino",
    "fairy",
    "fairytale",
    "fantasy",
    "fortune",
    "future",
    "futuro",
    "magic",
    "objetos",
    "prever",
    "tale",
    "tool"
  ],
  "📿": [
    "1f4ff",
    "acessorio",
    "beads",
    "clothing",
    "necklace",
    "objetos",
    "oracao",
    "prayer",
    "prayer beads",
    "religiao",
    "religion",
    "reza",
    "rosario",
    "rosario de oracao",
    "terco"
  ],
  "🧿": [
    "1f9ff",
    "amulet",
    "amuleto",
    "bead",
    "blue",
    "charm",
    "conta",
    "evil-eye",
    "grego",
    "mau-olhado",
    "micanga",
    "nazar",
    "nazar amulet",
    "objetos",
    "olho",
    "olho grego",
    "talisma",
    "talisman"
  ],
  "🪬": [
    "1faac",
    "amulet",
    "amuleto",
    "fatima",
    "fortune",
    "guia",
    "guide",
    "hamsa",
    "hand",
    "mao",
    "maria",
    "mary",
    "miriam",
    "objetos",
    "palm",
    "palma",
    "protecao",
    "protect",
    "protection",
    "sorte"
  ],
  "💈": [
    "1f488",
    "barbearia",
    "barbeiro",
    "barber",
    "barber pole",
    "cortar cabelo",
    "cut",
    "fresh",
    "haircut",
    "objetos",
    "pole",
    "poste",
    "poste de barbeiro",
    "shave"
  ],
  "⚗️": [
    "2697",
    "alambique",
    "alembic",
    "chemistry",
    "ferramenta",
    "objetos",
    "quimica",
    "tool"
  ],
  "🔭": [
    "1f52d",
    "ciencia",
    "contact",
    "extraterrestrial",
    "ferramenta",
    "objetos",
    "science",
    "telescope",
    "telescopio",
    "tool"
  ],
  "🔬": [
    "1f52c",
    "ciencia",
    "experiment",
    "ferramenta",
    "lab",
    "microscope",
    "microscopico",
    "microscopio",
    "objetos",
    "science",
    "tool"
  ],
  "🕳️": [
    "1f573",
    "buraco",
    "buraco no chao",
    "hole",
    "objetos"
  ],
  "🩻": [
    "1fa7b",
    "bones",
    "doctor",
    "doutor",
    "esqueleto",
    "medical",
    "medico",
    "objetos",
    "ossos",
    "radiografia",
    "raio x",
    "skeleton",
    "skull",
    "x-ray",
    "xray"
  ],
  "🩹": [
    "1fa79",
    "adesiva",
    "adhesive",
    "adhesive bandage",
    "atadura",
    "atadura adesiva",
    "bandage",
    "bandaid",
    "bandeide",
    "curativo",
    "objetos"
  ],
  "🩺": [
    "1fa7a",
    "coracao",
    "doctor",
    "estetoscopio",
    "heart",
    "medica",
    "medicina",
    "medicine",
    "medico",
    "objetos",
    "stethoscope",
    "tum tum"
  ],
  "💊": [
    "1f48a",
    "capsula",
    "comprimido",
    "doctor",
    "drugs",
    "medicated",
    "medicina",
    "medicine",
    "medico",
    "objetos",
    "pill",
    "pills",
    "pilula",
    "remedio",
    "sick",
    "vitamin"
  ],
  "💉": [
    "1f489",
    "agulha",
    "doctor",
    "flu",
    "injecao",
    "medicine",
    "medico",
    "needle",
    "objetos",
    "remedio",
    "seringa",
    "shot",
    "sick",
    "syringe",
    "tool",
    "vaccination",
    "vacina",
    "vacinacao"
  ],
  "🩸": [
    "1fa78",
    "bleed",
    "blood",
    "doacao",
    "donation",
    "drop",
    "drop of blood",
    "gota",
    "gota de sangue",
    "injury",
    "medicina",
    "medicine",
    "menstruacao",
    "menstruation",
    "objetos",
    "sangrar",
    "sangue"
  ],
  "🧬": [
    "1f9ec",
    "biologist",
    "biologista",
    "biologo",
    "codigo",
    "dna",
    "evolucao",
    "evolution",
    "gene",
    "genetica",
    "genetico",
    "genetics",
    "life",
    "objetos",
    "vida"
  ],
  "🦠": [
    "1f9a0",
    "ameba",
    "amoeba",
    "bacteria",
    "ciencia",
    "microbe",
    "microbio",
    "objetos",
    "science",
    "virus"
  ],
  "🧫": [
    "1f9eb",
    "bacteria",
    "biologia",
    "biologist",
    "biologista",
    "biologo",
    "biology",
    "ciencia",
    "cultura",
    "culture",
    "dish",
    "lab",
    "laboratorio",
    "objetos",
    "petri",
    "petri dish",
    "placa",
    "placa de petri"
  ],
  "🧪": [
    "1f9ea",
    "chemist",
    "chemistry",
    "ciencia",
    "ensaio",
    "experiencia",
    "experiment",
    "experimento",
    "lab",
    "laboratorio",
    "objetos",
    "quimica",
    "quimico",
    "science",
    "test",
    "test tube",
    "tube",
    "tubo",
    "tubo de ensaio"
  ],
  "🌡️": [
    "1f321",
    "clima",
    "objetos",
    "temperatura",
    "tempo",
    "termometro",
    "thermometer",
    "weather"
  ],
  "🧹": [
    "1f9f9",
    "broom",
    "bruxa",
    "cleaning",
    "limpar",
    "limpeza",
    "objetos",
    "sweeping",
    "varrer",
    "vassoura",
    "witch"
  ],
  "🪠": [
    "1faa0",
    "banheiro",
    "coco",
    "cup",
    "desentupidor",
    "encanador",
    "fezes",
    "force",
    "objetos",
    "plumber",
    "plunger",
    "poop",
    "sanitario",
    "succao",
    "suction",
    "toilet",
    "vaso"
  ],
  "🧺": [
    "1f9fa",
    "agricola",
    "agricultura",
    "basket",
    "cesta",
    "farming",
    "laundry",
    "lavanderia",
    "lavoura",
    "objetos",
    "picnic",
    "piquenique",
    "roupa",
    "suja"
  ],
  "🧻": [
    "1f9fb",
    "higienico",
    "objetos",
    "papel",
    "paper",
    "roll",
    "roll of paper",
    "rolo",
    "rolo de papel",
    "toalha",
    "toilet",
    "towels"
  ],
  "🚽": [
    "1f6bd",
    "banheiro",
    "bathroom",
    "objetos",
    "patente",
    "privada",
    "sanitario",
    "toalete",
    "toilet",
    "vaso",
    "vaso sanitario"
  ],
  "🚰": [
    "1f6b0",
    "agua",
    "agua potavel",
    "beber",
    "drinking",
    "objetos",
    "potable",
    "potable water",
    "potavel",
    "simbolo",
    "torneira",
    "water"
  ],
  "🚿": [
    "1f6bf",
    "agua",
    "banho",
    "chuveiro",
    "ducha",
    "objetos",
    "shower",
    "water"
  ],
  "🛁": [
    "1f6c1",
    "banheira",
    "banho",
    "bath",
    "bathtub",
    "objetos"
  ],
  "🛀": [
    "1f6c0",
    "agua",
    "banheira",
    "banho",
    "bath",
    "bathtub",
    "espuma",
    "objetos",
    "person",
    "person taking bath",
    "pessoa",
    "pessoa tomando banho",
    "taking",
    "tub"
  ],
  "🧼": [
    "1f9fc",
    "banho",
    "bar",
    "barra",
    "bathing",
    "clean",
    "cleaning",
    "espuma",
    "lather",
    "limpar",
    "limpeza",
    "objetos",
    "sabonete",
    "saboneteira",
    "soap",
    "soapdish"
  ],
  "🪥": [
    "1faa5",
    "banheiro",
    "bathroom",
    "brush",
    "clean",
    "dental",
    "dentes",
    "escova",
    "escova de dentes",
    "higiene",
    "hygiene",
    "limpeza",
    "objetos",
    "teeth",
    "toiletry",
    "toothbrush"
  ],
  "🪒": [
    "1fa92",
    "afiada",
    "afiado",
    "barbeador",
    "barbear",
    "depilar",
    "gilete",
    "lamina",
    "objetos",
    "raspar",
    "razor",
    "sharp",
    "shave"
  ],
  "🪮": [
    "1faae",
    "afro",
    "cabelo",
    "comb",
    "crespo",
    "groom",
    "hair",
    "hair pick",
    "objetos",
    "pente",
    "pente de cabelo",
    "pente garfo",
    "pentear",
    "pick",
    "retro"
  ],
  "🧽": [
    "1f9fd",
    "absorbing",
    "absorcao",
    "absorvente",
    "cleaning",
    "encharcar",
    "esponja",
    "limpeza",
    "objetos",
    "porosa",
    "poroso",
    "porous",
    "soak",
    "sponge"
  ],
  "🪣": [
    "1faa3",
    "balde",
    "baldinho",
    "barril",
    "bucket",
    "cask",
    "objetos",
    "pail",
    "vat"
  ],
  "🧴": [
    "1f9f4",
    "bottle",
    "condicionador",
    "creme",
    "frasco",
    "frasco de locao",
    "hidratante",
    "locao",
    "lotion",
    "lotion bottle",
    "moisturizer",
    "objetos",
    "protetor",
    "shampoo",
    "solar",
    "sunscreen",
    "xampu"
  ],
  "🛎️": [
    "1f6ce",
    "bell",
    "bellhop",
    "bellhop bell",
    "hotel",
    "objetos",
    "portaria",
    "sineta",
    "sino"
  ],
  "🔑": [
    "1f511",
    "chave",
    "key",
    "keys",
    "lock",
    "major",
    "objetos",
    "password",
    "senha",
    "trancado",
    "trancar",
    "unlock"
  ],
  "🗝️": [
    "1f5dd",
    "antiga",
    "chave",
    "chave antiga",
    "clue",
    "fechadura",
    "key",
    "lock",
    "objetos",
    "old",
    "old key"
  ],
  "🚪": [
    "1f6aa",
    "back",
    "closet",
    "door",
    "fechada",
    "front",
    "objetos",
    "porta"
  ],
  "🪑": [
    "1fa91",
    "assento",
    "cadeira",
    "chair",
    "objetos",
    "seat",
    "sentar",
    "sit"
  ],
  "🛋️": [
    "1f6cb",
    "couch",
    "couch and lamp",
    "hotel",
    "lamp",
    "lampada",
    "objetos",
    "sofa",
    "sofa e luminaria"
  ],
  "🛏️": [
    "1f6cf",
    "bed",
    "cama",
    "dormir",
    "hotel",
    "objetos",
    "sleep",
    "sono"
  ],
  "🛌": [
    "1f6cc",
    "bed",
    "bedtime",
    "boa",
    "cama",
    "cochilo",
    "dormindo",
    "dormir",
    "good",
    "goodnight",
    "hotel",
    "nap",
    "night",
    "noite",
    "objetos",
    "person",
    "person in bed",
    "pessoa",
    "pessoa deitada na cama",
    "sleep",
    "soneca",
    "sono",
    "tired",
    "zzz"
  ],
  "🧸": [
    "1f9f8",
    "bear",
    "bichinho",
    "brinquedo",
    "enchimento",
    "objetos",
    "pelucia",
    "plaything",
    "plush",
    "stuffed",
    "teddy",
    "teddy bear",
    "toy",
    "ursinho",
    "ursinho de pelucia",
    "urso"
  ],
  "🪆": [
    "1fa86",
    "babooshka",
    "baboushka",
    "babushka",
    "boneca",
    "boneca russa",
    "doll",
    "dolls",
    "matriosca",
    "matrioska",
    "matryoshka",
    "nesting",
    "nesting dolls",
    "objetos",
    "russa",
    "russia"
  ],
  "🖼️": [
    "1f5bc",
    "art",
    "arte",
    "emoldurado",
    "frame",
    "framed",
    "framed picture",
    "moldura",
    "museu",
    "museum",
    "objetos",
    "painting",
    "picture",
    "pintura",
    "quadro",
    "quadro emoldurado"
  ],
  "🪞": [
    "1fa9e",
    "especulo",
    "espelho",
    "makeup",
    "maquiagem",
    "mirror",
    "objetos",
    "reflection",
    "reflector",
    "refletor",
    "reflexao",
    "reflexo",
    "speculum"
  ],
  "🪟": [
    "1fa9f",
    "abertura",
    "air",
    "ar",
    "frame",
    "fresco",
    "fresh",
    "janela",
    "objetos",
    "opening",
    "quadro",
    "transparent",
    "transparente",
    "vidro",
    "view",
    "vista",
    "window"
  ],
  "🛍️": [
    "1f6cd",
    "bag",
    "bags",
    "compras",
    "hotel",
    "objetos",
    "presente",
    "sacolas",
    "sacolas de compras",
    "shopping",
    "shopping bags"
  ],
  "🛒": [
    "1f6d2",
    "carrinho",
    "carrinho de compras",
    "cart",
    "compras",
    "mercado",
    "objetos",
    "shopping",
    "shopping cart",
    "supermercado",
    "trolley"
  ],
  "🎁": [
    "1f381",
    "birthday",
    "bow",
    "box",
    "celebration",
    "christmas",
    "comemoracao",
    "embrulhado",
    "gift",
    "mimo",
    "objetos",
    "present",
    "presente",
    "surprise",
    "wrapped",
    "wrapped gift"
  ],
  "🎈": [
    "1f388",
    "aniversario",
    "balao",
    "balloon",
    "birthday",
    "celebracao",
    "celebrate",
    "celebration",
    "comemoracao",
    "festa",
    "objetos",
    "parabens"
  ],
  "🎏": [
    "1f38f",
    "bandeira",
    "bandeira de carpas",
    "carp",
    "carp streamer",
    "carpas",
    "celebration",
    "comemoracao",
    "koinobori",
    "objetos",
    "streamer"
  ],
  "🎀": [
    "1f380",
    "celebration",
    "comemoracao",
    "fita",
    "laco",
    "laco de fita",
    "objetos",
    "presente",
    "ribbon"
  ],
  "🪄": [
    "1fa84",
    "bruxa",
    "condao",
    "magia",
    "magic",
    "magic wand",
    "magica",
    "magician",
    "mago",
    "objetos",
    "varinha",
    "varinha magica",
    "wand",
    "witch",
    "wizard"
  ],
  "🪅": [
    "1fa85",
    "candy",
    "celebrate",
    "celebration",
    "cinco",
    "cinco de maio",
    "comemoracao",
    "de",
    "doce",
    "festa",
    "festival",
    "festive",
    "mayo",
    "objetos",
    "party",
    "pinada",
    "pinata",
    "pinhata"
  ],
  "🎊": [
    "1f38a",
    "ball",
    "bola",
    "celebracao",
    "celebrate",
    "celebration",
    "comemoracao",
    "confete",
    "confetti",
    "confetti ball",
    "eba",
    "oba",
    "objetos",
    "parabens",
    "party",
    "woohoo"
  ],
  "🎉": [
    "1f389",
    "alegria",
    "aniversario",
    "awesome",
    "birthday",
    "celebrar",
    "celebrate",
    "celebration",
    "comemoracao",
    "cone",
    "cone de festa",
    "eba",
    "excited",
    "festa",
    "hooray",
    "oba",
    "objetos",
    "parabens",
    "party",
    "party popper",
    "popper",
    "tada",
    "woohoo"
  ],
  "🎎": [
    "1f38e",
    "bonecas",
    "bonecas japonesas",
    "celebration",
    "comemoracao",
    "doll",
    "dolls",
    "festival",
    "japanesas",
    "japanese",
    "japanese dolls",
    "japones",
    "objetos"
  ],
  "🪭": [
    "1faad",
    "abanar",
    "arejar",
    "balancar",
    "calor",
    "clack",
    "clap",
    "cool",
    "cooling",
    "danca",
    "dance",
    "fan",
    "flertar",
    "flirt",
    "flutter",
    "folding",
    "folding hand fan",
    "hand",
    "hot",
    "leque",
    "leque dobravel",
    "objetos",
    "quente",
    "refrescar",
    "shy",
    "timidez"
  ],
  "🏮": [
    "1f3ee",
    "bar",
    "izakaya",
    "lantern",
    "lanterna",
    "lanterna vermelha de papel",
    "light",
    "objetos",
    "papel",
    "paper",
    "red",
    "red paper lantern",
    "restaurant",
    "restaurante",
    "vermelha"
  ],
  "🎐": [
    "1f390",
    "bell",
    "carrilhao de vento",
    "celebration",
    "chime",
    "objetos",
    "sino",
    "som",
    "vento",
    "wind",
    "wind chime"
  ],
  "🪩": [
    "1faa9",
    "balada",
    "ball",
    "boate",
    "bola",
    "brilho",
    "danca",
    "dancar",
    "dance",
    "disco",
    "discoteca",
    "espelhado",
    "espelho",
    "festa",
    "glitter",
    "globo",
    "globo de espelhos",
    "mirror",
    "mirror ball",
    "night",
    "objetos",
    "party"
  ],
  "🧧": [
    "1f9e7",
    "boa sorte",
    "dinheiro",
    "envelope",
    "envelope vermelho",
    "gift",
    "good",
    "hongbao",
    "lai",
    "lai see",
    "luck",
    "money",
    "objetos",
    "presente",
    "red",
    "red envelope",
    "see"
  ],
  "✉️": [
    "2709",
    "carta",
    "correspondencia",
    "e-mail",
    "email",
    "envelope",
    "letter",
    "objetos"
  ],
  "📩": [
    "1f4e9",
    "arrow",
    "carta",
    "communication",
    "comunicacao",
    "correspondencia",
    "down",
    "e-mail",
    "email",
    "envelope",
    "envelope com seta",
    "envelope with arrow",
    "letter",
    "mail",
    "objetos",
    "outgoing",
    "send",
    "sent",
    "seta"
  ],
  "📨": [
    "1f4e8",
    "carta",
    "chegando",
    "comunicacao",
    "correspondencia",
    "delivering",
    "e-mail",
    "email",
    "envelope",
    "envelope chegando",
    "incoming",
    "incoming envelope",
    "letter",
    "mail",
    "nova",
    "objetos",
    "recebida",
    "receive",
    "sent"
  ],
  "📧": [
    "1f4e7",
    "carta",
    "comunicacao",
    "correspondencia",
    "e-mail",
    "email",
    "letter",
    "mail",
    "objetos"
  ],
  "💌": [
    "1f48c",
    "carta",
    "carta de amor",
    "coracao",
    "correspondencia com coracao",
    "heart",
    "letter",
    "love",
    "love letter",
    "mail",
    "objetos",
    "romance",
    "valentine"
  ],
  "📥": [
    "1f4e5",
    "bandeja",
    "bandeja de entrada",
    "box",
    "caixa",
    "comunicacao",
    "correspondencia",
    "e-mail",
    "email",
    "entrada",
    "inbox",
    "inbox tray",
    "letter",
    "mail",
    "objetos",
    "recebida",
    "recebido",
    "receive",
    "tray",
    "zero"
  ],
  "📤": [
    "1f4e4",
    "bandeja",
    "bandeja de saida",
    "box",
    "caixa",
    "comunicacao",
    "correspondencia",
    "email",
    "enviada",
    "letter",
    "mail",
    "objetos",
    "outbox",
    "outbox tray",
    "saida",
    "sent",
    "tray"
  ],
  "📦": [
    "1f4e6",
    "box",
    "caixa",
    "communication",
    "delivery",
    "embrulho",
    "objetos",
    "package",
    "pacote",
    "parcel",
    "shipping"
  ],
  "🏷️": [
    "1f3f7",
    "etiqueta",
    "identificar",
    "label",
    "objetos",
    "rotulo",
    "tag"
  ],
  "🪧": [
    "1faa7",
    "aviso",
    "card",
    "cartaz",
    "demonstracao",
    "demonstration",
    "letreiro",
    "notice",
    "objetos",
    "picket",
    "piquete",
    "placa",
    "placard",
    "plaque",
    "protest",
    "protesto",
    "sign",
    "sinal"
  ],
  "📪": [
    "1f4ea",
    "abaixada",
    "bandeira",
    "caixa",
    "caixa de correio fechada com bandeira abaixada",
    "closed",
    "closed mailbox with lowered flag",
    "correio",
    "correspondencia",
    "fechada",
    "flag",
    "lowered",
    "mail",
    "mailbox",
    "objetos",
    "postbox",
    "vazia"
  ],
  "📫": [
    "1f4eb",
    "bandeira",
    "caixa",
    "caixa de correio fechada com bandeira levantada",
    "closed",
    "closed mailbox with raised flag",
    "communication",
    "correio",
    "correspondencia",
    "fechada",
    "flag",
    "levantada",
    "mail",
    "mailbox",
    "objetos",
    "postbox",
    "raised"
  ],
  "📬": [
    "1f4ec",
    "aberta",
    "bandeira",
    "caixa de correio aberta com bandeira levantada",
    "caixa de correspondencia aberta com bandeira levantada",
    "correspondencia",
    "flag",
    "mail",
    "mailbox",
    "objetos",
    "open",
    "open mailbox with raised flag",
    "postbox",
    "raised"
  ],
  "📭": [
    "1f4ed",
    "aberta",
    "bandeira",
    "caixa de correio aberta com bandeira abaixada",
    "caixa de correspondencia aberta com bandeira abaixada",
    "caixa de correspondencia aberta e vazia",
    "correspondencia",
    "flag",
    "lowered",
    "mail",
    "mailbox",
    "objetos",
    "open",
    "open mailbox with lowered flag",
    "postbox"
  ],
  "📮": [
    "1f4ee",
    "caixa",
    "caixa de correio",
    "carta",
    "correio",
    "correspondencia",
    "enviar",
    "mail",
    "mailbox",
    "objetos",
    "postbox"
  ],
  "📯": [
    "1f4ef",
    "corneta",
    "corneta postal",
    "correios",
    "horn",
    "objetos",
    "post",
    "postal",
    "postal horn"
  ],
  "📜": [
    "1f4dc",
    "objetos",
    "paper",
    "pergaminho",
    "rolo de papel",
    "scroll"
  ],
  "📃": [
    "1f4c3",
    "curl",
    "dobrado",
    "document",
    "documento",
    "objetos",
    "page",
    "page with curl",
    "pagina",
    "pagina dobrada",
    "papel",
    "paper"
  ],
  "📄": [
    "1f4c4",
    "document",
    "documento",
    "facing",
    "objetos",
    "oficial",
    "page",
    "page facing up",
    "pagina",
    "pagina voltada para cima",
    "papel",
    "paper",
    "up"
  ],
  "📑": [
    "1f4d1",
    "bookmark",
    "bookmark tabs",
    "marcador",
    "marcadores de pagina",
    "marcar",
    "mark",
    "marker",
    "objetos",
    "pagina",
    "tabs"
  ],
  "🧾": [
    "1f9fe",
    "accounting",
    "bookkeeping",
    "contabilidade",
    "escrituracao",
    "evidence",
    "evidencia",
    "fatura",
    "invoice",
    "objetos",
    "proof",
    "prova",
    "receipt",
    "recibo"
  ],
  "📊": [
    "1f4ca",
    "bar",
    "bar chart",
    "barra",
    "chart",
    "data",
    "diagrama",
    "grafico",
    "grafico de barras",
    "graph",
    "objetos"
  ],
  "📈": [
    "1f4c8",
    "chart",
    "chart increasing",
    "crescimento",
    "data",
    "diagrama",
    "grafico",
    "grafico de tendencia de crescimento",
    "grafico subindo",
    "graph",
    "growth",
    "increasing",
    "objetos",
    "right",
    "tendencia de crescimento",
    "trend",
    "up",
    "upward"
  ],
  "📉": [
    "1f4c9",
    "chart",
    "chart decreasing",
    "data",
    "decreasing",
    "diagrama",
    "down",
    "downward",
    "grafico",
    "grafico caindo",
    "grafico de tendencia negativa",
    "graph",
    "negativa",
    "negative",
    "objetos",
    "tendencia negativa",
    "trend"
  ],
  "🗒️": [
    "1f5d2",
    "bloco",
    "bloco espiral",
    "caderno",
    "espiral",
    "note",
    "notepad",
    "objetos",
    "pad",
    "spiral",
    "spiral notepad"
  ],
  "🗓️": [
    "1f5d3",
    "bloco",
    "calendar",
    "calendario",
    "calendario espiral",
    "data",
    "espiral",
    "objetos",
    "pad",
    "spiral",
    "spiral calendar"
  ],
  "📆": [
    "1f4c6",
    "calendar",
    "calendario",
    "calendario com folhas destacaveis",
    "data",
    "destacaveis",
    "destacavel",
    "dia",
    "folha",
    "objetos",
    "paginas",
    "tear-off",
    "tear-off calendar",
    "varias"
  ],
  "📅": [
    "1f4c5",
    "calendar",
    "calendario",
    "data",
    "datas",
    "date",
    "objetos"
  ],
  "🗑️": [
    "1f5d1",
    "can",
    "cesto",
    "garbage",
    "lixeira",
    "lixo",
    "objetos",
    "trash",
    "waste",
    "wastebasket"
  ],
  "📇": [
    "1f4c7",
    "card",
    "card index",
    "index",
    "indice",
    "indice de cartoes",
    "objetos",
    "old",
    "rolodex",
    "school"
  ],
  "🗃️": [
    "1f5c3",
    "arquivo",
    "box",
    "caixa",
    "caixa de arquivos",
    "card",
    "card file box",
    "cartao",
    "documentos",
    "ficheiro",
    "file",
    "objetos"
  ],
  "🗳️": [
    "1f5f3",
    "ballot",
    "ballot box with ballot",
    "box",
    "cedula",
    "eleicao",
    "eleitoral",
    "objetos",
    "urna",
    "urna eleitoral com cedula",
    "votar",
    "voto"
  ],
  "🗄️": [
    "1f5c4",
    "arquivo",
    "cabinet",
    "escritorio",
    "file",
    "file cabinet",
    "filing",
    "gabinete",
    "gavetas",
    "gavetas de escritorio",
    "objetos",
    "paper"
  ],
  "📋": [
    "1f4cb",
    "anotacoes",
    "clipboard",
    "do",
    "list",
    "notes",
    "objetos",
    "prancheta"
  ],
  "📁": [
    "1f4c1",
    "arquivo",
    "file",
    "file folder",
    "folder",
    "objetos",
    "pasta",
    "pasta de arquivos"
  ],
  "📂": [
    "1f4c2",
    "aberta",
    "abrir",
    "arquivo",
    "file",
    "folder",
    "objetos",
    "open",
    "open file folder",
    "pasta",
    "pasta de arquivos aberta"
  ],
  "🗂️": [
    "1f5c2",
    "arquivo",
    "card",
    "card index dividers",
    "dividers",
    "divisor",
    "divisores de pastas",
    "index",
    "indice",
    "objetos",
    "organizador",
    "pasta"
  ],
  "🗞️": [
    "1f5de",
    "enrolado",
    "jornal",
    "jornal enrolado",
    "news",
    "newspaper",
    "noticias",
    "objetos",
    "paper",
    "rolled",
    "rolled-up",
    "rolled-up newspaper"
  ],
  "📰": [
    "1f4f0",
    "communication",
    "jornal",
    "news",
    "newspaper",
    "noticias",
    "objetos",
    "paper"
  ],
  "📓": [
    "1f4d3",
    "caderno",
    "folhas",
    "notebook",
    "objetos"
  ],
  "📔": [
    "1f4d4",
    "agenda",
    "book",
    "caderno",
    "caderno decorado",
    "capa",
    "cover",
    "decoracao",
    "decorated",
    "decorative",
    "education",
    "escola",
    "livro",
    "notebook",
    "notebook with decorative cover",
    "objetos",
    "school",
    "writing"
  ],
  "📒": [
    "1f4d2",
    "caderno",
    "ledger",
    "livro contabil",
    "notebook",
    "objetos"
  ],
  "📕": [
    "1f4d5",
    "apostila",
    "book",
    "closed",
    "closed book",
    "education",
    "fechado",
    "livro",
    "livro fechado",
    "objetos"
  ],
  "📗": [
    "1f4d7",
    "biblioteca",
    "book",
    "caderno",
    "colegio",
    "education",
    "escola",
    "estudar",
    "fantasy",
    "green",
    "green book",
    "lendo",
    "ler",
    "library",
    "livraria",
    "livro",
    "livro verde",
    "objetos",
    "reading",
    "verde"
  ],
  "📘": [
    "1f4d8",
    "apostila",
    "azul",
    "blue",
    "blue book",
    "book",
    "education",
    "escola",
    "estudo",
    "fantasy",
    "leitura",
    "library",
    "livro",
    "livro azul",
    "objetos",
    "reading"
  ],
  "📙": [
    "1f4d9",
    "apostila",
    "book",
    "cartilha",
    "education",
    "fantasy",
    "laranja",
    "library",
    "livro",
    "livro laranja",
    "objetos",
    "orange",
    "orange book",
    "reading"
  ],
  "📚": [
    "1f4da",
    "biblioteca",
    "book",
    "books",
    "education",
    "estudando",
    "estudar",
    "fantasy",
    "knowledge",
    "leitura",
    "lendo",
    "ler",
    "library",
    "livraria",
    "livro",
    "livros",
    "novels",
    "objetos",
    "reading",
    "school",
    "study"
  ],
  "📖": [
    "1f4d6",
    "aberto",
    "biblioteca",
    "book",
    "education",
    "fantasy",
    "knowledge",
    "leitura",
    "lendo",
    "ler",
    "library",
    "livraria",
    "livro",
    "livro aberto",
    "novels",
    "objetos",
    "open",
    "open book",
    "reading"
  ],
  "🔖": [
    "1f516",
    "bookmark",
    "livro",
    "marcador",
    "marcador de pagina",
    "mark",
    "objetos",
    "pagina"
  ],
  "🧷": [
    "1f9f7",
    "alfinete",
    "alfinete de seguranca",
    "diaper",
    "fralda",
    "objetos",
    "pin",
    "punk",
    "rock",
    "safety",
    "safety pin"
  ],
  "🔗": [
    "1f517",
    "aneis",
    "corrente",
    "dois",
    "link",
    "links",
    "objetos",
    "simbolo",
    "vinculo"
  ],
  "📎": [
    "1f4ce",
    "clipe",
    "clipe de papel",
    "objetos",
    "paperclip"
  ],
  "🖇️": [
    "1f587",
    "clipe",
    "clipes",
    "clipes de papel",
    "clipes de papel conectados",
    "link",
    "linked",
    "linked paperclips",
    "objetos",
    "paperclip",
    "paperclips"
  ],
  "📐": [
    "1f4d0",
    "angle",
    "angulo",
    "geometria",
    "matematica",
    "math",
    "objetos",
    "regua",
    "regua triangular",
    "rule",
    "ruler",
    "set",
    "slide",
    "triangle",
    "triangular",
    "triangular ruler",
    "triangulo"
  ],
  "📏": [
    "1f4cf",
    "angle",
    "edge",
    "math",
    "objetos",
    "regua",
    "regua reta",
    "ruler",
    "straight",
    "straight ruler",
    "straightedge"
  ],
  "🧮": [
    "1f9ee",
    "abaco",
    "abacus",
    "calculadora",
    "calculation",
    "calculator",
    "calculo",
    "matematica",
    "numero",
    "objetos"
  ],
  "📌": [
    "1f4cc",
    "alfinete",
    "collage",
    "objetos",
    "pin",
    "pushpin",
    "tacha"
  ],
  "📍": [
    "1f4cd",
    "alfinete",
    "localizacao",
    "location",
    "map",
    "mapa",
    "objetos",
    "pin",
    "pushpin",
    "redonda",
    "round",
    "round pushpin",
    "tacha",
    "tacha redonda"
  ],
  "✂️": [
    "2702",
    "aberta",
    "cortar",
    "cut",
    "cutting",
    "ferramenta",
    "objetos",
    "paper",
    "scissors",
    "tesoura",
    "tool"
  ],
  "🖊️": [
    "1f58a",
    "ballpoint",
    "caneta",
    "esferografica",
    "objetos",
    "pen",
    "tinteiro"
  ],
  "🖋️": [
    "1f58b",
    "caneta",
    "caneta tinteiro",
    "destro",
    "fountain",
    "fountain pen",
    "objetos",
    "pen",
    "tinteiro"
  ],
  "✒️": [
    "2712",
    "black",
    "black nib",
    "caneta",
    "nib",
    "objetos",
    "pen",
    "ponta",
    "ponta de caneta tinteiro",
    "preto",
    "tinta",
    "tinteiro"
  ],
  "🖌️": [
    "1f58c",
    "objetos",
    "paintbrush",
    "painting",
    "pincel",
    "pintando",
    "pintar"
  ],
  "🖍️": [
    "1f58d",
    "cera",
    "crayon",
    "desenho",
    "giz",
    "giz de cera",
    "objetos",
    "vermelho"
  ],
  "📝": [
    "1f4dd",
    "anotacoes",
    "caderno",
    "communication",
    "comunicacao",
    "lapis",
    "media",
    "memo",
    "memorando",
    "notas",
    "notes",
    "objetos",
    "pencil"
  ],
  "✏️": [
    "270f",
    "lapis",
    "objetos",
    "pencil"
  ],
  "🔍": [
    "1f50d",
    "aumento",
    "busca",
    "esquerda",
    "ferramenta",
    "glass",
    "lab",
    "left",
    "left-pointing",
    "lente",
    "lupa",
    "lupa para a esquerda",
    "magnifying",
    "magnifying glass tilted left",
    "objetos",
    "pesquisa",
    "procura",
    "science",
    "search",
    "tilted",
    "tool"
  ],
  "🔎": [
    "1f50e",
    "aumento",
    "busca",
    "contact",
    "direita",
    "ferramenta",
    "glass",
    "lab",
    "lente",
    "lupa",
    "lupa para a direita",
    "magnifying",
    "magnifying glass tilted right",
    "objetos",
    "pesquisa",
    "procura",
    "right",
    "right-pointing",
    "science",
    "search",
    "tilted",
    "tool"
  ],
  "🔏": [
    "1f50f",
    "cadeado",
    "cadeado com caneta",
    "caneta",
    "ink",
    "lock",
    "locked",
    "locked with pen",
    "nib",
    "objetos",
    "pen",
    "privacidade",
    "privacy",
    "privado",
    "tinteiro"
  ],
  "🔐": [
    "1f510",
    "bike",
    "cadeado",
    "cadeado fechado com chave",
    "chave",
    "closed",
    "fechado",
    "key",
    "lock",
    "locked",
    "locked with key",
    "objetos",
    "secure",
    "seguro",
    "trancado"
  ],
  "🔒": [
    "1f512",
    "cadeado",
    "closed",
    "fechado",
    "lock",
    "locked",
    "objetos",
    "private",
    "trancado"
  ],
  "🔓": [
    "1f513",
    "aberto",
    "cadeado",
    "cadeado aberto",
    "cracked",
    "destrancado",
    "lock",
    "objetos",
    "open",
    "unlock",
    "unlocked"
  ],
  "🩷": [
    "143",
    "1fa77",
    "adorable",
    "adoravel",
    "adorei",
    "amo voce",
    "amor",
    "coracao",
    "coracao rosa",
    "curtir",
    "cute",
    "emocao",
    "emotion",
    "especial",
    "fofo",
    "gostar",
    "gostei",
    "heart",
    "ily",
    "like",
    "love",
    "pink",
    "pink heart",
    "simbolos",
    "special",
    "sweet",
    "te amo"
  ],
  "❤️": [
    "2764",
    "amor",
    "coracao",
    "coracao vermelho",
    "emotion",
    "heart",
    "love",
    "red",
    "red heart",
    "s2",
    "simbolos"
  ],
  "🧡": [
    "143",
    "1f9e1",
    "coracao",
    "coracao laranja",
    "emocao",
    "heart",
    "laranja",
    "orange",
    "orange heart",
    "s2",
    "simbolos"
  ],
  "💛": [
    "143",
    "1f49b",
    "amarelo",
    "amor",
    "cardiac",
    "coracao",
    "coracao amarelo",
    "emocao",
    "emotion",
    "heart",
    "ily",
    "love",
    "s2",
    "simbolos",
    "yellow",
    "yellow heart"
  ],
  "💚": [
    "143",
    "1f49a",
    "coracao",
    "coracao verde",
    "emocao",
    "emotion",
    "green",
    "green heart",
    "heart",
    "ily",
    "love",
    "romantic",
    "s2",
    "simbolos",
    "verde"
  ],
  "🩵": [
    "143",
    "1fa75",
    "adorar",
    "adorei",
    "amo voce",
    "amor",
    "blue",
    "coracao",
    "coracao azul-claro",
    "cute",
    "cyan",
    "emocao",
    "emotion",
    "especial",
    "fofo",
    "gostar",
    "gostei",
    "heart",
    "ily",
    "light",
    "light blue heart",
    "like",
    "love",
    "simbolos",
    "sky",
    "special",
    "te amo",
    "teal"
  ],
  "💙": [
    "143",
    "1f499",
    "azul",
    "blue",
    "blue heart",
    "coracao",
    "coracao azul",
    "emocao",
    "emotion",
    "heart",
    "ily",
    "love",
    "romance",
    "s2",
    "simbolos"
  ],
  "💜": [
    "143",
    "1f49c",
    "bestest",
    "coracao",
    "coracao lilas",
    "coracao roxo",
    "emocao",
    "emotion",
    "heart",
    "ily",
    "love",
    "purple",
    "purple heart",
    "roxo",
    "s2",
    "simbolos"
  ],
  "🖤": [
    "1f5a4",
    "black",
    "black heart",
    "coracao",
    "coracao preto",
    "evil",
    "heart",
    "negro",
    "preto",
    "s2",
    "simbolos",
    "wicked"
  ],
  "🩶": [
    "143",
    "1fa76",
    "adorar",
    "adorei",
    "amo voce",
    "amor",
    "coracao",
    "coracao cinza",
    "emocao",
    "emotion",
    "especial",
    "gostar",
    "gostei",
    "gray",
    "grey",
    "grey heart",
    "heart",
    "ily",
    "love",
    "silver",
    "simbolos",
    "slate",
    "special",
    "te amo"
  ],
  "🤍": [
    "143",
    "1f90d",
    "branco",
    "coracao",
    "coracao branco",
    "heart",
    "s2",
    "simbolos",
    "white",
    "white heart"
  ],
  "🤎": [
    "143",
    "1f90e",
    "brown",
    "brown heart",
    "coracao",
    "coracao marrom",
    "heart",
    "marrom",
    "s2",
    "simbolos"
  ],
  "💔": [
    "1f494",
    "amorosa",
    "break",
    "broken",
    "broken heart",
    "coracao",
    "coracao partido",
    "crushed",
    "decepcao",
    "desilusao",
    "emocao",
    "emotion",
    "heart",
    "heartbroken",
    "lonely",
    "partido",
    "quebrado",
    "rompimento",
    "s2",
    "sad",
    "simbolos",
    "sofrendo",
    "sofrimento",
    "triste"
  ],
  "❤️‍🔥": [
    "2764-200d-1f525",
    "amor",
    "burn",
    "chamas",
    "coracao",
    "coracao em chamas",
    "coracao sagrado",
    "fire",
    "fogo",
    "heart",
    "heart on fire",
    "love",
    "lust",
    "luxuria",
    "sacred",
    "simbolos"
  ],
  "❤️‍🩹": [
    "2764-200d-1fa79",
    "bem",
    "bom",
    "coracao remendado",
    "curando",
    "healthier",
    "heart",
    "improving",
    "mais saudavel",
    "melhorando",
    "mending",
    "mending heart",
    "recovering",
    "recuperacao",
    "recuperating",
    "simbolos",
    "well"
  ],
  "❣️": [
    "2763",
    "amor",
    "coracao",
    "exclamacao",
    "exclamacao de coracao",
    "exclamation",
    "heart",
    "heart exclamation",
    "heavy",
    "mark",
    "pontuacao",
    "punctuation",
    "s2",
    "simbolos",
    "sinal"
  ],
  "💕": [
    "143",
    "1f495",
    "amor",
    "aniversario",
    "anniversary",
    "casal",
    "coracao",
    "date",
    "dating",
    "dois",
    "dois coracoes",
    "emocao",
    "emotion",
    "heart",
    "hearts",
    "ily",
    "kisses",
    "love",
    "loving",
    "s2",
    "simbolos",
    "two",
    "two hearts",
    "xoxo"
  ],
  "💞": [
    "143",
    "1f49e",
    "adoravel",
    "adorbs",
    "amor",
    "anniversary",
    "bonitinho",
    "coracao",
    "coracoes",
    "coracoes girando",
    "emocao",
    "emotion",
    "girando",
    "heart",
    "hearts",
    "revolving",
    "revolving hearts",
    "s2",
    "simbolos"
  ],
  "💓": [
    "143",
    "1f493",
    "amor",
    "batendo",
    "beating",
    "beating heart",
    "cardio",
    "coracao",
    "coracao pulsante",
    "emocao",
    "emotion",
    "heart",
    "heartbeat",
    "ily",
    "love",
    "pulsante",
    "pulsating",
    "pulse",
    "s2",
    "simbolos"
  ],
  "💗": [
    "143",
    "1f497",
    "amor",
    "animado",
    "batendo",
    "coracao",
    "coracao crescendo",
    "crescendo",
    "emocao",
    "emotion",
    "excited",
    "growing",
    "growing heart",
    "heart",
    "heartpulse",
    "ily",
    "kisses",
    "muah",
    "nervosismo",
    "nervous",
    "pulse",
    "s2",
    "simbolos",
    "xoxo"
  ],
  "💖": [
    "143",
    "1f496",
    "amor",
    "brilhante",
    "coracao",
    "coracao brilhante",
    "emocao",
    "emocionante",
    "emotion",
    "excited",
    "good",
    "heart",
    "ily",
    "kisses",
    "morning",
    "night",
    "s2",
    "simbolos",
    "sparkle",
    "sparkling",
    "sparkling heart",
    "xoxo"
  ],
  "💘": [
    "143",
    "1f498",
    "adorbs",
    "amor",
    "arrow",
    "coracao",
    "coracao com flecha",
    "cupid",
    "cupido",
    "date",
    "emocao",
    "emotion",
    "flecha",
    "flechado",
    "heart",
    "heart with arrow",
    "ily",
    "love",
    "paixao",
    "romance",
    "s2",
    "simbolos",
    "valentine"
  ],
  "💝": [
    "143",
    "1f49d",
    "amor",
    "aniversario",
    "anniversary",
    "coracao",
    "coracao com fita",
    "dia dos namorados",
    "emotion",
    "fita",
    "heart",
    "heart with ribbon",
    "ily",
    "kisses",
    "presente",
    "ribbon",
    "s2",
    "simbolos",
    "valentine",
    "xoxo"
  ],
  "💟": [
    "143",
    "1f49f",
    "amor",
    "coracao",
    "coracao decorativo",
    "decoracao",
    "decoration",
    "decorativo",
    "emotion",
    "heart",
    "heart decoration",
    "hearth",
    "purple",
    "roxo",
    "s2",
    "selo",
    "simbolos",
    "white"
  ],
  "☮️": [
    "262e",
    "healing",
    "paz",
    "peace",
    "peace symbol",
    "peaceful",
    "simbolo",
    "simbolo da paz",
    "simbolos",
    "symbol"
  ],
  "✝️": [
    "271d",
    "christ",
    "christian",
    "cristao",
    "cross",
    "cruz",
    "cruz latina",
    "latin",
    "latin cross",
    "religiao",
    "religion",
    "simbolos"
  ],
  "☪️": [
    "262a",
    "crescent",
    "estrela e lua crescente",
    "isla",
    "islam",
    "muculmano",
    "muslim",
    "ramadan",
    "religiao",
    "religion",
    "simbolo isla",
    "simbolos",
    "star",
    "star and crescent"
  ],
  "🕉️": [
    "1f549",
    "hindu",
    "om",
    "religiao",
    "religion",
    "simbolos"
  ],
  "☸️": [
    "2638",
    "buddhist",
    "budista",
    "dharma",
    "religiao",
    "religion",
    "roda",
    "roda do dharma",
    "simbolos",
    "wheel",
    "wheel of dharma"
  ],
  "🪯": [
    "1faaf",
    "deg",
    "deg tegh fateh",
    "fateh",
    "fe",
    "khalsa",
    "khanda",
    "religiao",
    "religion",
    "sikh",
    "sikhism",
    "sikhismo",
    "simbolos",
    "siquismo",
    "tegh"
  ],
  "✡️": [
    "2721",
    "davi",
    "david",
    "estrela",
    "estrela de davi",
    "jew",
    "jewish",
    "judaico",
    "judaism",
    "judeu",
    "religiao",
    "religion",
    "simbolos",
    "star",
    "star of david"
  ],
  "🔯": [
    "1f52f",
    "adivinhacao",
    "destino",
    "dotted",
    "dotted six-pointed star",
    "estrela de seis pontas",
    "fortune",
    "jewish",
    "judaism",
    "seis pontas",
    "simbolos",
    "six-pointed",
    "star"
  ],
  "🕎": [
    "1f54e",
    "candelabro",
    "candelabro judeu",
    "candelabrum",
    "candlestick",
    "castical",
    "hanukkah",
    "jewish",
    "judaism",
    "judaismo",
    "memorah",
    "menora",
    "menorah",
    "religiao",
    "religion",
    "simbolos"
  ],
  "☯️": [
    "262f",
    "difficult",
    "lives",
    "religiao",
    "religion",
    "simbolos",
    "tao",
    "taoist",
    "taoista",
    "taoistas",
    "total",
    "yang",
    "yin",
    "yin yang",
    "yin-yang",
    "yinyang"
  ],
  "☦️": [
    "2626",
    "christian",
    "cristao",
    "cross",
    "cruz",
    "cruz ortodoxa",
    "orthodox",
    "orthodox cross",
    "religiao",
    "religion",
    "simbolos"
  ],
  "🛐": [
    "1f6d0",
    "culto",
    "local de culto",
    "local sagrado",
    "oracao",
    "place",
    "place of worship",
    "pray",
    "religiao",
    "religion",
    "reza",
    "simbolos",
    "worship"
  ],
  "⛎": [
    "26ce",
    "bearer",
    "cobra",
    "ofiuco",
    "ophiuchus",
    "serpent",
    "serpente",
    "signo de ofiuco",
    "simbolos",
    "snake",
    "zodiac",
    "zodiaco"
  ],
  "♈️": [
    "2648",
    "aries",
    "carneiro",
    "horoscope",
    "ram",
    "signo de aries",
    "simbolos",
    "zodiac",
    "zodiaco"
  ],
  "♉️": [
    "2649",
    "boi",
    "bull",
    "horoscope",
    "ox",
    "signo de touro",
    "simbolos",
    "taurus",
    "touro",
    "zodiac",
    "zodiaco"
  ],
  "♊️": [
    "264a",
    "gemeos",
    "gemini",
    "horoscope",
    "signo de gemeos",
    "simbolos",
    "twins",
    "zodiac",
    "zodiaco"
  ],
  "♋️": [
    "264b",
    "cancer",
    "caranguejo",
    "crab",
    "horoscope",
    "signo de cancer",
    "simbolos",
    "zodiac",
    "zodiaco"
  ],
  "♌️": [
    "264c",
    "horoscope",
    "leao",
    "leo",
    "lion",
    "signo de leao",
    "simbolos",
    "zodiac",
    "zodiaco"
  ],
  "♍️": [
    "264d",
    "horoscope",
    "signo de virgem",
    "simbolos",
    "virgem",
    "virgo",
    "zodiac",
    "zodiaco"
  ],
  "♎️": [
    "264e",
    "balanca",
    "balance",
    "horoscope",
    "justica",
    "justice",
    "libra",
    "scales",
    "signo de libra",
    "signo de virgem",
    "simbolos",
    "zodiac",
    "zodiaco"
  ],
  "♏️": [
    "264f",
    "escorpiao",
    "horoscope",
    "scorpio",
    "scorpion",
    "scorpius",
    "signo de escorpiao",
    "simbolos",
    "zodiac",
    "zodiaco"
  ],
  "♐️": [
    "2650",
    "archer",
    "arqueiro",
    "horoscope",
    "sagitario",
    "sagittarius",
    "signo de sagitario",
    "simbolos",
    "zodiac",
    "zodiaco"
  ],
  "♑️": [
    "2651",
    "cabra",
    "capricorn",
    "capricornio",
    "goat",
    "horoscope",
    "signo de capricornio",
    "simbolos",
    "zodiac",
    "zodiaco"
  ],
  "♒️": [
    "2652",
    "agua",
    "aquario",
    "aquarius",
    "bearer",
    "horoscope",
    "signo de aquario",
    "simbolos",
    "water",
    "zodiac",
    "zodiaco"
  ],
  "♓️": [
    "2653",
    "fish",
    "horoscope",
    "peixes",
    "pisces",
    "signo de peixes",
    "simbolos",
    "zodiac",
    "zodiaco"
  ],
  "🆔": [
    "1f194",
    "botao id",
    "button",
    "id",
    "id button",
    "identidade",
    "identity",
    "simbolo",
    "simbolo “id”",
    "simbolos"
  ],
  "⚛️": [
    "269b",
    "ateismo",
    "ateu",
    "atheist",
    "atom",
    "atom symbol",
    "atomo",
    "simbolo de atomo",
    "simbolo do ateismo",
    "simbolos",
    "symbol"
  ],
  "🉑": [
    "1f251",
    "acceptable",
    "aceitar",
    "alfabeto",
    "botao japones de “aceitavel”",
    "button",
    "chines",
    "ideografico circular “aceitar”",
    "ideograma",
    "ideograph",
    "japanese",
    "japanese “acceptable” button",
    "japones",
    "simbolos",
    "“aceitavel”",
    "可"
  ],
  "☢️": [
    "2622",
    "perigo",
    "radiacao",
    "radiativo",
    "radioactive",
    "radioativo",
    "sign",
    "simbolo",
    "simbolos",
    "sinal"
  ],
  "☣️": [
    "2623",
    "biohazard",
    "biologico",
    "ciencia",
    "perigo",
    "residuos",
    "residuos biologicos",
    "risco",
    "risco biologico",
    "sign",
    "simbolos"
  ],
  "📴": [
    "1f4f4",
    "cell",
    "celular",
    "desligado",
    "desligue o celular",
    "mobile",
    "mobile phone off",
    "off",
    "phone",
    "simbolos",
    "smartphone",
    "telefone",
    "telefone celular desligado",
    "telephone"
  ],
  "📳": [
    "1f4f3",
    "cel",
    "cell",
    "celular",
    "communication",
    "mobile",
    "mode",
    "modo",
    "modo vibratorio",
    "phone",
    "simbolos",
    "smartphone",
    "telefone",
    "telephone",
    "vibracao",
    "vibration",
    "vibration mode"
  ],
  "🈶": [
    "1f236",
    "alfabeto",
    "botao japones de “nao gratuito”",
    "button",
    "charge",
    "free",
    "ideografico",
    "ideograma",
    "ideograph",
    "japanese",
    "japanese “not free of charge” button",
    "japones",
    "nao gratuito",
    "not",
    "simbolos",
    "“nao gratuito”",
    "有"
  ],
  "🈚️": [
    "1f21a",
    "alfabeto",
    "botao japones de “gratuito”",
    "button",
    "charge",
    "de graca",
    "free",
    "gratis",
    "ideografico",
    "ideograma",
    "ideograph",
    "japanese",
    "japanese “free of charge” button",
    "japones",
    "sem custo",
    "simbolos",
    "“gratuito”",
    "無"
  ],
  "🈸": [
    "1f238",
    "alfabeto",
    "aplicar",
    "application",
    "botao japones de “aplicacao”",
    "button",
    "chines",
    "ideografico quadrado “aplicar”",
    "ideograma",
    "ideograph",
    "japanese",
    "japanese “application” button",
    "japones",
    "simbolos",
    "“aplicacao”",
    "申"
  ],
  "🈺": [
    "1f23a",
    "botao japones de “aberto para negocios”",
    "business",
    "button",
    "chines",
    "ideografico quadrado “operando”",
    "ideograma",
    "ideograph",
    "japanese",
    "japanese “open for business” button",
    "japones",
    "open",
    "operando",
    "simbolos",
    "“aberto para negocios”",
    "営"
  ],
  "🈷️": [
    "1f237",
    "alfabeto",
    "amount",
    "botao japones de “quantidade mensal”",
    "button",
    "ideografico",
    "ideograma",
    "ideograph",
    "japanese",
    "japanese “monthly amount” button",
    "japones",
    "monthly",
    "simbolos",
    "valor mensal",
    "“quantidade mensal”",
    "月"
  ],
  "✴️": [
    "*",
    "2734",
    "eight-pointed",
    "eight-pointed star",
    "estrela",
    "estrela de oito pontas",
    "oito pontas",
    "simbolos",
    "star"
  ],
  "🆚": [
    "1f19a",
    "botao vs",
    "button",
    "simbolo",
    "simbolo “vs”",
    "simbolos",
    "versus",
    "vs",
    "vs button"
  ],
  "💮": [
    "1f4ae",
    "carimbo",
    "carimbo de flor",
    "carimbo de parabens",
    "flor",
    "flor branca",
    "flower",
    "simbolos",
    "white",
    "white flower"
  ],
  "🉐": [
    "1f250",
    "alfabeto",
    "bargain",
    "barganha",
    "botao japones de “barganha”",
    "button",
    "ideografico",
    "ideograma",
    "ideograph",
    "japanese",
    "japanese “bargain” button",
    "japones",
    "pechincha",
    "simbolos",
    "“barganha”",
    "得"
  ],
  "㊙️": [
    "3299",
    "alfabeto",
    "botao japones de “segredo”",
    "button",
    "ideografico",
    "ideografico circular “segredo”",
    "ideograma",
    "ideograph",
    "japanese",
    "japanese “secret” button",
    "japones",
    "secret",
    "segredo",
    "simbolos",
    "“segredo”",
    "秘"
  ],
  "㊗️": [
    "3297",
    "alfabeto",
    "botao japones de “parabens”",
    "button",
    "congratulations",
    "ideografico",
    "ideografico circular “parabens”",
    "ideograma",
    "ideograph",
    "janones",
    "japanese",
    "japanese “congratulations” button",
    "japones",
    "parabens",
    "simbolos",
    "“parabens”",
    "祝"
  ],
  "🈴": [
    "1f234",
    "alfabeto",
    "botao japones de “nota minima”",
    "button",
    "chines",
    "grade",
    "ideografico",
    "ideografico quadrado “juntos”",
    "ideograma",
    "ideograph",
    "japanese",
    "japanese “passing grade” button",
    "japones",
    "juntos",
    "passing",
    "simbolos",
    "“nota minima”",
    "合"
  ],
  "🈵": [
    "1f235",
    "alfabeto",
    "botao japones de “sem vagas”",
    "button",
    "completude",
    "ideografico",
    "ideografico quadrado “completude”",
    "ideograma",
    "ideograph",
    "japanese",
    "japanese “no vacancy” button",
    "japones",
    "no",
    "simbolos",
    "vacancy",
    "“sem vagas”",
    "満"
  ],
  "🈹": [
    "1f239",
    "alfabeto",
    "botao japones de “desconto”",
    "button",
    "desconto",
    "discount",
    "ideografico",
    "ideograma",
    "ideograph",
    "japanese",
    "japanese “discount” button",
    "japones",
    "simbolos",
    "“desconto”",
    "割"
  ],
  "🈲": [
    "1f232",
    "alfabeto",
    "botao japones de “proibido”",
    "button",
    "ideografico",
    "ideografico quadrado “proibir”",
    "ideograma",
    "ideograph",
    "japanese",
    "japanese “prohibited” button",
    "japones",
    "prohibited",
    "proibido",
    "proibir",
    "simbolos",
    "“proibido”",
    "禁"
  ],
  "🅰️": [
    "1f170",
    "a",
    "a button (blood type)",
    "blood",
    "botao a (tipo sanguineo)",
    "button",
    "sangue",
    "simbolos",
    "tipo a",
    "tipo sanguineo",
    "tipo sanguineo a",
    "type"
  ],
  "🅱️": [
    "1f171",
    "b",
    "b button (blood type)",
    "blood",
    "botao b (tipo sanguineo)",
    "button",
    "sangue",
    "simbolos",
    "tipo b",
    "tipo sanguineo",
    "tipo sanguineo b",
    "type"
  ],
  "🆎": [
    "1f18e",
    "ab",
    "ab button (blood type)",
    "blood",
    "botao ab (tipo sanguineo)",
    "button",
    "sangue",
    "simbolos",
    "tipo ab",
    "tipo sanguineo",
    "tipo sanguineo ab",
    "type"
  ],
  "🆑": [
    "1f191",
    "botao cl",
    "button",
    "cl",
    "cl button",
    "limpar",
    "simbolo do cl",
    "simbolos"
  ],
  "🅾️": [
    "1f17e",
    "blood",
    "botao o (tipo sanguineo)",
    "button",
    "o",
    "o button (blood type)",
    "sangue",
    "simbolos",
    "tipo o",
    "tipo sanguineo",
    "tipo sanguineo o",
    "type"
  ],
  "🆘": [
    "1f198",
    "ajuda",
    "botao sos",
    "button",
    "help",
    "simbolo",
    "simbolo “sos”",
    "simbolos",
    "socorro",
    "sos",
    "sos button"
  ],
  "❌": [
    "274c",
    "cancel",
    "cancelar",
    "cross",
    "cross mark",
    "mark",
    "multiplicacao",
    "multiplicar",
    "multiplication",
    "multiply",
    "simbolos",
    "vermelho",
    "x",
    "xis",
    "×"
  ],
  "⭕️": [
    "2b55",
    "aro",
    "circle",
    "circulo",
    "circulo grande oco",
    "circulo vermelho vazio",
    "grande",
    "heavy",
    "hollow",
    "hollow red circle",
    "large",
    "o",
    "red",
    "simbolos",
    "vermelho"
  ],
  "🛑": [
    "1f6d1",
    "octagonal",
    "pare",
    "sign",
    "simbolos",
    "sinal",
    "sinal de pare",
    "stop",
    "stop sign"
  ],
  "⛔️": [
    "26d4",
    "do",
    "entrada",
    "entrada proibida",
    "entre",
    "entry",
    "fail",
    "forbidden",
    "nao",
    "no",
    "no entry",
    "not",
    "pass",
    "placa",
    "prohibited",
    "proibida",
    "proibido",
    "simbolos",
    "sinal",
    "traffic",
    "transito"
  ],
  "📛": [
    "1f4db",
    "badge",
    "cracha",
    "identificacao",
    "name",
    "name badge",
    "nome",
    "simbolos"
  ],
  "🚫": [
    "1f6ab",
    "entrada",
    "entry",
    "forbidden",
    "nao",
    "no",
    "not",
    "prohibited",
    "proibida",
    "proibido",
    "simbolo",
    "simbolos",
    "sinal",
    "smoke"
  ],
  "💯": [
    "100",
    "1f4af",
    "a+",
    "agree",
    "cem",
    "cem pontos",
    "certamente",
    "certeza",
    "clearly",
    "conte comigo",
    "definitely",
    "faithful",
    "fleek",
    "full",
    "hundred",
    "hundred points",
    "keep",
    "perfect",
    "point",
    "pontos",
    "score",
    "sem duvida",
    "simbolos",
    "top",
    "total",
    "true",
    "truth",
    "yup"
  ],
  "💢": [
    "1f4a2",
    "anger",
    "anger symbol",
    "angry",
    "com raiva",
    "comic",
    "emocao",
    "engracado",
    "mad",
    "raiva",
    "simbolo de raiva",
    "simbolos",
    "symbol",
    "upset"
  ],
  "♨️": [
    "2668",
    "calor",
    "chamas",
    "fogo",
    "fumaca",
    "hot",
    "hot springs",
    "hotsprings",
    "quente",
    "simbolos",
    "springs",
    "steaming"
  ],
  "🚷": [
    "1f6b7",
    "forbidden",
    "nao",
    "no",
    "no pedestrians",
    "not",
    "passagem",
    "pedestre",
    "pedestrian",
    "pedestrians",
    "permitidos",
    "prohibited",
    "proibida",
    "proibida a passagem de pedestres",
    "proibido",
    "simbolos"
  ],
  "🚯": [
    "1f6af",
    "forbidden",
    "jogar",
    "litter",
    "littering",
    "lixo",
    "nao",
    "nao jogue lixo no chao",
    "no",
    "no littering",
    "not",
    "prohibited",
    "proibido",
    "proibido jogar lixo no chao",
    "simbolo",
    "simbolos"
  ],
  "🚳": [
    "1f6b3",
    "bicicleta",
    "bicycle",
    "bicycles",
    "bike",
    "forbidden",
    "nao",
    "no",
    "no bicycles",
    "not",
    "permitidas",
    "prohibited",
    "proibido",
    "proibido andar de bicicleta",
    "sem",
    "simbolos"
  ],
  "🚱": [
    "1f6b1",
    "agua",
    "agua nao potavel",
    "consumo",
    "dry",
    "impropria",
    "nao",
    "non-drinking",
    "non-potable",
    "non-potable water",
    "potavel",
    "prohibited",
    "proibido",
    "seco",
    "sem",
    "simbolos",
    "water"
  ],
  "🔞": [
    "18",
    "1f51e",
    "age",
    "anos",
    "dezoito",
    "eighteen",
    "forbidden",
    "idade",
    "menor",
    "menores",
    "no",
    "no one under eighteen",
    "not",
    "one",
    "prohibited",
    "proibido",
    "proibido para menores de 18 anos",
    "restricao",
    "restriction",
    "simbolos",
    "underage"
  ],
  "📵": [
    "1f4f5",
    "cel",
    "cell",
    "celular",
    "forbidden",
    "mobile",
    "nao",
    "no",
    "no mobile phones",
    "not",
    "permitidos",
    "phone",
    "phones",
    "prohibited",
    "proibido",
    "proibido o uso de telefone celular",
    "sem",
    "simbolos",
    "smartphone",
    "telefone",
    "telephone"
  ],
  "🚭": [
    "1f6ad",
    "cigarro",
    "forbidden",
    "fumar",
    "nao e permitido fumar",
    "no",
    "no smoking",
    "not",
    "prohibited",
    "proibido",
    "proibido fumar",
    "simbolo",
    "simbolos",
    "smoke",
    "smoking"
  ],
  "❗️": [
    "!",
    "2757",
    "exclamacao",
    "exclamation",
    "mark",
    "ponto de exclamacao",
    "ponto de exclamacao vermelho",
    "pontuacao",
    "punctuation",
    "red",
    "red exclamation mark",
    "simbolos"
  ],
  "❕": [
    "!",
    "2755",
    "delineado",
    "exclamacao",
    "exclamation",
    "mark",
    "outlined",
    "ponto",
    "ponto de exclamacao branco",
    "pontuacao",
    "punctuation",
    "simbolos",
    "sinal",
    "white",
    "white exclamation mark"
  ],
  "❓": [
    "2753",
    "?",
    "interrogacao",
    "mark",
    "pergunta",
    "ponto",
    "ponto de interrogacao",
    "ponto de interrogacao vermelho",
    "pontuacao",
    "punctuation",
    "question",
    "red",
    "red question mark",
    "simbolos",
    "sinal"
  ],
  "❔": [
    "2754",
    "?",
    "delineado",
    "interrogacao",
    "mark",
    "outlined",
    "pergunta",
    "ponto de interrogacao branco",
    "pontuacao",
    "punctuation",
    "question",
    "simbolos",
    "sinal",
    "white",
    "white question mark"
  ],
  "‼️": [
    "!",
    "!!",
    "203c",
    "bangbang",
    "double",
    "double exclamation mark",
    "dupla exclamacao",
    "exclamacao",
    "exclamacao dupla",
    "exclamation",
    "explosao",
    "mark",
    "ponto de exclamacao duplo",
    "pontuacao",
    "punctuation",
    "simbolos"
  ],
  "⁉️": [
    "!",
    "!?",
    "2049",
    "?",
    "exclamacao",
    "exclamacao com interrogacao",
    "exclamation",
    "exclamation question mark",
    "interrobang",
    "interrogacao",
    "mark",
    "pergunta",
    "pontuacao",
    "punctuation",
    "question",
    "simbolos",
    "sinal"
  ],
  "🔅": [
    "1f505",
    "botao de diminuir brilho",
    "brightness",
    "brilho",
    "button",
    "dim",
    "dim button",
    "diminuir",
    "escurecer",
    "low",
    "simbolo para reduzir brilho",
    "simbolos"
  ],
  "🔆": [
    "1f506",
    "aumentar brilho",
    "botao de aumentar brilho",
    "bright",
    "bright button",
    "brightness",
    "brilho",
    "button",
    "light",
    "simbolo para aumentar brilho",
    "simbolos"
  ],
  "〽️": [
    "303d",
    "alternation",
    "canto",
    "japones",
    "mark",
    "part",
    "part alternation mark",
    "simbolo japones de canto",
    "simbolos",
    "sinal japones indicando inicio de musica"
  ],
  "⚠️": [
    "26a0",
    "atencao",
    "aviso",
    "caution",
    "cuidado",
    "simbolos",
    "sinal",
    "warning"
  ],
  "🚸": [
    "1f6b8",
    "atravessando",
    "child",
    "children",
    "children crossing",
    "crianca",
    "criancas",
    "criancas atravessando",
    "crossing",
    "pedestre",
    "pedestrian",
    "simbolo",
    "simbolos",
    "trafego",
    "traffic"
  ],
  "🔱": [
    "1f531",
    "anchor",
    "ancora",
    "emblem",
    "emblema",
    "emblema de tridente",
    "ferramenta",
    "navio",
    "poseidon",
    "ship",
    "simbolo de tridente",
    "simbolos",
    "tool",
    "trident",
    "trident emblem",
    "tridente"
  ],
  "⚜️": [
    "269c",
    "cavaleiros",
    "fleur-de-lis",
    "flor-de-lis",
    "knights",
    "simbolo",
    "simbolos"
  ],
  "🔰": [
    "1f530",
    "beginner",
    "chevron",
    "folha verde e amarela",
    "green",
    "iniciante",
    "japanese",
    "japanese symbol for beginner",
    "japones",
    "leaf",
    "simbolo japones de principiante",
    "simbolo japones para iniciante",
    "simbolos",
    "symbol",
    "tool",
    "verde e amarela",
    "verde e amarelo",
    "yellow"
  ],
  "♻️": [
    "267b",
    "reciclagem",
    "reclicar",
    "recycle",
    "recycling",
    "recycling symbol",
    "simbolo de reciclagem",
    "simbolo de reciclagem solido universal",
    "simbolos",
    "sinal",
    "symbol"
  ],
  "✅": [
    "2705",
    "botao",
    "button",
    "check",
    "check mark button",
    "checked",
    "checkmark",
    "complete",
    "completed",
    "completo",
    "done",
    "feito",
    "fixed",
    "marca",
    "marca de selecao branca",
    "marca de verificacao",
    "marca de verificacao grande",
    "mark",
    "simbolos",
    "tick",
    "verificacao",
    "verificado",
    "✓"
  ],
  "🈯️": [
    "1f22f",
    "alfabeto",
    "botao japones de “reservado”",
    "button",
    "ideografico",
    "ideograma",
    "ideograph",
    "japanese",
    "japanese “reserved” button",
    "japones",
    "reservado",
    "reserved",
    "simbolos",
    "“reservado”",
    "指"
  ],
  "💹": [
    "1f4b9",
    "ascendente",
    "ascensao",
    "bank",
    "chart",
    "chart increasing with yen",
    "crescimento",
    "currency",
    "dinheiro",
    "grafico",
    "grafico subindo com iene",
    "graph",
    "growth",
    "iene",
    "iene em alta",
    "increasing",
    "market",
    "mercado",
    "money",
    "rise",
    "simbolos",
    "trend",
    "upward",
    "yen"
  ],
  "❇️": [
    "*",
    "2747",
    "cruz",
    "faisca",
    "simbolos",
    "sparkle"
  ],
  "✳️": [
    "*",
    "2733",
    "asterisco",
    "asterisco de oito pontas",
    "asterisk",
    "eight-spoked",
    "eight-spoked asterisk",
    "estrela",
    "simbolos"
  ],
  "❎": [
    "274e",
    "botao com x",
    "botao de caixa com x",
    "botao de xis",
    "button",
    "cross",
    "cross mark button",
    "marcado",
    "mark",
    "multiplicar",
    "multiplication",
    "multiply",
    "quadrado",
    "simbolos",
    "square",
    "x",
    "x em um quadrado verde",
    "x verde",
    "×"
  ],
  "🌐": [
    "1f310",
    "earth",
    "globe",
    "globe with meridians",
    "globo com meridianos",
    "internet",
    "meridianos",
    "meridians",
    "simbolos",
    "web",
    "world",
    "worldwide"
  ],
  "💠": [
    "1f4a0",
    "comic",
    "comico",
    "dentro",
    "diamante",
    "diamante com ponto",
    "diamante com um ponto",
    "diamond",
    "diamond with a dot",
    "dot",
    "formato de diamante",
    "geometric",
    "geometrico",
    "simbolos"
  ],
  "Ⓜ️": [
    "24c2",
    "circle",
    "circled",
    "circled m",
    "circulo",
    "circulo com a letra m",
    "letra m",
    "m",
    "simbolos"
  ],
  "🌀": [
    "1f300",
    "ciclone",
    "clima",
    "cyclone",
    "dizzy",
    "espiral",
    "furacao",
    "hurricane",
    "simbolos",
    "tonto",
    "twister",
    "typhoon",
    "weather",
    "zonzo"
  ],
  "💤": [
    "1f4a4",
    "boa noite",
    "cansada",
    "cansado",
    "com sono",
    "comic",
    "dormindo",
    "dormir",
    "emocao",
    "engracado",
    "good",
    "goodnight",
    "night",
    "roncando",
    "simbolos",
    "sleep",
    "sleeping",
    "sleepy",
    "sono",
    "tired",
    "zzz"
  ],
  "🏧": [
    "1f3e7",
    "atm",
    "atm sign",
    "automated",
    "automatico",
    "banco",
    "bank",
    "caixa",
    "cash",
    "dinheiro",
    "eletronico",
    "grana",
    "money",
    "saque",
    "sign",
    "simbolo",
    "simbolo de caixa automatico",
    "simbolos",
    "teller"
  ],
  "🚾": [
    "1f6be",
    "bathroom",
    "closet",
    "latrina",
    "lavabo",
    "lavatory",
    "privada",
    "restroom",
    "simbolos",
    "toalete",
    "toilet",
    "vaso sanitario",
    "water",
    "water closet",
    "wc"
  ],
  "♿️": [
    "267f",
    "access",
    "acesso",
    "cadeira",
    "handicap",
    "rodas",
    "simbolo",
    "simbolo de cadeira de rodas",
    "simbolos",
    "sinal",
    "symbol",
    "wheelchair",
    "wheelchair symbol"
  ],
  "🅿️": [
    "1f17f",
    "botao p",
    "button",
    "estacionamento",
    "estacionar",
    "garagem de carros",
    "p",
    "p button",
    "parking",
    "simbolos"
  ],
  "🛗": [
    "1f6d7",
    "accessibility",
    "acessibilidade",
    "descer",
    "elevador",
    "elevar",
    "elevator",
    "hoist",
    "lift",
    "simbolos",
    "subir"
  ],
  "🈳": [
    "1f233",
    "alfabeto",
    "botao japones de “vago”",
    "button",
    "ideografico",
    "ideograma",
    "ideograph",
    "japanese",
    "japanese “vacancy” button",
    "japones",
    "simbolos",
    "vacancy",
    "vaga",
    "vago",
    "vazio",
    "“vago”",
    "空"
  ],
  "🈂️": [
    "1f202",
    "alfabeto",
    "botao japones de “taxa de servico”",
    "button",
    "charge",
    "japanese",
    "japanese “service charge” button",
    "japones",
    "katakana",
    "katanaka",
    "sa",
    "service",
    "simbolos",
    "taxa de servico",
    "“taxa de servico”",
    "サ"
  ],
  "🛂": [
    "1f6c2",
    "control",
    "controle",
    "controle de passaportes",
    "passaporte",
    "passport",
    "passport control",
    "simbolos"
  ],
  "🛃": [
    "1f6c3",
    "aduana",
    "aduaneira",
    "alfandega",
    "bens",
    "customs",
    "federal",
    "impostos",
    "packing",
    "receita",
    "simbolos"
  ],
  "🛄": [
    "1f6c4",
    "aeroporto",
    "area",
    "arrived",
    "bagagem",
    "bagagens",
    "baggage",
    "baggage claim",
    "bags",
    "case",
    "checked",
    "claim",
    "esteira",
    "ferias",
    "journey",
    "mala",
    "packing",
    "plane",
    "ready",
    "recolhimento",
    "restituicao",
    "restituicao de bagagem",
    "simbolos",
    "travel",
    "trip",
    "viagem"
  ],
  "🛅": [
    "1f6c5",
    "bagagem",
    "baggage",
    "case",
    "deposito",
    "deposito de bagagem",
    "esquecida",
    "left",
    "left luggage",
    "locker",
    "luggage",
    "malas",
    "servico",
    "simbolos"
  ],
  "🛜": [
    "1f6dc",
    "banda larga",
    "broadband",
    "computador",
    "computer",
    "conectividade",
    "connectivity",
    "hotspot",
    "internet",
    "network",
    "ponto de acesso",
    "rede",
    "roteador",
    "router",
    "sem fio",
    "simbolos",
    "smartphone",
    "wi-fi",
    "wifi",
    "wireless",
    "wlan"
  ],
  "🚹": [
    "1f6b9",
    "banheiro",
    "banheiro masculino",
    "bathroom",
    "homem",
    "lavatorio",
    "lavatory",
    "man",
    "masculino",
    "men’s",
    "men’s room",
    "restroom",
    "room",
    "simbolo",
    "simbolos",
    "toalete",
    "toilet",
    "wc"
  ],
  "🚺": [
    "1f6ba",
    "banheiro",
    "banheiro feminino",
    "bathroom",
    "feminino",
    "lavabo",
    "lavatorio",
    "lavatory",
    "mulher",
    "restroom",
    "room",
    "simbolo",
    "simbolos",
    "toalete",
    "toilet",
    "wc",
    "woman",
    "women’s",
    "women’s room"
  ],
  "🚼": [
    "1f6bc",
    "baby",
    "baby symbol",
    "bebe",
    "changing",
    "fralda",
    "fraldario",
    "simbolo",
    "simbolo de bebe",
    "simbolos",
    "symbol",
    "trocar"
  ],
  "🧑‍🧑‍🧒": [
    "1f9d1-200d-1f9d1-200d-1f9d2",
    "adult",
    "adulto",
    "child",
    "crianca",
    "familia",
    "familia: adulto, adulto, crianca",
    "family",
    "family: adult, adult, child",
    "simbolos"
  ],
  "🧑‍🧑‍🧒‍🧒": [
    "1f9d1-200d-1f9d1-200d-1f9d2-200d-1f9d2",
    "adult",
    "adulto",
    "adultos",
    "child",
    "crianca",
    "criancas",
    "familia",
    "familia: adulto, adulto, crianca, crianca",
    "family",
    "family: adult, adult, child, child",
    "filha",
    "filho",
    "simbolos"
  ],
  "🧑‍🧒": [
    "1f9d1-200d-1f9d2",
    "adult",
    "adulto",
    "child",
    "crianca",
    "familia",
    "familia: adulto, crianca",
    "family",
    "family: adult, child",
    "simbolos"
  ],
  "🧑‍🧒‍🧒": [
    "1f9d1-200d-1f9d2-200d-1f9d2",
    "adult",
    "adulto",
    "child",
    "criancas",
    "familia",
    "familia: adulto, crianca, crianca",
    "family",
    "family: adult, child, child",
    "simbolos"
  ],
  "⚧️": [
    "26a7",
    "simbolo transgenero",
    "simbolos",
    "symbol",
    "transgender",
    "transgender symbol",
    "transgenero"
  ],
  "🚻": [
    "1f6bb",
    "banheiro",
    "bathroom",
    "lavabo",
    "lavatory",
    "restroom",
    "sanitario",
    "simbolo",
    "simbolos",
    "toalete",
    "toilet",
    "wc"
  ],
  "🚮": [
    "1f6ae",
    "bin",
    "coloque o lixo no lixo",
    "lata",
    "litter",
    "litter in bin sign",
    "litterbin",
    "lixeira",
    "lixo",
    "sign",
    "simbolo",
    "simbolo de lixeira",
    "simbolos"
  ],
  "🎦": [
    "1f3a6",
    "camera",
    "cinema",
    "entretenimento",
    "film",
    "filme",
    "movie",
    "simbolo do cinema",
    "simbolos"
  ],
  "📶": [
    "1f4f6",
    "antena",
    "antena com barras",
    "antenna",
    "antenna bars",
    "bar",
    "barras de sinal",
    "bars",
    "cell",
    "celular",
    "communication",
    "conexao",
    "forca do sinal",
    "internet",
    "mobile",
    "phone",
    "signal",
    "simbolos",
    "sinais de telefonia movel",
    "telefone",
    "telephone"
  ],
  "🈁": [
    "\"aqui\"",
    "1f201",
    "alfabeto",
    "botao \"aqui\"",
    "botao japones de “aqui”",
    "button",
    "here",
    "japanese",
    "japanese “here” button",
    "japones",
    "katakana",
    "koko",
    "simbolos",
    "“aqui”",
    "ココ"
  ],
  "🔣": [
    "%",
    "&",
    "1f523",
    "digitacao",
    "input",
    "input symbols",
    "inserir simbolos",
    "simbolos",
    "symbols",
    "♪",
    "〒",
    "〒♪&%"
  ],
  "ℹ️": [
    "2139",
    "i",
    "informacao",
    "informacoes",
    "information",
    "simbolo",
    "simbolo de informacoes",
    "simbolos"
  ],
  "🔤": [
    "1f524",
    "abc",
    "alfabeto",
    "alphabet",
    "digitacao",
    "ingles",
    "input",
    "input latin letters",
    "inserir alfabeto latino",
    "latin",
    "latinas",
    "latino",
    "letras",
    "letras latinas",
    "letters",
    "simbolos"
  ],
  "🔡": [
    "1f521",
    "abcd",
    "caracteres latinos minusculos",
    "digitacao",
    "input",
    "input latin lowercase",
    "latin",
    "latinas",
    "latino",
    "letras",
    "letras latinas minusculas",
    "letters",
    "lowercase",
    "minusculas",
    "minusculos",
    "simbolos"
  ],
  "🔠": [
    "1f520",
    "abcd",
    "caracteres latinos maiusculos",
    "digitacao",
    "input",
    "input latin uppercase",
    "inserir caracteres latinos maiusculos",
    "latin",
    "latinas",
    "letras",
    "letras latinas maiusculas",
    "letters",
    "maiusculas",
    "maiusculos",
    "simbolos",
    "uppercase"
  ],
  "🆖": [
    "1f196",
    "botao ng",
    "button",
    "ng",
    "ng button",
    "simbolo",
    "simbolo “ng”",
    "simbolos"
  ],
  "🆗": [
    "1f197",
    "botao ok",
    "button",
    "ok",
    "ok button",
    "okay",
    "sim",
    "simbolo “ok”",
    "simbolos"
  ],
  "🆙": [
    "1f199",
    "botao \"up!\"",
    "button",
    "mark",
    "para cima",
    "simbolo",
    "simbolo “up!”",
    "simbolos",
    "up",
    "up!",
    "up! button"
  ],
  "🆒": [
    "1f192",
    "botao \"cool\"",
    "botao cool",
    "button",
    "cool",
    "cool button",
    "legal",
    "simbolo “cool”",
    "simbolos"
  ],
  "🆕": [
    "1f195",
    "botao \"new\"",
    "button",
    "new",
    "new button",
    "novo",
    "simbolo",
    "simbolos"
  ],
  "🆓": [
    "1f193",
    "botao \"free\"",
    "button",
    "free",
    "free button",
    "gratis",
    "gratuito",
    "simbolo",
    "simbolo “free”",
    "simbolos"
  ],
  "0️⃣": [
    "0",
    "30-20e3",
    "keycap",
    "keycap: 0",
    "simbolos",
    "tecla",
    "tecla: 0",
    "zero"
  ],
  "1️⃣": [
    "1",
    "31-20e3",
    "keycap",
    "keycap: 1",
    "one",
    "simbolos",
    "tecla",
    "tecla: 1",
    "um"
  ],
  "2️⃣": [
    "2",
    "32-20e3",
    "dois",
    "keycap",
    "keycap: 2",
    "simbolos",
    "tecla",
    "tecla: 2",
    "two"
  ],
  "3️⃣": [
    "3",
    "33-20e3",
    "keycap",
    "keycap: 3",
    "simbolos",
    "tecla",
    "tecla: 3",
    "three",
    "tres"
  ],
  "4️⃣": [
    "34-20e3",
    "4",
    "four",
    "keycap",
    "keycap: 4",
    "quatro",
    "simbolos",
    "tecla",
    "tecla: 4"
  ],
  "5️⃣": [
    "35-20e3",
    "5",
    "cinco",
    "five",
    "keycap",
    "keycap: 5",
    "simbolos",
    "tecla",
    "tecla: 5"
  ],
  "6️⃣": [
    "36-20e3",
    "6",
    "keycap",
    "keycap: 6",
    "seis",
    "simbolos",
    "six",
    "tecla",
    "tecla: 6"
  ],
  "7️⃣": [
    "37-20e3",
    "7",
    "keycap",
    "keycap: 7",
    "sete",
    "seven",
    "simbolos",
    "tecla",
    "tecla: 7"
  ],
  "8️⃣": [
    "38-20e3",
    "8",
    "eight",
    "keycap",
    "keycap: 8",
    "oito",
    "simbolos",
    "tecla",
    "tecla: 8"
  ],
  "9️⃣": [
    "39-20e3",
    "9",
    "keycap",
    "keycap: 9",
    "nine",
    "nove",
    "simbolos",
    "tecla",
    "tecla: 9"
  ],
  "🔟": [
    "1f51f",
    "keycap",
    "keycap: 10",
    "simbolos",
    "tecla",
    "tecla: 10"
  ],
  "🔢": [
    "1234",
    "1f522",
    "digitacao",
    "input",
    "input numbers",
    "inserir numeros",
    "numbers",
    "numeros",
    "simbolos"
  ],
  "#️⃣": [
    "23-20e3",
    "keycap",
    "keycap: #",
    "simbolos",
    "tecla",
    "tecla: #"
  ],
  "*️⃣": [
    "2a-20e3",
    "keycap",
    "keycap: *",
    "simbolos",
    "tecla",
    "tecla: *"
  ],
  "⏏️": [
    "23cf",
    "botao ejetar",
    "button",
    "eject",
    "eject button",
    "ejetar",
    "simbolos"
  ],
  "▶️": [
    "25b6",
    "arrow",
    "botao reproduzir",
    "button",
    "direita",
    "play",
    "play button",
    "reproduzir",
    "right",
    "seta",
    "seta para a direita",
    "simbolos",
    "triangle",
    "triangulo"
  ],
  "⏸️": [
    "23f8",
    "bar",
    "barra",
    "botao pausar",
    "button",
    "double",
    "dupla",
    "pausado",
    "pausar",
    "pause",
    "pause button",
    "simbolos",
    "vertical"
  ],
  "⏯️": [
    "23ef",
    "arrow",
    "botao",
    "botao de reproduzir ou pausar",
    "button",
    "direita",
    "pausar",
    "pause",
    "play",
    "play or pause button",
    "reproduzir",
    "reproduzir ou pausar",
    "right",
    "seta",
    "seta para a direita",
    "simbolos",
    "triangle",
    "triangulo"
  ],
  "⏹️": [
    "23f9",
    "botao parar",
    "button",
    "parar",
    "quadrado",
    "simbolos",
    "square",
    "stop",
    "stop button"
  ],
  "⏺️": [
    "23fa",
    "botao",
    "botao gravar",
    "button",
    "circle",
    "circulo",
    "gravar",
    "record",
    "record button",
    "simbolos"
  ],
  "⏭️": [
    "23ed",
    "arrow",
    "avancar",
    "botao de proxima faixa",
    "button",
    "flechas duplas",
    "next",
    "next track button",
    "passar para frente",
    "proxima cena",
    "proxima faixa",
    "scene",
    "seta",
    "seta dupla para a direita",
    "simbolos",
    "track",
    "triangle"
  ],
  "⏮️": [
    "23ee",
    "anterior",
    "arrow",
    "botao de faixa anterior",
    "button",
    "cena anterior",
    "faixa anterior",
    "flechas para esquerda",
    "last",
    "last track button",
    "previous",
    "scene",
    "seta",
    "seta dupla para a esquerda",
    "setas para a esquerda",
    "simbolos",
    "track",
    "triangle",
    "triangulo",
    "ultima faixa",
    "voltar"
  ],
  "⏩️": [
    "23e9",
    "arrow",
    "avancar",
    "botao avancar",
    "button",
    "direita",
    "double",
    "dupla",
    "fast",
    "fast-forward",
    "fast-forward button",
    "flechas",
    "forward",
    "passar para a frente",
    "rapido",
    "seta",
    "seta dupla para a direita",
    "simbolos"
  ],
  "⏪️": [
    "23ea",
    "arrow",
    "botao de retroceder",
    "button",
    "double",
    "dupla",
    "esquerda",
    "fast",
    "fast reverse button",
    "retroceder",
    "reverse",
    "rewind",
    "seta",
    "seta dupla para a esquerda",
    "seta dupla para tras",
    "simbolos",
    "voltar"
  ],
  "⏫️": [
    "23eb",
    "arrow",
    "botao de avanco para cima",
    "button",
    "double",
    "dupla",
    "fast",
    "fast up button",
    "flechas para cima",
    "para cima",
    "seta",
    "seta dupla para cima",
    "simbolos",
    "up"
  ],
  "⏬️": [
    "23ec",
    "arrow",
    "botao de avanco para baixo",
    "button",
    "double",
    "down",
    "fast",
    "fast down button",
    "flechas",
    "flechas para baixo",
    "para baixo",
    "retroceder rapido",
    "seta",
    "seta dupla para baixo",
    "simbolos"
  ],
  "◀️": [
    "25c0",
    "arrow",
    "botao de voltar",
    "button",
    "esquerda",
    "left",
    "reverse",
    "reverse button",
    "seta",
    "seta para a esquerda",
    "simbolos",
    "triangle",
    "triangulo",
    "voltar"
  ],
  "🔼": [
    "1f53c",
    "acima",
    "arrow",
    "botao",
    "botao apontando para cima",
    "botao de triangulo apontando para cima",
    "button",
    "para cima",
    "red",
    "seta",
    "simbolos",
    "triangulo",
    "triangulo apontando para cima",
    "up",
    "upwards",
    "upwards button",
    "vermelho"
  ],
  "🔽": [
    "1f53d",
    "arrow",
    "botao",
    "botao apontando para baixo",
    "botao de triangulo apontando para baixo",
    "button",
    "down",
    "downwards",
    "downwards button",
    "para baixo",
    "red",
    "seta",
    "simbolos",
    "triangulo",
    "triangulo apontando para baixo",
    "vermelho"
  ],
  "➡️": [
    "27a1",
    "arrow",
    "cardinal",
    "direcao",
    "direction",
    "direita",
    "east",
    "flecha",
    "leste",
    "right",
    "right arrow",
    "seta",
    "seta para a direita",
    "simbolos"
  ],
  "⬅️": [
    "2b05",
    "arrow",
    "atras",
    "cardinal",
    "direcao",
    "direction",
    "esquerda",
    "flecha",
    "left",
    "left arrow",
    "oeste",
    "seta",
    "seta para a esquerda",
    "simbolos",
    "voltar",
    "west"
  ],
  "⬆️": [
    "2b06",
    "arrow",
    "cardinal",
    "direcao",
    "direction",
    "norte",
    "north",
    "seta",
    "seta para cima",
    "simbolos",
    "up",
    "up arrow"
  ],
  "⬇️": [
    "2b07",
    "abaixo",
    "arrow",
    "baixo",
    "cardinal",
    "direcao",
    "direction",
    "down",
    "down arrow",
    "embaixo",
    "flecha",
    "seta",
    "seta para baixo",
    "simbolos",
    "south",
    "sul"
  ],
  "↗️": [
    "2197",
    "arrow",
    "diagonal",
    "direcao",
    "direction",
    "direita",
    "flecha",
    "intercardinal",
    "nordeste",
    "northeast",
    "seta",
    "seta para cima e para a direita",
    "simbolos",
    "superior",
    "up-right",
    "up-right arrow"
  ],
  "↘️": [
    "2198",
    "arrow",
    "diagonal",
    "direcao",
    "direction",
    "direita",
    "down-right",
    "down-right arrow",
    "flecha",
    "inferior",
    "intercardinal",
    "seta",
    "seta para baixo e para a direita",
    "simbolos",
    "southeast",
    "sudeste"
  ],
  "↙️": [
    "2199",
    "arrow",
    "diagonal",
    "direcao",
    "direction",
    "down-left",
    "down-left arrow",
    "esquerda",
    "flecha",
    "inferior",
    "intercardinal",
    "seta",
    "seta para baixo e para a esquerda",
    "simbolos",
    "southwest",
    "sudoeste"
  ],
  "↖️": [
    "2196",
    "arrow",
    "diagonal superior esquerda",
    "direcao",
    "direction",
    "flecha",
    "intercardinal",
    "noroeste",
    "northwest",
    "seta",
    "seta para cima e para a esquerda",
    "seta para esquerda superior",
    "simbolos",
    "up-left",
    "up-left arrow"
  ],
  "↕️": [
    "2195",
    "arrow",
    "flecha",
    "para baixo",
    "para cima",
    "seta",
    "seta para cima e para baixo",
    "simbolos",
    "up-down",
    "up-down arrow",
    "vertical"
  ],
  "↔️": [
    "2194",
    "arrow",
    "flecha",
    "horizontal",
    "lados",
    "left-right",
    "left-right arrow",
    "seta",
    "seta para esquerda e direita",
    "simbolos"
  ],
  "↪️": [
    "21aa",
    "arrow",
    "curva",
    "curving",
    "flecha",
    "left",
    "left arrow curving right",
    "retorno",
    "right",
    "seta",
    "seta curva da esquerda para a direita",
    "seta curva da esquerda para direita",
    "simbolos",
    "voltar a direita"
  ],
  "↩️": [
    "21a9",
    "arrow",
    "curva",
    "curving",
    "flecha",
    "left",
    "retorno",
    "right",
    "right arrow curving left",
    "seta",
    "seta curva da direita para a esquerda",
    "seta curva da direita para esquerda",
    "simbolos",
    "voltar a esquerda"
  ],
  "⤴️": [
    "2934",
    "arrow",
    "curva",
    "curving",
    "flecha",
    "right",
    "right arrow curving up",
    "seta",
    "seta curva de baixo para cima",
    "seta para a direita curvada para cima",
    "seta para cima",
    "simbolos",
    "up"
  ],
  "⤵️": [
    "2935",
    "arrow",
    "curva",
    "curving",
    "down",
    "embaixo",
    "flecha",
    "right",
    "right arrow curving down",
    "seta curva de cima para baixo",
    "seta para a direita curvada para baixo",
    "seta para baixo",
    "simbolos"
  ],
  "🔀": [
    "1f500",
    "arrow",
    "botao de musicas aleatorias",
    "button",
    "crossed",
    "cruzadas",
    "flechas",
    "seta",
    "setas",
    "setas cruzadas em direcao a direita",
    "shuffle",
    "shuffle tracks button",
    "simbolos",
    "tracks"
  ],
  "🔁": [
    "1f501",
    "arrow",
    "botao de repetir",
    "button",
    "clockwise",
    "flechas",
    "horario",
    "repeat",
    "repeat button",
    "repetir",
    "sentido horario",
    "seta",
    "setas",
    "setas em sentido horario",
    "simbolos"
  ],
  "🔂": [
    "1f502",
    "arrow",
    "botao de repetir",
    "botao de repetir uma unica faixa",
    "button",
    "clockwise",
    "horario",
    "numero 1",
    "once",
    "repeat",
    "repeat single button",
    "repetir",
    "repetir uma vez",
    "sentido horario",
    "seta",
    "setas",
    "setas em sentido horario com numero 1",
    "simbolos",
    "single",
    "uma vez"
  ],
  "🔄": [
    "1f504",
    "again",
    "anti-horario",
    "anticlockwise",
    "arrow",
    "arrows",
    "atualizar",
    "botao de setas em sentido anti-horario",
    "botao de setas no sentido anti-horario",
    "button",
    "counterclockwise",
    "counterclockwise arrows button",
    "deja",
    "refresh",
    "rewindershins",
    "sentido anti-horario",
    "seta",
    "setas",
    "setas em sentido anti-horario",
    "simbolos",
    "vu"
  ],
  "🔃": [
    "1f503",
    "arrow",
    "arrows",
    "clockwise",
    "clockwise vertical arrows",
    "flechas",
    "recarregar",
    "refresh",
    "reload",
    "sentido horario",
    "seta",
    "setas",
    "setas em sentido horario na vertical",
    "setas verticais no sentido horario",
    "simbolo de recarregar",
    "simbolos",
    "vertical"
  ],
  "🎵": [
    "1f3b5",
    "music",
    "musica",
    "musical",
    "musical note",
    "nota",
    "nota musical",
    "note",
    "simbolos",
    "sound"
  ],
  "🎶": [
    "1f3b6",
    "music",
    "musica",
    "musical",
    "musical notes",
    "nota",
    "notas",
    "notas musicais",
    "note",
    "notes",
    "simbolos",
    "sound"
  ],
  "➕": [
    "+",
    "2795",
    "cruz",
    "mais",
    "matematica",
    "plus",
    "simbolo de adicao",
    "simbolos",
    "sinal",
    "sinal de maior",
    "sinal de mais",
    "somar"
  ],
  "➖": [
    "-",
    "2796",
    "diminuir",
    "heavy",
    "matematica",
    "math",
    "menos",
    "minus",
    "sign",
    "simbolo de subtracao",
    "simbolos",
    "sinal",
    "sinal de menos",
    "travessao",
    "−"
  ],
  "➗": [
    "2797",
    "divide",
    "dividir",
    "divisao",
    "division",
    "heavy",
    "matematica",
    "math",
    "sign",
    "simbolo de divisao",
    "simbolos",
    "sinal",
    "sinal de divisao",
    "sinal de divisao grande",
    "÷"
  ],
  "✖️": [
    "2716",
    "cancel",
    "cancelar",
    "multiplicacao",
    "multiplicar",
    "multiplication",
    "multiply",
    "sign",
    "simbolos",
    "sinal de multiplicacao",
    "x",
    "x de multiplicacao",
    "x preto",
    "×"
  ],
  "🟰": [
    "1f7f0",
    "answer",
    "conta",
    "equal",
    "equality",
    "equals",
    "heavy",
    "heavy equals sign",
    "iguais",
    "igual",
    "igualdade",
    "matematica",
    "math",
    "resposta",
    "resultado",
    "sign",
    "simbolos",
    "sinal de igual"
  ],
  "♾️": [
    "267e",
    "eternidade",
    "forever",
    "ilimitado",
    "infinito",
    "infinity",
    "simbolos",
    "unbounded",
    "universal"
  ],
  "💲": [
    "1f4b2",
    "billion",
    "cash",
    "charge",
    "cifrao",
    "currency",
    "dinheiro",
    "dolar",
    "dollar",
    "grana",
    "heavy",
    "heavy dollar sign",
    "million",
    "moeda",
    "money",
    "pay",
    "sign",
    "simbolo do dolar",
    "simbolo do dolar em negrito",
    "simbolos"
  ],
  "💱": [
    "1f4b1",
    "banco",
    "bank",
    "cambio",
    "cambio de moeda",
    "currency",
    "currency exchange",
    "dinheiro",
    "exchange",
    "moeda",
    "money",
    "simbolos"
  ],
  "™️": [
    "2122",
    "marca registrada",
    "marca registrada “tm”",
    "mark",
    "simbolo",
    "simbolo de marca registrada",
    "simbolos",
    "tm",
    "trade",
    "trade mark",
    "trademark"
  ],
  "©️": [
    "a9",
    "c",
    "copyright",
    "direitos autorais",
    "simbolo de copyright",
    "simbolos"
  ],
  "®️": [
    "ae",
    "marca registrada",
    "marca registrada “r”",
    "r",
    "registered",
    "simbolo de registrado",
    "simbolos"
  ],
  "👁️‍🗨️": [
    "1f441-200d-1f5e8",
    "balao de dialogo",
    "balloon",
    "bubble",
    "eye",
    "eye in speech bubble",
    "olho",
    "olho no balao de dialogo",
    "simbolos",
    "speech",
    "testemunha",
    "witness"
  ],
  "🔚": [
    "1f51a",
    "arrow",
    "end",
    "end arrow",
    "fim",
    "fim com seta para a esquerda",
    "final",
    "seta",
    "seta \"end\"",
    "seta para a esquerda",
    "seta para ir para o fim",
    "simbolos"
  ],
  "🔙": [
    "1f519",
    "arrow",
    "back",
    "back arrow",
    "flecha",
    "seta",
    "seta \"back\"",
    "seta para a esquerda",
    "seta para voltar",
    "simbolos",
    "voltar",
    "voltar com seta para a esquerda"
  ],
  "🔛": [
    "1f51b",
    "arrow",
    "flecha",
    "marca",
    "mark",
    "on",
    "on!",
    "on! arrow",
    "seta",
    "seta \"on!\"",
    "seta “on”",
    "simbolos"
  ],
  "🔝": [
    "1f51d",
    "arrow",
    "cima",
    "homie",
    "para cima",
    "seta",
    "seta \"top",
    "seta \"top\"",
    "seta para cima",
    "simbolo top",
    "simbolos",
    "top",
    "top arrow",
    "top com seta para cima",
    "up"
  ],
  "🔜": [
    "1f51c",
    "arrow",
    "brb",
    "em breve",
    "flecha",
    "omw",
    "seta",
    "seta \"soon\"",
    "simbolo “soon”",
    "simbolos",
    "soon",
    "soon arrow",
    "“soon” com seta para a direita"
  ],
  "〰️": [
    "3030",
    "dash",
    "onda",
    "ondulado",
    "pontuacao",
    "punctuation",
    "simbolos",
    "travessao",
    "travessao ondulado",
    "wavy",
    "wavy dash"
  ],
  "➰": [
    "27b0",
    "curl",
    "curly",
    "curly loop",
    "laco encaracolado",
    "loop",
    "onda",
    "ondulado",
    "simbolos",
    "volta"
  ],
  "➿": [
    "27bf",
    "curl",
    "curly",
    "double",
    "double curly loop",
    "duas vezes",
    "duplo",
    "encaradolado",
    "loop",
    "loop encaracolado duas vezes",
    "onda",
    "ondulado",
    "simbolos"
  ],
  "✔️": [
    "2714",
    "check",
    "check mark",
    "checked",
    "checkmark",
    "done",
    "feito",
    "heavy",
    "marca",
    "marca de selecao",
    "marca de verificacao simples",
    "marcar",
    "mark",
    "selecionar",
    "simbolos",
    "tick",
    "verificacao",
    "✓"
  ],
  "☑️": [
    "2611",
    "ballot",
    "box",
    "caixa",
    "caixa de selecao marcada com tique",
    "check",
    "check box with check",
    "checked",
    "done",
    "feito",
    "marca de verificacao",
    "marca de verificacao cinza",
    "off",
    "simbolos",
    "tick",
    "verificacao",
    "✓"
  ],
  "🔘": [
    "1f518",
    "botao",
    "botao de opcao",
    "button",
    "geometric",
    "geometrico",
    "radio",
    "radio button",
    "simbolos"
  ],
  "🔴": [
    "1f534",
    "bola vermelha",
    "circle",
    "circulo",
    "circulo vermelho",
    "circulo vermelho grande",
    "geometric",
    "geometrico",
    "red",
    "red circle",
    "simbolos",
    "vermelho"
  ],
  "🟠": [
    "1f7e0",
    "circle",
    "circulo",
    "circulo laranja",
    "laranja",
    "orange",
    "orange circle",
    "simbolos"
  ],
  "🟡": [
    "1f7e1",
    "amarelo",
    "circle",
    "circulo",
    "circulo amarelo",
    "simbolos",
    "yellow",
    "yellow circle"
  ],
  "🟢": [
    "1f7e2",
    "circle",
    "circulo",
    "circulo verde",
    "green",
    "green circle",
    "simbolos",
    "verde"
  ],
  "🔵": [
    "1f535",
    "azul",
    "blue",
    "blue circle",
    "bolinha azul",
    "circle",
    "circulo",
    "circulo azul",
    "circulo azul grande",
    "geometric",
    "geometrico",
    "simbolos"
  ],
  "🟣": [
    "1f7e3",
    "circle",
    "circulo",
    "circulo roxo",
    "purple",
    "purple circle",
    "roxo",
    "simbolos"
  ],
  "⚫️": [
    "26ab",
    "black",
    "black circle",
    "circle",
    "circulo",
    "circulo preto",
    "geometric",
    "geometrico",
    "preto",
    "simbolos"
  ],
  "⚪️": [
    "26aa",
    "branco",
    "circle",
    "circulo",
    "circulo branco",
    "geometric",
    "geometrico",
    "simbolos",
    "white",
    "white circle"
  ],
  "🟤": [
    "1f7e4",
    "brown",
    "brown circle",
    "circle",
    "circulo",
    "circulo marrom",
    "marrom",
    "simbolos"
  ],
  "🔺": [
    "1f53a",
    "geometric",
    "geometrico",
    "pointed",
    "red",
    "red triangle pointed up",
    "simbolos",
    "triangle",
    "triangulo",
    "triangulo vermelho apontando para cima",
    "triangulo vermelho para cima",
    "up",
    "vermelho"
  ],
  "🔻": [
    "1f53b",
    "down",
    "geometric",
    "geometrico",
    "pointed",
    "red",
    "red triangle pointed down",
    "simbolos",
    "triangle",
    "triangulo",
    "triangulo vermelho apontando para baixo",
    "triangulo vermelho para baixo",
    "vermelho"
  ],
  "🔸": [
    "1f538",
    "cor de laranja",
    "diamante",
    "diamante cor de laranja pequeno",
    "diamante laranja pequeno",
    "diamond",
    "geometric",
    "geometrico",
    "laranja",
    "losango",
    "losango laranja pequeno",
    "orange",
    "simbolos",
    "small",
    "small orange diamond"
  ],
  "🔹": [
    "1f539",
    "azul",
    "blue",
    "diamante",
    "diamante azul pequeno",
    "diamond",
    "geometric",
    "geometrico",
    "losango",
    "losango azul pequeno",
    "simbolos",
    "small",
    "small blue diamond"
  ],
  "🔶": [
    "1f536",
    "cor de laranja",
    "diamante",
    "diamante cor de laranja grande",
    "diamante laranja grande",
    "diamond",
    "geometric",
    "geometrico",
    "laranja",
    "large",
    "large orange diamond",
    "losango",
    "losango laranja grande",
    "orange",
    "simbolos"
  ],
  "🔷": [
    "1f537",
    "azul",
    "balao",
    "blue",
    "diamante",
    "diamante azul grande",
    "diamond",
    "geometric",
    "geometrico",
    "large",
    "large blue diamond",
    "losango",
    "losango azul grande",
    "simbolos"
  ],
  "🔳": [
    "1f533",
    "botao",
    "botao quadrado branco",
    "botao quadrado branco e preto",
    "button",
    "geometric",
    "outlined",
    "quadrado",
    "simbolos",
    "square",
    "white",
    "white square button"
  ],
  "🔲": [
    "1f532",
    "black",
    "black square button",
    "botao",
    "botao quadrado preto",
    "botao quadrado preto e branco",
    "button",
    "geometric",
    "geometrico",
    "quadrado",
    "simbolos",
    "square"
  ],
  "▪️": [
    "25aa",
    "black",
    "black small square",
    "geometric",
    "geometrico",
    "pequeno",
    "preto",
    "quadrado",
    "quadrado preto pequeno",
    "simbolos",
    "small",
    "square"
  ],
  "▫️": [
    "25ab",
    "branco",
    "geometric",
    "geometrico",
    "pequeno",
    "quadrado",
    "quadrado branco pequeno",
    "simbolos",
    "small",
    "square",
    "white",
    "white small square"
  ],
  "◾️": [
    "25fe",
    "black",
    "black medium-small square",
    "geometric",
    "geometrico",
    "medium-small",
    "preto",
    "quadrado",
    "quadrado preto medio menor",
    "simbolos",
    "square"
  ],
  "◽️": [
    "25fd",
    "branco",
    "geometric",
    "geometrico",
    "medium-small",
    "quadrado",
    "quadrado branco medio menor",
    "simbolos",
    "square",
    "white",
    "white medium-small square"
  ],
  "◼️": [
    "25fc",
    "black",
    "black medium square",
    "geometric",
    "geometrico",
    "medium",
    "quadrado",
    "quadrado preto medio",
    "simbolos",
    "square"
  ],
  "◻️": [
    "25fb",
    "geometric",
    "geometrico",
    "medium",
    "quadrado",
    "quadrado branco medio",
    "simbolos",
    "square",
    "white",
    "white medium square"
  ],
  "🟥": [
    "1f7e5",
    "card",
    "penalty",
    "quadrado",
    "quadrado vermelho",
    "red",
    "red square",
    "simbolos",
    "square",
    "vermelho"
  ],
  "🟧": [
    "1f7e7",
    "laranja",
    "orange",
    "orange square",
    "quadrado",
    "quadrado laranja",
    "simbolos",
    "square"
  ],
  "🟨": [
    "1f7e8",
    "amarelo",
    "card",
    "penalty",
    "quadrado",
    "quadrado amarelo",
    "simbolos",
    "square",
    "yellow",
    "yellow square"
  ],
  "🟩": [
    "1f7e9",
    "green",
    "green square",
    "quadrado",
    "quadrado verde",
    "simbolos",
    "square",
    "verde"
  ],
  "🟦": [
    "1f7e6",
    "anil",
    "azul",
    "blue",
    "blue square",
    "quadrado",
    "quadrado azul",
    "simbolos",
    "square"
  ],
  "🟪": [
    "1f7ea",
    "purple",
    "purple square",
    "purpura",
    "quadrado",
    "quadrado roxo",
    "roxo",
    "simbolos",
    "square"
  ],
  "⬛️": [
    "2b1b",
    "black",
    "black large square",
    "geometric",
    "geometrico",
    "large",
    "preto",
    "quadrado",
    "quadrado preto grande",
    "simbolos",
    "square"
  ],
  "⬜️": [
    "2b1c",
    "geometric",
    "geometrico",
    "large",
    "quadrado",
    "quadrado branco grande",
    "simbolos",
    "square",
    "white",
    "white large square"
  ],
  "🟫": [
    "1f7eb",
    "brown",
    "brown square",
    "marrom",
    "quadrado",
    "quadrado marrom",
    "simbolos",
    "square"
  ],
  "🔈": [
    "1f508",
    "alto-falante",
    "alto-falante com volume baixo",
    "baixo",
    "low",
    "mudo",
    "musica",
    "silencio",
    "simbolos",
    "soft",
    "som",
    "sound",
    "speaker",
    "speaker low volume",
    "volume"
  ],
  "🔇": [
    "1f507",
    "alto-falante",
    "alto-falante silenciado",
    "calar",
    "mudo",
    "mute",
    "muted",
    "muted speaker",
    "quiet",
    "quieto",
    "silenciar",
    "silencio",
    "silent",
    "simbolos",
    "som",
    "sound",
    "speaker"
  ],
  "🔉": [
    "1f509",
    "alto-falante",
    "alto-falante com volume medio",
    "baixo",
    "diminuir",
    "medio",
    "medium",
    "simbolos",
    "som",
    "sound",
    "speaker",
    "speaker medium volume",
    "volume"
  ],
  "🔊": [
    "1f50a",
    "alto",
    "alto-falante",
    "alto-falante com volume alto",
    "gritar",
    "high",
    "loud",
    "music",
    "musica",
    "simbolos",
    "som",
    "sound",
    "speaker",
    "speaker high volume",
    "volume"
  ],
  "🔔": [
    "1f514",
    "bell",
    "break",
    "capela",
    "church",
    "simbolos",
    "sino",
    "sound"
  ],
  "🔕": [
    "1f515",
    "bell",
    "bell with slash",
    "forbidden",
    "mudo",
    "mute",
    "no",
    "not",
    "notificacao",
    "prohibited",
    "proibido",
    "quiet",
    "quieto",
    "sem som",
    "silencio",
    "silencioso",
    "silent",
    "simbolos",
    "sino",
    "sino silenciado",
    "slash",
    "sound"
  ],
  "📣": [
    "1f4e3",
    "aplausos",
    "cheering",
    "comunicacao",
    "megafone",
    "megaphone",
    "simbolos",
    "sound"
  ],
  "📢": [
    "1f4e2",
    "address",
    "alto",
    "alto-falante",
    "aviso",
    "buzina",
    "communication",
    "comunicado",
    "discurso",
    "gritar",
    "loud",
    "loudspeaker",
    "megafone",
    "public",
    "simbolos",
    "sound"
  ],
  "💬": [
    "1f4ac",
    "balao",
    "balao de conversa",
    "balao de dialogo",
    "balloon",
    "bubble",
    "comic",
    "dialog",
    "dialogo",
    "engracado",
    "message",
    "simbolos",
    "sms",
    "speech",
    "speech balloon",
    "talk",
    "text",
    "typing"
  ],
  "💭": [
    "1f4ad",
    "balao",
    "balao de pensamento",
    "balloon",
    "bubble",
    "cartoon",
    "cloud",
    "comic",
    "daydream",
    "decisions",
    "dream",
    "engracado",
    "idea",
    "ideia",
    "invencao",
    "invent",
    "inventando",
    "invention",
    "pensamento",
    "pensando",
    "realize",
    "simbolos",
    "think",
    "thought balloon",
    "thoughts",
    "wonder"
  ],
  "🗯️": [
    "1f5ef",
    "anger",
    "angry",
    "balao",
    "balao de raiva a direita",
    "balloon",
    "briga",
    "bubble",
    "conversa",
    "dialogo",
    "direita",
    "discurso",
    "discussao",
    "energico",
    "furioso",
    "irado",
    "mad",
    "raiva",
    "right",
    "right anger bubble",
    "simbolos"
  ],
  "♠️": [
    "2660",
    "baralho",
    "card",
    "carta",
    "espadas",
    "game",
    "jogo",
    "naipe",
    "naipe de espadas",
    "simbolos",
    "spade",
    "spade suit",
    "suit"
  ],
  "♣️": [
    "2663",
    "baralho",
    "card",
    "carta",
    "club",
    "club suit",
    "clubs",
    "game",
    "jogo",
    "naipe",
    "naipe de paus",
    "paus",
    "simbolos",
    "suit"
  ],
  "♥️": [
    "2665",
    "baralho",
    "card",
    "carta",
    "copas",
    "emotion",
    "game",
    "heart",
    "heart suit",
    "hearts",
    "jogo",
    "naipe",
    "naipe de copas",
    "s2",
    "simbolos",
    "suit"
  ],
  "♦️": [
    "2666",
    "baralho",
    "card",
    "carta",
    "diamond",
    "diamond suit",
    "game",
    "jogo",
    "naipe",
    "naipe de ouros",
    "ouro",
    "simbolos",
    "suit"
  ],
  "🃏": [
    "1f0cf",
    "baralho",
    "card",
    "carta",
    "coringa",
    "curinga",
    "game",
    "jogo",
    "joker",
    "simbolos",
    "wildcard"
  ],
  "🎴": [
    "1f3b4",
    "baralho",
    "card",
    "cards",
    "carta de baralho",
    "carta de flores",
    "flores",
    "flower",
    "flower playing cards",
    "game",
    "hanafuda",
    "japanese",
    "jogo de baralho",
    "playing",
    "simbolos"
  ],
  "🀄️": [
    "1f004",
    "dragao",
    "dragao vermelho de mahjong",
    "dragon",
    "game",
    "jogo",
    "mahjong",
    "mahjong red dragon",
    "peca",
    "red",
    "simbolos",
    "vermelho"
  ],
  "🕐": [
    "1",
    "1 hora",
    "13h",
    "1:00",
    "1f550",
    "1h",
    "1h00",
    "clock",
    "one",
    "one o’clock",
    "o’clock",
    "relogio",
    "simbolos",
    "time",
    "uma"
  ],
  "🕑": [
    "14h",
    "1f551",
    "2",
    "2 horas",
    "2:00",
    "2h",
    "2h00",
    "clock",
    "duas",
    "o’clock",
    "relogio",
    "simbolos",
    "time",
    "two",
    "two o’clock"
  ],
  "🕒": [
    "15h",
    "1f552",
    "3",
    "3 horas",
    "3:00",
    "3h00",
    "clock",
    "hora",
    "horario",
    "o’clock",
    "relogio",
    "simbolos",
    "three",
    "three o’clock",
    "time",
    "tres"
  ],
  "🕓": [
    "1f553",
    "4",
    "4 horas",
    "4:00",
    "4h00",
    "clock",
    "four",
    "four o’clock",
    "horario",
    "o’clock",
    "quatro",
    "relogio",
    "simbolos",
    "time"
  ],
  "🕔": [
    "1f554",
    "5",
    "5 horas",
    "5:00",
    "5h00",
    "cinco",
    "clock",
    "five",
    "five o’clock",
    "o’clock",
    "relogio",
    "simbolos",
    "time"
  ],
  "🕕": [
    "18h",
    "1f555",
    "6",
    "6 horas",
    "6:00",
    "6h00",
    "clock",
    "o’clock",
    "relogio",
    "seis",
    "simbolos",
    "six",
    "six o’clock",
    "time"
  ],
  "🕖": [
    "0",
    "19h",
    "1f556",
    "7",
    "7 horas",
    "7:00",
    "7h00",
    "clock",
    "o’clock",
    "relogio",
    "sete",
    "seven",
    "seven o’clock",
    "simbolos"
  ],
  "🕗": [
    "1f557",
    "8",
    "8 horas",
    "8:00",
    "8h00",
    "clock",
    "eight",
    "eight o’clock",
    "hora",
    "oito",
    "o’clock",
    "relogio",
    "simbolos",
    "time"
  ],
  "🕘": [
    "1f558",
    "21h",
    "9",
    "9 horas",
    "9:00",
    "9h00",
    "clock",
    "nine",
    "nine o’clock",
    "nove",
    "o’clock",
    "relogio",
    "simbolos",
    "time"
  ],
  "🕙": [
    "0",
    "10",
    "10 horas",
    "10:00",
    "10h00",
    "1f559",
    "22h",
    "clock",
    "dez",
    "o’clock",
    "relogio",
    "simbolos",
    "ten",
    "ten o’clock"
  ],
  "🕚": [
    "11",
    "11 horas",
    "11:00",
    "11h00",
    "1f55a",
    "clock",
    "eleven",
    "eleven o’clock",
    "onze",
    "o’clock",
    "relogio",
    "simbolos",
    "time"
  ],
  "🕛": [
    "12",
    "12 horas",
    "12:00",
    "12h00",
    "1f55b",
    "clock",
    "doze",
    "meia-noite",
    "meio-dia",
    "o’clock",
    "relogio",
    "simbolos",
    "time",
    "twelve",
    "twelve o’clock"
  ],
  "🕜": [
    "1",
    "13:30",
    "13h30",
    "1:30",
    "1f55c",
    "1h30",
    "30",
    "clock",
    "one",
    "one-thirty",
    "relogio",
    "simbolos",
    "thirty",
    "time",
    "uma e meia"
  ],
  "🕝": [
    "1f55d",
    "2",
    "2:30",
    "2h30",
    "30",
    "clock",
    "duas e meia",
    "relogio",
    "simbolos",
    "thirty",
    "time",
    "two",
    "two-thirty"
  ],
  "🕞": [
    "1f55e",
    "3",
    "30",
    "3:30",
    "3h30",
    "clock",
    "relogio",
    "simbolos",
    "thirty",
    "three",
    "three-thirty",
    "time",
    "tres e meia"
  ],
  "🕟": [
    "1f55f",
    "30",
    "4",
    "4:30",
    "4h30",
    "clock",
    "four",
    "four-thirty",
    "quatro e meia",
    "relogio",
    "simbolos",
    "thirty",
    "time"
  ],
  "🕠": [
    "17h30",
    "1f560",
    "30",
    "5",
    "5:30",
    "5h30",
    "cinco e meia",
    "clock",
    "five",
    "five-thirty",
    "relogio",
    "simbolos",
    "thirty",
    "time"
  ],
  "🕡": [
    "18h30",
    "1f561",
    "30",
    "6",
    "6:30",
    "6h30",
    "clock",
    "relogio",
    "seis e meia",
    "simbolos",
    "six",
    "six-thirty",
    "thirty"
  ],
  "🕢": [
    "1f562",
    "30",
    "7",
    "7:30",
    "7h30",
    "clock",
    "relogio",
    "sete e meia",
    "seven",
    "seven-thirty",
    "simbolos",
    "thirty"
  ],
  "🕣": [
    "1f563",
    "30",
    "8",
    "8:30",
    "8h30",
    "clock",
    "eight",
    "eight-thirty",
    "oito e meia",
    "relogio",
    "simbolos",
    "thirty",
    "time"
  ],
  "🕤": [
    "1f564",
    "30",
    "9",
    "9:30",
    "9h30",
    "clock",
    "hora",
    "nine",
    "nine-thirty",
    "nove e meia",
    "relogio",
    "simbolos",
    "thirty",
    "time"
  ],
  "🕥": [
    "10",
    "10:30",
    "10h30",
    "1f565",
    "22h30",
    "30",
    "clock",
    "dez e meia",
    "relogio",
    "simbolos",
    "ten",
    "ten-thirty",
    "thirty",
    "time"
  ],
  "🕦": [
    "11",
    "11:30",
    "11h30",
    "1f566",
    "23h30",
    "30",
    "clock",
    "eleven",
    "eleven-thirty",
    "onze e meia",
    "relogio",
    "simbolos",
    "thirty",
    "time"
  ],
  "🕧": [
    "12",
    "12:30",
    "12h30",
    "1f567",
    "30",
    "clock",
    "doze e meia",
    "relogio",
    "simbolos",
    "thirty",
    "time",
    "twelve",
    "twelve-thirty"
  ],
  "🏳️": [
    "1f3f3",
    "bandeira",
    "bandeira branca",
    "bandeiras",
    "branca",
    "flag",
    "paz",
    "tremulando",
    "waving",
    "white",
    "white flag"
  ],
  "🏴": [
    "1f3f4",
    "bandeira",
    "bandeira preta",
    "bandeiras",
    "black",
    "black flag",
    "flag",
    "preta",
    "tremulando",
    "waving"
  ],
  "🏴‍☠️": [
    "1f3f4-200d-2620",
    "bandeira",
    "bandeira de pirata",
    "bandeiras",
    "caveira",
    "flag",
    "jolly",
    "osso",
    "pirata",
    "pirate",
    "pirate flag",
    "plunder",
    "roger",
    "saque",
    "tesouro",
    "treasure"
  ],
  "🏁": [
    "1f3c1",
    "bandeira",
    "bandeira quadriculada",
    "bandeiras",
    "checkered",
    "chegada",
    "chequered",
    "chequered flag",
    "corrida",
    "esporte",
    "finish",
    "flag",
    "flags",
    "game",
    "quadriculada",
    "race",
    "racing",
    "sport",
    "vitoria",
    "win"
  ],
  "🚩": [
    "1f6a9",
    "bandeira",
    "bandeira triangular",
    "bandeiras",
    "construction",
    "flag",
    "golf",
    "informacoes",
    "localizacao",
    "post",
    "poste",
    "triangular",
    "triangular flag",
    "vermelha",
    "vermelho"
  ],
  "🏳️‍🌈": [
    "1f3f3-200d-1f308",
    "arco-iris",
    "bandeira",
    "bandeira do arco-iris",
    "bandeiras",
    "bisexual",
    "bissexual",
    "flag",
    "gay",
    "genderqueer",
    "glbt",
    "glbtq",
    "lesbian",
    "lesbica",
    "lgbt",
    "lgbtq",
    "lgbtqia",
    "orgulho",
    "pride",
    "queer",
    "rainbow",
    "rainbow flag",
    "trans",
    "transexual",
    "transgender",
    "transgenero",
    "travesti"
  ],
  "🏳️‍⚧️": [
    "1f3f3-200d-26a7",
    "azul claro",
    "bandeira",
    "bandeira transgenero",
    "bandeiras",
    "blue",
    "branco",
    "flag",
    "light",
    "pink",
    "rosa",
    "transgender",
    "transgender flag",
    "transgenero",
    "white"
  ],
  "🇺🇳": [
    "1f1fa-1f1f3",
    "bandeira",
    "bandeira: nacoes unidas",
    "bandeiras",
    "flag",
    "flag: united nations"
  ],
  "🇦🇫": [
    "1f1e6-1f1eb",
    "bandeira",
    "bandeira: afeganistao",
    "bandeiras",
    "flag",
    "flag: afghanistan"
  ],
  "🇦🇽": [
    "1f1e6-1f1fd",
    "bandeira",
    "bandeira: ilhas aland",
    "bandeiras",
    "flag",
    "flag: aland islands"
  ],
  "🇦🇱": [
    "1f1e6-1f1f1",
    "bandeira",
    "bandeira: albania",
    "bandeiras",
    "flag",
    "flag: albania"
  ],
  "🇩🇿": [
    "1f1e9-1f1ff",
    "bandeira",
    "bandeira: argelia",
    "bandeiras",
    "flag",
    "flag: algeria"
  ],
  "🇦🇸": [
    "1f1e6-1f1f8",
    "bandeira",
    "bandeira: samoa americana",
    "bandeiras",
    "flag",
    "flag: american samoa"
  ],
  "🇦🇩": [
    "1f1e6-1f1e9",
    "bandeira",
    "bandeira: andorra",
    "bandeiras",
    "flag",
    "flag: andorra"
  ],
  "🇦🇴": [
    "1f1e6-1f1f4",
    "bandeira",
    "bandeira: angola",
    "bandeiras",
    "flag",
    "flag: angola"
  ],
  "🇦🇮": [
    "1f1e6-1f1ee",
    "bandeira",
    "bandeira: anguila",
    "bandeiras",
    "flag",
    "flag: anguilla"
  ],
  "🇦🇶": [
    "1f1e6-1f1f6",
    "bandeira",
    "bandeira: antartida",
    "bandeiras",
    "flag",
    "flag: antarctica"
  ],
  "🇦🇬": [
    "1f1e6-1f1ec",
    "bandeira",
    "bandeira: antigua e barbuda",
    "bandeiras",
    "flag",
    "flag: antigua & barbuda"
  ],
  "🇦🇷": [
    "1f1e6-1f1f7",
    "bandeira",
    "bandeira: argentina",
    "bandeiras",
    "flag",
    "flag: argentina"
  ],
  "🇦🇲": [
    "1f1e6-1f1f2",
    "bandeira",
    "bandeira: armenia",
    "bandeiras",
    "flag",
    "flag: armenia"
  ],
  "🇦🇼": [
    "1f1e6-1f1fc",
    "bandeira",
    "bandeira: aruba",
    "bandeiras",
    "flag",
    "flag: aruba"
  ],
  "🇦🇺": [
    "1f1e6-1f1fa",
    "bandeira",
    "bandeira: australia",
    "bandeiras",
    "flag",
    "flag: australia"
  ],
  "🇦🇹": [
    "1f1e6-1f1f9",
    "bandeira",
    "bandeira: austria",
    "bandeiras",
    "flag",
    "flag: austria"
  ],
  "🇦🇿": [
    "1f1e6-1f1ff",
    "bandeira",
    "bandeira: azerbaijao",
    "bandeiras",
    "flag",
    "flag: azerbaijan"
  ],
  "🇧🇸": [
    "1f1e7-1f1f8",
    "bandeira",
    "bandeira: bahamas",
    "bandeiras",
    "flag",
    "flag: bahamas"
  ],
  "🇧🇭": [
    "1f1e7-1f1ed",
    "bandeira",
    "bandeira: barein",
    "bandeiras",
    "flag",
    "flag: bahrain"
  ],
  "🇧🇩": [
    "1f1e7-1f1e9",
    "bandeira",
    "bandeira: bangladesh",
    "bandeiras",
    "flag",
    "flag: bangladesh"
  ],
  "🇧🇧": [
    "1f1e7-1f1e7",
    "bandeira",
    "bandeira: barbados",
    "bandeiras",
    "flag",
    "flag: barbados"
  ],
  "🇧🇾": [
    "1f1e7-1f1fe",
    "bandeira",
    "bandeira: bielorrussia",
    "bandeiras",
    "flag",
    "flag: belarus"
  ],
  "🇧🇪": [
    "1f1e7-1f1ea",
    "bandeira",
    "bandeira: belgica",
    "bandeiras",
    "flag",
    "flag: belgium"
  ],
  "🇧🇿": [
    "1f1e7-1f1ff",
    "bandeira",
    "bandeira: belize",
    "bandeiras",
    "flag",
    "flag: belize"
  ],
  "🇧🇯": [
    "1f1e7-1f1ef",
    "bandeira",
    "bandeira: benin",
    "bandeiras",
    "flag",
    "flag: benin"
  ],
  "🇧🇲": [
    "1f1e7-1f1f2",
    "bandeira",
    "bandeira: bermudas",
    "bandeiras",
    "flag",
    "flag: bermuda"
  ],
  "🇧🇹": [
    "1f1e7-1f1f9",
    "bandeira",
    "bandeira: butao",
    "bandeiras",
    "flag",
    "flag: bhutan"
  ],
  "🇧🇴": [
    "1f1e7-1f1f4",
    "bandeira",
    "bandeira: bolivia",
    "bandeiras",
    "flag",
    "flag: bolivia"
  ],
  "🇧🇦": [
    "1f1e7-1f1e6",
    "bandeira",
    "bandeira: bosnia e herzegovina",
    "bandeiras",
    "flag",
    "flag: bosnia & herzegovina"
  ],
  "🇧🇼": [
    "1f1e7-1f1fc",
    "bandeira",
    "bandeira: botsuana",
    "bandeiras",
    "flag",
    "flag: botswana"
  ],
  "🇧🇷": [
    "1f1e7-1f1f7",
    "bandeira",
    "bandeira: brasil",
    "bandeiras",
    "flag",
    "flag: brazil"
  ],
  "🇻🇬": [
    "1f1fb-1f1ec",
    "bandeira",
    "bandeira: ilhas virgens britanicas",
    "bandeiras",
    "flag",
    "flag: british virgin islands"
  ],
  "🇧🇳": [
    "1f1e7-1f1f3",
    "bandeira",
    "bandeira: brunei",
    "bandeiras",
    "flag",
    "flag: brunei"
  ],
  "🇧🇬": [
    "1f1e7-1f1ec",
    "bandeira",
    "bandeira: bulgaria",
    "bandeiras",
    "flag",
    "flag: bulgaria"
  ],
  "🇧🇫": [
    "1f1e7-1f1eb",
    "bandeira",
    "bandeira: burquina faso",
    "bandeiras",
    "flag",
    "flag: burkina faso"
  ],
  "🇧🇮": [
    "1f1e7-1f1ee",
    "bandeira",
    "bandeira: burundi",
    "bandeiras",
    "flag",
    "flag: burundi"
  ],
  "🇰🇭": [
    "1f1f0-1f1ed",
    "bandeira",
    "bandeira: camboja",
    "bandeiras",
    "flag",
    "flag: cambodia"
  ],
  "🇨🇲": [
    "1f1e8-1f1f2",
    "bandeira",
    "bandeira: camaroes",
    "bandeiras",
    "flag",
    "flag: cameroon"
  ],
  "🇨🇦": [
    "1f1e8-1f1e6",
    "bandeira",
    "bandeira: canada",
    "bandeiras",
    "flag",
    "flag: canada"
  ],
  "🇮🇨": [
    "1f1ee-1f1e8",
    "bandeira",
    "bandeira: ilhas canarias",
    "bandeiras",
    "flag",
    "flag: canary islands"
  ],
  "🇨🇻": [
    "1f1e8-1f1fb",
    "bandeira",
    "bandeira: cabo verde",
    "bandeiras",
    "flag",
    "flag: cape verde"
  ],
  "🇧🇶": [
    "1f1e7-1f1f6",
    "bandeira",
    "bandeira: paises baixos caribenhos",
    "bandeiras",
    "flag",
    "flag: caribbean netherlands"
  ],
  "🇰🇾": [
    "1f1f0-1f1fe",
    "bandeira",
    "bandeira: ilhas cayman",
    "bandeiras",
    "flag",
    "flag: cayman islands"
  ],
  "🇨🇫": [
    "1f1e8-1f1eb",
    "bandeira",
    "bandeira: republica centro-africana",
    "bandeiras",
    "flag",
    "flag: central african republic"
  ],
  "🇹🇩": [
    "1f1f9-1f1e9",
    "bandeira",
    "bandeira: chade",
    "bandeiras",
    "flag",
    "flag: chad"
  ],
  "🇮🇴": [
    "1f1ee-1f1f4",
    "bandeira",
    "bandeira: territorio britanico do oceano indico",
    "bandeiras",
    "flag",
    "flag: british indian ocean territory"
  ],
  "🇨🇱": [
    "1f1e8-1f1f1",
    "bandeira",
    "bandeira: chile",
    "bandeiras",
    "flag",
    "flag: chile"
  ],
  "🇨🇳": [
    "1f1e8-1f1f3",
    "bandeira",
    "bandeira: china",
    "bandeiras",
    "flag",
    "flag: china"
  ],
  "🇨🇽": [
    "1f1e8-1f1fd",
    "bandeira",
    "bandeira: ilha christmas",
    "bandeiras",
    "flag",
    "flag: christmas island"
  ],
  "🇨🇨": [
    "1f1e8-1f1e8",
    "bandeira",
    "bandeira: ilhas cocos (keeling)",
    "bandeiras",
    "flag",
    "flag: cocos (keeling) islands"
  ],
  "🇨🇴": [
    "1f1e8-1f1f4",
    "bandeira",
    "bandeira: colombia",
    "bandeiras",
    "flag",
    "flag: colombia"
  ],
  "🇰🇲": [
    "1f1f0-1f1f2",
    "bandeira",
    "bandeira: comores",
    "bandeiras",
    "flag",
    "flag: comoros"
  ],
  "🇨🇬": [
    "1f1e8-1f1ec",
    "bandeira",
    "bandeira: republica do congo",
    "bandeiras",
    "flag",
    "flag: congo - brazzaville"
  ],
  "🇨🇩": [
    "1f1e8-1f1e9",
    "bandeira",
    "bandeira: congo - kinshasa",
    "bandeiras",
    "flag",
    "flag: congo - kinshasa"
  ],
  "🇨🇰": [
    "1f1e8-1f1f0",
    "bandeira",
    "bandeira: ilhas cook",
    "bandeiras",
    "flag",
    "flag: cook islands"
  ],
  "🇨🇷": [
    "1f1e8-1f1f7",
    "bandeira",
    "bandeira: costa rica",
    "bandeiras",
    "flag",
    "flag: costa rica"
  ],
  "🇨🇮": [
    "1f1e8-1f1ee",
    "bandeira",
    "bandeira: costa do marfim",
    "bandeiras",
    "flag",
    "flag: cote d’ivoire"
  ],
  "🇭🇷": [
    "1f1ed-1f1f7",
    "bandeira",
    "bandeira: croacia",
    "bandeiras",
    "flag",
    "flag: croatia"
  ],
  "🇨🇺": [
    "1f1e8-1f1fa",
    "bandeira",
    "bandeira: cuba",
    "bandeiras",
    "flag",
    "flag: cuba"
  ],
  "🇨🇼": [
    "1f1e8-1f1fc",
    "bandeira",
    "bandeira: curacao",
    "bandeiras",
    "flag",
    "flag: curacao"
  ],
  "🇨🇾": [
    "1f1e8-1f1fe",
    "bandeira",
    "bandeira: chipre",
    "bandeiras",
    "flag",
    "flag: cyprus"
  ],
  "🇨🇿": [
    "1f1e8-1f1ff",
    "bandeira",
    "bandeira: tchequia",
    "bandeiras",
    "flag",
    "flag: czechia"
  ],
  "🇩🇰": [
    "1f1e9-1f1f0",
    "bandeira",
    "bandeira: dinamarca",
    "bandeiras",
    "flag",
    "flag: denmark"
  ],
  "🇩🇯": [
    "1f1e9-1f1ef",
    "bandeira",
    "bandeira: djibuti",
    "bandeiras",
    "flag",
    "flag: djibouti"
  ],
  "🇩🇲": [
    "1f1e9-1f1f2",
    "bandeira",
    "bandeira: dominica",
    "bandeiras",
    "flag",
    "flag: dominica"
  ],
  "🇩🇴": [
    "1f1e9-1f1f4",
    "bandeira",
    "bandeira: republica dominicana",
    "bandeiras",
    "flag",
    "flag: dominican republic"
  ],
  "🇪🇨": [
    "1f1ea-1f1e8",
    "bandeira",
    "bandeira: equador",
    "bandeiras",
    "flag",
    "flag: ecuador"
  ],
  "🇪🇬": [
    "1f1ea-1f1ec",
    "bandeira",
    "bandeira: egito",
    "bandeiras",
    "flag",
    "flag: egypt"
  ],
  "🇸🇻": [
    "1f1f8-1f1fb",
    "bandeira",
    "bandeira: el salvador",
    "bandeiras",
    "flag",
    "flag: el salvador"
  ],
  "🇬🇶": [
    "1f1ec-1f1f6",
    "bandeira",
    "bandeira: guine equatorial",
    "bandeiras",
    "flag",
    "flag: equatorial guinea"
  ],
  "🇪🇷": [
    "1f1ea-1f1f7",
    "bandeira",
    "bandeira: eritreia",
    "bandeiras",
    "flag",
    "flag: eritrea"
  ],
  "🇪🇪": [
    "1f1ea-1f1ea",
    "bandeira",
    "bandeira: estonia",
    "bandeiras",
    "flag",
    "flag: estonia"
  ],
  "🇸🇿": [
    "1f1f8-1f1ff",
    "bandeira",
    "bandeira: essuatini",
    "bandeiras",
    "flag",
    "flag: eswatini"
  ],
  "🇪🇹": [
    "1f1ea-1f1f9",
    "bandeira",
    "bandeira: etiopia",
    "bandeiras",
    "flag",
    "flag: ethiopia"
  ],
  "🇪🇺": [
    "1f1ea-1f1fa",
    "bandeira",
    "bandeira: uniao europeia",
    "bandeiras",
    "flag",
    "flag: european union"
  ],
  "🇫🇰": [
    "1f1eb-1f1f0",
    "bandeira",
    "bandeira: ilhas malvinas",
    "bandeiras",
    "flag",
    "flag: falkland islands"
  ],
  "🇫🇴": [
    "1f1eb-1f1f4",
    "bandeira",
    "bandeira: ilhas faroe",
    "bandeiras",
    "flag",
    "flag: faroe islands"
  ],
  "🇫🇯": [
    "1f1eb-1f1ef",
    "bandeira",
    "bandeira: fiji",
    "bandeiras",
    "flag",
    "flag: fiji"
  ],
  "🇫🇮": [
    "1f1eb-1f1ee",
    "bandeira",
    "bandeira: finlandia",
    "bandeiras",
    "flag",
    "flag: finland"
  ],
  "🇫🇷": [
    "1f1eb-1f1f7",
    "bandeira",
    "bandeira: franca",
    "bandeiras",
    "flag",
    "flag: france"
  ],
  "🇬🇫": [
    "1f1ec-1f1eb",
    "bandeira",
    "bandeira: guiana francesa",
    "bandeiras",
    "flag",
    "flag: french guiana"
  ],
  "🇵🇫": [
    "1f1f5-1f1eb",
    "bandeira",
    "bandeira: polinesia francesa",
    "bandeiras",
    "flag",
    "flag: french polynesia"
  ],
  "🇹🇫": [
    "1f1f9-1f1eb",
    "bandeira",
    "bandeira: territorios franceses do sul",
    "bandeiras",
    "flag",
    "flag: french southern territories"
  ],
  "🇬🇦": [
    "1f1ec-1f1e6",
    "bandeira",
    "bandeira: gabao",
    "bandeiras",
    "flag",
    "flag: gabon"
  ],
  "🇬🇲": [
    "1f1ec-1f1f2",
    "bandeira",
    "bandeira: gambia",
    "bandeiras",
    "flag",
    "flag: gambia"
  ],
  "🇬🇪": [
    "1f1ec-1f1ea",
    "bandeira",
    "bandeira: georgia",
    "bandeiras",
    "flag",
    "flag: georgia"
  ],
  "🇩🇪": [
    "1f1e9-1f1ea",
    "bandeira",
    "bandeira: alemanha",
    "bandeiras",
    "flag",
    "flag: germany"
  ],
  "🇬🇭": [
    "1f1ec-1f1ed",
    "bandeira",
    "bandeira: gana",
    "bandeiras",
    "flag",
    "flag: ghana"
  ],
  "🇬🇮": [
    "1f1ec-1f1ee",
    "bandeira",
    "bandeira: gibraltar",
    "bandeiras",
    "flag",
    "flag: gibraltar"
  ],
  "🇬🇷": [
    "1f1ec-1f1f7",
    "bandeira",
    "bandeira: grecia",
    "bandeiras",
    "flag",
    "flag: greece"
  ],
  "🇬🇱": [
    "1f1ec-1f1f1",
    "bandeira",
    "bandeira: groenlandia",
    "bandeiras",
    "flag",
    "flag: greenland"
  ],
  "🇬🇩": [
    "1f1ec-1f1e9",
    "bandeira",
    "bandeira: granada",
    "bandeiras",
    "flag",
    "flag: grenada"
  ],
  "🇬🇵": [
    "1f1ec-1f1f5",
    "bandeira",
    "bandeira: guadalupe",
    "bandeiras",
    "flag",
    "flag: guadeloupe"
  ],
  "🇬🇺": [
    "1f1ec-1f1fa",
    "bandeira",
    "bandeira: guam",
    "bandeiras",
    "flag",
    "flag: guam"
  ],
  "🇬🇹": [
    "1f1ec-1f1f9",
    "bandeira",
    "bandeira: guatemala",
    "bandeiras",
    "flag",
    "flag: guatemala"
  ],
  "🇬🇬": [
    "1f1ec-1f1ec",
    "bandeira",
    "bandeira: guernsey",
    "bandeiras",
    "flag",
    "flag: guernsey"
  ],
  "🇬🇳": [
    "1f1ec-1f1f3",
    "bandeira",
    "bandeira: guine",
    "bandeiras",
    "flag",
    "flag: guinea"
  ],
  "🇬🇼": [
    "1f1ec-1f1fc",
    "bandeira",
    "bandeira: guine-bissau",
    "bandeiras",
    "flag",
    "flag: guinea-bissau"
  ],
  "🇬🇾": [
    "1f1ec-1f1fe",
    "bandeira",
    "bandeira: guiana",
    "bandeiras",
    "flag",
    "flag: guyana"
  ],
  "🇭🇹": [
    "1f1ed-1f1f9",
    "bandeira",
    "bandeira: haiti",
    "bandeiras",
    "flag",
    "flag: haiti"
  ],
  "🇭🇳": [
    "1f1ed-1f1f3",
    "bandeira",
    "bandeira: honduras",
    "bandeiras",
    "flag",
    "flag: honduras"
  ],
  "🇭🇰": [
    "1f1ed-1f1f0",
    "bandeira",
    "bandeira: hong kong, rae da china",
    "bandeiras",
    "flag",
    "flag: hong kong sar china"
  ],
  "🇭🇺": [
    "1f1ed-1f1fa",
    "bandeira",
    "bandeira: hungria",
    "bandeiras",
    "flag",
    "flag: hungary"
  ],
  "🇮🇸": [
    "1f1ee-1f1f8",
    "bandeira",
    "bandeira: islandia",
    "bandeiras",
    "flag",
    "flag: iceland"
  ],
  "🇮🇳": [
    "1f1ee-1f1f3",
    "bandeira",
    "bandeira: india",
    "bandeiras",
    "flag",
    "flag: india"
  ],
  "🇮🇩": [
    "1f1ee-1f1e9",
    "bandeira",
    "bandeira: indonesia",
    "bandeiras",
    "flag",
    "flag: indonesia"
  ],
  "🇮🇷": [
    "1f1ee-1f1f7",
    "bandeira",
    "bandeira: ira",
    "bandeiras",
    "flag",
    "flag: iran"
  ],
  "🇮🇶": [
    "1f1ee-1f1f6",
    "bandeira",
    "bandeira: iraque",
    "bandeiras",
    "flag",
    "flag: iraq"
  ],
  "🇮🇪": [
    "1f1ee-1f1ea",
    "bandeira",
    "bandeira: irlanda",
    "bandeiras",
    "flag",
    "flag: ireland"
  ],
  "🇮🇲": [
    "1f1ee-1f1f2",
    "bandeira",
    "bandeira: ilha de man",
    "bandeiras",
    "flag",
    "flag: isle of man"
  ],
  "🇮🇱": [
    "1f1ee-1f1f1",
    "bandeira",
    "bandeira: israel",
    "bandeiras",
    "flag",
    "flag: israel"
  ],
  "🇮🇹": [
    "1f1ee-1f1f9",
    "bandeira",
    "bandeira: italia",
    "bandeiras",
    "flag",
    "flag: italy"
  ],
  "🇯🇲": [
    "1f1ef-1f1f2",
    "bandeira",
    "bandeira: jamaica",
    "bandeiras",
    "flag",
    "flag: jamaica"
  ],
  "🇯🇵": [
    "1f1ef-1f1f5",
    "bandeira",
    "bandeira: japao",
    "bandeiras",
    "flag",
    "flag: japan"
  ],
  "🎌": [
    "1f38c",
    "bandeira",
    "bandeiras",
    "bandeiras cruzadas",
    "celebration",
    "comemoracao",
    "cross",
    "crossed",
    "crossed flags",
    "cruzadas",
    "cruzar",
    "flags",
    "japanese",
    "japao",
    "japones"
  ],
  "🇯🇪": [
    "1f1ef-1f1ea",
    "bandeira",
    "bandeira: jersey",
    "bandeiras",
    "flag",
    "flag: jersey"
  ],
  "🇯🇴": [
    "1f1ef-1f1f4",
    "bandeira",
    "bandeira: jordania",
    "bandeiras",
    "flag",
    "flag: jordan"
  ],
  "🇰🇿": [
    "1f1f0-1f1ff",
    "bandeira",
    "bandeira: cazaquistao",
    "bandeiras",
    "flag",
    "flag: kazakhstan"
  ],
  "🇰🇪": [
    "1f1f0-1f1ea",
    "bandeira",
    "bandeira: quenia",
    "bandeiras",
    "flag",
    "flag: kenya"
  ],
  "🇰🇮": [
    "1f1f0-1f1ee",
    "bandeira",
    "bandeira: quiribati",
    "bandeiras",
    "flag",
    "flag: kiribati"
  ],
  "🇽🇰": [
    "1f1fd-1f1f0",
    "bandeira",
    "bandeira: kosovo",
    "bandeiras",
    "flag",
    "flag: kosovo"
  ],
  "🇰🇼": [
    "1f1f0-1f1fc",
    "bandeira",
    "bandeira: kuwait",
    "bandeiras",
    "flag",
    "flag: kuwait"
  ],
  "🇰🇬": [
    "1f1f0-1f1ec",
    "bandeira",
    "bandeira: quirguistao",
    "bandeiras",
    "flag",
    "flag: kyrgyzstan"
  ],
  "🇱🇦": [
    "1f1f1-1f1e6",
    "bandeira",
    "bandeira: laos",
    "bandeiras",
    "flag",
    "flag: laos"
  ],
  "🇱🇻": [
    "1f1f1-1f1fb",
    "bandeira",
    "bandeira: letonia",
    "bandeiras",
    "flag",
    "flag: latvia"
  ],
  "🇱🇧": [
    "1f1f1-1f1e7",
    "bandeira",
    "bandeira: libano",
    "bandeiras",
    "flag",
    "flag: lebanon"
  ],
  "🇱🇸": [
    "1f1f1-1f1f8",
    "bandeira",
    "bandeira: lesoto",
    "bandeiras",
    "flag",
    "flag: lesotho"
  ],
  "🇱🇷": [
    "1f1f1-1f1f7",
    "bandeira",
    "bandeira: liberia",
    "bandeiras",
    "flag",
    "flag: liberia"
  ],
  "🇱🇾": [
    "1f1f1-1f1fe",
    "bandeira",
    "bandeira: libia",
    "bandeiras",
    "flag",
    "flag: libya"
  ],
  "🇱🇮": [
    "1f1f1-1f1ee",
    "bandeira",
    "bandeira: liechtenstein",
    "bandeiras",
    "flag",
    "flag: liechtenstein"
  ],
  "🇱🇹": [
    "1f1f1-1f1f9",
    "bandeira",
    "bandeira: lituania",
    "bandeiras",
    "flag",
    "flag: lithuania"
  ],
  "🇱🇺": [
    "1f1f1-1f1fa",
    "bandeira",
    "bandeira: luxemburgo",
    "bandeiras",
    "flag",
    "flag: luxembourg"
  ],
  "🇲🇴": [
    "1f1f2-1f1f4",
    "bandeira",
    "bandeira: macau, rae da china",
    "bandeiras",
    "flag",
    "flag: macao sar china"
  ],
  "🇲🇬": [
    "1f1f2-1f1ec",
    "bandeira",
    "bandeira: madagascar",
    "bandeiras",
    "flag",
    "flag: madagascar"
  ],
  "🇲🇼": [
    "1f1f2-1f1fc",
    "bandeira",
    "bandeira: malaui",
    "bandeiras",
    "flag",
    "flag: malawi"
  ],
  "🇲🇾": [
    "1f1f2-1f1fe",
    "bandeira",
    "bandeira: malasia",
    "bandeiras",
    "flag",
    "flag: malaysia"
  ],
  "🇲🇻": [
    "1f1f2-1f1fb",
    "bandeira",
    "bandeira: maldivas",
    "bandeiras",
    "flag",
    "flag: maldives"
  ],
  "🇲🇱": [
    "1f1f2-1f1f1",
    "bandeira",
    "bandeira: mali",
    "bandeiras",
    "flag",
    "flag: mali"
  ],
  "🇲🇹": [
    "1f1f2-1f1f9",
    "bandeira",
    "bandeira: malta",
    "bandeiras",
    "flag",
    "flag: malta"
  ],
  "🇲🇭": [
    "1f1f2-1f1ed",
    "bandeira",
    "bandeira: ilhas marshall",
    "bandeiras",
    "flag",
    "flag: marshall islands"
  ],
  "🇲🇶": [
    "1f1f2-1f1f6",
    "bandeira",
    "bandeira: martinica",
    "bandeiras",
    "flag",
    "flag: martinique"
  ],
  "🇲🇷": [
    "1f1f2-1f1f7",
    "bandeira",
    "bandeira: mauritania",
    "bandeiras",
    "flag",
    "flag: mauritania"
  ],
  "🇲🇺": [
    "1f1f2-1f1fa",
    "bandeira",
    "bandeira: mauricio",
    "bandeiras",
    "flag",
    "flag: mauritius"
  ],
  "🇾🇹": [
    "1f1fe-1f1f9",
    "bandeira",
    "bandeira: mayotte",
    "bandeiras",
    "flag",
    "flag: mayotte"
  ],
  "🇲🇽": [
    "1f1f2-1f1fd",
    "bandeira",
    "bandeira: mexico",
    "bandeiras",
    "flag",
    "flag: mexico"
  ],
  "🇫🇲": [
    "1f1eb-1f1f2",
    "bandeira",
    "bandeira: micronesia",
    "bandeiras",
    "flag",
    "flag: micronesia"
  ],
  "🇲🇩": [
    "1f1f2-1f1e9",
    "bandeira",
    "bandeira: moldavia",
    "bandeiras",
    "flag",
    "flag: moldova"
  ],
  "🇲🇨": [
    "1f1f2-1f1e8",
    "bandeira",
    "bandeira: monaco",
    "bandeiras",
    "flag",
    "flag: monaco"
  ],
  "🇲🇳": [
    "1f1f2-1f1f3",
    "bandeira",
    "bandeira: mongolia",
    "bandeiras",
    "flag",
    "flag: mongolia"
  ],
  "🇲🇪": [
    "1f1f2-1f1ea",
    "bandeira",
    "bandeira: montenegro",
    "bandeiras",
    "flag",
    "flag: montenegro"
  ],
  "🇲🇸": [
    "1f1f2-1f1f8",
    "bandeira",
    "bandeira: montserrat",
    "bandeiras",
    "flag",
    "flag: montserrat"
  ],
  "🇲🇦": [
    "1f1f2-1f1e6",
    "bandeira",
    "bandeira: marrocos",
    "bandeiras",
    "flag",
    "flag: morocco"
  ],
  "🇲🇿": [
    "1f1f2-1f1ff",
    "bandeira",
    "bandeira: mocambique",
    "bandeiras",
    "flag",
    "flag: mozambique"
  ],
  "🇲🇲": [
    "1f1f2-1f1f2",
    "bandeira",
    "bandeira: mianmar (birmania)",
    "bandeiras",
    "flag",
    "flag: myanmar (burma)"
  ],
  "🇳🇦": [
    "1f1f3-1f1e6",
    "bandeira",
    "bandeira: namibia",
    "bandeiras",
    "flag",
    "flag: namibia"
  ],
  "🇳🇷": [
    "1f1f3-1f1f7",
    "bandeira",
    "bandeira: nauru",
    "bandeiras",
    "flag",
    "flag: nauru"
  ],
  "🇳🇵": [
    "1f1f3-1f1f5",
    "bandeira",
    "bandeira: nepal",
    "bandeiras",
    "flag",
    "flag: nepal"
  ],
  "🇳🇱": [
    "1f1f3-1f1f1",
    "bandeira",
    "bandeira: paises baixos",
    "bandeiras",
    "flag",
    "flag: netherlands"
  ],
  "🇳🇨": [
    "1f1f3-1f1e8",
    "bandeira",
    "bandeira: nova caledonia",
    "bandeiras",
    "flag",
    "flag: new caledonia"
  ],
  "🇳🇿": [
    "1f1f3-1f1ff",
    "bandeira",
    "bandeira: nova zelandia",
    "bandeiras",
    "flag",
    "flag: new zealand"
  ],
  "🇳🇮": [
    "1f1f3-1f1ee",
    "bandeira",
    "bandeira: nicaragua",
    "bandeiras",
    "flag",
    "flag: nicaragua"
  ],
  "🇳🇪": [
    "1f1f3-1f1ea",
    "bandeira",
    "bandeira: niger",
    "bandeiras",
    "flag",
    "flag: niger"
  ],
  "🇳🇬": [
    "1f1f3-1f1ec",
    "bandeira",
    "bandeira: nigeria",
    "bandeiras",
    "flag",
    "flag: nigeria"
  ],
  "🇳🇺": [
    "1f1f3-1f1fa",
    "bandeira",
    "bandeira: niue",
    "bandeiras",
    "flag",
    "flag: niue"
  ],
  "🇳🇫": [
    "1f1f3-1f1eb",
    "bandeira",
    "bandeira: ilha norfolk",
    "bandeiras",
    "flag",
    "flag: norfolk island"
  ],
  "🇰🇵": [
    "1f1f0-1f1f5",
    "bandeira",
    "bandeira: coreia do norte",
    "bandeiras",
    "flag",
    "flag: north korea"
  ],
  "🇲🇰": [
    "1f1f2-1f1f0",
    "bandeira",
    "bandeira: macedonia do norte",
    "bandeiras",
    "flag",
    "flag: north macedonia"
  ],
  "🇲🇵": [
    "1f1f2-1f1f5",
    "bandeira",
    "bandeira: ilhas marianas do norte",
    "bandeiras",
    "flag",
    "flag: northern mariana islands"
  ],
  "🇳🇴": [
    "1f1f3-1f1f4",
    "bandeira",
    "bandeira: noruega",
    "bandeiras",
    "flag",
    "flag: norway"
  ],
  "🇴🇲": [
    "1f1f4-1f1f2",
    "bandeira",
    "bandeira: oma",
    "bandeiras",
    "flag",
    "flag: oman"
  ],
  "🇵🇰": [
    "1f1f5-1f1f0",
    "bandeira",
    "bandeira: paquistao",
    "bandeiras",
    "flag",
    "flag: pakistan"
  ],
  "🇵🇼": [
    "1f1f5-1f1fc",
    "bandeira",
    "bandeira: palau",
    "bandeiras",
    "flag",
    "flag: palau"
  ],
  "🇵🇸": [
    "1f1f5-1f1f8",
    "bandeira",
    "bandeira: territorios palestinos",
    "bandeiras",
    "flag",
    "flag: palestinian territories"
  ],
  "🇵🇦": [
    "1f1f5-1f1e6",
    "bandeira",
    "bandeira: panama",
    "bandeiras",
    "flag",
    "flag: panama"
  ],
  "🇵🇬": [
    "1f1f5-1f1ec",
    "bandeira",
    "bandeira: papua-nova guine",
    "bandeiras",
    "flag",
    "flag: papua new guinea"
  ],
  "🇵🇾": [
    "1f1f5-1f1fe",
    "bandeira",
    "bandeira: paraguai",
    "bandeiras",
    "flag",
    "flag: paraguay"
  ],
  "🇵🇪": [
    "1f1f5-1f1ea",
    "bandeira",
    "bandeira: peru",
    "bandeiras",
    "flag",
    "flag: peru"
  ],
  "🇵🇭": [
    "1f1f5-1f1ed",
    "bandeira",
    "bandeira: filipinas",
    "bandeiras",
    "flag",
    "flag: philippines"
  ],
  "🇵🇳": [
    "1f1f5-1f1f3",
    "bandeira",
    "bandeira: ilhas pitcairn",
    "bandeiras",
    "flag",
    "flag: pitcairn islands"
  ],
  "🇵🇱": [
    "1f1f5-1f1f1",
    "bandeira",
    "bandeira: polonia",
    "bandeiras",
    "flag",
    "flag: poland"
  ],
  "🇵🇹": [
    "1f1f5-1f1f9",
    "bandeira",
    "bandeira: portugal",
    "bandeiras",
    "flag",
    "flag: portugal"
  ],
  "🇵🇷": [
    "1f1f5-1f1f7",
    "bandeira",
    "bandeira: porto rico",
    "bandeiras",
    "flag",
    "flag: puerto rico"
  ],
  "🇶🇦": [
    "1f1f6-1f1e6",
    "bandeira",
    "bandeira: catar",
    "bandeiras",
    "flag",
    "flag: qatar"
  ],
  "🇷🇪": [
    "1f1f7-1f1ea",
    "bandeira",
    "bandeira: reuniao",
    "bandeiras",
    "flag",
    "flag: reunion"
  ],
  "🇷🇴": [
    "1f1f7-1f1f4",
    "bandeira",
    "bandeira: romenia",
    "bandeiras",
    "flag",
    "flag: romania"
  ],
  "🇷🇺": [
    "1f1f7-1f1fa",
    "bandeira",
    "bandeira: russia",
    "bandeiras",
    "flag",
    "flag: russia"
  ],
  "🇷🇼": [
    "1f1f7-1f1fc",
    "bandeira",
    "bandeira: ruanda",
    "bandeiras",
    "flag",
    "flag: rwanda"
  ],
  "🇼🇸": [
    "1f1fc-1f1f8",
    "bandeira",
    "bandeira: samoa",
    "bandeiras",
    "flag",
    "flag: samoa"
  ],
  "🇸🇲": [
    "1f1f8-1f1f2",
    "bandeira",
    "bandeira: san marino",
    "bandeiras",
    "flag",
    "flag: san marino"
  ],
  "🇸🇹": [
    "1f1f8-1f1f9",
    "bandeira",
    "bandeira: sao tome e principe",
    "bandeiras",
    "flag",
    "flag: sao tome & principe"
  ],
  "🇨🇶": [
    "1f1e8-1f1f6",
    "bandeira",
    "bandeira: sark",
    "bandeiras",
    "flag",
    "flag: sark"
  ],
  "🇸🇦": [
    "1f1f8-1f1e6",
    "bandeira",
    "bandeira: arabia saudita",
    "bandeiras",
    "flag",
    "flag: saudi arabia"
  ],
  "🇸🇳": [
    "1f1f8-1f1f3",
    "bandeira",
    "bandeira: senegal",
    "bandeiras",
    "flag",
    "flag: senegal"
  ],
  "🇷🇸": [
    "1f1f7-1f1f8",
    "bandeira",
    "bandeira: servia",
    "bandeiras",
    "flag",
    "flag: serbia"
  ],
  "🇸🇨": [
    "1f1f8-1f1e8",
    "bandeira",
    "bandeira: seicheles",
    "bandeiras",
    "flag",
    "flag: seychelles"
  ],
  "🇸🇱": [
    "1f1f8-1f1f1",
    "bandeira",
    "bandeira: serra leoa",
    "bandeiras",
    "flag",
    "flag: sierra leone"
  ],
  "🇸🇬": [
    "1f1f8-1f1ec",
    "bandeira",
    "bandeira: singapura",
    "bandeiras",
    "flag",
    "flag: singapore"
  ],
  "🇸🇽": [
    "1f1f8-1f1fd",
    "bandeira",
    "bandeira: sint maarten",
    "bandeiras",
    "flag",
    "flag: sint maarten"
  ],
  "🇸🇰": [
    "1f1f8-1f1f0",
    "bandeira",
    "bandeira: eslovaquia",
    "bandeiras",
    "flag",
    "flag: slovakia"
  ],
  "🇸🇮": [
    "1f1f8-1f1ee",
    "bandeira",
    "bandeira: eslovenia",
    "bandeiras",
    "flag",
    "flag: slovenia"
  ],
  "🇬🇸": [
    "1f1ec-1f1f8",
    "bandeira",
    "bandeira: ilhas georgia do sul e sandwich do sul",
    "bandeiras",
    "flag",
    "flag: south georgia & south sandwich islands"
  ],
  "🇸🇧": [
    "1f1f8-1f1e7",
    "bandeira",
    "bandeira: ilhas salomao",
    "bandeiras",
    "flag",
    "flag: solomon islands"
  ],
  "🇸🇴": [
    "1f1f8-1f1f4",
    "bandeira",
    "bandeira: somalia",
    "bandeiras",
    "flag",
    "flag: somalia"
  ],
  "🇿🇦": [
    "1f1ff-1f1e6",
    "bandeira",
    "bandeira: africa do sul",
    "bandeiras",
    "flag",
    "flag: south africa"
  ],
  "🇰🇷": [
    "1f1f0-1f1f7",
    "bandeira",
    "bandeira: coreia do sul",
    "bandeiras",
    "flag",
    "flag: south korea"
  ],
  "🇸🇸": [
    "1f1f8-1f1f8",
    "bandeira",
    "bandeira: sudao do sul",
    "bandeiras",
    "flag",
    "flag: south sudan"
  ],
  "🇪🇸": [
    "1f1ea-1f1f8",
    "bandeira",
    "bandeira: espanha",
    "bandeiras",
    "flag",
    "flag: spain"
  ],
  "🇱🇰": [
    "1f1f1-1f1f0",
    "bandeira",
    "bandeira: sri lanka",
    "bandeiras",
    "flag",
    "flag: sri lanka"
  ],
  "🇧🇱": [
    "1f1e7-1f1f1",
    "bandeira",
    "bandeira: sao bartolomeu",
    "bandeiras",
    "flag",
    "flag: st. barthelemy"
  ],
  "🇸🇭": [
    "1f1f8-1f1ed",
    "bandeira",
    "bandeira: santa helena",
    "bandeiras",
    "flag",
    "flag: st. helena"
  ],
  "🇰🇳": [
    "1f1f0-1f1f3",
    "bandeira",
    "bandeira: sao cristovao e nevis",
    "bandeiras",
    "flag",
    "flag: st. kitts & nevis"
  ],
  "🇱🇨": [
    "1f1f1-1f1e8",
    "bandeira",
    "bandeira: santa lucia",
    "bandeiras",
    "flag",
    "flag: st. lucia"
  ],
  "🇵🇲": [
    "1f1f5-1f1f2",
    "bandeira",
    "bandeira: sao pedro e miquelao",
    "bandeiras",
    "flag",
    "flag: st. pierre & miquelon"
  ],
  "🇻🇨": [
    "1f1fb-1f1e8",
    "bandeira",
    "bandeira: sao vicente e granadinas",
    "bandeiras",
    "flag",
    "flag: st. vincent & grenadines"
  ],
  "🇸🇩": [
    "1f1f8-1f1e9",
    "bandeira",
    "bandeira: sudao",
    "bandeiras",
    "flag",
    "flag: sudan"
  ],
  "🇸🇷": [
    "1f1f8-1f1f7",
    "bandeira",
    "bandeira: suriname",
    "bandeiras",
    "flag",
    "flag: suriname"
  ],
  "🇸🇪": [
    "1f1f8-1f1ea",
    "bandeira",
    "bandeira: suecia",
    "bandeiras",
    "flag",
    "flag: sweden"
  ],
  "🇨🇭": [
    "1f1e8-1f1ed",
    "bandeira",
    "bandeira: suica",
    "bandeiras",
    "flag",
    "flag: switzerland"
  ],
  "🇸🇾": [
    "1f1f8-1f1fe",
    "bandeira",
    "bandeira: siria",
    "bandeiras",
    "flag",
    "flag: syria"
  ],
  "🇹🇼": [
    "1f1f9-1f1fc",
    "bandeira",
    "bandeira: taiwan",
    "bandeiras",
    "flag",
    "flag: taiwan"
  ],
  "🇹🇯": [
    "1f1f9-1f1ef",
    "bandeira",
    "bandeira: tadjiquistao",
    "bandeiras",
    "flag",
    "flag: tajikistan"
  ],
  "🇹🇿": [
    "1f1f9-1f1ff",
    "bandeira",
    "bandeira: tanzania",
    "bandeiras",
    "flag",
    "flag: tanzania"
  ],
  "🇹🇭": [
    "1f1f9-1f1ed",
    "bandeira",
    "bandeira: tailandia",
    "bandeiras",
    "flag",
    "flag: thailand"
  ],
  "🇹🇱": [
    "1f1f9-1f1f1",
    "bandeira",
    "bandeira: timor-leste",
    "bandeiras",
    "flag",
    "flag: timor-leste"
  ],
  "🇹🇬": [
    "1f1f9-1f1ec",
    "bandeira",
    "bandeira: togo",
    "bandeiras",
    "flag",
    "flag: togo"
  ],
  "🇹🇰": [
    "1f1f9-1f1f0",
    "bandeira",
    "bandeira: tokelau",
    "bandeiras",
    "flag",
    "flag: tokelau"
  ],
  "🇹🇴": [
    "1f1f9-1f1f4",
    "bandeira",
    "bandeira: tonga",
    "bandeiras",
    "flag",
    "flag: tonga"
  ],
  "🇹🇹": [
    "1f1f9-1f1f9",
    "bandeira",
    "bandeira: trinidad e tobago",
    "bandeiras",
    "flag",
    "flag: trinidad & tobago"
  ],
  "🇹🇳": [
    "1f1f9-1f1f3",
    "bandeira",
    "bandeira: tunisia",
    "bandeiras",
    "flag",
    "flag: tunisia"
  ],
  "🇹🇷": [
    "1f1f9-1f1f7",
    "bandeira",
    "bandeira: turquia",
    "bandeiras",
    "flag",
    "flag: turkiye"
  ],
  "🇹🇲": [
    "1f1f9-1f1f2",
    "bandeira",
    "bandeira: turcomenistao",
    "bandeiras",
    "flag",
    "flag: turkmenistan"
  ],
  "🇹🇨": [
    "1f1f9-1f1e8",
    "bandeira",
    "bandeira: ilhas turcas e caicos",
    "bandeiras",
    "flag",
    "flag: turks & caicos islands"
  ],
  "🇹🇻": [
    "1f1f9-1f1fb",
    "bandeira",
    "bandeira: tuvalu",
    "bandeiras",
    "flag",
    "flag: tuvalu"
  ],
  "🇻🇮": [
    "1f1fb-1f1ee",
    "bandeira",
    "bandeira: ilhas virgens americanas",
    "bandeiras",
    "flag",
    "flag: u.s. virgin islands"
  ],
  "🇺🇬": [
    "1f1fa-1f1ec",
    "bandeira",
    "bandeira: uganda",
    "bandeiras",
    "flag",
    "flag: uganda"
  ],
  "🇺🇦": [
    "1f1fa-1f1e6",
    "bandeira",
    "bandeira: ucrania",
    "bandeiras",
    "flag",
    "flag: ukraine"
  ],
  "🇦🇪": [
    "1f1e6-1f1ea",
    "bandeira",
    "bandeira: emirados arabes unidos",
    "bandeiras",
    "flag",
    "flag: united arab emirates"
  ],
  "🇬🇧": [
    "1f1ec-1f1e7",
    "bandeira",
    "bandeira: reino unido",
    "bandeiras",
    "flag",
    "flag: united kingdom"
  ],
  "🏴󠁧󠁢󠁥󠁮󠁧󠁿": [
    "1f3f4-e0067-e0062-e0065-e006e-e0067-e007f",
    "bandeira",
    "bandeira: inglaterra",
    "bandeiras",
    "flag",
    "flag: england"
  ],
  "🏴󠁧󠁢󠁳󠁣󠁴󠁿": [
    "1f3f4-e0067-e0062-e0073-e0063-e0074-e007f",
    "bandeira",
    "bandeira: escocia",
    "bandeiras",
    "flag",
    "flag: scotland"
  ],
  "🏴󠁧󠁢󠁷󠁬󠁳󠁿": [
    "1f3f4-e0067-e0062-e0077-e006c-e0073-e007f",
    "bandeira",
    "bandeira: pais de gales",
    "bandeiras",
    "flag",
    "flag: wales"
  ],
  "🇺🇸": [
    "1f1fa-1f1f8",
    "bandeira",
    "bandeira: estados unidos",
    "bandeiras",
    "flag",
    "flag: united states"
  ],
  "🇺🇾": [
    "1f1fa-1f1fe",
    "bandeira",
    "bandeira: uruguai",
    "bandeiras",
    "flag",
    "flag: uruguay"
  ],
  "🇺🇿": [
    "1f1fa-1f1ff",
    "bandeira",
    "bandeira: uzbequistao",
    "bandeiras",
    "flag",
    "flag: uzbekistan"
  ],
  "🇻🇺": [
    "1f1fb-1f1fa",
    "bandeira",
    "bandeira: vanuatu",
    "bandeiras",
    "flag",
    "flag: vanuatu"
  ],
  "🇻🇦": [
    "1f1fb-1f1e6",
    "bandeira",
    "bandeira: cidade do vaticano",
    "bandeiras",
    "flag",
    "flag: vatican city"
  ],
  "🇻🇪": [
    "1f1fb-1f1ea",
    "bandeira",
    "bandeira: venezuela",
    "bandeiras",
    "flag",
    "flag: venezuela"
  ],
  "🇻🇳": [
    "1f1fb-1f1f3",
    "bandeira",
    "bandeira: vietna",
    "bandeiras",
    "flag",
    "flag: vietnam"
  ],
  "🇼🇫": [
    "1f1fc-1f1eb",
    "bandeira",
    "bandeira: wallis e futuna",
    "bandeiras",
    "flag",
    "flag: wallis & futuna"
  ],
  "🇪🇭": [
    "1f1ea-1f1ed",
    "bandeira",
    "bandeira: saara ocidental",
    "bandeiras",
    "flag",
    "flag: western sahara"
  ],
  "🇾🇪": [
    "1f1fe-1f1ea",
    "bandeira",
    "bandeira: iemen",
    "bandeiras",
    "flag",
    "flag: yemen"
  ],
  "🇿🇲": [
    "1f1ff-1f1f2",
    "bandeira",
    "bandeira: zambia",
    "bandeiras",
    "flag",
    "flag: zambia"
  ],
  "🇿🇼": [
    "1f1ff-1f1fc",
    "bandeira",
    "bandeira: zimbabue",
    "bandeiras",
    "flag",
    "flag: zimbabwe"
  ]
}

export default whatsAppEmojiKeywords
